export const StubTranslationsMock = {
  "AccessDenied": {
    "PageDescription": "You don't have permission to view this page.",
    "PageTitle": "Access denied"
  },
  "Account.ForgottenPassword": {
    "AccountHasNoEmail": "This account has no email address! Contact your system administrator.",
    "BackToLogin": "Back to login",
    "PasswordReset": "Password Reset",
    "RecoveryEmailHasBeenSent": "An email with recovery link has been sent to your email.",
    "SendEmail": "Send email",
    "Title": "Cirrus assessment - Forgotten password",
    "UsernameNotFound": "This username is not found!",
    "FormTitle": "Forgot your password?"
  },
  "Account.Login": {
    "AlreadyLoggedIn": "You are already logged in. In order to log in you first need to log out from the other device.",
    "CantLogIn": "Can't log in?",
    "Description": "Log in with the Cirrus platform",
    "Language": "Language",
    "Login": "Login",
    "Title": "Cirrus assessment - Login",
    "Version": "Version",
    "LoginWith": "Login with",
    "LoginByName": "Login using Cirrus credentials",
    "LoginViaSaml": "Login via SAML",
    "Keycode": "Keycode",
    "UseKeycodeLink": "Click here to login using a 8-character keycode for an exam (or review).",
    "KeycodePlaceholder": "8-character keycode",
    "ForgotPasswordLinkButton": "Forgot password?",
    "TFA_Title": "2-factor authentication",
    "TFA_CodePlaceholder": "Enter 6-digit code",
    "TFA_CodeHelperText": "Open Google Authenticator app on your mobile phone and enter code here",
    "TFA_TrustBrowser": "Trust this browser for 30 days",
    "TFA_CodeErrorHelperText": "Your two-factor authentication code was incorrect. Please try again.",
    "InvalidKeycode": "Invalid keycode",
    "InvalidUsernameOrKeycode": "The user name or keycode is incorrect.",
    "TFA_Help": "Having troubles?"
  },
  "Account.RestoreForgottenPassword": {
    "BackToLogin": "Back to login",
    "PasswordReset": "Password Reset",
    "PasswordSuccessfullyChanged": "Your password has been successfully changed",
    "Reset": "Reset",
    "Title": "Cirrus assessment - Forgotten password recovery",
    "UsernameNotFound": "This username is not found!",
    "ValidityOfRequestHasExpired": "Validity of the request has expired!",
    "PasswordRule": "New password should be different from the previous password"
  },
  "AciTree.Sortable": {
    "After": "after",
    "And": "and",
    "Before": "before",
    "More": "more",
    "Move": "move",
    "To": "to"
  },
  "AddSection": {
    "NoSectionPages": "There are no section pages",
    "SearchSectionPages": "Search section pages",
    "SelectQuestions": "Select Questions",
    "SelectSection": "Select Section",
    "SelectSectionPage": "Select the section page you want to use for this section.",
    "StartTypingNameOrText": "Start typing the name or text of the section page",
    "SelectOptions": "Options",
    "MaxTimeForSection": "Max time allowed for the candidate on this section (minutes)",
    "MaxTimeForSectionInfo": "Set the max time allowed for this section.",
    "MaxTimeForSection2": "Max time allowed",
    "MaxTimeForSectionInfo2": "Set a maximum allowed time for a section. The time allowed cannot be more than the max time for the complete assessment.",
    "MaxTimeForSectionPlaceholder": "Enter time in minutes",
    "ValueRangeTip": "Value should be between {min} and {max}. Leave the field blank for unlimited time"
  },
  "Admin.AssessmentScale.Grades": {
    "HighestOnTop": "Highest grade should be on top"
  },
  "Admin.AssessmentSettings.Dialogs.Add": {
    "Title": "Add assessment scale"
  },
  "Admin.AssessmentSettings": {
    "AddRow": "Add row",
    "AddScale": "Add scale",
    "Admin": "Admin",
    "Administration": "Administration",
    "AssessmentSettingCreation": "Assessment setting creation",
    "AssessmentSettings": "Assessment settings",
    "AssessmentSettingsCreation": "Assessment settings creation",
    "AssessmentSettingsEdit": "Assessment settings edit",
    "AutomaticallyCalculatePercentage": "Automatically calculate percentage",
    "AvailableIn": "Available in",
    "CirrusAssessment": "Cirrus assessment",
    "DeleteSettings": "Delete settings",
    "Description": "Description",
    "EditScalesPageTitle": "Edit assessment scales",
    "LastModified": "Last modified",
    "NoAssessmentSettings": "No assessment settings",
    "NoSettings": "No settings",
    "ObjectPermanentDeletionNotice": "It will be deleted permanently.",
    "ObjectsPermanentDeletionNotice": "They will be deleted permanently.",
    "PercentageFromAndIncluding": "Percentage from and including",
    "Title": "Title",
    "Update": "Update",
    "PassGrade": "Pass grade"
  },
  "Admin.Breadcrumbs": {
    "Administration": "Administration",
    "AssessmentScales": "Assessment scales",
    "ExternalApi": "External API",
    "GlobalSettings": "Global settings",
    "Hierarchies": "Hierarchies",
    "HierarchyUsers": "Hierarchy {0} Users",
    "Import": "Import",
    "IMSMappings": "IMS LIS Mappings",
    "Labels": "Labels",
    "ObjectiveRepositories": "Learning objectives repositories",
    "Objectives": "Objectives",
    "Overview": "Overview",
    "Qualifications": "Qualifications",
    "RegionalSettings": "Regional settings",
    "Roles": "Roles",
    "SafeExamBrowser": "Safe exam browser",
    "Search": "Search",
    "Taxonomies": "Taxonomies",
    "Templates": "Templates",
    "Terms": "Terms",
    "UserAccessRights": "Users",
    "UserEdit": "User edit",
    "WebServices": "Web services",
    "SamlIntegration": "SAML Integration ",
    "Clusters": "Clusters"
  },
  "Admin.CollectionsAndAssessments": {
    "Admin": "Admin",
    "Administration": "Administration",
    "AdministrationCollectionAndAssessmentAdministration": "Administration - Collection and assessment administration",
    "Archive": "Archive",
    "AssessmentDeletionConfirmation": "Are you sure you want to delete this assessment \"{0}\"?",
    "Assessments": "Assessments",
    "AssessmentsDeletionConfirmation": "Are you sure you want to delete {0} assessments?",
    "AssessmentsPageTitle": "Assessment administration",
    "AvailableTo": "Available to",
    "CirrusAssessment": "Cirrus assessment",
    "CollectionDeletionConfirmation": "Are you sure you want to delete this collection \"{0}\"?",
    "CollectionManagment": "Collection managment",
    "Collections": "Collections",
    "CollectionsAndAssessments": "Collections and assessments",
    "CollectionsDeletionConfirmation": "Are you sure you want to delete {0} collections?",
    "CollectionsPageTitle": "Collection administration",
    "Created": "Created",
    "CreatedBy": "Created by",
    "Edit": "Edit",
    "EditCollection": "Edit collection",
    "Hierarchy": "Hierarchy",
    "LastEdited": "Last edited",
    "LastUpdated": "Last updated",
    "LastVisited": "Last visited",
    "NDaysObjectRestorationPeriodNotice": "It will be possible to restore it within {0} days. After that period all data will be deleted permanently.",
    "NDaysObjectsRestorationPeriodNotice": "It will be possible to restore them within {0} days. After that period all data will be deleted permanently.",
    "NoAssessments": "No assessments",
    "NoCollections": "No collections",
    "NumberOfQuestions": "No. of questions",
    "Participants": "Participants",
    "Qualifications": "Qualifications",
    "Status": "Status",
    "Term": "Term",
    "Title": "Title",
    "AuthorUserName": "Username",
    "Author": "Author",
    "Code": "Code"
  },
  "Admin.EditGlobalSettings": {
    "Admin": "Admin",
    "Administration": "Administration",
    "AssessmentSettings": "Assessment settings",
    "AssessmentSettingsDescription": "Allows you to define assessment scales.",
    "CirrusAssessment": "Cirrus assessment",
    "EditGlobalSettings": "Edit global settings",
    "LearningObjectives": "Learning objectives",
    "LearningObjectivesDescription": "Allows you to create and import learning objectives.",
    "RegionalSettings": "Regional settings",
    "RegionalSettingsDescription": "Administrate settings for language, time zone and formats.",
    "Taxonomies": "Taxonomies",
    "TaxonomiesDescription": "Allows you to set allowed taxonomies used for tagging items."
  },
  "Admin.Hierarchies": {
    "AllowRelationshipWithCollections": "Allow relationship with Collections",
    "AllowRelationshipWithCollectionsDescription": "This allows users belonging to this hierarchy to add this hierarchy to their collections",
    "AllowRelationshipWithScheduledAssessments": "Allow relationship with Scheduled assessments",
    "AllowRelationshipWithSchedulesDescription": "This allows users belonging to this hierarchy to schedule assessments belonging to this hierarchy",
    "collections": "collections",
    "CreateHierarchy": "Add hierarchy",
    "DropOrganisationWarning": "This branch already has an organization",
    "EditHierarchy": "Edit hierarchy",
    "EnableIn": "Available in: ",
    "HierarchyDeletedSuccess": "Hierarchy was successfully deleted",
    "NoHierarchies": "No hierarchies",
    "Organisation": "Organization",
    "OrganisationAddress": "Organization address",
    "OrganisationDescription": "By defining this hierarchy level as an organization this level will be the root level for all users belonging to this hierarchy",
    "OrganisationId": "Organization ID",
    "OrganisationMessage": "Define this hierarchy level as organization",
    "Path": "Path",
    "schedules": "schedules",
    "SynchronizationKeyUnique": "Synchronisation key should be unique. The entered Key is used in \"{0}\".",
    "Title": "Title",
    "ViewUsers": "View users",
    "RootLevel": "Root level",
    "DefineAsRootLevel": "Define this hierarchy level as a new root level",
    "DefineAsRootLevelDescription": "Useful if you want to limit the access of users",
    "DropRootLevelWarning": "This branch already has a new root level",
    "DropRootWarning": "The tree should have only one root group",
    "SortSameLevelWarning": "It isn't possible to sort same level groups",
    "ArchivedDropWarning": "Cannot be moved under archived hierarchy",
    "ArchiveConfirmation": "Are you sure you want to archive this hierarchy?",
    "ArchiveSuccessful": "Hierarchy was successfully archived",
    "UnarchiveSuccessful": "Hierarchy was successfully unarchived",
    "ArchiveFilterTooltip": "Toggle whether you want to show archived hierarchies or not"
  },
  "Admin.Home": {
    "Admin": "Admin",
    "AdminHome": "Admin home",
    "Administration": "Administration",
    "CirrusAssessment": "Cirrus assessment"
  },
  "Admin.Ims": {
    "SynchronizationKey": "Synchronization key",
    "SynchronizationKeyWarning": "Changing the Synchronisation key can influence the integration with your external system"
  },
  "Admin.IMSLIS": {
    "Unmapped": "Unmapped"
  },
  "Admin.IndividualTaxonomies": {
    "Active": "Active",
    "Admin": "Admin",
    "Administration": "Administration",
    "Category": "Category",
    "CirrusAssessment": "Cirrus assessment",
    "DeleteIndividualTaxonomies": "Delete individual taxonomies",
    "DeleteTaxonomy": "Delete taxonomy",
    "EditCategories": "Edit categories",
    "EditCategory": "Edit category",
    "EditTaxonomies": "Edit taxonomies",
    "IndividualTaxonomies": "Individual taxonomies",
    "IndividualTaxonomiesCreation": "Individual taxonomies creation",
    "IndividualTaxonomiesDeletionConfirmation": "Are you sure you want to delete {0} individual taxonomies?",
    "IndividualTaxonomyDeletionConfirmation": "Are you sure you want to delete individual taxonomy \"{0}\"?",
    "NoIndividualTaxonomies": "No individual taxonomies",
    "ObjectPermanentDeletionNotice": "It will be deleted permanently.",
    "ObjectsPermanentDeletionNotice": "They will be deleted permanently.",
    "Title": "Title"
  },
  "Admin.Labels.Dialogs.Add": {
    "Title": "Add label"
  },
  "Admin.Labels": {
    "AddLearningObjectives": "Add learning objectives",
    "ChangeLearningObjectives": "Change learning objectives",
    "Description": "Description",
    "LearningObjective": "Learning objective",
    "ManualLabelWarning": "This label was manually assigned to question(s). You can't connect it to learning objectives.",
    "NoLabels": "No labels",
    "Title": "Title"
  },
  "Admin.LearningObjectives": {
    "AddNewObjective": "Add new objective",
    "Administration": "Administration",
    "Description": "Description",
    "ErrorReadingExcelFile": "Error reading from file. Unsupported version of Excel",
    "Import": "Import",
    "ImportLearningObjectives": "Import learning objectives",
    "ImportLearningObjectivesCreatedInCVSFile": "Import learning objectives from a CSV file",
    "LearningObjectiveDeletedSuccess": "Learning objective was successfully deleted",
    "LearningObjectives": "Learning objectives",
    "MaximumFileSizeIsNKB": "Maximum file size is: 102400 KB",
    "Title": "Title"
  },
  "Admin.Objectives.Import": {
    "AllIncorrect": "All selected learning objectives are incorrect",
    "ChoseFile": "Choose file",
    "ContainsErrors": "Chosen file contains some broken data that cannot be imported even being selected. You can continue importing data or correct the file firstly and upload it again.",
    "FolderContainsErrors": "This folder contains errors",
    "IdNotDefined": "Some Id fields in chosen file are not defined",
    "ImportSelected": "Import selected",
    "ImportWithErrorsWarning": "Some of the learning objectives that you have selected cannot be imported. Import anyway?",
    "ReadyForImport": "Ready for import",
    "DuplicatedIds": "Chosen file contains duplicated IDs, that data cannot be imported even being selected. You can continue importing data or correct the file firstly and upload it again.",
    "FileContainDuplicatedIds": "Chosen file contains duplicate IDs {0}. \r\nData with duplicate IDs wasn't added."
  },
  "Admin.Objectives": {
    "CreateCategory": "Add category",
    "CreateFolder": "Add folder",
    "CreateObjective": "Add learning objective",
    "CreateSubject": "Add subject",
    "Description": "Description",
    "EditCategory": "Edit category",
    "Editfolder": "Edit folder",
    "EditFolder": "Edit folder",
    "EditLearningObjectives": "Edit learning objectives",
    "EditObjective": "Edit learning objective",
    "EditSubject": "Edit subject",
    "Id": "ID",
    "IdAlreadyExists": "File has already been added.",
    "IdMustNotContainSpecialSymbols": "ID should not contain spaces or special symbols",
    "Import": "Import",
    "ImportLearningObjectives": "Import .csv",
    "Navigation": "Navigation",
    "NoItems": "No items",
    "NoObjectives": "No learning objectives",
    "Preview": "Preview",
    "QuestionCirrusId": "ID",
    "QuestionCollection": "Collection",
    "QuestionStatus": "Status",
    "QuestionTitle": "Title",
    "QuestionType": "Type",
    "Title": "Title",
    "Type": "Type",
    "Hierarchy": "Hierarchy",
    "Published": "Published",
    "RepositoryContent": "Repository content",
    "EmptyFields": "Fill in the required fields",
    "Unpublished": "Unpublished",
    "Unpublish": "Unpublish",
    "Publish": "Publish",
    "ConfirmUnPublish": "Once the status has been set to Unpublished, the repository won't be visible for the authors.  Are you sure you want to change the status?"
  },
  "Admin.ObjectivesRepository.Dialogs.Add": {
    "EditTitle": "Edit repository",
    "Title": "Add repository"
  },
  "Admin.ObjectivesRepository": {
    "CreateRepository": "Add repository",
    "NoRepositories": "No repositories",
    "Repository": "Repository",
    "SelectRepository": "Select repository",
    "TableHint": "By connecting the learning objective repositories to certain hierarchies you can control who has access to these repositories."
  },
  "Admin.Overview.Sidebar": {
    "LicenceStatistics": "Licence statistics"
  },
  "Admin.Qualifications.Dialogs.Add": {
    "Title": "Add qualification"
  },
  "Admin.Qualifications": {
    "AddHierarchy": "Add",
    "AddQualification": "Add qualification",
    "Description": "Description",
    "Hierarchies": "Hierarchies",
    "Hierarchy": "Hierarchy",
    "NoHierarchiesSelected": "No hierarchies selected",
    "NoQualifications": "No qualifications",
    "SelectHierarchy": "Select hierarchy",
    "Title": "Title",
    "UsedInAssessments": "This qualification is used in assessment(s)"
  },
  "Admin.Roles.Create": {
    "AlreadyExists": "Name already exist"
  },
  "Admin.Roles.RolesType": {
    "Admin": "Admin",
    "Author": "Author",
    "Candidate": "Candidate",
    "SystemAdmin": "System admin"
  },
  "Admin.Roles.StartPage": {
    "None": "None"
  },
  "Admin.Roles": {
    "AccessToItems": "Access to items",
    "AccessToStatistics": "Access to statistics",
    "AddAndManageQuestionBlocks": "Add and manage sections",
    "AddAssessmentRole": "Add assessment role",
    "AddAssessmentRoles": "Add assessment role",
    "AddAssessments": "Add assessments",
    "AddCollectionRole": "Add collection role",
    "AddCollectionRoles": "Add collection role",
    "AddCollections": "Add collections",
    "AddItems": "Add items",
    "AddMarkingRoles": "Add marking role",
    "AddMediaElements": "Add media elements",
    "AddQuestions": "Add questions",
    "AddSiteRole": "Add site role",
    "AddSiteRoles": "Add site role",
    "Admin": "Admin",
    "Administration": "Administration",
    "AdministrationRoles": "Administration - Roles",
    "ArchiveAssessment": "Archive assessment",
    "ArchiveCollection": "Archive collection",
    "Assessment": "Assessment",
    "AssessmentManagement": "Assessment management",
    "Assessments": "Assessments",
    "ChangeRemoveItems": "Change/remove items",
    "ChangeScale": "Change assessment scale",
    "CirrusAssessment": "Cirrus assessment",
    "Collection": "Collection",
    "CollectionItemManagement": "Collection item management",
    "Collections": "Collections",
    "CollectionsUseTrashCan": "Collections - use trash can",
    "CreateCopy": "Create copy",
    "Dashboard": "Dashboard",
    "DefaultRole": "Default role",
    "DefaultRoleForCreatorOfAssessment": "Default role for the creator of the assessment",
    "DefaultRoleForCreatorOfCollection": "Default role for the creator of the collection",
    "DeleteAssessment": "Delete assessment",
    "DeleteAssessmentRole": "Delete assessment role",
    "DeleteCollection": "Delete collection",
    "DeleteCollectionRole": "Delete collection role",
    "DeleteItems": "Delete items",
    "DeleteSiteRole": "Delete site role",
    "Delivering": "Delivering",
    "EditAssessmentInformation": "Edit assessment information",
    "EditItems": "Edit items",
    "EditOptions": "Edit options",
    "ExportItems": "Export items",
    "Functionality": "Functionality",
    "GenerateAssessment": "Forms",
    "ImportItems": "Import items",
    "Library": "Library",
    "ManageAssessmentSettings": "Manage assessment settings",
    "ManageAssessors": "Manage assessors",
    "ManageCollectionsAndAssessments": "Manage collections and assessments",
    "ManageContent": "Manage content",
    "ManageHierarchies": "Manage hierarchies",
    "ManageLabels": "Manage labels",
    "ManageLearningObjectives": "Manage learning objectives",
    "ManageQualifications": "Manage qualifications",
    "ManageRegionalSettings": "Manage regional settings",
    "ManageRoles": "Manage roles",
    "ManageSharing": "Manage sharing",
    "ManageTaxonomies": "Manage taxonomies",
    "ManageTerms": "Manage terms",
    "ManageTrashCan": "Manage trash can",
    "ManageUsers": "Manage users",
    "ManageWebServices": "Manage web services",
    "MarkAssessments": "Mark assessments",
    "Marking": "Marking",
    "MediaElementsSharing": "Media elements: manage sharing",
    "NewAssessmentRoleTitle": "New assessment role",
    "NewCollectionRoleTitle": "New collection role",
    "NewMarkingRoleTitle": "New marking role",
    "NewSiteRoleTitle": "New site role",
    "ObjectPermanentDeletionNotice": "It will be deleted permanently.",
    "Participate": "Participate",
    "Permissions": "Permissions",
    "ReleaseResults": "Release results",
    "RemoveQuestions": "Remove questions",
    "Reports": "Reports",
    "RoleDeletionConfirmation": "Are you sure you want to delete this role \"{0}\"?",
    "Roles": "Roles",
    "RolesType": "Roles Type",
    "ScheduleAssessments": "Schedule assessments",
    "ShareMediaElements": "Share media elements",
    "Site": "Site",
    "StandardRole": "Standard role",
    "StartPage": "Start page",
    "StatusManagement": "Status management",
    "ViewAssessmentsOverviewTab": "View assessments overview tab",
    "ViewAssessmentStatisticsTab": "View assessment statistics tab",
    "ViewCollectionsTab": "View collections tab",
    "ViewInvigilationTab": "View proctor tab",
    "ViewItemsTab": "View items tab",
    "ViewMediaElementsTab": "View media elements tab",
    "ViewScheduleTab": "View schedule tab",
    "ManageSkins": "Manage themes",
    "ManageGlobalSettings": "Manage global settings",
    "AddForm": "Add and delete form",
    "ManageItemsInForm": "Manage items in form",
    "AssessmentPerformance": "Assessment performance",
    "ViewCandidateResults": "View candidate results",
    "ViewDeliveryVolume": "View delivery volume",
    "ViewAssessTab": "View assess tab",
    "ViewCoordinatorTab": "View coordinator tab",
    "ViewResultsTab": "View results tab",
    "ViewCompletedTab": "View Audit tab",
    "ManageSeb": "Manage lock-down browser",
    "ViewReScoringTab": "View Rescoring tab",
    "ViewReviewSessionTab": "View Candidate review tab",
    "AllowPrintingOfAssessments": "Allow printing of assessments",
    "ManageClusters": "Manage clusters",
    "AllowPreviewingOfAssessments": "Allow previewing of assessments",
    "CreateItemVersion": "Create new version",
    "CopyAssessment": "Copy assessment",
    "InvigilationViewLogs": "View user logs",
    "LoginAs": "Allow login as",
    "EditFormOptions": "Edit Form Options",
    "LimitedReportsAccessOnly": "Limited reports access only",
    "SendMessages": "Send messages",
    "VoidAttempts": "Void attempts",
    "ManageIntegrations": "Manage integrations",
    "AlwaysShowScoreReport": "View score report (always)",
    "ViewRemarkingTab": "View remarking tab",
    "EditReportFeedbackOption": "Edit report feedback option",
    "EditFormScale": "Edit Form Scale"
  },
  "Admin.SafeExamBrowser": {
    "BrowserQuitPassword": "Browser quit password",
    "Download": "Download",
    "SafeExamBrowserTitle": "Safe Exam Browser",
    "StartBrowserPassword": "Start browser password",
    "StartPageURL": "Start page url",
    "UninstallPreviousVersion": "1. Uninstall previous version of Safe Exam Browser",
    "UseFormToGetFileWithParameters": "3. Use this form to get file with parameters",
    "UseThisLinkToDownload": "2. Use this link to download",
    "UseHttpHeaderKeyCheck": "Enable Key Check. <b>Warning:</b> When active for an assessment, it can <b>only</b> be taken when Safe Exam Browser version <i>3.5.0+</i> is used with a configuration using <i>one of the keys below</i>!"
  },
  "Admin.SEBrowser": {
    "BrowserQuitPassword": "Browser quit password",
    "Download": "Download",
    "StartBrowserPassword": "Start browser password",
    "StartPageUrl": "Start page URL",
    "UseThisFormToGetFileWithParameters": "Use this form to get file with parameters",
    "UseThisLinkToDownload": "Use this link to download"
  },
  "Admin.Sidebar": {
    "AdminHomeTitle": "Admin home",
    "AdministrationTitle": "Administration",
    "AssessmentsDescription": "Allows you to manage assessments.",
    "AssessmentSettingsDescription": "Allows you to define assessment scales.",
    "AssessmentSettingsTitle": "Assessment scales",
    "AssessmentsTitle": "Assessments",
    "CollectionsAndAssessmentsDescription": "Allows you to manage collections and tests.",
    "CollectionsAndAssessmentsTitle": "Collections and assessments",
    "CollectionsDescription": "Allows you to manage collections.",
    "CollectionsTitle": "Collections",
    "ContentTitle": "Content management",
    "EnterpriseWebServicesDescription": "Allows you to manage IMS Enterprise web services.",
    "EnterpriseWebServicesTitle": "Enterprise web services",
    "ExternalApi": "External API",
    "HierarchiesDescription": "Allows you to add and edit hierarchies.",
    "HierarchiesTitle": "Hierarchies",
    "IMSMappingsTitle": "IMS LIS mappings",
    "IntegrationsTitle": "Integrations",
    "LabelsDescription": "Allows you to define labels",
    "LabelsTitle": "Labels",
    "LearningObjectivesDescription": "Allows you to add and import learning objectives.",
    "LearningObjectivesTitle": "Learning objectives",
    "Overview": "Overview",
    "QualificationsDescription": "Allows you to add and edit qualifications.",
    "QualificationsTitle": "Qualifications",
    "RegionalSettingsDescription": "Administrate settings for language, time zone and formats.",
    "RegionalSettingsTitle": "Regional settings",
    "RolesDescription": "Allows you to manage site and collection roles. Roles are used to grant permissions for different features.",
    "RolesTitle": "Roles",
    "SafeExamBrowserDescription": "Allows you to specify and download Safe Exam Browser start parameters.",
    "SafeExamBrowserTitle": "Safe Exam Browser",
    "SchedulesDescription": "Allows you to manage schedules.",
    "SchedulesTitle": "Schedules",
    "SettingsTitle": "Settings",
    "TaxonomiesDescription": "Allows you to set allowed taxonomies used for tagging items.",
    "TaxonomiesTitle": "Taxonomies",
    "TemplatesTitle": "Templates",
    "TermsDescription": "Allows you to manage terms.",
    "TermsTitle": "Terms",
    "TrashCanDescription": "Allows you to restore collections, assessments and users that have been deleted.",
    "TrashCanTitle": "Trash can",
    "UserAccessAndRightsDescription": "Allows you to manage user and access rights.",
    "UserAccessAndRightsTitle": "Users",
    "WebServicesTitle": "WebServices",
    "IsSeed": "Is seed item",
    "SkinsTitle": "Themes",
    "ImsLtiTitle": "IMS LTI",
    "SamlIntegration": "SAML Integration",
    "VplSettings": "VPL",
    "ClustersTitle": "Clusters",
    "Plagiarism": "Plagiarism"
  },
  "Admin.Taxonomies.Dialogs.Add": {
    "Title": "Add taxonomy category"
  },
  "Admin.Taxonomies": {
    "AddTaxonomy": "Add taxonomy category",
    "AvailableIn": "Available In",
    "Description": "Description",
    "EditTaxonomyPageTitle": "Edit taxonomy",
    "LastModified": "Last Modified",
    "NoTaxonomies": "No taxonomies",
    "Title": "Title"
  },
  "Admin.Templates.Dialogs.Add": {
    "Title": "Add new template"
  },
  "Admin.Templates.Dialogs.Edit": {
    "Title": "Edit template"
  },
  "Admin.Templates.Questions": {
    "AddEitherOr": "Add either/or question",
    "AddShortEntry": "Add short text entry question",
    "AlternativesRequired": "Answer alternatives should not be empty",
    "ColumnHeader": "Question title",
    "EitherOr": "Either/or",
    "EnterAlternatives": "Enter the answer alternatives",
    "EnterTheQuestion": "Enter the question",
    "NoQuestions": "No questions",
    "QuestionTextRequired": "Question text should not be empty",
    "ShortEntry": "Short entry",
    "Title": "Title",
    "Type": "Type",
    "MultipleChoice": "Multiple choice",
    "AddMultipleChoice": "Add multiple choice question",
    "ExternalIdHint": "Enter the external ID you want to give the question",
    "MultipleResponse": "Multiple response",
    "AddMultipleResponse": "Add multiple response",
    "QuestionText": "Question text"
  },
  "Admin.Templates": {
    "AddTemplate": "Add",
    "CategoryForm": "Registration form",
    "CategoryNDA": "NDA",
    "ColumnHeaderHint": "This title will be displayed in excel file when exporting data from template",
    "ConfirmLeaveWithoutSave": "You are about to leave this page. {0} You need to save the page otherwise your data will get lost. {0}  Are you sure you want to continue without saving?",
    "DeclineText": "Decline text",
    "Description": "Description",
    "DescriptionHint": "Enter the description of this template",
    "EditTitle": "Title of template",
    "Language": "Language",
    "LastUpdate": "Last updated",
    "MainText": "Main text",
    "NoTemplates": "No templates",
    "QuestionsShouldNotBeEmpty": "At least one question must be added",
    "Reqired": "Required field",
    "RequiredField": "\"{0}\" field is required",
    "SelectCategory": "Select category",
    "SelectCategoryHint": "Select the type of template",
    "TemplateHint": "Type the name you want to give the template",
    "Title": "Title",
    "Type": "Type",
    "WelcomeText": "Welcome screen",
    "ExternalId": "External ID",
    "ExternalIdHint": "Enter the external id you want to give the template.",
    "FinishText": "Finish screen",
    "TimeTip": "Select the time that the candidates are allowed to spend on the registration form",
    "ShowOnOnePage": "Show questions on one page",
    "AllQuestionsNeedsAnswer": "Each question needs to be answered",
    "TimeAllowed": "Time allowed",
    "TimeTipInMins": "in minutes. Empty = unlimited",
    "TimeAllowedError": "Time allowed should be less than or equal to {0}"
  },
  "Admin.Terms.Dialogs.Add": {
    "Title": "Add term"
  },
  "Admin.Terms": {
    "AddTerm": "Add term",
    "Description": "Description",
    "EndDate": "End date",
    "Hierarchy": "Hierarchy",
    "NoTerms": "No terms",
    "StartDate": "Start date",
    "Title": "Title"
  },
  "Admin.Trashcan": {
    "ArchiveStatus": "Archive status",
    "AvailableTo": "Available to",
    "Deleted": "Deleted",
    "DeletedBy": "Deleted by",
    "Lastlogin": "Last login",
    "Name": "Name",
    "NoAssessments": "No assessments",
    "NoCollections": "No collections",
    "NoUsers": "No users",
    "NumberOfLogins": "Number of logins",
    "NumberOfParticipants": "Number of participants",
    "QuarantinePeriodLeft": "Quarantine period left",
    "Status": "Status",
    "Title": "Title",
    "Today": "Today"
  },
  "Admin.UserEdit.Dialogs.Change": {
    "Title": "Change password"
  },
  "Admin.Users.Create": {
    "CandidateNumberAlreadyExists": "Candidate number is in use",
    "Title": "Add user",
    "UserAlreadyExists": "User with this username already exists",
    "UsernameMustContainSpaces": "Username should not contain spaces",
    "UsernameMustContainSpecialSymbols": "Username should not contain spaces or special symbols"
  },
  "Admin.Users.Delete": {
    "Title": "Delete user (s)"
  },
  "Admin.Users.Import": {
    "Title": "Import users",
    "Fail": "Import users fail"
  },
  "Admin.Users": {
    "SynchronizationKeyUnique": "Synchronisation key should be unique. The entered Key is used by \"{0}\"."
  },
  "Admin.WebServices.Dialogs.Add": {
    "Title": "Add integration"
  },
  "Admin": {
    "AddCollection": "Add collection",
    "AssessmentAdministration": "Assessment administration",
    "CollectionAdministration": "Collection administration",
    "DeleteAssessment": "Delete assessment",
    "DeleteCollection": "Delete collection",
    "DeleteUser": "Delete user",
    "LicencesUsed": "Licences used",
    "NewLicencePeriod": "New licence period",
    "NoUpdates": "No updates",
    "NumberOfLicences": "Number of licences",
    "RolesAssessmentRoles": "Roles: Assessment roles",
    "RolesCollectionRoles": "Roles: Collection roles",
    "RolesSiteRoles": "Roles: Site roles",
    "SystemUpdates": "System updates",
    "AddHierarchy": "Add hierarchy",
    "Skins": "Themes",
    "NoSkins": "No themes",
    "SkinTitle": "Title of theme",
    "CreateNewSkin": "Add new theme",
    "EditSkin": "Edit theme",
    "ImsLti": "IMS LTI",
    "AddImsLtiItem": "Add IMS LTI item",
    "ImsLtiItem": "IMS LTI item",
    "AddSebKey": "Add SEB key",
    "SebKey": "Edit SEB key"
  },
  "AdminHierarchies.Relations": {
    "Assessments": "assessments",
    "Collections": "collections",
    "Schedules": "schedules"
  },
  "AdminHierarchies": {
    "AllowedRelationsString": "Allowed relations: {0}"
  },
  "All": {
    "Search": "Search"
  },
  "Archive.States": {
    "Active": "Active",
    "Archived": "Archived"
  },
  "ArchiveState": {
    "Active": "Active",
    "Archived": "Archived"
  },
  "AssessingType": {
    "OneAssessor": "One assessor",
    "TwoAssessors": "Two assessors"
  },
  "Assessment.Breadcrums": {
    "Assessments": "Assessments",
    "EditAssessment": "Edit assessment",
    "RevisionHistory": "Revision history",
    "Statistics": "statistics"
  },
  "Assessment.Controls": {
    "SaveAndNext": "Save and Next",
    "Unpublish": "Unpublish"
  },
  "Assessment.Gen.Topics": {
    "AllOption": "All"
  },
  "Assessment.Gen": {
    "AddQuestionBlock": "Add question block",
    "AddSection": "Add Section",
    "Available": "available",
    "BottomOfList": "Bottom of list",
    "Difficulty": "Difficulty",
    "DisplayQuestionsInRandomOrder": "Display questions in the question block in random order",
    "EmptySection": "Section is empty",
    "FillDragging": "Fill a block dragging the block footer down below some questions, or by dragging questions here",
    "Generate": "Generate",
    "GenerateAssessment": "Forms",
    "LearningObjectives": "Learning objectives",
    "NoRandomization": "no randomization",
    "NumberOfQuestions": "Number of questions in assessment",
    "NumberOfQuestionsHelper": "Enter the number of questions you want to generate",
    "OutOf": "out of",
    "Question": "Question",
    "Questions": "Questions",
    "Randomization": "randomization",
    "SendTo": "Send to",
    "Taxonomies": "Taxonomies",
    "Topic": "Topic",
    "TopOfList": "Top of list",
    "_Questions": "questions",
    "EditSection": "Edit Section",
    "CreateForm": "Add form",
    "AvailableScore": "Available score",
    "AddForm": "Add form",
    "InCollection": "In collection",
    "ScoreToSelect": "Score to select",
    "QuestionsToSelect": "Questions to select",
    "TitleInputLabel": "Title of the Form (required)",
    "AmountOfQuestionsTitle": "Amount of questions",
    "AmountOfQuestionsTip": "Select the amount of questions the form should contain out of the total available in the question pool.",
    "AssessmentTypeTip": "Fixed forms allows you to create forms that will be equal to all candidate. Random forms (Linear On the Fly Test) will randomly generate a form for each candidate.",
    "DifficultyMethod": "Difficulty method",
    "DifficultyMethodTip": "Allow you to select whether to use the P-value or Angoff value to define difficulty.",
    "DifficultyTip": "You can set a percentage of easy, medium and hard questions that this form will contain.<br /><br />When creating a form, the system uses the available items in each difficulty category, and then generates the form. If values are empty, the difficulty will not be taken into account.",
    "DifficultyAvailableQuestionsTip": "<b>{0}%</b> of questions are available.",
    "DifficultyMaxQuestions": "You don’t have enough {0} questions to create this form. You either need to have more easy questions in your library, or decrease the percentage to {1}%."
  },
  "Assessment.Generation": {
    "CannotPublishAssessment": "Assessment cannot be published. Please fill in all the necessary information.",
    "Difficulty": "Difficulty",
    "Discrimination": "Discrimination",
    "EasyItems": "Easy items",
    "EasyItemsDescription": "Facility value above 0.7",
    "EditSection": "Edit section",
    "EnterTheTitle": "Please enter a title of this assessment",
    "HardItems": "Hard items",
    "HardItemsDescription": "Facility value below 0.3",
    "HaveInvalidValues": "You have entered invalid values. The page can therefore not be saved. Please change this and try again",
    "MediumItems": "Medium items",
    "MediumItemsDescription": "Facility between 0.3 and 0.7",
    "PreviewQuestion": "Preview question",
    "PreviewSection": "Preview section",
    "QuestionBlock": "Question block",
    "RemoveQuestion": "Remove question",
    "RemoveSection": "Remove section",
    "TitleEmptyDeletionWarning": "You are about to leave this page.  You need to enter a title or the assessment will be deleted. Are you sure you want to continue?",
    "SectionMaxTimeLabel": "Max time (minutes)",
    "NdaPagesAreNotAllowed": "Assessment cannot be published. NDA pages are not allowed.",
    "EnterTheTitleAndSave": "Please enter and save a title of this assessment",
    "PreviewSet": "Preview set"
  },
  "Assessment.Info": {
    "Code": "Code",
    "CodeInfo": "Enter the code you want to give the assessment.",
    "CodePlaceholder": "Code",
    "ExternalIdInfo": "Enter the external id you want to give the assessment.",
    "ExternalIdPlaceholder": "External ID",
    "Finish": "Finish",
    "FinishInfo": "Enter the finish text the candidates will see when they submit their answers to the assessment.",
    "Information": "Information",
    "IntoductionInfo": "Enter the welcome text that the candidates will see when they log in to the assessment.",
    "Introduction": "Welcome",
    "NdaInfo": "Enter the NDA text candidates will see when logging in. Candidates needs to accept this in order to continue to take the assessment.",
    "QualificationInfo": "Select the qualification you want to associate with the assessment.",
    "QuestionSelectionType": "Question selection type",
    "RegFormInfo": "Select the registration form the candidates will need to fill in after completing test.",
    "SelectNda": "Select NDA",
    "SelectRegForm": "Select registration form",
    "Text": "Text",
    "Title": "Title",
    "TitleInfo": "Enter the title of the assessment.",
    "TitlePlaceholder": "Title of assessment",
    "UseNda": "Use NDA",
    "UseRegForm": "Use Registration form",
    "LockNotification": "This assessment is already being edited by {0}. Your co-author needs to exit this assessment in order for you to make changes.",
    "UpdateAssessmentNotification": "One or more items used in this assessment have been changed. Do you want to update the assessment to reflect these changes?",
    "MultipleFormsAlert": "A form is a variant of the assessment. You can create multiple forms and each form can be delivered randomly to your candidates.",
    "ScheduledBySearchFieldPlaceholder": "Search for hierarchies or clusters"
  },
  "Assessment.Opt": {
    "AssessmentScaleInfo": "Select how you want to grade this assessment",
    "AttemptCountsInfo": "Select which attempt counts.",
    "AttemptsInfo": "How many attempts do you want to give each candidate?",
    "CalculatorInfo": "Enables a web-based calculator to be used by the candidates during the assessment.",
    "CandidateExperience": "Candidate experience",
    "CorrectAnswer": "Correct answer",
    "Custom": "Custom",
    "CustomTimeComment": "In minutes.",
    "ExtraTime": "Extra time",
    "Feedback": "Feedback",
    "FeedbackOnAlternatives": "Feedback on alternatives",
    "FeedbackOnQuestions": "Feedback on questions",
    "HideOptionsFromSchedulerInfo": "Selecting this option will remove the options tab during scheduling. The scheduler will not be able to see the options.",
    "MaxTimePerAttempt": "Max time allowed for each attempt (minutes)",
    "NeverShowResultsInfo": "This option releases the results to the candidates when the assessor decides.",
    "NoFeedbackInfo": "The assessment will not show feedback to the candidates.",
    "NumberOfAttemptsAllowed": "Number of attempts allowed",
    "PartiallyCorrectAnswer": "Partially correct answer",
    "PenaltyDichotomous": "Dichotomous score for questions in assessments WITH penalty is not yet implemented.",
    "PercentageForPass": "Percentage for Pass mark",
    "ScoringRulesInfo": "Selecting this option will give negative score for each incorrect answer. ",
    "SelectAssessmentScale": "Please select assessment scale",
    "Settings": "Settings",
    "ShowOnlyTotalScore": "Show only total score",
    "ShowOptionsToSchedulerInfo": "Selecting this option will enable the scheduler to change the assessment options during scheduling of the assessment.",
    "ShowResultsAfterEveryAttemptInfo": "This allows the candidate to view the results after every attempt.",
    "ShowResultsAfterLastAttemptInfo": "This allows the candidate to view their results after the last attempt available to the candidate.",
    "TimeAllowedInfo": "Set the max time allowed for each attempt.",
    "Unlimited": "Unlimited",
    "WhichAttemptCounts": "Which attempt counts",
    "WrongAnswer": "Wrong answer",
    "Options": "Options",
    "CustomTimeCommentEmpty": "Empty = unlimited",
    "ExtraTimeInfo": "Extra time: set the extra time for candidates with special needs.",
    "WithoutExtraTime": "Select extra time",
    "ExtraTimeInMinutes": "Extra time (minutes)",
    "WhenAssessorDecidesWarning": "This option is not allowed for the \"Do not assign assessors\" marking workflow.",
    "NeverShowResults": "If you select this option the results will never shown for the candidates.",
    "MarkingScheme": "Show marking scheme",
    "SettingsTip": "Settings allows you to control the behaviour of the assessment",
    "DeliveryExperience": "Delivery experience",
    "DeliveryExperienceTip": "Settings related to candidate experience during the test delivery.",
    "ResultsTip": "Settings related to candidate results and automated feedback to candidates.",
    "Results": "Results",
    "OptionsTip": "Selecting this option will remove the options tab during scheduling. The scheduler will not be able to see the options.",
    "PlagiarismControlTip": "Plagiarism control automatically checks candidate responses for authenticity"
  },
  "Assessment.Options.Annotation": {
    "AnonymousCandidateDescription": "Candidates will be identified by a candidate number",
    "AnonymousCandidateTitle": "Anonymous candidate",
    "AnonymousExternalEvaluatorDescription": "External assessor will not be known to other assessors",
    "AnonymousExternalEvaluatorTitle": "Anonymous external assessor",
    "AnonymousInternalEvaluatorDescription": "Internal assessor will not be known to other assessors",
    "AnonymousInternalEvaluatorTitle": "Anonymous internal assessor",
    "SharingAnnotationsBetweenEvaluatorsDescription": "Assessors are able to see each others annotations",
    "SharingAnnotationsBetweenEvaluatorsTitle": "Share assessments between assessors"
  },
  "Assessment.Options.Feedback": {
    "NoFeedbackTitle": "No feedback",
    "OnAlternativesDescription": "Shows feedback after every alternative.",
    "OnAlternativesTitle": "On alternatives",
    "OnQuestionsDescription": "Shows feedback after every question.",
    "OnQuestionsTitle": "On questions",
    "MarkingSchemeDescription": "Selecting this option will allow the candidate to see the marking scheme",
    "AfterEachQuestion": "After each question",
    "OnResultPage": "On the results page"
  },
  "Assessment.Options.ManageAssessors": {
    "AssessorsChangeableBySchedulerTitle": "Allow assessors to be set by scheduler",
    "WhenToSetAssessors": "When to set assessors"
  },
  "Assessment.Options.Navigation": {
    "FreeNavigationDescription": "Allow free navigation",
    "FreeNavigationTitle": "Allow free navigation",
    "RandomOrderDescription": "Present the questions in a random order from candidate to candidate",
    "RandomOrderTitle": "Display questions in random order"
  },
  "Assessment.Options.ResultsDisplayTypes": {
    "AfterEachAttemptTitle": "After each attempt",
    "AfterLastAttemptTitle": "After last attempt",
    "DetailedDescription": "Shows the correct answer to each question",
    "DetailedTitle": "Detailed",
    "NeverTitle": "Never",
    "ScoreReportDescription": "Shows the subject achievement",
    "ScoreReportTitle": "Score report",
    "ShowOnlyTotalScoreDescription": "Candidates will see their total score, but not which questions are answered correct/incorrect.",
    "ShowOnlyTotalScoreTitle": "Show only total score",
    "SummaryDescription": "Shows the questions and whether the candidate answered (in)correctly.",
    "SummaryTitle": "Summary",
    "ResultsDisplayHint": "Shows the scores and the correct answers",
    "ShowOnlyStatus": "Show only passed / failed",
    "ReportWithObjectivesDescription": "Shows the learning objective achievement",
    "ReportWithObjectivesTitle": "Show learning objectives",
    "WhenAssessorDecides": "When assessor decides",
    "EmptySelect": "Please select",
    "ShowPointsForQuestionsTitle": "Show per question",
    "ShowPointsForQuestionsDescription": "Show max score during test delivery",
    "ShowResultsWidget": "Show summary metrics to candidates",
    "ShowWidgetsTip": "Summary metrics like score, percentage, max score, and a final score are shown",
    "ShowOnlyStatusTip": "'Passed' or 'Failed' outcome is shown, not scores",
    "PassFailOutcome": "Show Pass/Fail outcome",
    "WithSubjects": "With Subjects",
    "WithLearningObjectives": "With Learning Objectives",
    "WithTopics": "With Topics",
    "ReportWithTopicsDescription": "Shows the topic achievement",
    "ShowResultOutcome": "Show result outcome",
    "ShowPassingPercentage": "Show passing percentage",
    "ShowPassingPercentageDescription": "The minimum percentage required to pass the exam",
    "ShowGrade": "Show grade",
    "ShowGradeDescription": "The assessment scale (grade) the candidate achieved on the exam",
    "ShowSubject": "Show subject",
    "ShowTopics": "Show topics",
    "ShowScorePerQuestion": "Show score per question"
  },
  "Assessment.Options.Scoring": {
    "PenaltyForIncorrectAnswerDescription": "Give a penalty for incorrect or incomplete answers. Useful in exams and formal tests. The penalty may prevent participants from guessing.",
    "PenaltyForIncorrectAnswerTitle": "Penalty for incorrect answer"
  },
  "Assessment.Options.Sections": {
    "Annotation": "Annotation",
    "Attempts": "Attempts",
    "AvailableTools": "Available tools",
    "PassMarkCriteria": "Pass mark criteria",
    "QuestionNavigation": "Question navigation",
    "ScoringRules": "Scoring rules",
    "Security": "Security",
    "ShowCandidateResults": "Show candidate results",
    "Tools": "Tools",
    "UseFeedback": "Use feedback",
    "WhenToSetOptions": "When to set options",
    "Feedback": "Feedback",
    "AdjustPassMarkValue": "Adjust pass mark",
    "SecurityTip": "Select how you want to secure your assessment.",
    "ToolsTip": "Select which tools will be available for the candidates during delivery"
  },
  "Assessment.Options.Security": {
    "LockDownBrowserDescription": "For high stake assessments, lock-down mode is recommended. This ensures candidates cannot leave the assessment while in progress and other safety measures. *Do not use this when exam will be remotely proctored*.",
    "LockDownBrowserTitle": "Lock-down browser",
    "SafeExamBrowserTitle": "Require Safe Exam Browser",
    "UsePINDescription": "Use the PIN code to add an extra layer of security. Useful for high-stake assessments: candidates get this via their Proctor in order to start.\r\n*Do not use this when exam will be remotely proctored via ProctorU*.",
    "UsePINTitle": "Use PIN",
    "UseProctorIoDescription": "By checking this option, remote proctoring through Proctorio will be used for this assessment",
    "UseProctorIo": "Use Proctorio",
    "ProctorIo": "Proctorio",
    "Pincode": "Pincode"
  },
  "Assessment.Options": {
    "ChangeableBySchedulerTitle": "Allow options to be changed by scheduler",
    "HidingDuringSchedulingTitle": "Hide options during scheduling",
    "PercentageToPass": "Percentage to pass",
    "AdjustPassMarkValueTitle": "Adjust percentage to pass for chance score",
    "ExtraTimeInvalidMin": "Extra time should be number greater than 0",
    "ExtraTimeRequired": "Please enter Extra time",
    "MaxTimeAllowedForEachAttemptInvalidMin": "Max time allowed for each attempt should be number greater than 0",
    "MaxTimeAllowedForEachAttemptRequired": "Please enter Max time allowed for each attempt",
    "PercentageForPassMarkInvalidRange": "Percentage for Pass mark should be number between 0 and 100",
    "PercentageForPassMarkRequired": "Please enter Percentage for Pass mark",
    "AdjustPassMarkTip": "Adjusts percentage to pass and grade scale percentages using chance scores. To be used with dichotomous questions only.",
    "AdjustPassMarkActiveTip": "Be sure to understand more about how this works before using this with our dichotomous question types. Read more in our article \"score calculation when using adjust for chance score\" on our support site.",
    "AdjustPassMarkActiveTipLink": "Marking: how are scores calculated when using adjust for chance score",
    "PassGrade": "Pass grade",
    "Navigation": "Navigation",
    "DurationRequired": "Please select Duration",
    "WhichAttemptCountsRequired": "Please select Which attempt counts",
    "ShowCandidateResultsRequired": "Please select Show candidate results",
    "SelectOptionsWarning": "Please select options in the Results section",
    "EnterTime": "Enter time",
    "ResultAvailabilityDurationRequired": "Please enter Duration of the results",
    "AttemptDuration": "Attempt duration",
    "AvailableFor": "Available for",
    "ScoreReportAchievements": " Score report achievements",
    "SelectAttempt": "Select attempt",
    "ShowResultsLabel": "When to show results to candidates?",
    "NotDisplayOptions": "Do not display Options during scheduling",
    "ProfilePercentage": "Use percentage from candidates' profile",
    "NoReasonableAdjustment": "No extra time",
    "NoExtraTime": "No extra time"
  },
  "Assessment.Preview": {
    "AssessmentInformation": "Assessment information",
    "NotGenerated": "The assessment is not generated yet",
    "Random": "Randomisation of questions"
  },
  "Assessment.Qualifications": {
    "EmptyListText": "No qualification available"
  },
  "Assessment.Questions.Blueprint.Settings": {
    "GeneralSettings": "General settings",
    "ItemUsege": "Item usage",
    "ItemUsegePartOne": "Don't use items that have been used less than",
    "ItemUsegePartTwo": "times",
    "ItemUsegePartThree": "or more than",
    "SeedItemsDescription": "Forms should always contain the following percentage of seed items",
    "SeedItems": "Seed items",
    "SeedItemsLabel": "Leave empty if you're not using seed items",
    "AdvancedOptionsShow": "Show advanced options",
    "AdvancedOptionsHide": "Hide advanced options",
    "Difficulty": "Difficulty",
    "DifficultyDescription": "Each form should contain items with a difficulty between",
    "ItemTypesDescription": "Use the following form types",
    "BlueprintSettings": "Blueprint settings",
    "FixQuestionPoolOnPublish": "Fix question pool on publish",
    "SectionsAsOneItem": "Count section as one item"
  },
  "Assessment.Questions.Blueprint": {
    "NoLearningObjectives": "No learning objectives"
  },
  "Assessment.Questions": {
    "AvailableQuestions": "Available questions",
    "Created": "Added",
    "Difficulty": "Difficulty",
    "DoNotUseUsedItems": "Do not use items that has been used",
    "Hide": "Hide",
    "ItemPurpose": "Item purpose",
    "ItemsUsedPreviously": "Items used previously",
    "ItemTypes": "Item types",
    "LastModified": "Last Modified",
    "LearningObjective": "Learning objective",
    "LessThan": "Less than",
    "Max": "Max",
    "MaxScore": "Max score",
    "Min": "Min",
    "MoreThan": "More than",
    "NoQuestions": "No questions",
    "NotSet": "Not set",
    "NumberOfTimesUsed": "No. of times used",
    "Question": "Question",
    "QuestionType": "Question type",
    "ScoringRule": "Scoring rule",
    "SelectAndReorderColumns": "Select and reorder columns in this grid",
    "SelectAndReorderColumnsHint": "Check a column to select it, drag to change order.",
    "SelectedQuestions": "Selected questions",
    "SelectedScore": "Selected score",
    "SelectLearningObjectives": "Select learning objectives",
    "SelectLearningObjectivesToStartBuildingBlueprint": "To start building the blueprint, you first need to select one or more learning objectives. Click to select learning objectives and taxonomies.",
    "SelectTaxonomies": "Select taxonomies",
    "ShowAll": "Show all",
    "Status": "Status",
    "Subtotal": "Subtotal",
    "TaxonomiesEmptyListText": "No taxonomies available",
    "Taxonomy": "Taxonomy",
    "Total": "Total",
    "_Times": "times",
    "TableHint": "Remember: for a summative assessment you will only see summative items here, so be sure to set the correct item purpose. Similarly: for a formative assessment you will only see formative items here.",
    "LearningObjectives": "Learning objectives",
    "SelectQuestions": "You have selected {0} out of {0} available questions",
    "Score": "Score",
    "QuestionsNotRemoved": "The following questions were not excluded:",
    "UsedInForms": "{0} used in {1}",
    "TotalIncludedScore": "Total included score:",
    "TotalIncluded": "Total included:",
    "IncludedDisabledTip": "All selected items have been already included to the assessment",
    "ExcludedDisabledTip": "All selected items have been already excluded from the assessment",
    "NoTaxonomy": "No taxonomy",
    "SelectTopics": "Select topics",
    "SelectItemTypes": "Select item types",
    "SelectDifficulty": "Select difficulty"
  },
  "Assessment.QuestionSelectionType": {
    "BlueprintDescription": "Allows you to add questions based on a blueprint. The blueprint is defined during the question selection",
    "BlueprintTitle": "Blueprint",
    "ManualDescription": "Allows you to add questions manually during the question selection",
    "ManualTitle": "Manual question selection",
    "Manual": "Manual",
    "Blueprint": "Blueprint"
  },
  "Assessment.SectionDialog": {
    "AvailableQuestionsHeader": "Available questions",
    "CreatedHeader": "Added",
    "DragQuestionsHelper": "Drag questions to add them to the section",
    "LastModifiedHeader": "Last modified",
    "NoAvailableQuestions": "No available questions",
    "QuestionTypeHeader": "Question type",
    "Randomize": "Randomize",
    "SearchQuestionsPlaceholder": "Search questions"
  },
  "Assessment.Sidebar.Progress": {
    "Summary": "Assessment summary"
  },
  "Assessment.Sidebar.Sections": {
    "Assessment": "Assessment",
    "Details": "Details",
    "Preview": "Preview",
    "Progress": "Progress",
    "Share": "Share",
    "Sharing": "Sharing"
  },
  "Assessment.Sidebar": {
    "BackTo^^Draft": "Back to Draft",
    "Draft": "Draft",
    "EnterAssessmentCode": "Please enter an 'Assessment code'.",
    "EnterAssessmentTitle": "Please enter an 'Assessment Title'.",
    "EnterFinishText": "Finish Page Missing: One or more forms below is missing a Finish Page. Please click on the form/s and add the Finish Page under 'Finish' section",
    "EnterIntroductionText": "Welcome Page Missing: One or more forms below is missing a Welcome Page. Please click on the form/s and add the Welcome Page under 'Introduction' section",
    "GenerateAssessment": "Form Missing: Please add a 'Form' by clicking the 'Add Form' button. ",
    "NOfMActionsDone": "{0} of {1} actions done",
    "Publish": "Publish",
    "Published": "Published",
    "SelectAssessmentScale": "Assessment Scale Missing: One or more forms below is missing an assessment scale. Please click on the form/s, go to 'Option' tab and select an assessment scale under 'Settings'",
    "SelectLiveStatus": "Please change the 'Status' from 'Draft' to 'Live'.",
    "SelectPercentagePassMark": "Select percentage pass mark",
    "SelectQualifications": "Select qualification(s)",
    "SelectQuestionNavigation": "Select question navigation",
    "SelectQuestions": "Questions Missing: Select questions from the 'Question Selection' tab and click 'Add Selected' to add them to the Form.",
    "SelectScoringMethod": "Select scoring method",
    "Status": "Status",
    "SelectMarkingWorkflow": "Marking Workflow selection missing: Please select the choice between 'Simple' and 'Extended' workflow by clicking on radio button.",
    "AvailabilityIsNotValid": "Activation/Deactivation dates are not valid",
    "RemoveNonLiveQuestions": "Assessment can only have 'Live' questions to be able to Publish. Please check the 'Status' of the questions selected and change from 'Draft' to 'Live' in Library.",
    "NotEnoughQuestionsForRandomForm": "You don't have enough questions for a random form",
    "MatrixIsNotValid": "Blueprint is not valid: Please either change the values in the matrix or create more questions in the Library to make the Blueprint valid.",
    "RemoveHasNonLivePages": "Remove non-live pages",
    "RemoveHasNonLiveSections": "Remove non-live sections",
    "RemoveNonLivePages": "Assessment can only have 'Live' Pages to be able to Publish. Please check the 'Status' of the Page/s and change it from 'Draft' to 'Live' in Library.",
    "RemoveNonLiveSections": "Assessment can only have 'Live' Sections to be able to Publish. Please check the 'Status' of the Section and change it from 'Draft' to 'Live' in Library.",
    "SelectShowResults": "'Select when results should be shown' selection missing: Please indicate the choice by selecting a value from the dropdown. ",
    "SectionPassMarkIsNotValid": "Pass mark for one or more sections is not valid: Please either change the pass mark or adjust questions in the section to make Pass Mark valid.",
    "DifferentVersionsInForms": "Forms contain different versions of the same item. Please 'Update' versions of items to solve this.",
    "MatrixIsNotValid.WithLink": "Seems the blueprint is built incorrectly. {/}Please check{/} if the blueprint is valid before you create test form(s).",
    "SectionNumberOfRequiredQuestionsIsNotValid": "Number of question to answer for one or more sections is not valid: Please either change the option or add questions in the section to make it valid."
  },
  "Assessment.States": {
    "Active": "Active",
    "Archived": "Archived"
  },
  "Assessment.Statistic": {
    "Assessments": "Assessments",
    "AssessmentSummary": "Assessment summary",
    "AverageDifficulty": "Average difficulty: ",
    "AverageDiscrimination": "Average discrimination: ",
    "AverageScore": "Average score: ",
    "AverageTime": "Average time: ",
    "AvgScore": "Avg. score",
    "CandidatesNumber": "No. of candiates",
    "ChanceScore": "Chance score:",
    "Difficulty": "Difficulty",
    "DifficultyShort": "DF",
    "Discrimination": "Discrimination",
    "DiscriminationShort": "DS",
    "MaxScore": "Max. score",
    "MaxTotalScore": "Max total score:",
    "NumberOfTimesTaken": "No. of times taken",
    "NumberOfTimesTakenShort": "NTT",
    "PercentagePassed": "Percentage passed",
    "PercentageToPass": "Percentage to pass",
    "PsychometricData": "Psychometric data",
    "Question": "Question",
    "QuestionType": "Question type",
    "ReliabilityAlphaKR20": "Reliability Alpha/KR-20: ",
    "Statistics": "Statistics {0}",
    "Title": "{0} - Statistics",
    "TotalNumberOfQuestions": "Total no. of questions: "
  },
  "Assessment.Statuses": {
    "Archived": "Archived",
    "Draft": "Draft",
    "Live": "Live"
  },
  "Assessment.Steps": {
    "Blueprint": "blueprint",
    "GenerateAssessment": "forms",
    "Information": "information",
    "Options": "options",
    "QuestionSelection": "question selection",
    "QuestionSelectionTip": "Manual question selection gives you more control of which questions to select, while blueprint gives better control of which areas you want to test.",
    "Overview": "overview"
  },
  "Assessment": {
    "AssessmentType": "Assessment type",
    "CorrectFeedback": "Congratulations, you answered the question correctly",
    "FixedDescription": "Assessment will be generated in advance. All candidates will get the same set of questions.",
    "FixedTitle": "Fixed assessment",
    "PartiallyCorrectFeedback": "Almost, you got some of the answers correct",
    "Preview": "Assessment preview",
    "RandomDescription": "Assessment will be randomly generated when candidate starts the assessment. Each candidate will get a different set of questions.",
    "RandomGeneratedMessage": "Questions will be generated when candidate starts assessment",
    "RandomTitle": "Randomly generated assessment",
    "WrongFeedback": "Sorry, but you answered this question incorrectly",
    "NoMarkingDescription": "All your questions are automatically scored and you don't need to add assessors. Results can be viewed in Reports without publishing.",
    "ScalePerForm": "Scale per form",
    "PercentagePerForm": "Percentage per form",
    "MakeVersionCurrent": "Make this version current",
    "PassPercentageTip": "Adjusted percentage to pass: {0}",
    "MakeCurrentConfirmation": "Are you sure to make this version of assessment current?",
    "CreateVersion": "Create new version",
    "RevertToVersionConfirmation": "Are you sure you want to revert back to a previous version of this assessment? Existing schedules will always use the latest published version - if publishing is done up to 5 minutes before the start of the schedule.",
    "ViewVersionHistory": "View history",
    "FormsOverview": "Forms overview",
    "RevisionHistoryAssessment": "History - {0}",
    "StatisticsOverview": "Statistics overview",
    "Versions": "Versions",
    "WaitForRevision": "Please wait, a new version is being generated",
    "ItemsOverview": "Items overview",
    "DownloadAnswerForm": "Download answer form",
    "DownloadAnswerFormNotification": "Please wait while the answer form is being generated",
    "AwaitingGeneration": "Please wait while the assessment is being generated",
    "UpdateQuestionVersionsConfirmation": "Are you sure you want to Update the Assessment? Impact: Old forms will be deleted. New forms with new rules need to created for the assessment.",
    "StatusDescription": "Allows you to set the period of which this assessment can be scheduled.",
    "SettingsIntegration": "Integration",
    "SettingsIntegrationDescription": "Enable this if this assessment will be used in integrations so it gets an “External ID”. You can change the automatically generated external id here to match the id in your external system.",
    "EmptySectionsInSelectedQuestions": "Selected questions include an empty section. You need to either remove the section or add questions to the section in the library"
  },
  "AssessmentItem": {
    "QuestionBlock1": "Question block 1"
  },
  "AssessmentItemStatus": {
    "Archive": "Archive",
    "Draft": "Draft",
    "Live": "Live",
    "Published": "Published",
    "Undefined": "Undefined",
    "Unpublished": "Not published"
  },
  "AssessmentPublishedStatus": {
    "Published": "published",
    "Unpublished": "unpublished"
  },
  "AssessmentPurpose": {
    "Formative": "Formative",
    "Mixed": "Mixed",
    "Summative": "Summative"
  },
  "Assessments.Overview.Dialogs.Add": {
    "DescriptionFormative": "Allows you to create a formative assessment. Formative assessments are mainly for practice purpose. Choosing this assessment type limits your question selection to formative item type.",
    "DescriptionMixed": "Allows you to create a mixed assessment. This assessment type is a mix of formative and summative assessment. Choosing this assessment types enables you to select both formative and summative item types.",
    "DescriptionSummative": "Allows you to create a summative assessment. Summative assessments are high-stakes assessments like exams. Choosing this assessment type limits your question selection to summative only item type.",
    "PleaseSelect": "Please select assessment type.",
    "Title": "Add new assessment"
  },
  "Assessments.Overview": {
    "Action": "Action",
    "AddAssessment": "Add assessment",
    "AvailableTo": "Available to",
    "Code": "Code",
    "CreateCopy": "Create copy",
    "Created": "Created",
    "CreatedBy": "Created by",
    "LastEdited": "Last edited",
    "LastEditedBy": "Last edited by",
    "Modified": "Last Modified",
    "NoAssessments": "No assessments",
    "NoQualifiationsSelected": "No qualifications selected",
    "Published": "Published",
    "Qualifiations": "Qualifications",
    "QuestionSelection": "Question selection",
    "Role": "Role",
    "SelectHowToAssemble": "Select how you want to assemble the assessment",
    "SelectQualification": "Select qualification",
    "State": "State",
    "Status": "Status",
    "Title": "Title",
    "Type": "Type",
    "SearchPlaceholder": "Search for the name or ID of the assessment(s) you want to find...",
    "ShortSearchPlaceholder": "Search for the assessment name or ID...",
    "Forms": "Forms",
    "ModifiedBy": "Modified by",
    "NoFilteredItemsDesc": "Try to change the word or select <b>Archieved</b> or <b>Trashcan</b> option in the filter.",
    "ShowTrashcan": "Show assessments at Trashcan",
    "NoFilteredItems": "None of assessments matched to this search. ",
    "IntegrationId": "Integration ID",
    "SelectPurpose": "Select purpose",
    "SelectHierarchies": "Select hierarchies",
    "NoItems": "Click on Add item button to create your first assessment.",
    "SelectClusters": "Select clusters",
    "UnpublishedVersion": "Unpublished version",
    "Printable": "Printable",
    "PublishedVersion": "Published version",
    "SelectStatuses": "Select statuses"
  },
  "Assessments.Statistics": {
    "AverageDifficulty": "Average difficulty",
    "AverageDiscrimination": "Average discrimination",
    "AverageScore": "Average score",
    "Code": "Code",
    "HighestScore": "Highest score",
    "LowestScore": "Lowest score",
    "NoAssessments": "No assessments",
    "Qualification": "Qualification",
    "Title": "Title",
    "SearchPlaceholder": "Search for the name or ID of the assessment(s) you want to find..."
  },
  "Assessments.Tabs": {
    "AssessmentsOverview": "Assessments",
    "Statistics": "Statistics"
  },
  "Assessments": {
    "CirrusAssessment": "Cirrus assessment",
    "Exams": "Exams",
    "Overview": "Assessments",
    "OverviewTitle": "Assessments",
    "StartAssessment": "Start Assessment",
    "Statistics": "Statistics",
    "StatisticsTitle": "Assessment statistics",
    "UpcomingAssessments": "Upcoming assessments",
    "UpcomingPracticeTests": "Upcoming practice tests",
    "WelcomeToAssessment": "Welcome to \"{0}\"",
    "NoMarking": "Do not assign assessors",
    "AssessmentForm": "Assessment form",
    "VersionOverview": "Version overview",
    "VersionsOverview": "Versions overview",
    "ArchivedOverviewTitle": "Archived Assessments",
    "Details.AssessmentPurpose": "Assessment purpose",
    "Overview.LatestChanges": "Latest changes",
    "Overview.Steps": "Steps",
    "Overview.Feedback": "What would you like to see on this dashboard? Give us your",
    "Overview.NoChanges": "The latest notifications will be shown here. There are currently no notifications."
  },
  "AssessmentScale.Content": {
    "CannotDeleteAdd": "Assessment scale is used in exam(s). It is not possible to add or delete grades.",
    "DuplicateError": "Grades name and percentage cannot have the same values.",
    "EmptyFieldError": "Grades name and percentage cannot be empty.",
    "MissingZeroError": "\"Percentage from\" of one of the grades should be 0%.",
    "OverflowError": "Percentage cannot be more than 100.",
    "SuccessSave": "Assessment scale saved successfully.",
    "MinError": "Percentage cannot be less than 0.",
    "PassGradeRequired": "Please select pass grade"
  },
  "AssessmentType": {
    "Advanced": "Blueprint",
    "Regular": "Manual",
    "Underfined": "Undefined",
    "TestWizard": "Test wizard"
  },
  "AssessmentVolume": {
    "Average": "Average"
  },
  "AssessmentWorkflowStatus": {
    "Draft": "Draft",
    "Live": "Live"
  },
  "Assessors": {
    "Add": "Add",
    "Allocation": "Allocation",
    "Assessors": "Assessors",
    "AssignToAllCandidates": "Assign to all candidates",
    "CandidateId": "User ID",
    "CandidateIdNotSet": "Not Set",
    "CandidateName": "Candidate name",
    "NoCandidates": "No candidates",
    "Person": "Person",
    "Remove": "Remove",
    "Role": "Role",
    "StartTypingNameOfAssessor": "Start typing the name of user",
    "SaveAndNext": "Save and next step",
    "AssignToAllItems": "Assign to all items"
  },
  "Author.Login": {
    "AccountHasNotEmail": "This account has no email address! Contact your system administrator.",
    "BackToLogin": "Back to login",
    "ForgottenPassword": "Cirrus assessment - Forgotten password",
    "ForgottenPasswordRecoveryTitle": "Cirrus assessment - Forgotten password recovery",
    "NotValid": "Password is not valid",
    "PasswordReset": "Password Reset",
    "PasswordsDoNotMatch": "The passwords do not match!",
    "PasswordSuccessfullyChanged": "Your password has been successfully changed",
    "RecoveryEmailSent": "An email with recovery link has been sent to your email.",
    "RequestValidityExpired": "Validity of the request has expired!",
    "Reset": "Reset",
    "UsernameNotFound": "This username is not found!",
    "CantResetPassword": "Password can't be reset for this user"
  },
  "Author.Stepwise": {
    "Step": "Step {0}"
  },
  "Breadcrumbs": {
    "Home": "Home",
    "AssessMultiple": "Modify multiple"
  },
  "Candidate.States": {
    "HandedIn": "Handed in",
    "InProgress": "In progress",
    "NotActivated": "Not Activated",
    "Paused": "Paused",
    "Ready": "Ready"
  },
  "CandidateResults.DateFilter": {
    "IWouldLikeTo": "I would like to:",
    "LastXDays": "Last {0} days",
    "RunReports": "Run reports for the selected time periode"
  },
  "CandidateStatus": {
    "HandedIn": "Handed in",
    "InProgress": "In progress",
    "NotActivated": "Not Activated",
    "NotStarted": "Not started",
    "Paused": "Paused",
    "Ready": "Ready",
    "Void": "Void"
  },
  "ChangeTypes": {
    "AddQuestionCreated": "Add: question created",
    "AnswerChanged": "Answer changed",
    "BlankAdded": "Edit: Blank(s) added",
    "BlankChanged": "Edit: Blank(s) changed",
    "BlankRemoved": "Edit: Blank(s) removed",
    "ChoicesChanged": "Edit: Choice(s) changed",
    "EditAlternativeAdded": "Edit: Answer alternative(s) added",
    "EditAlternativeChanged": "Edit: alternative(s) changed",
    "EditAlternativeRemoved": "Edit: Answer alternative(s) removed",
    "EditAnswerAdded": "Edit: Answer(s) added",
    "EditAnswerChanged": "Edit: Answer(s) changed",
    "EditAnswerRemoved": "Edit: Answer(s) removed",
    "EditQuestionChanged": "Edit: question changed",
    "ExternalIdChanged": "External ID: changed",
    "FeedbackChanged": "Edit: Feedback(s) changed",
    "FileChanged": "File changed",
    "FileLoaded": "File loaded",
    "FileRemoved": "File removed",
    "HotspotAdded": "Edit: Hotspot area(s) added",
    "HotspotChanged": "Edit: Hotspot area(s) changed",
    "HotspotRemoved": "Edit: Hotspot area(s) removed",
    "LearningObjectiveChanged": "Learning objective: changed",
    "LearningObjectiveSelected": "Learning objective: selected",
    "MatchingPairAdded": "Edit: Matching pair(s) added",
    "MatchingPairChanged": "Edit: Matching pair(s) changed",
    "MatchingPairRemoved": "Edit: Matching pair(s) removed",
    "OptionsChanged": "Options changed",
    "Rollback": "Rolled back from revision {0}",
    "ScoreChanged": "Answer: Maximum score changed from {0} to {1}",
    "StatusChanged": "Status: changed from {0} to {1}",
    "TagsEdited": "Tags: changed",
    "TaxonomyAdded": "Taxonomy: selected",
    "TaxonomyChanged": "Taxonomy: changed",
    "TopicChanged": "Topic changed",
    "SeedChanged": "Edit: Is a seed item changed from '{0}' to '{1}'",
    "FunctionalIdChanged": "Item ID: changed",
    "CorrectFeedbackChanged": "Correct feedback text changed",
    "IncorrectFeedbackChanged": "Incorrect feedback text changed",
    "PartiallyCorrectFeedbackChanged": "Partially correct feedback text changed",
    "SourceFileIdChanged": "Resource file changed",
    "MediaFileIdChanged": "Media file changed",
    "IsAllowedToOpenInPopupChanged": "Possibility of opening media file in pop-up changed",
    "PaperBasedIntroductionTextChanged": "Paper-based introduction text has been changed",
    "OnScreenIntroductionTextChanged": "On-screen introduction text has been changed",
    "IsWorkoutAllowedChanged": "Notepad option has been changed",
    "SourceFilesChanged": "Resource files changed",
    "GeneralFeedbackChanged": "General feedback changed",
    "FeedbackTypeChanged": "Feedback type changed",
    "AudioIsPlaybackLimitedChanged": "Option \"Limit the number of playbacks\" has been changed",
    "AudioPlaybackLimitChanged": "Option \"Set the number of playbacks\" has been changed",
    "AudioDisablePausingAndRewinding": "Option \"Disable pausing and rewinding of audio\" has been changed",
    "AudioDisableNavigationOnPlaying": "Option \"Disable navigation while audio is playing\" has been changed",
    "FileResponseRationaleChanged": "Edit: Rationale input field enabled/disabled",
    "FileResponseRationaleRichEditorChanged": "Edit: Rationale rich-text editor option changed",
    "AngoffChanged": "Angoff changed",
    "SectionConnectedItemsChanged": "Connected items changed",
    "SectionItemIdChanged": "Connection to section changed",
    "DurationChanged": "Question duration changed",
    "ServerLimitsChanged": "Limits changed"
  },
  "CKEditor.Watermark": {
    "Choice": "Choice",
    "Match": "Match"
  },
  "CKEditor": {
    "BorderColorMode": "Border Color Mode",
    "BorderConfiguratingMode": "Border Configurating Mode",
    "BorderConfigurationMode": "Border Configuration Mode",
    "BorderConfiguringMode": "Border Configuring Mode",
    "BorderWidth": "Border Width",
    "BorderWidthValidation": "Border width should be a number.",
    "BottomBorderColor": "Bottom Border Color",
    "BottomBorderWidth": "Bottom Border Width",
    "LeftBorderColor": "Left Border Color",
    "LeftBorderWidth": "Left Border Width",
    "OneForAllSides": "For all sides",
    "OneForEachSide": "Per side",
    "RightBorderColor": "Right Border Color",
    "RightBorderWidth": "Right Border Width",
    "TopBorderColor": "Top Border Color",
    "TopBorderWidth": "Top Border Width"
  },
  "Collection.Statuses": {
    "Active": "Active",
    "Archived": "Archived"
  },
  "CollectionItem.Preview": {
    "Title": "Collection item preview",
    "YourScore": "Your Score: {0} of {1}"
  },
  "CollectionItemType": {
    "EitherOr": "Either/Or",
    "Equation": "Equation entry",
    "Essay": "Essay",
    "ExtendedMatch": "Extended match",
    "FileResponse": "File response",
    "FillInTheBlankGap": "Select from list",
    "FillInTheBlankText": "Fill in the blank",
    "Hotspot": "Hotspot",
    "Match": "Match",
    "MultipleChoice": "Multiple choice",
    "MultipleResponse": "Multiple response",
    "Numeric": "Numeric",
    "Order": "Order",
    "Section": "Section",
    "SelectFromTheList": "Select from list",
    "ShortAnswer": "Short answer",
    "Sowiso": "Mathematical question",
    "Undefined": "Undefined",
    "Page": "Page",
    "AssessmentPage": "Page",
    "DragAndDrop": "Drag and drop",
    "FinancialStatement": "Financial statement",
    "ExtendedMultipleChoice": "Extended multiple choice",
    "ComprehensiveIntegratedPuzzle": "Comprehensive Integrated Puzzle",
    "Programming": "Programming"
  },
  "CollectionItemTypes": {
    "EitherOr": "Either/Or",
    "Equation": "Equation entry",
    "Essay": "Essay",
    "FileResponse": "File response",
    "FillInTheBlankGap": "Select from list",
    "FillInTheBlankText": "Fill in the blank",
    "Hotspot": "Hotspot",
    "Match": "Match",
    "MultipleChoice": "Multiple choice",
    "MultipleResponse": "Multiple response",
    "Numeric": "Numeric",
    "Order": "Order",
    "SelectFromTheList": "Select from list",
    "ShortAnswer": "Short answer",
    "Sowiso": "Mathematical question",
    "Undefined": "Undefined"
  },
  "Common.Sowiso": {
    "Correct": "Correct",
    "Correctanswer": "Correct answer",
    "Fine": "Fine",
    "Greatjob": "Great job",
    "Okay": "Okay",
    "Welldone": "Well done",
    "Wrong": "Wrong"
  },
  "Common": {
    "Import": "Import",
    "OngoingSchedulesWontBeDeleted": "Ongoing schedules won't be deleted",
    "ScheduleDeleteConfirmation": "Are you sure you want to delete this schedule \"<b>{0}</b>\"?",
    "SchedulesDeletionConfirmation": "Are you sure you want to delete <b>{0}</b> schedules?",
    "TryImport": "Try import"
  },
  "Dashboard.Notifications": {
    "": "Notifications"
  },
  "Dashboard": {
    "AddAssessment": "Add assessment",
    "AddCollection": "Add collection",
    "Assessed": "Assessed",
    "Assessments": "Assessments",
    "AverageScore": "Average score",
    "BackToDashboard": "Back to dashboard",
    "Collections": "Collections",
    "CreatedBy": "Created by",
    "CreatedBySimple": "by:",
    "Delivered": "Delivered",
    "Delivering": "Delivering",
    "Deliverings": "Deliverings",
    "Duration": "Duration",
    "HighestScore": "Highest score",
    "LastEdited": "Last edited",
    "LowestScore": "Lowest score",
    "MaxScore": "Max score",
    "NoActivatedAssessment": "No activated assessment",
    "NoScheduledAssessmentsYet": "You don't have scheduled assessments yet",
    "NotAssessed": "Not assessed",
    "Notifications": "Notifications",
    "NotMarked": "Not Marked",
    "NumberOfPassedCandidates": "No. of passed candidates",
    "NumberOfQuestions": "No. of questions",
    "Scheduled": "Scheduled",
    "SearchDashboard": "Search dashboard",
    "ShowAll": "Show All",
    "ThereAreNoAssessments": "There are no assessments",
    "ThereAreNoCollections": "There are no notification about collections for you at the moment",
    "ThereAreNoNotifications": "There are no notifications",
    "ThereAreNoScheduledAssessments": "There are no scheduled assessments",
    "Title": "Title",
    "ToProfile": "To profile",
    "TotalNumberOf": "Total number of",
    "WelcomeBack": "Welcome back",
    "LoginAsNotifications": "Login as notifications",
    "ThereAreNoLoginAsNotifications": "There are no notification about login-as for you at the moment"
  },
  "DefaultData.Roles": {
    "Author": "Author",
    "CoAuthor": "Co-Author",
    "Reviewer": "Reviewer"
  },
  "DefaultData.SiteRoles": {
    "Administrator": "Administrator",
    "Author": "Author",
    "Candidate": "Candidate",
    "SystemAdministrator": "System administrator"
  },
  "Delete.Confirmation": {
    "SchedulesInProgressWontBeDeleted": "Schedules currently in progress shouldn't be deleted"
  },
  "DeletionConfirmation": {
    "TemplateQuestion": "Are you sure you want to delete this question \"{0}\"?",
    "TemplateQuestions": "Are you sure you want to delete {0} questions?",
    "AssessmentPage": "Are you sure you want to delete this page {0}?",
    "AssessmentPages": "Are you sure you want to delete this {0} pages?",
    "AssessmentPagesTitle": "Remove page(s)",
    "QuestionComment": "Delete comment",
    "QuestionCommentText": "Do you really want to delete this comment?",
    "QuestionCommentsText": "You are going to remove comment with related comments. Are you sure you want to continue?",
    "Webhooks": "Delete webhooks",
    "WebhooksText": "Do you really want to delete these webhooks?"
  },
  "Delivering.Invigilation": {
    "ActionIsNotAllowed": "The action cannot be executed for {0} candidates.",
    "Actions": "Actions",
    "All": "All",
    "Assessment": "Assessment",
    "AssessmentAnswerForm": "Assessment answer form",
    "AssessmentName": "Assessment Name",
    "Attempt": "Attempt",
    "AttendenceRegister": "Attendence register",
    "CandidateId": "User ID",
    "CandidateName": "Candidate name",
    "CandidateNumber": "Candidate number",
    "Candidates": "Candidates",
    "CirrusPlatform": "Cirrus platform",
    "Comment": "Comment:",
    "Correct": "correct",
    "Date": "Date",
    "DateWithColon": "Date:",
    "Declaration": "Declaration:",
    "DeclarationText": "I declare that the information provided is accurate",
    "DeliveringInvigilation": "Delivering: Proctoring",
    "DetailsPageTitle": "Proctoring - {0}",
    "Duration": "Duration",
    "EndDate": "End date",
    "EndTime": "End time",
    "ExtraTime": "Extra time",
    "ExtraTimeWithColon": "Extra time:",
    "GeneratePINCode": "Generate PIN code",
    "GiveExtraTime": "Give extra time",
    "HandedIn": "Handed in",
    "Hierarchy": "Hierarchy",
    "Incorrect": "incorrect",
    "InProgress": "In progress",
    "Instructions": "Instructions",
    "InvigilationDetails": "Proctoring details",
    "InvigilationTitle": "Proctoring - {0}",
    "LoggedIn": "Logged in",
    "Name": "Name",
    "NameWithColon": "Name:",
    "NoActions": "No actions",
    "NoCandidates": "No candidates",
    "NotSet": "Not set",
    "OverviewPageTitle": "Delivering",
    "Page": "Page",
    "Pause": "Pause",
    "Paused": "Paused",
    "PauseStart": "Pause/Start",
    "PINCode": "PIN code",
    "Present": "Present",
    "Print": "Print",
    "PrintCandidateList": "Print candidate list",
    "PrintLoginCredentials": "Print login credentials",
    "QuestionsSamePage": "Questions: same page",
    "QuestionsSeparatePage": "Questions: separate page",
    "Ready": "Ready",
    "SetForAllCandidates": "Set for all candidates",
    "Signature": "Signature:",
    "Start": "Start",
    "StartDate": "Start date",
    "StartTime": "Start time",
    "Status": "Status",
    "TimeLeft": "Deadline",
    "Timestamp": "Timestamp",
    "UserLog": "User log",
    "Void": "Void",
    "ConfirmPauseExam": "Are you sure you want to pause exam for the selected candidates?",
    "VoidConfirmation": "Are you sure? This action cannot be undone.",
    "NoConnectionMessage": "There is {0} candidate without internet connection.",
    "NoConnectionMessagePlural": "There are {0} candidates without internet connection or who navigated away.",
    "TimeSpent": "Time spent",
    "LogType": "Action",
    "QuestionNumber": "Question number",
    "ItemId": "Item ID",
    "Error": "Error",
    "Browser": "Browser",
    "IpAddress": "IP address",
    "Refresh": "Refresh",
    "SubmittedBy": "Submitted by",
    "NotHavePermissionsForActions": "You are not a proctor. You cannot make changes to the scheduled assessment. ",
    "ExtraTimeForCurrentAttempt": "Extra time for current attempt",
    "ExtraTimeForNextAttempt": "Extra time for next attempt",
    "SendMessage": "Message",
    "NewMessage": "New message",
    "MessageHint": "Not all candidates have \"In progress\" attempt  status. Message will be sent to candidates with attempt status \"In progress\"",
    "PrintKeycodeSlips": "Print Keycode Slips",
    "KeycodeDisabledTip": "Please ask your system admin to enable this feature.",
    "PrintKeycodes": "Print keycodes",
    "PauseExam": "Pause exam",
    "VoidAttempt": "Void attempt",
    "ResumeExam": "Resume exam",
    "Resume": "Resume",
    "GiveExtraTimeHandedInOrVoidedDesc": "{0} of {1} selected exams were {3} or {4}.<br><br>Extra time will be added to the attempt to {2} of {1} candidates.",
    "VoidExam": "Void exam",
    "PrintKeycodesSingle": "One keycode per page",
    "PrintKeycodesDescription": "One keycode per page is intended for slips that are handed out to candidates, while multiple keycodes per page is intended for administrative staff.",
    "GiveExtraTimeAdditionalDesc": "If candidate has extra attempt, extra time will be given to next attempt if the previous attempt was handed in or voided.",
    "PrintKeycodesMultiple": "Multiple keycode per page",
    "GiveExtraTimeDesc": "Extra time will be added to the attempt of the {0} selected candidates.",
    "GiveExtraTimeHandedInOrVoidedDescAll": "Extra time is not applied to {0} and {1} exams.",
    "GiveExtraTimeDisabledTooltip": "Extra time can not be added because the attempt duration equals to the schedule duration.",
    "ExraTimeAddedSuccessfull": "{0} mins was added"
  },
  "Delivering.Schedule.Dialogs.Add": {
    "NoAssessments": "No assessments to schedule",
    "Qualification": "Qualification",
    "SelectAssessmentDescription": "Search for and select the assessment you want to schedule.",
    "Selected": "Selected",
    "StartTyping": "Start typing the name of the assessment",
    "Title": "Schedule new assessment",
    "Type": "Type",
    "Search": "Search for the assessment you want to schedule",
    "DialogTitle": "Add new schedule",
    "SelectAssessment": "Select assessment",
    "SearchDescription": "Select assessment",
    "Confirm": "Schedule",
    "Cancel": "Cancel",
    "TableColumnTitle": "Title",
    "Code": "Code",
    "Version": "Version",
    "LastModified": "Last modified",
    "Author": "Author",
    "SearchPlaceholder": "Search",
    "EnterTitle": "You have to first enter a title before you can enable Integrations.",
    "IntegrationDescription": "Will this assessment be used for integrations?",
    "ScheduleWindow": "Schedule window",
    "ScheduleDescription": "The schedule window is the time-frame when the assessment can be started and finished by the candidates.",
    "KeycodeDescription": "Using a unique keycode will allow candidates to directly enter the assessment without using a username and password. It's advised that you look at the knowledge base before using this functionality."
  },
  "Delivering.Schedule": {
    "OverviewPageTitle": "Delivering",
    "ScheduleAssessment": "Schedule",
    "ScheduleTitle": "Are you ready to schedule this assessment?",
    "Notifications": "Notifications",
    "Todo": "To do",
    "TodoEmpty": "You are all set and can schedule the assessment",
    "UnscheduleAssessment": "Unschedule",
    "EnterAssessment": "Select assessment",
    "EnterScheduleTitle": "Set the title",
    "EnterHierarchy": "Select hierarchy",
    "EnterTerm": "Set assessment start and end date (Max schedule duration: 2 years)",
    "EnterPassMark": "Enter percentage pass mark",
    "EnterAssessmentScale": "Select assessment scale",
    "EnterCandidates": "Add candidates",
    "EnterUserIds": "Set user IDs",
    "EnterPinCode": "Generate PIN code",
    "EditScheduleAssessment": "Edit schedule settings",
    "ActiveStartEndDates": "Assessment start and end dates must be set in the time frame in which assessment is active",
    "InvalidShowResults": "You have invalid option \"Show candidate results\" for current assessment",
    "Search": "Search for the title or ID you want to find...",
    "ArchivedOverviewPageTitle": "Archived Delivering",
    "PublishAssessment": "Assessment must be published",
    "EnterStartEndDateWithDuration": "Set assessment start and end date (Attempt duration: {0} minutes, Max schedule duration: 2 years)",
    "ShortSearchPlaceholder": "Search for the assessment...",
    "EnterExternalId": "Enter External ID",
    "ScheduleTitleTip": "By activating the schedule you are making it available for your candidates (within the time-window). ",
    "InformUsers": "Inform Users",
    "InformUsersTip": "By selecting these options, you will inform the candidates and/or invigilators about the scheduled assessment.",
    "Options": "Assessment options",
    "OptionsHeader": "Below is a list of options set for this assessment",
    "OptionsTip": "These options have been set by the assessment author. ",
    "ShowMaxScore": "Show max score per question",
    "NoFilteredItems": "None of available schedules matched this search",
    "NoResultsText": "Click on Add schedule to set up an assessment to be delivered to your candidates.",
    "SetPinText": "You can set up PIN code that is being used in conjunction with the test. This is a good way to prevent outsiders accessing the test.",
    "SetPinDescription": "The pin code is normally released to the candidates by the invigilator.",
    "AddScheduleButton": "Add schedule"
  },
  "Delivering.Shcedule": {
    "Title": "Schedule title"
  },
  "Delivering.Sidebar": {
    "Archived": "Archived"
  },
  "Delivering.Terms": {
    "EmptyListText": "No terms available"
  },
  "Delivering": {
    "Assessment": "Assessment",
    "AssessmentCode": "Code",
    "AssessmentEnd": "Assessment end",
    "AssessmentStart": "Assessment start",
    "AssessmentTitle": "Assessment title",
    "CandidatesInformed": "Candidates notified {0}",
    "CandidatesNotInformed": "Candidates not notified",
    "Code": "Code",
    "CreateCopy": "Create copy",
    "Duration": "Duration",
    "Ending": "Ending",
    "EvaluatorsInformed": "Assessors notified {0}",
    "EvaluatorsNotInformed": "Assessors not notified",
    "Invigilation": "Proctoring",
    "Invigilator": "Invigilator",
    "InvigilatorsInformed": "Proctors notified {0}",
    "InvigilatorsNotInformed": "Proctors not notified",
    "LastModified": "Last modified",
    "NoScheduledAssessments": "No scheduled assessments",
    "Notifications": "Notifications",
    "Qualifications": "Qualification",
    "Schedule": "Schedule",
    "ScheduleAssessment": "Schedule assessment",
    "ScheduledBy": "Scheduled by",
    "SelectTimeZone": "Select time zone",
    "Starting": "Starting",
    "Status": "Status",
    "Term": "Term",
    "Title": "Title",
    "AssessmentVersion": "Version",
    "EndDateInvalid": "The end date of the schedule is invalid.",
    "StartDateInvalid": "The start date of the schedule is invalid.",
    "ExternalId": "External ID",
    "NumberOfCandidates": "Candidates",
    "NumberOfGeneratedAttempts": "Generated",
    "NumberOfStartedAttempts": "Started",
    "NumberOfFinishedAttempts": "Finished",
    "SharedWith": "Shared with"
  },
  "Delivery.Accessibility.ColorThemes": {
    "BlackWithCremeText": "Black with creme text",
    "BlackWithCyanText": "Black with cyan text",
    "BlackWithGreenText": "Black with green text",
    "BlackWithMagentaText": "Black with magenta text",
    "BlackWithPurpleText": "Black with purple text",
    "BlackWithWhiteText": "Black with white text",
    "CremeWithBlackText": "Creme with black text",
    "Default": "Default",
    "WhiteWithBlackText": "White with Black text"
  },
  "Delivery.Accessibility": {
    "SelectColorTheme": "Select color theme"
  },
  "Delivery.ActionButtons": {
    "CompleteTest": "Complete assessment",
    "Flag": "Flag",
    "Introduction": "Introduction",
    "Overview": "Overview",
    "SourceFile": "Resource",
    "SourceFiles": "Resources",
    "NavigationConfirmation": "Are you sure you want to navigate further, away from this question? You can’t go back to the current question"
  },
  "Delivery.Assessments.Editor": {
    "AnsweredAndFlaggedQuestions": "You have answered {0} out of {1} questions and you have flagged {2} question(s)",
    "FileSubmittedCount": "and you have submitted {0} out of {1} files"
  },
  "Delivery.Clock": {
    "TimeRemaining": "Time remaining"
  },
  "Delivery.CompleteTestConfirm": {
    "CompletionConfirmation": "Are you sure you want to complete the test?",
    "EnterPINCode": "Enter PIN code",
    "FinishingConfirmation": "Are you sure you want to finish?",
    "PINCode": "PIN code",
    "SkippingQuestionConfirmation": "You didn't answer this question. Are you sure you want to go to the next question?",
    "WarningAboutFinishing": "If you click on Finish, your answer(s) will be submitted and you will not be able to return to the assessment",
    "WarningAboutSkippingQuestion": "You won't be able to return to this question."
  },
  "Delivery.EnterPINCode": {
    "EnterPINCode": "Enter PIN Code"
  },
  "Delivery.Error": {
    "ErrorOccured": "Error occured",
    "ErrorWithIdOccured": "An error has occured. Error id: {0}",
    "ReadFAQ": "Read the faq",
    "ReCheckUrl": "Re-check the url for typos",
    "TellAboutError": "Tell us about it",
    "UnexpectedError": "Unexpected Error"
  },
  "Delivery.Exam.Sowiso": {
    "Proceed": "Proceed without saving",
    "SowisoDialogCheckConfirm": "You're leaving the question page without saving your answer.  Please click 'Cancel' and save your answer first by clicking the \"Check\" button under the answer field or proceed without saving.",
    "SowisoDialogIncorrectInputConfirm": "There are input errors in your answer. Your answer has not been saved."
  },
  "Delivery.Exam": {
    "ConnectionLostMessage": "There is a problem with the connection. Do not leave the page and do not press F5. Trying to reconnect...",
    "ExtraTimeGiven": "You have {0} minute(s) more",
    "FinalizingExamMessage": "Finalizing the exam...",
    "FinalizingExamWarning": "Please wait. Do not leave the page and do not press F5",
    "OnBeforeUnloadText": "You have attempted to leave this page in an inccorect way. You will be logged out and might lose your answers.",
    "PausedExamMessage": "Your exam was paused by the invigilator!",
    "StoppedExamMessage": "Your exam was stopped by the invigilator!",
    "NotAllRequiredQuestionsAreAnswered": "Not all required questions are answered in the section you left.",
    "ReadModeTooltip": "In order to navigate you need to turn off 'listen-mode' by setting this option to Off",
    "ReadModeTooltipOn": "In order to navigate you need to turn off 'listen-mode' by setting this option to Off",
    "ReadModeTooltipOff": "In order to use Readspeaker you need to turn on 'listen-mode' by setting this option to On",
    "AnswerBytesSizeExceeded": "Your answer is over 200kb and could not be saved"
  },
  "Delivery.Exams.Calculator": {
    "AddToMemory": "Add to memory",
    "ClearMemory": "Clear the memory",
    "CloseCalculator": "Close the calculator",
    "EraseLastDigit": "Erase the last digit",
    "EraseLastNumber": "Erase the last number",
    "EraseValue": "Erase the value from the field",
    "OpenCalculator": "Open the calculator",
    "RecallValueFromMemory": "Recall the value from memory",
    "ResetCalculator": "Reset the calculator",
    "StoreValueMemory": "Store the value in memory",
    "SubtractFromMemory": "Subtract from memory",
    "SwitchToBinary": "Switch to binary",
    "SwitchToDecimal": "Switch to decimal",
    "SwitchToDegrees": "Switch to degrees",
    "SwitchToHexadecimal": "Switch to hexadecimal",
    "SwitchToOctal": "Switch to octal",
    "SwitchToRadians": "Switch to radians",
    "Title": "Calculator",
    "UseCurrentValue": "Use the current value"
  },
  "Delivery.Info": {
    "Welcome": "Welcome, {0}",
    "BrowserApproved": "Your browser has been approved.",
    "BrowserNotApproved": "Your browser has not been approved. Please update your browser or contact your system administrator.",
    "ImageServerIsNotAvailable": "Image server is not available. You will not be able to view images during exam. Please contact your system administrator."
  },
  "Delivery.Login": {
    "Description": "Log in with the Cirrus platform",
    "LoginDescription": "Log in to the Cirrus platform",
    "LoginTitle": "Cirrus assessment - Login"
  },
  "Delivery.Nda": {
    "Accept": "Yes, I accept",
    "Candidate": "Candidate",
    "CandidateId": "User ID",
    "Date": "Date",
    "Decline": "No, I do not accept",
    "DeclineConfirmText": "Click 'Exit exam' if you choose not to accept the terms and conditions as set forward. You will then exit the exam and forfeit this attempt.\r\n\r\nClick 'Return to exam' to return to the previous page.",
    "DeclineDescription": "Your organization requires that all exam candidates review and accept its Candidate Agreement prior to taking a certification exam.",
    "DeclineDescription2": "Please note that exam fees for candidates are not refundable.",
    "DeclinedHeader": "Results",
    "DeclinePagePrintReminder": "In order to retain this page, the candidate must Print this page now. There will not be a means to retrieve it later. The Print button is in the upper right hand corner of this page.",
    "Exam": "Exam",
    "ExamHeaderPostfix": "score report",
    "IncorrectObjectivesDescription": "You incorrectly answered one or more questions in the following objective areas:",
    "PassFail": "Pass/fail",
    "PassingScore": "Passing score",
    "ScoreReportPrintReminder": "In order to retain this Score Report, the candidate must Print this page now.  There will not be a means to retrieve it later.  The Print button is in the upper right hand corner of this page.  ",
    "ExitExam": "Exit exam",
    "ReturnToExam": "Return to exam"
  },
  "Delivery.ScoreReport": {
    "CandidateScore": "Candidate score",
    "Fail": "Fail",
    "Pass": "Pass",
    "AssessmentName": "Assessment name",
    "AssessmentOutcome": "Assessment outcome",
    "ContainsNotScoredHumanMarkedWarning": "This assessment contains questions that needs manual scoring. The result only shows the automatically scored questions.",
    "DateFinished": "Date finished",
    "DoesNotMeet": "Does not meet",
    "LearningObjective": "Learning objective",
    "Mastered": "Mastered",
    "Meets": "Meets",
    "NoLearningObjectives": "No Learning objectives",
    "NotAnswered": "Not answered",
    "PartiallyMeets": "Partially meets",
    "PercentageScore": "Percentage score",
    "Subject": "Subject",
    "MaxScore": "Max score",
    "PassPercentage": "Percentage for Pass mark",
    "AwaitingScoring": "Awaiting scoring",
    "UnScoredQuestionsAreNotCounted": "Questions that have not been scored yet are not counted for your mastery level yet. Final scores and results are determined by your exam supplier.",
    "NoTopics": "No Topics"
  },
  "Delivery.Notifications": {
    "AssessmentNotStarted": "Please wait until assessment is started. The exam will start automatically.",
    "AssessmentTimeout": "The deadline for this assessment has passed.",
    "AttemptNotReady": "Please wait while your attempt is being generated. The exam will start automatically.",
    "BrowserIsRegular": "You can start this assessment only using <b>Safe Exam Browser</b>. Please check if you're using the correct version and configuration or contact your system administrator.",
    "BrowserNotCompatible": "You can't start this assessment with this browser.",
    "NoAttempsLeft": "No attempts left for this assessment.",
    "ResultsBrowserIsRegular": "You can view these results only using <b>Safe Exam Browser</b>. Please check if you're using the correct version and configuration or contact your system administrator.",
    "MessageFromInvigilator": "You have new message(s) from Proctor",
    "NoAttemptsLeft": "No attempts left for this assessment.",
    "ReadSpeakerNotAvailable": "ReadSpeaker doesn't available for this language"
  },
  "Delivery.PinCodeConfirm": {
    "EnterPINCode": "Enter PIN code",
    "EnterYourPINCode": "Enter your PIN code",
    "PINCode": "PIN code",
    "ShowPIN": "Show PIN code",
    "WrongPINCode": "Wrong PIN code!",
    "ShowPINTitle": "Show the password as plain text (not advisable in a public place)"
  },
  "Delivery.Results.PieChart": {
    "Correct": "Correct",
    "NotAnswered": "Not answered",
    "NotMarked": "Manually scored",
    "PartiallyCorrect": "Partially correct",
    "Wrong": "Wrong"
  },
  "Delivery.Results": {
    "AverageScore": "Average score",
    "Correct": "Correct",
    "CorrectAnswer": "Correct answer",
    "CorrectNotAnswered": "Correct - not answered",
    "Incorrect": "Incorrect",
    "MaxScore": "Max score",
    "NoAnswers": "No answers",
    "NotMarked": "Manually scored",
    "PartiallyCorrect": "Partially correct",
    "PercentageGained": "Percentage gained",
    "PercentageRequired": "Percentage required",
    "PercentageScore": "Percentage Score",
    "Score": "Score",
    "SubmittedAnswer": "Submitted answer",
    "TotalScore": "Total score",
    "WrongOrMissing": "Wrong or missing",
    "YourScore": "Your score",
    "ContainsNotScoredHumanMarkedWarning": "This assessment contains questions that needs manual scoring. The result only shows the automatically scored questions.",
    "AssessmentName": "Assessment name",
    "DateFinished": "Date finished",
    "ResultsFor": "Results for {0}",
    "YouDidNotPass": "Unfortunately, you didn’t pass.",
    "YouHavePassed": "Well done. You have passed.",
    "PercentageCorrect": "Percentage Correct",
    "EnterPinCode": "Enter PIN Code",
    "EnterYourPinCode": "Enter your PIN code",
    "PinCode": "PIN code",
    "PinCodeIsNotCorrect": "PIN code is not correct",
    "PleaseEnterPinCode": "Please enter PIN code",
    "NotRequiredQuestion": "Not required to be answered",
    "ShowOnlyStatus.Failed": "Your result: Failed",
    "ShowOnlyStatus.Passed": "Your result: Passed",
    "RowNumber": "Row number"
  },
  "Delivery.Timer": {
    "Minutes": "minutes",
    "Seconds": "seconds",
    "TimeRemaining": "{0} time remaining"
  },
  "Delivery": {
    "AnsweredQuestions": "Answered questions",
    "Assessment": "Assessment",
    "AssessmentDeadline": "Assessment deadline",
    "AssessmentForBy": "Assessment for {0} by {1}",
    "AssessmentIntroduction": "Assessment introduction",
    "AssessmentStart": "Assessment start",
    "AssessmentTitle": "Assessment title",
    "Attempt": "Attempt",
    "CalculatingResults": "Calculating results...",
    "CandidateId": "User ID",
    "CandidateNumber": "Candidate number",
    "Close": "Close",
    "ContinueAssessment": "Continue Assessment",
    "ContinueTest": "Continue test",
    "Duration": "Duration",
    "ExamWasPaused": "Your exam was paused by the invigilator!",
    "Feedback": "Feedback",
    "Flagged": "Flagged",
    "FlaggedQuestions": "Flagged questions",
    "FlagQuestion": "Flag question",
    "HandwrittenInput": "Handwritten input",
    "KeyboardInput": "Keyboard input",
    "Mandatory": "Mandatory",
    "NextQuestion": "Next question",
    "NoAnswers": "No answers given",
    "NotAnsweredQuestions": "Not answered questions",
    "NoUpcomingAssessments": "No upcoming assessments",
    "NumberOfAttempts": "Number of attempts",
    "NumberOfQuestions": "Number of questions",
    "PercentageOfPass": "Percentage to pass",
    "PrevQuestion": "Previous question",
    "QuestionOf": "Question {0} of {1}",
    "QuestionOverview": "Question overview",
    "RemainingTime": "Remaining time",
    "RestoreAnswer": "Restore answer",
    "RestoreSelected": "Restore this",
    "ResultsPreview": "Results preview",
    "StartAssessment": "Start Assessment",
    "StillToDo": "Still to do",
    "SuggestionEitherOr": "Select the correct answer",
    "SuggestionEssay": "Fill in your answer",
    "SuggestionExtMatch": "Drag lines between the boxes to match the answers",
    "SuggestionFileResponse": "Select your file answer",
    "SuggestionFillInTheBlank": "Fill in the blank(s)",
    "SuggestionHotspot": "Click on the hotspot(s)",
    "SuggestionMarkup": "Fill in the answer",
    "SuggestionMatch": "Drag the boxes to match the correct answers",
    "SuggestionMath": "Fill in the missing value(s)",
    "SuggestionMC": "Select the correct answer",
    "SuggestionMR": "Select  the  correct answer(s)",
    "SuggestionNumeric": "Fill in the missing value",
    "SuggestionOrder": "Drag the following in the correct order",
    "SuggestionProfitAndLoss": "Fill in the answer",
    "SuggestionResultsBudget": "Fill in your answer",
    "SuggestionSection": "Fill in the answer",
    "SuggestionSelectFromList": "Select the correct answer from the drop-down(s)",
    "SuggestionShortAnswer": "Enter your answer here",
    "TestInformation": "Information",
    "WhichAttemptsCounts": "Which attempts counts",
    "WorkingOutBox": "Working out box",
    "YourAnswer": "Your answer",
    "DragAndDrop": "Drag the labels to the correct placeholder",
    "SuggestionDragAndDrop": "Drag the labels to the correct placeholder",
    "LoadingAvailableAssessments": "Loading available assessments...",
    "PercentageForPassMark": "Percentage for pass mark",
    "Dashboard": "Dashboard",
    "WaitForSessionKeyConfirmation": "Please wait until proctor confirms your session key. After that you'll be able to start the exam.",
    "YourSessionKey": "Your current session key is",
    "SessionKeyDenied": "Your session key was denied by proctor.",
    "SessionKeyConfirmation": "Session key confirmation",
    "ConnectionError": "To continue you should have internet connection. Please connect and try again.",
    "ViewMarker": "View",
    "SuggestionFS": "Enter the correct answer(s)",
    "SuggestionCIP": "Select the correct answer",
    "ReviewSessionUnavailable": "Review session is unavailable",
    "ScheduleStart": "Schedule start",
    "ScheduleDeadline": "Schedule deadline",
    "NotepadHint": "Your notes will be visible to the assessor(s). Notes will be auto-saved.",
    "NetworkLanguageError": "Can not change language due to network error",
    "QuestionTimeExpired": "The time of the question has expired",
    "AbortAttempt": "Abort attempt"
  },
  "Dialogs.Confirm": {
    "LiveQuestionLockConfirmChange": "You are about to save changes to a question, which is used in assessment(s). Changing this question will take effect in assessment(s), which contain this question. Are you sure you want to change the question text?",
    "PrintConfirm1": "You are about to start printing exam. In that case - all candidates will have their 1 attempt started.",
    "PrintConfirm2": "Are you sure you want to continue?",
    "PrintConfirmation": "Print confirmation.",
    "PrintConfirmTitle": "Exam print confirmation",
    "PublishConfirm1": "Published results will show under 'Reports: Results' tab and can be scheduled for review via the 'Candidate Review' tab. They will also show on the candidate dashboard if this has been setup by the assessment author.\n",
    "PublishConfirm2": "Are you sure you want to publish?",
    "PublishConfirmTitle": "Publish results",
    "QuestionLockConfirmChange": "Changing this question will take effect in assessment(s) which contain this question. Are you sure you want to change the question text?",
    "SectionLockConfirmChange": "Changing this section will take effect in assessment(s) which contain this section. Are you sure you want to change the section?",
    "SubmitConfirm1": "Are you sure you want to submit the scores? After you have submitted the scores you cannot make any changes to the scoring.",
    "SubmitConfirm2": "Are you sure you want to continue?",
    "SubmitConfirmTitle": "Submit confirmation",
    "AssessmentPageLockConfirmChange": "Changing this page will take effect in assessment(s) which contain this page. Are you sure you want to change the page text?",
    "QuestionLockConfirmChangeTextOrStatus": "Changing this question will take effect in assessment(s) which contain this question. Are you sure you want to change the question text and/or status?",
    "AssessmentPageLockConfirmChangeTextOrStatus": "Changing this page will take effect in assessment(s) which contain this page. Are you sure you want to change the page text/answers and/or status?",
    "SectionLockConfirmChangeTextOrStatus": "Changing this section will take effect in assessment(s) which contain this section. Are you sure you want to change the section text and/or status?",
    "QuestionLockConfirmCreateNewVersion": "You have made changes that will affect the psychometric data of this item. A new version of this item will be created. Are you sure you want to continue?",
    "QuestionLockConfirmChangeQuestion": "Changing this question will take effect in assessment(s) which contain this question. Are you sure you want to change the question?",
    "VoidConfirmText": "Are you sure you want to void selected attempts? This action cannot be undone.",
    "VoidConfirmTitle": "Void attempts confirmation"
  },
  "Dialogs.DeleteConfirm": {
    "DeleteAssessmentRoles": "Delete assessment role(s)",
    "DeleteAssessments": "Delete assessment(s)",
    "DeleteAssessmentScales": "Delete assessment scale(s)",
    "DeleteAssessmentsTrashcan": "Delete assessment(s)",
    "DeleteCollectionRoles": "Delete collection role(s)",
    "DeleteCollections": "Delete collection(s)",
    "DeleteCollectionsTrashcan": "Delete collection(s)",
    "DeleteGrades": "Delete grade(s)",
    "DeleteHierarchies": "Delete hierarchy (ies)",
    "DeleteIndividualTaxonomies": "Delete individual taxonomy(s)",
    "DeleteItems": "Delete item(s)",
    "DeleteLabels": "Delete label (s)",
    "DeleteMediaElements": "Delete media element(s)",
    "DeleteMediaElementsPermanently": "Delete media element(s) permanently",
    "DeleteObjectiveRepositories": "Delete repository (s)",
    "DeleteObjectives": "Delete learning objective&#xfeff;(s)",
    "DeleteQualifications": "Delete qualification(s)",
    "DeleteQuestions": "Delete item(s)",
    "DeleteSchedules": "Delete schedule(s)",
    "DeleteSection.Text": "You are about to remove section. \nDo you want to continue?",
    "DeleteSection.Title": "Delete section",
    "DeleteSiteRoles": "Delete site role(s)",
    "DeleteTaxonomies": "Delete taxonomy category(s)",
    "DeleteTemplateQuestions": "Delete question(s)",
    "DeleteTemplates": "Delete template(s)",
    "DeleteTerms": "Delete term(s)",
    "DeleteUserGroup": "Delete user membership",
    "DeleteUsers": "Delete user(s)",
    "DeleteUsersTrashcan": "Delete user(s)",
    "DeleteSkins": "Delete theme(s)",
    "DeleteSebKeys": "Delete key(s)",
    "DeleteScheduleCandidate": "Delete candidate(s)",
    "DeleteScheduleCandidateText": "Are you sure you want to delete  {0}  candidate?",
    "DeleteScheduleCandidatesText": "Are you sure you want to delete  {0}  candidates?",
    "DeleteScheduleInvigilator": "Delete invigilator(s)",
    "DeleteScheduleInvigilatorsText": "Are you sure you want to delete  <b>{0}</b>  proctors?",
    "DeleteScheduleInvigilatorText": "Are you sure you want to delete  <b>{0}</b>  invigilator?",
    "ReviewSessionCandidatesText": "You are about to remove <b>{0}</b> out of <b>{1}</b> selected candidates who haven't viewed results . <br> Are you sure you want to continue?",
    "ReviewSessionCandidateText": "You are about to remove <b>{0}</b> who haven't viewed results . <br> Are you sure you want to continue?",
    "DeleteClusters": "Delete cluster(s)",
    "DeleteClustersHierarchy": "Delete hierarchy (ies)"
  },
  "Dialogs.LearningObjectives": {
    "NoObjectives": "No learning objectives",
    "SelectLearningObjectives": "Select learning objectives"
  },
  "Dialogs.MediaLibrary": {
    "Title": "Media Library"
  },
  "Dialogs.Progress": {
    "UploadingFile": "uploading file..."
  },
  "EasError": {
    "BackToDashboard": "Back to Dashboard",
    "BackToPreviousPage": "Back to the Previous Page",
    "Error404PageTitle": "Page not found",
    "ErrorPageDescription": "Unexpected Error",
    "ErrorPageTitle": "Error occured",
    "ErrorWithIdOccured": "An error has occured. Error id: {0}",
    "PageNotFoundExplanation": "Sorry, the page you were looking for could not be found!",
    "Page^Not^Found": "Page Not Found",
    "ReadFAQ": "Read the faq",
    "ReCheckUrl": "Re-check the url for typos",
    "TellUsAboutIt": "Tell us about it"
  },
  "Enumerations.ResultShow": {
    "After each attempt": "After each attempt",
    "After last attempt": "After last attempt",
    "Never": "Never",
    "On screen": "On screen"
  },
  "Enumerations.WhichAttemptCounts": {
    "Best attempt": "Best attempt",
    "Last attempt": "Last attempt"
  },
  "Errors": {
    "0": "Unknown error.",
    "0_named": "Error occured: {0}",
    "100": "Not all questions have been marked.",
    "200": "Sowiso server error. Make sure that credentials of sowiso are correct.",
    "202": "Saving variables error: {0}",
    "204": "Saving solutions error: {0}",
    "205": "Saving feedback error: {0}",
    "206": "Saving text error: {0}",
    "50": "Can't deserialize.",
    "51": "Wrong format of file: {0}.",
    "60": "You do not have enough permissions.",
    "71": "Can't unarchive item because collection is in archive state.",
    "72": "Seems that file was protected. Try to resave it.",
    "73": "Hierarchy was not deleted. It's used in other parts of the system.",
    "74": "Objective was not deleted. It's used in other parts of the system.",
    "90000": "Unknown error.",
    "70": "Object in quarantine.",
    "101": "Not all candidates have been marked."
  },
  "Evaluation.Content": {
    "Comment": "Comment",
    "CrossOut": "Cross out",
    "CrossOutText": "Cross out this text",
    "EditComment": "Edit comment",
    "Highlight": "Highlight",
    "HighlightText": "Highlight this text",
    "Maximize": "Maximize",
    "QuestionNotAnswered": "Question not answered",
    "Remove": "Remove",
    "UnhighlightText": "Unhighlight this text",
    "Unselect": "Unselect",
    "Answer": "{0}'s {1} answer",
    "OpenInNewTab": "Open in new tab",
    "SubmittedOn": "Submitted on",
    "NoTextInputted": "No text inputted"
  },
  "Evaluation.Publish": {
    "InformCandidatesByEmail": "Inform candidates by e-mail",
    "InformCandidatesDescription": "An e-mail will be sent to all candidates informing them about their result."
  },
  "Evaluation.Results.Sidebar": {
    "AttemptsAllowed": "Attempts allowed:",
    "AverageTime": "Average time:",
    "ChanceScore": "Chance score:",
    "Manual-scoring": "Manual-scoring:",
    "MaxTotalScore": "Max total score:",
    "NumberOfCandidates": "No. of candidates:",
    "PercentageToPass": "Percentage to pass:",
    "Submitted": "Submitted:",
    "TimeAllowed": "Time allowed:",
    "TotalNumberOfQuestions": "Total no. of questions:",
    "WhichCounts": "Which attempt count:"
  },
  "Evaluation.Results.Statistics": {
    "AverageDifficulty": "Avg. P-Value",
    "AverageDifficultyCorrected": "Avg. Pc-Value",
    "AverageRir": "Avg. Rir",
    "AverageRit": "Avg. Rit",
    "ChanceScore": "Chance score",
    "GivenAnswers": "Given answers",
    "PcValue": "Pc",
    "PValue": "P",
    "Question": "Question",
    "ReliabilityChAlpha": "Reliablity Cr. Alpha",
    "Rir": "Rir",
    "Rit": "Rit",
    "Status": "Status",
    "Type": "Type",
    "Answered": "Answered",
    "Id": "Item ID"
  },
  "Evaluation.Results": {
    "All": "All",
    "AssessmentScale": "Assessment scale:",
    "Attempt": "Attempt no.",
    "Automatic": "Automatic score",
    "AvgScore": "Avg. score",
    "ByPercentage": "By percentage",
    "ByScore": "By score",
    "CandidateId": "User ID",
    "CandidateNumber": "Candidate number",
    "CoAssessorScore": "Co-assessor score",
    "Comarker": "Co-assessor",
    "Difficulty": "Difficulty",
    "Discrimination": "Discrimination",
    "ExportCandidateResults": "Candidate results - including seed items",
    "ExportCandidateResultsAndForm": "Candidate results including registration form data",
    "ExportCandidateScores": "Candidate scores - including seed items",
    "ExportToExcel": "Export to Excel",
    "FlagForRemark": "Flag for remark",
    "FromScore": "From score",
    "GivenAnswers": "Given answers",
    "Grade": "Grade",
    "HandedIn": "Handed in",
    "Manual": "Manual score",
    "ModeratorScore": "Moderator score",
    "Name": "Candidate name",
    "NoAnswer": "No answer",
    "NoGrades": "No grades",
    "NoResults": "No results",
    "NoStatistics": "No statistics",
    "NotAnswered": "Not answered",
    "NotPublished": "Not published",
    "NotSubmitted": "Not submitted",
    "NumberOfCandidates": "No. of candidates",
    "PercentageOfCandidates": "Percentage of candidates",
    "PercentScore": "Percent score",
    "PublishAllResults": "Publish all results",
    "Published": "Published",
    "PublishResults": "Publish results",
    "Question": "Question",
    "QuestionNumber": "Question{0}",
    "QuestionType": "Question type",
    "Scale": "Scale",
    "Score": "Score",
    "ShowComments": "Show comments",
    "StatisticsNotAvailable": "These values will be available when marking is completed",
    "Status": "Status",
    "SubmitResults": "Submit scores",
    "Submitted": "Submitted",
    "ToScore": "To score",
    "Total": "Total score",
    "YourScore": "Total score",
    "^^Attempts": "ATTEMPTS",
    "^^Automatic": "AUTOMATIC",
    "^^Avg^^Score": "AVG. SCORE",
    "^^Difficulty": "DIFFICULTY",
    "^^Discrimination": "DISCRIMINATION",
    "^^From^^Score": "FROM SCORE",
    "^^Given^^Answers": "GIVEN ANSWERS",
    "^^Grade": "GRADE",
    "^^Manual": "MANUAL",
    "^^Name": "NAME",
    "^^Number^^Of^^Candidates": "NO. OF CANDIDATES",
    "^^Percentage^^Of^^Candidates": "PERCENTAGE OF CANDIDATES",
    "^^Question": "QUESTION",
    "^^Score": "SCORE",
    "^^Status": "STATUS",
    "^^Submitted": "SUBMITTED",
    "^^Total": "TOTAL",
    "^^To^^Score": "TO SCORE",
    "ExportCandidateScoresWithoutSeedItems": "Candidate scores",
    "ExportCandidateResultsWithoutSeedItems": "Candidate results",
    "SubmittedScore": "Scores submitted",
    "LimitExportRows": "You cannot to export more then 100 000 rows.",
    "AssessorsScore": "Assessor score",
    "Assessor": "assessor",
    "Moderator": "moderator",
    "RescoringScore": "Manual score after rescoring",
    "TotalScore": "Total score",
    "ManuallyMarked": "Manually marked",
    "LastAssessed": "Last assessed",
    "CandidateSubmitted": "Candidate submitted",
    "ScoresSubmitted": "Scores submitted",
    "CandidateProgress": "Candidate progress",
    "QuestionsProgress": "Questions marking progress",
    "Remarker": "remarker",
    "ManualScoreYou": "Manual score (you)",
    "ManualScoreAssessors": "Manual score (assessors)",
    "ManualScoreCoAssessors": "Manual score (co-assessors)",
    "ManualScoreModerators": "Manual score (moderators)"
  },
  "Evaluation.Sidebar.Sections": {
    "Assessment": "Assessment",
    "Evaluations": "Annotations",
    "Marking": "Marking",
    "StudentsInformation": "Student's information"
  },
  "Evaluation.Sidebar": {
    "Anonymous": "Anonymous",
    "Attempt": "Attempt",
    "MarkingScheme": "Marking scheme",
    "Passmark": "Passmark",
    "Score": "Score",
    "Submitted": "Submitted",
    "Title": "Title",
    "CannotSetScore": "Score can't be higher than 0 for unanswered questions"
  },
  "Evaluation": {
    "Annotate": "Annotate",
    "AnnotationOverview": "Annotation overview",
    "CancelWarning": "You are navigating away from this page. All entered data will be lost. Are you sure you want to continue?",
    "Comments": "Comments",
    "Marker": "Assessor",
    "Moderator": "Moderator",
    "MyComment": "My annotations",
    "NextCandidate": "Go to next candidate",
    "NextQuestion": "Go to next question",
    "NoHightlight": "No hightlight",
    "NoMarkingScheme": "There is no marking scheme available for this question.",
    "OverallConclusion": "Overall conclusion",
    "Question": "Question",
    "SaveAndNextCandidate": "Save and next candidate",
    "SaveAndNextQuestion": "Save and next question",
    "SelectedText": "Selected text",
    "StrikeThrough": "Strike-through",
    "TypeYourComment": "Type your comment",
    "ViewAndMarkQuestions": "View And Mark Questions",
    "ViewComment": "View",
    "YourComment": "Your comment",
    "CharacterCount": "Characters",
    "PreviousCandidate": "Previous candidate",
    "PreviousQuestion": "Previous question",
    "Other": "Other",
    "YouHaveMadeChanges": "You have made changes to this item. Click 'Save' to save them. ",
    "OveralConclusion": "Overall Conclusion",
    "Section": "Section",
    "NoSection": "No section page connected to this question.",
    "NavigateToNextCandidateSameQuestion": "Navigate to next candidate - same question",
    "Scoring": "Scoring",
    "Score": "Score",
    "Annotations": "Annotations",
    "AssignMark": "Save ",
    "MarkingScheme": "Marking scheme",
    "NoComments": "No comments",
    "AssignMarkAndNextCandidate": "Save & Next candidate",
    "AssignMarkAndNextAnswer": "Save & Next answer",
    "NavigateToPreviousCandidateSameQuestion": "Navigate to previous candidate - same question",
    "ViewMyComment": "You",
    "ViewAssessor": "View as",
    "ScoreCanNotBeHigherThanMaxValue": "Score can't be higher than {0}",
    "GoToNextCandidate": "Next candidate",
    "PreviousCandidateSameQuestion": "Previous candidate - same question",
    "NextCandidateSameQuestion": "Next candidate - same question",
    "PreviousQuestionSameCandidate": "Previous question - same candidate",
    "NextQuestionSameCandidate": "Next question - same candidate",
    "MarkingSchemeHistory": "History",
    "MarkerAndModerator": "Assessor and moderator",
    "ChangeRole": "Change role",
    "Dual": "Assessor and moderator",
    "Subcriteria": "Sub-Сriteria",
    "CannotSetScoreNumberOfQuestions": "Score can't be higher than 0 for unanswered questions in sections with limited amount of required questions to answer"
  },
  "EvaluationResults.Splitted.Content.Tabs": {
    "Answers": "Answers",
    "Grades": "Grades",
    "Results": "Results",
    "Statistics": "Statistics",
    "Submissions": "Submissions"
  },
  "EvaluationResults.Splitted.Sidebar": {
    "AssessmentSummary": "Assessment summary",
    "PsychometricData": "Psychometric data"
  },
  "ExamResults": {
    "Assessing": "Assessing",
    "Detailed": "Detailed results",
    "NotTaken": "Not taken",
    "OnGoing": "On going",
    "ScoreReport": "Score report",
    "ShowOnlyCorrectQuestions": "Only incorrect/partially correct answers are shown"
  },
  "Exception": {
    "AssessmentPermission": "You do not have enough permissions.",
    "ContentPermission": "You don't have access to the content in this area",
    "EasEntityNotFoundByOptionException": "Entity with type {0} was not found by options: {1}."
  },
  "ExternalMatch": {
    "ConnectionDeletionConfirmation": "Are you sure you want to delete this choice/match? Relationship with this choice/match will be removed."
  },
  "Feedback": {
    "NoFeedback": "No feedback",
    "OnAlternatives": "On alternatives",
    "OnQuestions": "On questions"
  },
  "Filter.Filters": {
    "Active": "Active",
    "AllItems": "All items",
    "Archived": "Archived",
    "Favourites": "Favourites",
    "Trashcan": "Trashcan",
    "All": "All",
    "Deleted": "Deleted"
  },
  "Filter.Parameters.QuestionsRelated": {
    "Collections": "Collections",
    "CollectionsEmptyListText": "No collections available",
    "Difficulty": "Difficulty",
    "ItemPurpose": "Item purpose",
    "MarkingType": "Marking type",
    "QuestionType": "Question type",
    "TaxonomiesEmptyListText": "No taxonomies available",
    "Taxonomy": "Taxonomy"
  },
  "Filter.Parameters": {
    "AllItems": "All items",
    "ArchiveStatus": "Archive ",
    "Availability": "Available to",
    "Collection": "Collection",
    "Filter": "Filter",
    "Filters": "Filters",
    "Published": "Published",
    "Qualification": "Qualification",
    "QualificationsEmptyListText": "No qualifications available",
    "State": "State",
    "Status": "Status",
    "StatusesEmptyListText": "No statuses",
    "Terms": "Terms",
    "TermsEmptyListText": "No terms",
    "Type": "Type",
    "TypesEmptyListText": "No types",
    "Hierarchy": "Filter",
    "Clusters": "Clusters"
  },
  "FinishPage": {
    "TestSuccessfullySubmitted": "Your test was successfully submitted to the server on {0} at {1}",
    "ThankYouForTakingExam": "Dear Candidate, {0} Thank you for taking the {1} Exam. Your results can be viewed by clicking Next.",
    "TestVoided": "Your attempt has been voided by invigilator on {0} at {1}"
  },
  "Framework.Modules": {
    "": "Modules",
    "Archive": "Archive",
    "AssessmentRoles": "Assessment roles",
    "Assessments": "Assessments",
    "CollectionRoles": "Collection roles",
    "Collections": "Collections",
    "CollectionsAndAssessments": "Collections and assessments",
    "Complete": "Complete",
    "Coordinator": "Coordinator",
    "Delivering": "Delivering",
    "Detailed": "Detailed results",
    "General": "General",
    "Grades": "Grades",
    "Hierarchies": "Hierarchies",
    "Invigilation": "Proctoring",
    "Items": "Items",
    "Library": "Library",
    "Marking": "Marking",
    "MarkingRoles": "Marking roles",
    "Mastery": "Mastery",
    "Media": "Media elements",
    "Overview": "Overview",
    "Results": "Results",
    "Roles": "Roles",
    "Schedule": "Schedule",
    "ScoreReport": "score report",
    "Short": "Short",
    "SiteRoles": "Site roles",
    "Statistics": "Statistics",
    "Submissions": "Submissions",
    "Summary": "Summary",
    "ToBeAssessed": "Assess",
    "Trashcan": "Trash can",
    "UserEdit": "Edit user",
    "Users": "Users",
    "Candidates": "Candidates",
    "Schedules": "Schedules"
  },
  "Framework": {
    "GeneralSettings": "General settings",
    "NextStep": "Next step",
    "PerPage": "per page",
    "Show": "Show",
    "TotalFound": "Total {0} item(s) found",
    "_Items": "{0} item(s)"
  },
  "General.AssessmentScales": {
    "DefaultTitleForNotPassedScaleItem": "Not passed",
    "DefaultTitleForPassedNotPassedScale": "Passed/Not passed",
    "DefaultTitleForPassedScaleItem": "Passed"
  },
  "General.Expiration": {
    "LogOutNow": "Log Out Now",
    "SessionExpirationDescription": "Because you have been inactive, your session is about to expire.",
    "SessionExpirationWarning": "Session Expiration Warning",
    "StayLoggedIn": "Stay Logged In",
    "TimeRemaining": "Time remaining"
  },
  "General.UsersDialog": {
    "NoUsersAvailable": "No users available",
    "SearchFor": "Search for",
    "SearchUser": "Search user"
  },
  "General.UsersTable": {
    "SelectPermission": "Select permission",
    "SelectRole": "Select role"
  },
  "General": {
    "AccessToItemReports": "Access to item reports",
    "Add": "Add",
    "AddAndClose": "Add and close",
    "AddAnswerItem": "Add an Answer item",
    "AddCandidates": "Add candidates",
    "AddChoice": "Add choice",
    "AddChoiceDistractor": "Add Choice distractor",
    "AddCollectionProfile": "Add collection role",
    "AddExaminers": "Add assessor(s)",
    "AddMatch": "Add match",
    "AddMatchDistractor": "Add Match distractor",
    "AddMatchingPair": "Add Matching Pair",
    "AddQuestionCreated": "Add: question created",
    "AddSelected": "Add selected",
    "AddSiteProfile": "Add site role",
    "Administration": "Administration",
    "Administrator": "Administrator",
    "All": "All",
    "AllowedHTMLCodeLevel": "Allowed HTML code level",
    "Alternatives": "Alternatives",
    "AndLowerCase": "and",
    "Anonymous": "Anonymous",
    "Answer": "Answer",
    "AnswerChanged": "Answer changed",
    "Answered": "Answered",
    "AnswerMaxScoreChangedFromTo": "Answer: Maximum score changed from {0} to {1}",
    "Archive": "Archive",
    "ArchiveCollection": "Archive collection",
    "Assessed": "Assessed",
    "AssessmentDeletionConfirmation": "Are you sure you want to delete this assessment \"{0}\"?",
    "AssessmentDeletionDialogs.Confirmation": "Are you sure you want to delete this assessment \"{0}\"?",
    "AssessmentRoleDeletionConfirmation": "Are you sure you want to delete this assessment role \"<b>{0}</b>\"?",
    "AssessmentRolesDeletionConfirmation": "Are you sure you want to delete <b>{0}</b> assessment roles?",
    "AssessmentRolesDeletionWarning": "Assessment roles used in sharing won't be deleted.",
    "Assessments": "Assessments",
    "AssessmentScale": "Assessment scale",
    "AssessmentScaleDeletionConfirmation": "Are you sure you want to delete assessment scale \"{0}\"?",
    "AssessmentScaleInQuestionsWontBeDeleted": "Assessment scales used in marking won't be deleted",
    "AssessmentScalesDeletionConfirmation": "Are you sure you want to delete {0} assessment scales?",
    "AssessmentsDeletionConfirmation": "Are you sure you want to delete {0} assessments?",
    "AssessmentsInSchedulesWontBeDeleted": "Assessments used in schedules won't be deleted",
    "AssessmentsInSchedulesWontBeDeletedWithDot": "Assessments used in schedules won't be deleted.",
    "AssignExaminersToCandidates": "Assign assessors to candidates",
    "Attempt": "Attempt",
    "Audio": "Audio",
    "Author": "Author",
    "AutoGenerate": "Auto-generate",
    "AverageDifficulty": "Average difficulty:",
    "AverageDiscrimination": "Average discrimination:",
    "AverageScore": "Average score",
    "AverageTime": "Average time:",
    "BackToPreviousPage": "Back to the Previous Page",
    "BackWithArrow": "< Back",
    "Between": "Between",
    "BlueprintNoObjectives": "Blueprint is incomplete. You need to select at least 1 objective.",
    "BlueprintNoTaxonomies": "Blueprint is incomplete. You need to select at least 1 taxonomy.",
    "BlueprintTooltip1": "The question is not ready for Blueprint assessment creation yet. Blueprint requires either 1 Learning Objective and 1 Taxonomy or 1 Topic to be set.",
    "BlueprintTooltip2": "Set only 1 learning objective and 1 taxonomy.",
    "Calculator": "Calculator",
    "Cancel": "Cancel",
    "Candidate": "Candidate",
    "ChanceScore": "Chance score",
    "ChangeType": "Change type:",
    "Check": "Check",
    "Choice": "Choice",
    "CirrusID": "ID",
    "Clear": "Clear",
    "Close": "Close",
    "ClosedQuestions": "Closed questions",
    "CollectionDeletionConfirmation": "Are you sure you want to delete this collection \"{0}\"?",
    "CollectionRoleDeletionConfirmation": "Are you sure you want to delete this collection role \"<b>{0}</b>\"?",
    "CollectionRolesDeletionConfirmation": "Are you sure you want to delete <b>{0}</b> collection roles?",
    "CollectionRolesDeletionWarning": "Collection roles used in sharing won't be deleted.",
    "CollectionsDeletionConfirmation": "Are you sure you want to delete {0} collections?",
    "Comments": "Comments:",
    "Confirm": "Confirm",
    "ConfirmLeaveWithoutSave": "You are about to leave this page. You need to save the page otherwise your data will get lost. Are you sure you want to continue without saving?",
    "Continue": "Continue",
    "Create": "Create",
    "CreateAssessments": "Create assessments",
    "CreateCollections": "Create collections",
    "CreatedBy": "Created by:",
    "CreatedOn": "Created on:",
    "CurrentlyUnavailable": "Currently unavailable",
    "Dashboard": "Dashboard",
    "DataPermanentDeletionNotice": "All data will be deleted permanently.",
    "Date": "Date",
    "DateOfBirth": "Date of birth",
    "DefaultPermissionsForNewCollections": "Default permissions (used when new collections are created)",
    "DefaultSettings": "Default settings",
    "Delete": "Delete",
    "DeleteChoice": "Delete choice",
    "DeleteCollection": "Delete collection",
    "DeleteMatch": "Delete match",
    "DeletePermanently": "It will be deleted permanently. Items in quarantine will not be deleted.",
    "DeletePermanentlyButton": "Delete permanently",
    "Deleting": "Deleting",
    "Description": "Description",
    "Detailed": "Detailed results",
    "Details": "Details",
    "DragMediaElementsToThisAreaOrSelectFromMediaLibrary": "Drag a media element to this area, or select one from Media library.",
    "Edit": "Edit",
    "EditAlternativesChanged": "Edit: alternative(s) changed",
    "EditAnswerAlternativesAdded": "Edit: Answer alternative(s) added",
    "EditAnswerAlternativesRemoved": "Edit: Answer alternative(s) removed",
    "EditAnswersAdded": "Edit: Answer(s) added",
    "EditAnswersChanged": "Edit: Answer(s) changed",
    "EditAnswersRemoved": "Edit: Answer(s) removed",
    "EditBlanksAdded": "Edit: Blank(s) added",
    "EditBlanksChanged": "Edit: Blank(s) changed",
    "EditBlanksRemoved": "Edit: Blank(s) removed",
    "EditCollectionTitle": "Edit collection title",
    "EditFeedbackChanged": "Edit: feedback changed",
    "EditHotspotAreasAdded": "Edit: Hotspot area(s) added",
    "EditHotspotAreasRemoved": "Edit: Hotspot area(s) removed",
    "EditMatchingPairsAdded": "Edit: Matching pair(s) added",
    "EditMatchingPairsChanged": "Edit: Matching pair(s) changed",
    "EditMatchingPairsRemoved": "Edit: Matching pair(s) removed",
    "EditQuestionChanged": "Edit: question changed",
    "Empty": "Empty",
    "EnableRichEditor": "Enable rich editor",
    "EnableSowiso": "Sowiso questions",
    "EnableTeleform": "Teleform print & scan module",
    "EnableWiris": "Wiris equation editor",
    "EndDate": "End date",
    "EnterAnswer": "Enter the answer",
    "EnterAnswersInCorrectOrder": "Enter the answers in correct order",
    "EnterChoicesAndCorrespondingMatches": "Enter choices and corresponding match for each choice",
    "EnterPercentagePassMark": "Enter percentage pass mark",
    "EnterSectionText": "Enter the section text",
    "Exit": "Exit",
    "ExportToExcel": "Export to Excel",
    "ExternalApiSettings": "External API settings",
    "ExternalId": "External ID",
    "ExternalIdUnique": "Organization ID should be unique. The entered ID is used in \"{0}\".",
    "Feedback": "Feedback",
    "FileChanged": "File changed",
    "FileLoaded": "File loaded",
    "FileRemoved": "File removed",
    "FileWasUploaded": "The file was uploaded",
    "FilterBy": "Filter by:",
    "FilterByWithColon": "Filter by:",
    "Finish": "Finish",
    "Finished": "Finished",
    "FirstName": "First name",
    "ForbiddenPageContent": "This page you are looking for has restricted access.",
    "ForbiddenPageTitle": "Forbidden",
    "Formative": "Formative",
    "Functionality": "Functionality",
    "General": "General",
    "GeneratePINCode": "Generate PIN code",
    "GivenAnswers": "Given answers",
    "GlobalSettings": "Global settings",
    "GradeDeletionConfirmation": "Are you sure you want to delete this grade \"{0}\"?",
    "GradeInMarkingWontBeDeleted": "Grades in assessment scales that are used in marking won't be deleted",
    "GradesDeletionConfirmation": "Are you sure you want to delete {0} grades?",
    "Hierarchies": "Hierarchies",
    "HierarchiesDeletionConfirmation": "Are you sure you want to delete {0} hierarchies?",
    "HierarchiesUsedWontBeDeleted": "Hierarchies used in other parts of the system won't be deleted",
    "HierarchyDeletionConfirmation": "Are you sure you want to delete this hierarchy \"{0}\"?",
    "HighestScore": "Highest score",
    "Hotspot": "Hotspot",
    "Hotspots": "Hotspots",
    "HotspotSettings": "Hotspot settings",
    "IfFileIsSelectedFromComputerThatMediaElementWillBeAddedToLibraryAutomatically": "If a file is selected from the computer, that media element will be added to the library automatically.",
    "IgnoreNonAlphametricCharactersInCandidateResponse": "Ignore non-alphanumeric characters in candidate response",
    "IgnoreNonAlphanumericResponse": "Ignore non alphanumeric response",
    "Image": "Image",
    "ImageLoadError": "Error during loading image",
    "Import": "Import",
    "Importing": "Importing",
    "IncludeWorkingOutBoxForCandidate": "Include a working out box for candidate",
    "IndividualTaxonomiesDeletionConfirmation": "Are you sure you want to delete {0} individual taxonomies?",
    "IndividualTaxonomyDeletionConfirmation": "Are you sure you want to delete this individual taxonomy \"{0}\"?",
    "IndividualTaxonomyInQuestionsWontBeDeleted": "Individual taxonomies used in questions won't be deleted",
    "Insert": "Insert",
    "IntegrationDeletionConfirmation": "Are you sure you want to delete this integration \"{0}\"?",
    "IntegrationsDeletionConfirmation": "Are you sure you want to delete {0} integrations?",
    "Interface": "Interface",
    "InternetOff": "Internet OFF",
    "InternetOn": "Internet ON",
    "Introduction": "Introduction",
    "InvalidGuidWarning": "You must enter valid GUID",
    "IsCaseSensetive": "Is case sensitive",
    "IsCaseSensitive": "Is case sensitive",
    "Item": "Item",
    "ItemWasDeleted": "Item was deleted",
    "LabelDeletionConfirmation": "Are you sure you want to delete this label \"{0}\"?",
    "LabelsDeletionConfirmation": "Are you sure you want to delete {0} labels?",
    "LastName": "Last name",
    "LastUpdated": "Last updated",
    "LearningObjectiveChanged": "Learning objective: changed",
    "LearningObjectiveDeletionConfirmation": "Are you sure you want to delete this learning objective \"{0}\"?",
    "LearningObjectivesDeletionConfirmation": "Are you sure you want to delete {0} learning objectives?",
    "LearningObjectiveSelected": "Learning objective: selected",
    "LearningObjectivesInQuestionsWontBeDeleted": "Learning objectives used in collections or questions won't be deleted",
    "LeastUsed": "Least used",
    "Library": "Library",
    "LoadingTableMessage": "Loading, please wait...",
    "LockdownBrowser": "Lockdown browser",
    "Logout": "Logout",
    "LowestScore": "Lowest score",
    "ManageAssessments": "Manage assessments",
    "ManageEnterpriseServices": "Manage Enterprise Services",
    "ManageGeneralAdministrationPermissions": "Manage general administration permissions",
    "ManageSharing": "Manage sharing",
    "ManageTrashCan": "Manage trash can",
    "ManageUsers": "Manage users",
    "MarkAssessments": "Mark assessments",
    "Marking": "Marking",
    "MarkingRoleDeletionConfirmation": "Are you sure you want to delete this marking role \"<b>{0}</b>\"?",
    "MarkingRolesDeletionConfirmation": "Are you sure you want to delete <b>{0}</b> marking roles?",
    "MarkingRolesDeletionWarning": "Marking roles connected to assessors won't be deleted.",
    "MaxScore": "Max score",
    "MaxTotalScore": "Max total score:",
    "MaxValue": "Max. value",
    "MediaElementDeletionConfirmation": "Are you sure you want to delete this media element \"{0}\"?",
    "MediaElementPermanentDeletionConfirmation": "Are you sure you want to delete this media element permanently \"{0}\"?",
    "MediaElementsDeletionConfirmation": "Are you sure you want to delete {0} media elements?",
    "MediaElementsInQuestionsWontBeDeleted": "Media elements that are used in questions won't be deleted.",
    "MediaElementsPermanentDeletionConfirmation": "Are you sure you want to delete {0} media elements permanently?",
    "Minutes": "minutes",
    "MinValue": "Min. value",
    "ModifiedBy": "Modified by:",
    "ModifiedOn": "Modified on:",
    "ModifiedOnBy": "{0} by {1}",
    "MostUsed": "Most used",
    "MoveToArchive": "Move to Archive",
    "MySettings": "My settings",
    "NDaysDataRestorationPeriodNotice": "It will be possible to restore it within {0} days. After that period all data will be deleted permanently.",
    "Never": "Never",
    "Next": "Next",
    "NFromMShortForm": "{0} / {1}",
    "No": "No",
    "NoDescription": "No description",
    "NoEntry": "No entry",
    "NoFileChosen": "No file chosen",
    "NOfM": "{0} of {1}",
    "NoItems": "No items",
    "NoItemsSelected": "No {0} selected",
    "NoMediaElements": "No media elements",
    "NoName": "No name",
    "NoQualification": "No qualification",
    "NormalLogin": "Normal login",
    "NotAssessed": "Not assessed",
    "NotAvailableShortForm": "N/A",
    "NotEnoughData": "Not enough data",
    "NotSelected": "Not selected",
    "NotSet": "Not set",
    "NoUploadedFile": "No file has been uploaded:",
    "NoUsersHaveBeenSelected": "No users have been selected yet",
    "NumberOfCandidates": "No. of candidates",
    "NumberShortForm": "No.",
    "ObjectivesRepositoriesDeletionConfirmation": "Are you sure you want to delete {0} repositories?",
    "ObjectivesRepositoryDeletionConfirmation": "Are you sure you want to delete this repository \"{0}\"?",
    "ObjectivesRepositoryInQuestionsWontBeDeleted": "Repositories that contains learning objectives used in collections or questions won't be deleted",
    "Of": "of",
    "OfPreposition": "{0} of {1}\n",
    "OfTotal": "of {0}",
    "Ok": "OK",
    "OneOrMoreDays": "{0} days",
    "online": "online",
    "OpenQuestions": "Open questions",
    "Options": "Options",
    "Page": "Page",
    "Pager": "Pager",
    "Password": "Password",
    "PercentagePassed": "Percentage passed:",
    "PercentageScore": "Percentage Score",
    "PercentageToPass": "Percentage to pass:",
    "Permissions": "Permissions",
    "PersonalSettings": "Personal settings",
    "PINCode": "PIN code",
    "Points": "points",
    "Prev": "Prev",
    "Preview": "Preview",
    "PreviewExercise": "Preview exercise:",
    "PreviewLowerCase": "preview",
    "Print": "Print",
    "ProfileSettings": "Role settings",
    "Publish": "Publish",
    "Qualification": "Qualification",
    "QualificationDeletionConfirmation": "Are you sure you want to delete this qualification \"{0}\"?",
    "QualificationInAssessmentsWontBeDeleted": "Qualification used in assessments won't be deleted",
    "Qualifications": "Qualifications",
    "QualificationsDeletionConfirmation": "Are you sure you want to delete {0} qualifications?",
    "Question": "Question",
    "QuestionDeletionConfirmation": "Are you sure you want to delete this item \"{0}\"?",
    "QuestionsDeletionConfirmation": "Are you sure you want to delete {0} items?",
    "QuestionsInAssessmentsWontBeDeleted": "Items used in assessments won't be deleted",
    "QuestionType": "Question type:",
    "Quota": "Quota",
    "Randomise": "Randomise",
    "Range": "Range",
    "RangeWithColonAndSpace": "Range: ",
    "Refresh": "Refresh",
    "RegistrationForm": "Registration form",
    "ReliabilityAlphaKR20": "Reliability Alpha/KR-20:",
    "Remove": "Remove",
    "RemoveCandidates": "Remove candidates",
    "Reports": "Reports",
    "Restore": "Restore",
    "Results": "Results",
    "Revision": "Revision",
    "RevisionWithSpace": "Revision ",
    "Role": "Role",
    "RolledBackFromRevision": "Rolled back from revision {0}",
    "Save": "Save",
    "SaveAndCancel": "Save and Close",
    "Saving": "Saving",
    "ScaleImageToPreventScrolling": "Scale the image to prevent scrolling",
    "Schedule": "Schedule",
    "ScheduleAssessments": "Schedule assessments",
    "Score": "Score",
    "Search": "Search",
    "SecureLogin": "Secure login",
    "SecurityLevel": "Security level",
    "SelectAddFile": "Select or Add File",
    "SelectAssessment": "Select assessment",
    "Selected": "Selected",
    "SelectExercise": "Select exercise",
    "SelectHierarchy": "Select hierarchy",
    "SelectInvigilator": "Select invigilator",
    "SelectMarker": "Select marker",
    "SelectModerator": "Select moderator",
    "SelectScheduler": "Select scheduler",
    "SelectTerm": "Select term",
    "SendEmail": "Send email",
    "SetAssessingDeadline": "Set assessing deadline",
    "SetAssessmentStartAndEndDate": "Set assessment start and end date",
    "SetCandidateIDs": "Set user IDs",
    "SetMarkingStartAndEndDate": "Set marking start and end date",
    "Settings": "Settings",
    "SetTitle": "Set the title",
    "SetUserIDs": "Set user IDs",
    "SeveralDays": "{0} days",
    "Share": "Share",
    "Sharing": "Sharing",
    "Show": "Show",
    "ShowPasswordDescription": "Show the password as plain text (not advisable in a public place)",
    "ShowPasswordTitle": "Show Password",
    "SiteRoleDeletionConfirmation": "Are you sure you want to delete this site role \"<b>{0}</b>\"?",
    "SiteRolesDeletionConfirmation": "Are you sure you want to delete <b>{0}</b> site roles?",
    "SiteRolesDeletionWarning": "Site roles connected to users won't be deleted.",
    "SortBy": "Sort by:",
    "Sorting": "Sorting",
    "SowisoAdminToken": "Admin token",
    "SowisoAuthorToken": "Author token",
    "SowisoPlayerToken": "Player token",
    "SowisoUserId": "User ID",
    "SpecificNumberOfItemsSelected": "{0} {1} selected",
    "SpecificValue": "Specific value",
    "SpecificValueWithColonAndSpace": "Specific value: ",
    "StandardProfile": "Standard role",
    "StartDate": "Start date",
    "StartPage": "Start page",
    "StartTest": "Start test",
    "StatusChangedFromTo": "Status: changed from {0} to {1}",
    "StillNotAvailable": "This data is not yet available",
    "Submit": "Submit",
    "SubmitAndResults": "Submit and see results",
    "Summary": "Summary",
    "Summative": "Summative",
    "TagsChanged": "Tags: changed",
    "TaxonomiesDeletionConfirmation": "Are you sure you want to delete {0} taxonomy categories?",
    "TaxonomyChanged": "Taxonomy: changed",
    "TaxonomyDeletionConfirmation": "Are you sure you want to delete this taxonomy category \"{0}\"?",
    "TaxonomyInQuestionsWontBeDeleted": "Taxonomy category that contains taxonomy used in questions won't be deleted",
    "TaxonomyRemoved": "Taxonomy: removed",
    "TaxonomySelected": "Taxonomy: selected",
    "TemplateDeletionConfirmation": "Are you sure you want to delete this template \"{0}\"?",
    "TemplatesDeletionConfirmation": "Are you sure you want to delete {0} templates?",
    "TermDeletionConfirmation": "Are you sure you want to delete this term \"{0}\"?",
    "TermsDeletionConfirmation": "Are you sure you want to delete {0} terms?",
    "TermsInSchedulesWontBeDeleted": "Term used in schedules won't be deleted",
    "TestBeginsTime": "Test begins {0}",
    "Text": "Text:",
    "TextPlain": "Text",
    "Time": "Time",
    "TimeAllowed": "Time allowed",
    "Timer.Days.Short": "d",
    "Timer.Hours.Short": "h",
    "Timer.Minutes.Short": "m",
    "Title": "Title",
    "TotalMaxScore": "Total max. score",
    "TotalNumberOfQuestions": "Total no.of questions:",
    "TryAgain": "Try again",
    "Unarchive": "Unarchive",
    "Unknown": "Unknown",
    "Unlimited": "Unlimited",
    "Unspecified": "Unspecified",
    "Untitled": "Untitled",
    "Update": "Update",
    "UploadedFile": "Uploaded file:",
    "UploadFile": "Upload file",
    "UploadImage": "Upload Image",
    "UploadingDots": "Uploading...",
    "UploadingFileToMediaLibrary": "Uploading file to Media library",
    "UploadNewFile": "Upload New File",
    "UsedTemplateDeletionConfirmation": "Template \"{0}\" is used in assessment(s)",
    "UsedTemplatesDeletionConfirmation": "Template \"{0}\" is used in assessment(s)",
    "UserDeletionConfirmation": "Are you sure you want to delete this user \"{0}\"?",
    "UserGroupDeletionConfirmation": "You are about to remove this user's membership to hierarchy \"{0}\" and all it's sub-levels. This may affect user's access to certain parts of the platform.",
    "UserId": "User Id",
    "UserIdUnique": "User ID should be unique. The entered ID is used by \"{0}\".",
    "UserName": "User name",
    "UsersDeletionConfirmation": "Are you sure you want to delete {0} users?",
    "UseThisProfileForUsersCreatingCollection": "Use this role for users creating a collection",
    "UseTrashCan": "Use trash can",
    "Value": "Value",
    "Video": "Video",
    "Void": "Void",
    "Warning": "Warning",
    "WordCount": "Words",
    "WordsCount": "Words count",
    "WorkingOutBox": "Working OutBox",
    "Yes": "Yes",
    "YourAnswer": "Your answer",
    "ZeroNumberOfItems": "No",
    "_And": "and",
    "ApplyLabels": "Apply labels",
    "Select": "Select",
    "Previous": "Previous",
    "Comma": "comma [ , ]",
    "Dot": "dot [ . ]",
    "DecimalSign": "Decimal marker",
    "Status": "Status",
    "EnterPageText": "Enter the page text",
    "SelectPageType": "Select the page type",
    "ID": "ID",
    "Type": "Type",
    "Total": "Total",
    "Error": "Error",
    "Custom": "Custom",
    "Placeholders": "Placeholders",
    "AudioNotUploaded": "Audio file was not uploaded",
    "SeedInfoOnHover": "Seed items are considered unscored and will not count towards the score of the candidate. Typically it’s used if you want to test the item before applying them to live assessments.",
    "SeedInfoTableHint": "Question scores marked with an asterix (*) are seed items and will not count towards the score for the candidates.",
    "SeedItemCount": "Number of seed items",
    "SeedItemTotalMaxScore": "Total max. score for seed items",
    "ItemCount": "Number of non-seed items",
    "Bottom": "bottom",
    "Top": "top",
    "Right": "right",
    "Left": "left",
    "Notification": "Notification",
    "False": "false",
    "True": "true",
    "SendPdfToEmail": "Send Score Report to Email",
    "Export": "Export",
    "Failed": "Failed",
    "Passed": "Passed",
    "Result": "Result",
    "Survey": "Survey",
    "Assessment": "Assessment",
    "Code": "Code",
    "CodeUnique": "Code should be unique.",
    "Delivered": "Delivered",
    "Items": "Items",
    "LastSat": "Last sat",
    "PassRate": "Pass rate",
    "Reliability": "Reliability",
    "Version": "Version",
    "FunctionalId": "Item ID",
    "ExternalIdsUsed": "The following External IDs are already used in the system",
    "Draft": "Draft",
    "Forms": "Forms",
    "Live": "Live",
    "FunctionalIdsUsed": "The following Item IDs are already used in the system",
    "DeletingIsInProgress": "Please wait, deleting in progress...",
    "NoResultsFound": "No results found",
    "ArchivingIsInProgress": "Please wait, archiving in progress...",
    "UnarchivingIsInProgress": "Please wait, unarchiving in progress...",
    "CopyingIsInProgress": "Please wait, copying in progress...",
    "CorrectAnswers": "Correct answer(s)",
    "Included": "Included",
    "Unassigned": "Unassigned",
    "Hierarchy": "Hierarchy",
    "FinalScore": "Final score",
    "SkinDeletionConfirmation": "Are you sure you want to delete this theme \"{0}\"?",
    "SkinsDeletionConfirmation": "Are you sure you want to delete {0} theme?",
    "Available": "Available",
    "Reset": "Reset",
    "Loading": "loading...",
    "Sections": "Sections",
    "UsedSkinDeletionConfirmation": "Theme \"{0}\" is used in schedule(s)",
    "UsedSkinsDeletionConfirmation": "Themes \"{0}\" are used in schedule(s)",
    "Candidates": "Candidates",
    "Grade": "Grade",
    "Schedules": "Schedules",
    "Submitted": "Submitted",
    "View": "View",
    "Published": "Published",
    "Key": "Key",
    "FileTypeNotSupported": "File type not supported",
    "NotPublished": "Not published",
    "SebKeyDeletionConfirmation": "Are you sure you want to delete this key \"{0}\"?",
    "SebKeysDeletionConfirmation": "Are you sure you want to delete {0} keys?",
    "SelectPublisher": "Select publisher",
    "StartTyping": "Start typing",
    "TypeHereToSearch": "Type here to search",
    "Rescored": "Rescored",
    "PcValue": "Pc",
    "PValue": "P",
    "Rir": "Rir",
    "Rit": "Rit",
    "ApplyChanges": "Apply changes",
    "Discard": "Discard",
    "Apply": "Apply",
    "Change": "Change",
    "Changed": "Changed",
    "Comment": "Comment",
    "Removed": "Removed",
    "Undo": "Undo",
    "Scored": "Scored",
    "Seed": "Seed",
    "ResetToDefault": "Reset to default",
    "AdjustedStatus": "Adjusted result",
    "CandidateName": "Candidate name",
    "InformCandidates": "Inform candidates",
    "NoResults": "No results",
    "NotSatisfactory": "Not satisfactory",
    "OriginalStatus": "Original result",
    "Percentage": "Percentage",
    "Rescoring": "Rescoring",
    "Satisfactory": "Satisfactory",
    "ScheduleTitle": "Schedule title",
    "SendEmailToCandidates": "Send e-mail to candidates",
    "UserIdUpperCase": "User ID",
    "Action": "Action",
    "None": "None",
    "Always": "Always",
    "AssessmentForm": "Assessment form",
    "AssessmentTitle": "Assessment title",
    "AssessmentType": "Assessment type",
    "By": "By",
    "CandidateLowerCase": "candidate",
    "Ending": "Ending",
    "LearningObjectives": "Learning objectives",
    "LoadingItems": "Loading items...",
    "LockDownBrowser": "Lock-down browser",
    "Mixed": "Mixed",
    "Next7Days": "Next 7 days",
    "NoLearningObjectives": "No learning objectives",
    "NoTaxonomies": "No taxonomies",
    "NumberOfQuestions": "Number of questions",
    "PublishedOn": "Published on",
    "ResultsFor": "Results for",
    "Scheduled": "Scheduled",
    "SearchFor": "Search for",
    "Security": "Security",
    "SetTimeSpan": "Set time span",
    "Starting": "Starting",
    "Taxonomies": "Taxonomies",
    "UsePinCode": "Use pin code",
    "Welcome": "Welcome",
    "Now": "Now",
    "ReadMore": "Read more",
    "AssessmentCode": "Assessment code",
    "Form": "Form",
    "LearningObjective": "Learning objective",
    "LastModified": "Last modified",
    "AssessmentPagePreview": "Assessment page preview",
    "Questions": "Questions",
    "SeedItem": "Seed item",
    "Connection": "Connection",
    "AddQuestions": "Add questions",
    "Section": "Section",
    "Hide": "Hide",
    "ConnectedQuestionsWillBeDeleted": "Connected questions will be deleted together with the section(s)",
    "FileSizeExceeded": "The maximum size of files uploaded is 15MB. You could try to compress the file",
    "SowisoSetsWillBeDeleted": "Deleting mathematical questions that are included in sets will lead to deletion of the whole sets",
    "Generate": "Generate",
    "Copy": "Copy",
    "CommentsRaw": "Comments",
    "Marked": "marked",
    "Progress": "Progress",
    "ClustersDeletionConfirmation": "Are you sure you want to delete {0} clusters?",
    "ClusterDeletionConfirmation": "Are you sure you want to delete this cluster \"{0}\"?",
    "ClusterInAssessmentsWontBeDeleted": "Cluster used in assessments won't be deleted",
    "SeveralSeconds": "{0} seconds",
    "SeveralMinutes": "{0} minutes",
    "Cluster": "Cluster",
    "Path": "Path",
    "Groups": "Groups",
    "ClustersHierarchyDeletionConfirmation": "This cluster is being used in assessment(s). Users that belong to hierarchy won’t be able to schedule assessment. Are you sure you want to delete hierarchy  <b>\"{0}\"</b>?",
    "Clusters": "Clusters",
    "Success": "Success",
    "Default": "Default",
    "Alert": "Alert",
    "Info": "Info",
    "Rename": "Rename",
    "Evaluation": "Evaluation",
    "Evaluate": "Evaluate",
    "Submission": "Submission",
    "Run": "Run",
    "Compilation": "Compilation",
    "InputField": "Input field",
    "BelongsTo": "Belongs to",
    "SynchronizationKeyIsNotValid": "The Synchronization key is not valid. Field won't be updated.",
    "Unlock": "Unlock",
    "LockedBy": "Locked by",
    "LockedDate": "Locked date",
    "Debug": "Debug",
    "EnterSectionIntroductionText": "Enter the section introduction text",
    "Point": "point",
    "Webhooks": "Webhooks",
    "SettingPinIsInProgress": "Please wait, setting PIN-codes in progress...",
    "Autoscored": "autoscored",
    "Voided": "Voided",
    "ShowExtraFields": "Show extra fields",
    "Browse": "Browse",
    "DefaultMarkerRole": "Default marker role",
    "ClearAnswer": "Clear answer",
    "DefaultCandidateRole": "Default candidate role",
    "Minimize": "Minimize",
    "Paste": "Paste",
    "Users": "Users",
    "TableFetchFailed": "Data fetch failed, please",
    "WorkoutBox": "Notepad",
    "Send": "Send",
    "Notepad": "Notepad",
    "ViewBy": "View by",
    "InsertPdf": "Insert PDF",
    "AddFile": "Add file",
    "Hours": "hours",
    "Days": "days",
    "ShowLess": "Show less",
    "ShowMore": "Show more",
    "DataFetchFailed": "An error occurred while loading data. Please,",
    "Disabled": "Disabled",
    "Randomize": "Randomize",
    "ExternalIdIsNotValid": "External id is not valid. Field won't be updated.",
    "AudioSettings": "Audio Settings",
    "Step": "Step",
    "NotepadTip": "Allow candidates to make notes during the exam",
    "AudioSettingsTip": "Audio settings only applies if you have used recorded audio in your question or uploaded an mp3 file.",
    "Round": "Round",
    "AddStep": "Add step",
    "Download": "Download",
    "Revoke": "Revoke",
    "UnrecognizedEvent": "Unrecognized event",
    "InvalidJSON": "Invalid JSON",
    "CopyToClipboard": "Copy to clipboard",
    "PleaseConfirm": "Please confirm",
    "Open": "Open",
    "Token": "Token",
    "PageType": "Page type",
    "Mean": "Mean",
    "Median": "Median",
    "ModeNotSupported": "Mode not supported!",
    "PrintScoreReport": "Print Score Report",
    "Keycode": "Keycode",
    "Table": "Table",
    "TableEmpty": "Table empty",
    "MeanValue": "Mean value",
    "MedianValue": "Median value",
    "Issuer": "Issuer",
    "DeploymentId": "Deployment ID",
    "PlatformId": "Platform ID",
    "PublicKey": "Public Key",
    "Platform": "Platform/LMS",
    "ConnectionDetails": "Connection details",
    "IntegrationSettings": "Integration settings",
    "ClientId": "Client ID",
    "InvalidUrl": "You must enter valid URL",
    "NoNotifications": "The latest notifications will be shown here. There are currently no notifications.",
    "SelectCandidates": "Select candidates",
    "ResetFilters": "Reset filters",
    "RemoteProctorioSettings": "Remote proctoring settings",
    "TestDate": "Test date",
    "CandidateId": "Candidate ID",
    "ResetSettings": "Reset settings",
    "CustomizeTable": "Customize table",
    "CustomizeDialogContent": "Select the columns you want to show in the table",
    "SelectPageHint": "All {0} rows on this page are selected.",
    "SelectAll": "Select all {0} items in this page.",
    "SelectTableHint": "All {0} rows on this table are selected.",
    "PickDateRange": "Pick date range",
    "RowsPerPage": "Rows per page",
    "RowSelected": "row selected",
    "RowsSelected": "rows selected",
    "Timer": "Timer",
    "BulkActions": "Bulk actions",
    "FromDate": "From date",
    "ToDate": "To date",
    "ShowSessions": "Show sessions",
    "Archieved": "Archived",
    "OnlyActive": "Only active",
    "DeleteApprove": "Are you sure you want to delete this/these review session(s)?",
    "PlagiarismControl": "Originality check",
    "ViewReport": "View report",
    "RemarkerScore": "Remarker score",
    "RemarkerName": "Remarker name",
    "RemarkerComment": "Remarker comment",
    "You": "You",
    "VersionShort": "Version",
    "SearchSchedules": "Search for schedules",
    "EditSettingsFor": "Edit settings for {0}",
    "ToSettings": "To settings",
    "ShowSchedules": "Show schedules",
    "ShowAssessments": "Show assessments",
    "SearchUserByName": "Search users by name",
    "AddItem": "Add item",
    "CreateCopy": "Create copy",
    "Labels": "Labels",
    "AllTypes": "All types",
    "Sent": "Sent",
    "Closed": "Closed",
    "Invalid": "Invalid",
    "CreatedBetween": "Created between",
    "Announce": "Announce",
    "UpdateStatus": "Update status",
    "CandidateEmail": "Candidate email",
    "ItemVersion": "Item version",
    "AuthorEmails": "Author email(s)",
    "StatusRemark": "Status Remark",
    "FeedbackType": "Feedback type",
    "FillAllFields": "Please fill out all fields correctly",
    "Seconds": "seconds",
    "Used": "Used",
    "Label": "Label",
    "ApplyToAll": "Apply to all",
    "RemoveFromAll": "Remove from all",
    "LO": "LO",
    "TX": "TX",
    "RemoveLabels": "Remove labels",
    "TimeExpired": "Time has expired",
    "Regular": "Regular",
    "BasedOnTemplate": "Based on template",
    "ItemId": "Item ID",
    "NoFiltersResults": "Try a different word or uncheck some of chosen filters.",
    "NoFilteredItems": "None of available items matched this search",
    "CheckingPermissions": "You don't have permission to view this page.",
    "LearningObjectivesShort": "LO",
    "TaxonomiesShort": "TX",
    "OpenFile": "Open file",
    "Opened": "Opened",
    "Updated": "Updated",
    "BackToTemplates": "Back to templates",
    "SaveAndSpecify": "Save and specify details",
    "BackToDetails": "Back to details",
    "ToAdvancedSettings": "To advanced settings",
    "BackToSettings": "Back to Settings",
    "AssessmentActive": "Assessment Active",
    "AssessmentsPublishingConfirmation": "A new published version of the selected assessments will be created.",
    "UpdateAndPublish": "Update and publish",
    "AdvancedAssessmentSettings": "Advanced assessment settings",
    "AssessmentsPublishingNotice": "The marking workflow and other publishing options will be taken from the originally published assessments without changings.",
    "Purpose": "Purpose",
    "UsersIn": "Users in {0}",
    "Workflow": "Workflow",
    "AllHierarchies": "All hierarchies",
    "ShowUsers": "Show users",
    "SEB": "SEB",
    "OverallProgress": "Overall progress",
    "Scripts": "Scripts",
    "ByAssessor": "By assessor",
    "ByRounds": "By rounds",
    "ExportResults": "Export results",
    "AssessmentPerformance": "Assessing Performance",
    "MarkingHasntStarted": "Marking haven’t started yet.",
    "PerfomanceWillShowSoon": "Performance will be shown here as soon as the first assessor submit results.\n",
    "NumberOfForms": "Number of forms",
    "AddPublisher": "Add publisher",
    "PreliminaryExportTooltip": "Allows you to download the preliminary results. Note that these results are not final an only reflects the marking progress up to the point when you download the file.",
    "FormsUsed": "Forms used",
    "SearchByAssessor": "Search by assessors",
    "ProgressMarkedLeft": "Progress (marked-left)",
    "MarkingStarted": "Marking haven’t started yet.",
    "LearnMore": "Learn more!",
    "Target": "Target",
    "AssessorNotActive": "Assessor hasn’t been active for a long time",
    "NoCoordinatorDashboardResults": "None of assigned assessors matched this search.",
    "NoCoordinatorDashboardResultsDescription": "Please check the spelling of the assessor’s name.",
    "Display": "Display",
    "CandidateReviewSessionStepDescription": "A candidate review session allows you to schedule a time and duration the candidates can view the results of their assessments. It's convenient if you want to control the environment the candidates uses when reviewing their results",
    "AssessmentStepTitle": "The role of the assessment author",
    "CandidateReviewSession": "Candidate review session",
    "ScheduleStepDescription": "The scheduler is responsible for scheduling assessments to be sat by candidates. This includes selecting the assessment to be scheduled, setting the date for when the schedule can be sat and adding candidates.",
    "ScheduleStepTitle": "The role of the scheduler",
    "AssessmentStepDescription": "The assessment author is responsible for creating the assessment. This includes setting the options, select questions and create one or more forms.",
    "1n": "1st",
    "2n": "2nd",
    "3n": "3rd",
    "Shared": "Shared",
    "ReasonableAdjustment": "Extra time",
    "Excluded": "Excluded",
    "ShowTrashcan": "Show trashcan",
    "Basic": "Basic",
    "Optional": "Optional",
    "SelectAnOption": "Select an option",
    "Required": "Required",
    "QuestionsDeletionConfirmationAll": "Are you sure you want to delete ALL elements?",
    "PublicationNeeded": "Publication needed",
    "Assigned": "Assigned",
    "SuccessArchivedPlural": "{0} items were archived",
    "NotSuccessArchivedPlural": "{0} items were not archived",
    "AttemptStatus": "Attempt status",
    "AttemptStatus (Copy)": "Attempt status",
    "Reminder": "Reminder",
    "CloseReminder": "Close and don't show again",
    "ByQuestion": "By Question",
    "ByCandidate": "By Candidate",
    "TwoFactorAuth": "Two-factor authentication",
    "Disable": "Disable",
    "Enable": "Enable",
    "Statuses": "Statuses",
    "Types": "Types",
    "News": "News",
    "Or": "or",
    "NoNews": "No news",
    "RevisionHistory": "Revision history",
    "QuestionEditorEmptySection": "No section for this question",
    "Redo": "Redo",
    "OpenSectionSettings": "Open section's settings",
    "CopyrightText": "Cirrus ({0}) Copyright © {1} Cirrus - all rights reserved",
    "ShowReport": "Show report",
    "NowYouAreViewingAs": "Now you are viewing as",
    "Visibility": "Visibility",
    "ComingSoon": "Coming soon",
    "FileNotSupported": "File is not supported and cannot be opened. Please download the file by clicking on the download icon.",
    "GoodDay": "Good day",
    "AverageTimeRaw": "Average time",
    "LastUsageDate": "Last usage date",
    "NumberOfAssessments": "Number of assessments",
    "Minute": "Minute",
    "Second": "Second",
    "Attach": "Attach",
    "AttachFiles": "Attach files",
    "NameToSave": "Name to save",
    "MaximumAttachments": "Maximum attachments",
    "Format": "Format",
    "WrongFileFormat": "Wrong file format",
    "DeliveryNowYouAreViewingAs": "Now your are viewing {0}'s annotations and feedback",
    "ViewAnnotationsAndFeedback": "View annotation and feedback",
    "DragFilesHere": "Drag files here",
    "ExcludeScoredQuestions": "Exclude scored questions"
  },
  "Geuserneral": {
    "AddExaminers": "Add assessor(s)"
  },
  "Infobox": {
    "AssessmentsDeliveredThisWeek": "Assessments delivered this week",
    "AssessmentsDeliveredToday": "Assessments delivered today",
    "Usage": "Usage",
    "UsersLoggedInLastWeek": "Users logged in last week",
    "UsersLoggedInNow": "Users logged in last day"
  },
  "InvigilationDetails.ExtraTime": {
    "GiveExtraTime": "Give extra time"
  },
  "InvigilationUserDetails": {
    "Answered": "Answered",
    "AnsweredChoices": "Selected choices: {0}",
    "Complete": "{0} completed exam {1}.",
    "Confirmed": "{0} confirmed {1} exam.",
    "ConnectionLost": "Connection was lost from {0} UTC to {1} UTC. Attempt: {2}. Exam: {3}",
    "Continued": "{0} continued {1} exam.",
    "NoAnswer": "Not answered",
    "NotSupportedLog": "This log not supported here.",
    "QuestionAnswered": "{0} answered {1}. Attempt: {2}. {3}.",
    "QuestionVisited": "{0} opened question {1} in {2} exam.",
    "Started": "{0} started {1} exam.",
    "LogOff": "User logged off",
    "PageVisited": "{pageType} \"{pageTitle}\" opened",
    "SurveyQuestionAnswered": "{userName} answered survey question \"{questionTitle}\" - \"{answer}\" in \"{examTitle}\".",
    "SurveyQuestionVisited": "{userName} opened survey question \"{questionTitle}\" in \"{examTitle}\" exam.",
    "SurveySubmitted": "Registration form \"{surveyTitle}\" submitted"
  },
  "ItemPurpose": {
    "Formative": "Formative",
    "Summative": "Summative",
    "Unspecified": "Not specified"
  },
  "Library.Collection.Dialogs.Import": {
    "FromCollection": "Another collection",
    "FromCollectionDesc": "Allows you to select a collection from which you want to import the questions. ",
    "FromExcel": "Excel file",
    "FromExcelDesc": "Allows you to select an Excel file from which you want to import the questions.",
    "FromQTI": "IMS QTI file",
    "FromQTIDesc": "Allows you to select an IMS QTI 2.1 compliant file from which you want to import the questions. ",
    "SelectImportType": "Questions can be imported from several different sources. Select the one that matches your source data:",
    "Title": "Import questions",
    "FromMoodle": "Moodle file type",
    "FromMoodleDesc": "Allows to select a Moodle file from which you want to import the questions.",
    "FromQTITAO": "IMS QTI TAO file",
    "FromQTITAODesc": "Allows you to select an IMS QTI 2.1 TAO compliant file from which you want to import the questions.",
    "FromSowiso": "Mathematical questions",
    "FromSowisoDesc": "Allows you to select a SOWISO compliant xml file from which you want to import the questions.",
    "SowisoInvalidDocument": "Invalid SOWISO xml document.",
    "SowisoAssetsNotSupported": "One or more items contains media files. Media files are currently not supported and will not be imported.",
    "FromQMLDesc": "Allows you to select an QML compliant file from which you want to import the questions. ",
    "FromQML": "QML file"
  },
  "Library.Collection": {
    "Add": "Add",
    "AvgScoreWithDot": "Avg. score",
    "ChanceScore": "Chance score",
    "ClosedQuestions": "Closed questions",
    "ColumnLO": "Learning objective",
    "ColumnMaxScore": "Score",
    "CreateCopy": "Create copy",
    "Created": "Created",
    "Difficulty": "Difficulty",
    "Discrimination": "Discrimination",
    "Export": "Export",
    "FollowingQuestionsWereNotExported": "The following questions were not exported:",
    "Import": "Import",
    "Items": "Items",
    "LearningObjectives": "Learning objectives",
    "LO": "Learning Objective",
    "MaxScore": "Max score",
    "MaxScoreWithDot": "Max. score",
    "Modified": "Modified",
    "NoAnswer": "No answer",
    "NoQuestions": "No questions",
    "NotSet": "Not set",
    "NumberOfRevisions": "No. of revisions",
    "NumberOfTimesTaken": "No. of times taken",
    "OpenQuestions": "Open questions",
    "Pages": "Pages",
    "PcValue": "Pc",
    "PleaseWaitForExport": "The file will now be downloaded. Please wait.",
    "PValue": "P",
    "Question": "Question",
    "QuestionId": "Question Id",
    "QuestionType": "Question type",
    "SelectQuestionType": "Select item type",
    "State": "State",
    "Statistics": "Statistics",
    "Status": "Status",
    "Title": "Collection - {0}",
    "Type": "Type",
    "SeedInfoTableHint": "Question scores marked with an asterix (*) are seed items and will not count towards the score for the candidates.",
    "CollectionSettings": "Collection settings",
    "Share": "Share",
    "ChangeItemPurpose": "Change item purpose",
    "ChangeStatus": "Change status",
    "SomethingWentWrong": "Something went wrong",
    "Taxonomy": "Taxonomy",
    "UsedIn": "Used in",
    "Hint": "You can change these settings at any time within the collection. If you don't select any repository, then all repositories will be available.",
    "UploadTemplateFile": "Upload template file",
    "DropFile": "or simply drop it here",
    "PageTypeHint": "Pages are used to build the test forms. You need at least one welcome page and one finish page.",
    "TopicsPopupCloseButton": "Close",
    "TopicsPopupTitle": "Topics",
    "TopicsPopupContentHeader": "Manage Topics",
    "TopicsPopupContentText": "You can manage your topics used in this collection here. Changes made will automatically be applied to the items using these topics.",
    "TopicsPopupDeleteConfirmationConfirmButton": "Confirm",
    "TopicsPopupDeleteConfirmationCancelButton": "Cancel",
    "TopicsPopupDeleteConfirmationTitle": "Confirm topic deletion",
    "TopicsPopupNoTopicsMessage": "There is no one topic in this collection",
    "TopicsPopupTableColumnTitle": "Title",
    "TopicsPopupTableColumnNumberOfQuestion": "# OF QUESTIONS",
    "TopicsPopupDeleteConfirmationText": "Are you sure you want to delete the topic? Topic will be removed from all the questions.",
    "CollectionSettingsManageTopics": "Manage topics",
    "TopicsPopupSuccessUpdatedMessage": "Topic name was successfully updated",
    "TopicsPopupErrorDeleteMessage": "Topics used assigned to Sowiso can not be deleted when already used in an assessment",
    "TopicsPopupSuccessDeleteMessage": "Topic deleted successfully - “{0}” questions impacted",
    "TopicsPopupTableNoTopicsFound": "No Topics found matching this criteria."
  },
  "Library.CollectionImport.Tip": {
    "Community": "Community",
    "CommunityTip": " - show collections shared by community",
    "Institution": "Institution",
    "InstitutionTip": " - show collections that are shared at the site level",
    "Personal": "Personal",
    "PersonalTip": " - show only my own collections",
    "SharedWithMe": "Shared with me",
    "SharedWithMeTip": " - show collections that shared personally with me by other authors"
  },
  "Library.CollectionImport": {
    "All": "All",
    "AllowsToImportQuestionsFromAnotherTest": "Allows you to import questions from another test",
    "AllowsToImportQuestionsFromFile": "Allows you to import questions from a file",
    "AllowsToImportQuestionsFromIMSQTIFile": "Allows you to import questions from IMS QTI file",
    "AnotherCollection": "Another collection",
    "CollectionImport": "Collection import",
    "Collections": "Collections",
    "Community": "Community",
    "Created": "Created",
    "File": "File",
    "Import": "Import",
    "IMSQTIFormatFiles": "IMS QTI format files",
    "Institution": "Institution",
    "ItemPurposeDoesntExist": "The following item purposes could not be imported because it doesn’t exist",
    "MaxScore": "Max score",
    "Modified": "Modified",
    "NoQuestions": "No questions",
    "NumberOfRevisions": "No. of revisions",
    "ObjectiveNotImported": "The following learning objectives could not be imported",
    "ObjectiveWrongFolder": "The following learning objectives could not be imported because they don't belong to the folder that has been selected for the collection",
    "Personal": "Personal",
    "QuestionType": "Question type",
    "SeeAnExample": "See an example",
    "SelectCollection": "Select collection:",
    "SelectFile": "Select file",
    "SelectFromWhereToImportQuestions": "Select from where you want to import questions.",
    "SelectQuestionsToImport": "Select which questions you want to import from the list below",
    "SharingType": "Sharing type",
    "Show": "Show",
    "Status": "Status",
    "TaxonomyDoesntExist": "The following taxonomies you are trying to import do not exist. You need to add this taxonomies in the Admin interface. Please contact your administrator for this",
    "TaxonomyNotActive": "The following taxonomies could not be imported because they are inactive",
    "TaxonomyNotImported": "The following taxonomies could not be imported",
    "TaxonomyWrongFolder": "The following taxonomies could not be imported because they don't belong to the taxonomy category that has been selected for the collection",
    "ExternalIdWarning": "External ID's will be removed from the existing questions and assigned to the imported ones.",
    "FunctionalIdWarning": "The existing Item IDs will be replaced by a generated ID.",
    "StatusesBecameDraft": "Questions with the following statuses became draft",
    "CannotImportStatuses": "Questions with the following statuses could not be imported",
    "ParentSectionUsedInAssessment": "Parent section with the following IDs are used in assessments",
    "ItemsHasErrorsInConnectedTo": "The following items had errors in \"Connected to\" field",
    "ChildQuestionIsUsedInAssessment": "The following sections had connected questions that used in assessments",
    "ChildQuestionIsAlreadyInSection": "The following sections had connected questions that are already in sections"
  },
  "Library.Collections.Dialogs.AddCollection": {
    "Title": "Add collection"
  },
  "Library.Collections": {
    "Add": "Add",
    "Available": "Available to",
    "AvailableTo": "Available to",
    "CollectionPrefix": "Collection Prefix",
    "DialogCancelWarning": "You are closing this dialog. All entered data will be lost. Are you sure you want to continue?",
    "Hierarchy": "Hierarchy",
    "HierarchyDescription": "Select a hierarchy that will be connected to this collection.<br/>\nAll users belonging to this hierarchy can use these items when creating an assessments.",
    "Hierarhy": "Hierarchy",
    "ImportExcel": "Import Excel",
    "ImportQTI": "Import IMS QTI",
    "ImportSelected": "Import selected",
    "LastEditedBy": "Last edited by",
    "LearningObjectiveFolder": "Learning objective folder",
    "LearningObjectiveFolderDescription": "Select a learning objective folder that will be connected to this collection.<br/>\nBy doing this, you make sure you don`t see learning objectives that don`t apply to your subject.",
    "Modified": "Last Modified",
    "NoCollections": "No collections",
    "NoPrefix": "No prefix",
    "NumberOfQuestions": "No. of questions",
    "Personal": "Personal",
    "Prefix": "Prefix",
    "PrefixAlreadyExists": "Collection with this prefix already exists. This field should be unique.",
    "PrefixDescription": "Prefix may contain letters and digits and should be 10 characters max",
    "PrefixMustNotContainSpecialSymbols": "Prefix should not contain spaces or special symbols",
    "Questions": "Items",
    "Role": "Role",
    "SelectHierarchy": "Select hierarchy",
    "SelectObjective": "Select folder",
    "SelectTaxonomy": "Select taxonomy category",
    "SharedWithMe": "Shared with me",
    "Status": "Status",
    "TaxonomyCategory": "Taxonomy category",
    "TaxonomyCategoryDescription": "Adding taxonomy groups to your collection allows you to limit the taxonomies to those contained in the taxonomy group.",
    "Title": "Title",
    "TitleDescription": "Type the name of the collection",
    "FunctionalId": "Prefix",
    "LearningObjectiveRepository": "Learning objective repository",
    "LearningObjectiveRepositoryDescription": "Adding learning objective repositories to your collection allows you to limit the learning objectives to those contained in the repositories.",
    "SelectRepository": "Select repository",
    "SearchCollection": "Search for the name or the owner of the collection",
    "Owner": "Owner",
    "ShortSearchCollection": "Search for the collection or owner...",
    "Export.QTI_v2_1": "IMS QTI v2.1",
    "Export.Excel": "Excel",
    "Archived": "Collection {0} was archived",
    "WereNotArchivedPermission": "Collection {0} wasn't archived. Not enough permissions.",
    "WasUnarchived": "Collection {0} was unarchived."
  },
  "Library.Import": {
    "Title": "Question import"
  },
  "Library.ItemAvailabilities": {
    "Community": "Community",
    "Institution": "Institution",
    "Personal": "Personal",
    "SharedWithMe": "Shared with me"
  },
  "Library.Items": {
    "Collection": "Collection",
    "Created": "Created",
    "Imported": "Imported",
    "ItemPurpose": "Item purpose",
    "Labels": "Labels",
    "Modified": "Modified",
    "NoItems": "No items",
    "NumberOfTimesUsed": "No. of times used",
    "QuestionId": "Id",
    "QuestionNoId": "No Id",
    "QuestionType": "Question type",
    "SelectCollection": "Please, select collection",
    "Status": "Status",
    "Title": "Title",
    "ItemType": "Item type",
    "ChangeStatusConfirmText": "You are about to change the status to {0} for the selected {1} items. Do you want to continue?",
    "ChangeItemPurposeConfirmText": "You are about to change the item purpose to {0} for the selected {1} item. Do you want to continue?",
    "NoResultsText": "Click on Add item button to start working with the collection, or Import Items.",
    "TimePerQuestion": "Time per question",
    "ItemWasDeleted": "Item {0} was deleted.",
    "ItemWasDeletedPlural": "{0} item(s) was deleted"
  },
  "Library.ItemStatuses": {
    "Archived": "Archived",
    "Draft": "Draft"
  },
  "Library.Labels": {
    "Filter": "Filter",
    "Labels": "Labels",
    "NoLablesAvailable": "No labels available",
    "SelectAll": "Select all",
    "UnSelectAll": "Unselect all",
    "Add": "Add labels",
    "ErrorTitleExists": "Label with the same title already exists"
  },
  "Library.Media": {
    "Add": "Add",
    "AvailableTo": "Available to",
    "Created": "Created",
    "NoMediaElements": "No media elements",
    "SelectAll": "Select all",
    "SelectFilter": "Select filter",
    "Title": "Title",
    "Uses": "Uses"
  },
  "Library.MediaItemTypes": {
    "Document": "Document",
    "Picture": "Picture",
    "Sound": "Sound",
    "Video": "Video"
  },
  "Library.Shared": {
    "Check": "Check",
    "EditTags": "Edit tags",
    "Formative": "Formative",
    "ItemPurpose": "Item purpose",
    "LoadFileFromMediaLibrary": "Load file from media library",
    "Question": "Question",
    "QuestionPreview": "Question preview",
    "Rollback": "Rollback",
    "SelectLearningObjective": "Select learning objective",
    "ShowDifference": "Show difference",
    "Summative": "Summative",
    "UploadFile": "Upload file",
    "Value": "Value",
    "WorkingOutBox": "Working out box",
    "YourAnswer": "Your answer"
  },
  "Library.Sharing.Collection.UsersTable": {
    "EmptyTable": "You haven't shared the collection with anyone yet"
  },
  "Library.Sharing.Collection": {
    "Hint": "Select who should have access to your collection",
    "PageTitle": "Share collection",
    "SetPermissionWarning": "Please set permission for selected users"
  },
  "Library.Sharing.Overview.UsersTable": {
    "CollectionRole": "Collection role",
    "EmptyTable": "You haven't shared anything with anyone yet"
  },
  "Library.Sharing.Overview": {
    "AccessToQuestions": "Use in assessments",
    "PageTitle": "View permissions"
  },
  "Library.Sharing.Questions.UsersTable": {
    "EmptyTable": "You haven't shared the questions with anyone yet"
  },
  "Library.Sharing.Questions": {
    "Hint": "Select who should have access to your questions",
    "PageTitle": "Share questions"
  },
  "Library.Sharing.UsersTable": {
    "Email": "E-mail",
    "Hierarchy": "Hierarchy",
    "Name": "Name",
    "Permission": "Permission",
    "Role": "Role"
  },
  "Library.Sharing": {
    "IWouldLikeTo": "I would like to:",
    "ShareCollectionLink": "Select who should have access to my collection",
    "ShareQuestionsLink": "Select who should be able to use questions from this collection in assessments",
    "SharingOverviewLink": "View a detailed overview of the current sharing permissions",
    "YouCanNow": "You can now: "
  },
  "Library.Sidebar": {
    "AvailableTo": "Available to",
    "Filters": "Filters",
    "NoItems": "No items"
  },
  "Library.Submodules": {
    "Collections": "Collections",
    "Items": "Items",
    "MediaElements": "Media elements"
  },
  "Library.Tabs": {
    "Collections": "Collections",
    "Items": "Items",
    "MediaElements": "Media elements"
  },
  "Library": {
    "CollectionsSubmoduleTitlePart": "collections",
    "Import": "Import",
    "Items": "Items",
    "Statistics": "Statistics",
    "SubmoduleTitle": "Library: {0}",
    "Title": "Library:{0}",
    "TrashcanErrorSectionConnected": "Items used in sections can only be restored together with section.",
    "TrashcanErrorSectionConnectedSingle": "Items {0} used in sections can only be restored together with section."
  },
  "Login": {
    "InvalidUsernameOrPassword": "Invalid username or password.",
    "Language": "Language",
    "Login": "Login",
    "Password": "Password",
    "Username": "Username",
    "Version": "Version",
    "NotAllowedIp": "Sorry, but you don’t have permission to log in from this IP or IP range",
    "DisabledUser": "Use SAML to login, you are not allowed to login using username/password",
    "InvalidSessionToken": "Invalid session token!",
    "NoRole": "The user does not have any permissions. Contact your administrator.",
    "InvalidUsernameOrKeycode": "Invalid username or keycode.",
    "InvalidKeycode": "Invalid keycode.",
    "RecoveryEmailPerhapsSent": "If you entered a valid username an email containing a recovery link will have been sent to your user's email address. (For security reasons we cannot disclose if the username you entered was correct)"
  },
  "MailTemplates": {
    "ExamEvaluationEnded": "<p>Dear {{ name }},</p><p>You received <strong>{{ grade }}</strong> for <strong>{{ exam }}</strong> examination.</p>\n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "ForgottenPassword": "<p><b>Forgot your password? </b> </p> <br />\n\n<p>Follow the link below to reset your password </p> \n<p>You'll be resetting the password for the account [{{ Email }}]</p> <br />\n\n<a href=\"{{ AppHost }}/{{ Token }}\" target=\"_blank\"><b>Reset password</b></a> <br /> <br />\n\n<p>Or use this link to reset your password:</p>\n<a href=\"{{ AppHost }}/{{ Token }}\" target=\"_blank\"><b>{{ AppHost }}/{{ Token }}</b></a> <br /> <br />\n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "InformCandidate": "<p>Dear {{ FirstName }} {{ LastName }},</p><br>\r\n<p>Your administrator has scheduled you to take the following exam:<br>\r\n{{ ExamTitle }} on {{ ExamDate }} at {{ ExamTime }}</p> \r\n<br>\r\n<p>Best regards,<br>\r\nCirrus Assessment Platform</p>",
    "InfromInvigilator": "<p>Dear {{ FirstName }} {{ LastName }},</p> \n<p>Your administrator has scheduled you as an invigilator to invigilate the following assessment: {{ ExamTitle }}.\n<br>\nThe assessment starts on {{ ExamDate }} at {{ ExamTime }}. \n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "InfromMarker": "Dear {{ FirstName }} {{ LastName }},\n<br>\nYour administrator has scheduled you as an assessor to assess the following assessment: {{ ExamTitle }}.\n<br>\nPlease note that you can only start assessing once candidates have submitted their answers.\n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "InfromModerator": "Dear {{ FirstName }} {{ LastName }},\n<br>\nYour administrator has scheduled you as a moderator to assess the following assessment: {{ ExamTitle }}.\n<br>\nPlease note that you can only start assessing once candidates have submitted their answers.\n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "NewCustomer": "<p>Welcome, {{ FirstName }} {{ LastName }}</p>\r\n<p>Thank you for choosing Cirrus, the next generation in e-Assessment!</p>\r\n<p>You've joined a growing list of organisations that are now using Cirrus to manage their e-assessment processes and create better assessments.</p>\r\n<p>A new Cirrus environment has just been created for you: {{ ShortName }}.{{ Host }}\r\n<br>\r\nYour administrator login is: {{ UserName }}\r\n<br>\r\nPassword: {{ Password }}\r\n</p>\r\n<h3>Next steps:</h3>\r\n<ul>\r\n<li> Take a moment to visit our <a href=\"https://help.cirrusassessment.com/\">Help Centre</a> (<a href=\"https://help.cirrusassessment.com/\">help.cirrusassessment.com</a>) about <a href=\"https://help.cirrusassessment.com/purl/getting-started\">Getting Started</a>.</li>\r\n<li>We will contact you to organise an Intake and <a href=\"https://help.cirrusassessment.com/purl/training\">Training</a>.</li>\r\n<li>You will receive an invite for our Customer Portal. Our <a href=\"https://help.cirrusassessment.com/purl/customer-portal-intro\">Customer Portal Intro</a> page has a 1-Minute Briefing.\r\n<li>Start by creating questions and assembling your first assessment.</li>\r\n</ul>\r\n<p>Our Customer Success team is eager to make your Cirrus a success! Our <a href=\"https://help.cirrusassessment.com/purl/getting-started\">Getting Started</a> page also briefs you about <a href=\"https://help.cirrusassessment.com/docs/getting-help\">Getting Help</a> from them.</p>\r\n<p>Best wishes,<br>\r\nThe Cirrus Assessment team.</p>",
    "PasswordUpdate": "<p>Hello, {{ FirstName }} {{ LastName }}</p>      \n<br>\n<p>Your password has just been changed.</p>\n<br>\n<p>Your administrator login is: {{ UserName }}\n<br>\nNew password: {{ Password }}</p>\n<br>\n<p>Best regards,<br>\nCirrus Assessment Platform</p>",
    "InformCandidateAboutReScoring": "<p>Dear {{ FirstName }} {{ LastName }},</p>      \r\n<p>The scoring of the {{ ExamTitle }} exam has been changed.</p>  \r\n<p>You can view the adjusted results on your personal dashboard or ask your assessor for the adjusted results.<br>\r\n<br>\r\n<p>Best regards,<br>\r\nCirrus Assessment Platform</p>",
    "InformUserThatAdministratorLoggedInUnderHisAccount": "<p>Dear {{ FirstName }} {{ LastName }},</p>      \r\n<p>{{ AdminFirstName }} {{ AdminLastName }} ({{ AdminRole }}) has logged in as you on {{ DateTime }}.</p> \r\n<br>\r\n<p>Best regards,<br>\r\nCirrus Assessment Platform</p>",
    "CandidateFeedback": "{{ CandidateFirstName }} {{ CandidateLastName }} (id: {{ CandidateId }}, email: {{ CandidateEmail }}) has provided the following feedback during Assessment \"{{ AssessmentTitle }}\" (code: {{ AssessmentCode }}) on {{ FeedbackDate }} at {{ FeedbackTime }}:<br>\n<br>\nFeedback Title: {{ FeedbackTitle }}<br>\nFeedback Type: {{ FeedbackType }}<br>\nItem-ID {{ ItemID }}<br>\nQuestion-type: {{ ItemQuestionType }}<br>\n<br>\nFeedback:<br>\n{{ FeedbackDescription }}",
    "CandidateFeedbackSubject": "Feedback on item {{ ItemID }} - \"{{ FeedbackTitle }}\" - {{ FeedbackTimestamp }}"
  },
  "Marking.Adjustment": {
    "AcceptAdjustedAnswer": "Accept adjusted answer for all candidates",
    "AdjustedAnswer": "Adjusted answer",
    "Adjustments": "Adjustments",
    "ChangeMaxScore": "Change the max score",
    "DonNotUseQuestion": "Don't use this question",
    "GiveFullScore": "Give full score to all candidates",
    "OriginalAnswer": "Original answer",
    "Question": "Question",
    "Score": "Score",
    "ThisQuestionIsManualyMarked": "This question is marked manually"
  },
  "Marking.Archive": {
    "ResultsPublished": "Results published"
  },
  "Marking.Assessments": {
    "All": "All",
    "AssessmentStart": "Schedule start",
    "AssessmentTitle": "Assessment title",
    "Code": "Code",
    "EvaluationDeadline": "Marking deadline",
    "EvaluationDeadlineDescr": "Marking deadline",
    "EvaluationStart": "Marking start",
    "HandInDeadline": "Hand-in deadline",
    "NoAssessments": "No assessments",
    "Progress": "Progress",
    "ProgressToBeModerated": "Progress / To be moderated",
    "Qualification": "Qualification",
    "Status": "Status",
    "Term": "Term",
    "Title": "Title",
    "LastSubmitted": "Last submitted",
    "AssessmentEnd": "Schedule end",
    "SubmittedBefore": "Submitted before",
    "SubmittedAfter": "Submitted after"
  },
  "Marking.Assessors": {
    "SetRoleWarning": "Please set role for selected users"
  },
  "Marking.Candidates": {
    "Candidates": "Candidates"
  },
  "Marking.Coordinator": {
    "Change": "Change",
    "NeedAssessors": "Need assessor(s)",
    "SearchSchedule": "Search for the assessment you want to assess...",
    "Search": "Search for the assessment you want to coordinate assessors for...",
    "SearchSearchPlaceholder": "Search for the assessment...",
    "OnlyIfAssessingSame": "Only if assessing same",
    "AllItems": "All candidates/items",
    "EditMarkingScheme": "Edit marking scheme",
    "ModeratorDecides": "Moderator decides",
    "AssessorDecides": "Assessor decides",
    "ViewPublishedResults": "View published results",
    "ArchiveAssessmentsText": "Are you sure you want to archive {0} item(s)?",
    "ArchiveAssessmentsAdditionalText": "Once archived, you can unarchive each of them from Filter.",
    "ArchiveAssessments": "Archive assessment(s)",
    "ArchiveNotAssessedMessage": "{0} of the selected assessments hasn't been assessed, please note that assigned markers can not complete the marking once the assessment has been archived."
  },
  "Marking.Overview": {
    "NoItems": "No items",
    "PopupProgress": "{0} out of {1} candidate(s) assessed",
    "PopupProgressModerator": "{0} candidate(s) need(s) to be moderated"
  },
  "Marking.Results.Tabs": {
    "Detailed": "Detailed results",
    "Short": "Summary",
    "Summary": "Summary"
  },
  "Marking.Results": {
    "All": "All",
    "Mark": "Mark",
    "NoQuestions": "No questions",
    "Number": "No.",
    "Question": "Question",
    "ScoreOutOfMaxScore": "{0} out of {1}",
    "SubmittedAnswer": "Submitted answer",
    "TotalScore": "Total score",
    "AssignedToMe": "Assigned to me",
    "FilterBy": "Filter by",
    "VoidAttempts": "Please request your Admin to allow this permission for your role."
  },
  "Marking.ScoreReport": {
    "ContainsNotScoredHumanMarkedWarning": "Not all questions have been scored. In order for this report to be accurate  all questions must first be scored.",
    "NoAllAssessorsSubmitted": "Not all assessors have submitted scores. In order for this report to be accurate all assessors should submit results."
  },
  "Marking.SubmissionModeratorStatus": {
    "All": "All"
  },
  "Marking.Submissions": {
    "AllCandidatesHandedIn": "All candidate submissions ready to be scored.",
    "AllCandidatesScored": "You have finished scoring all candidate submissions.",
    "NoCandidatesHandedIn": "No candidate has submitted their answers. Please wait for the candidate to start submitting their answers.",
    "OnlyAutomaticallyScored": "All the questions are automatically scored. No action is needed.",
    "SomeCandidatesHandedIn": "There are {0} out of {1} candidate submissions ready to be scored.",
    "SomeCandidatesScored": "You have scored {0} out of {1} candidates.",
    "SomeCandidatesSubmitted": "You have submitted the scores of {0} out of {1} candidates.",
    "WaitingForCoAssessors": "You cannot publish the results before the following assessor(s)/moderator(s) have submitted their scores:",
    "AllCandidatesSubmitted": "Congratulations, you are done scoring. ",
    "AllCandidatesSubmittedByModerator": "Congratulations, you are done scoring.",
    "CanPublishResultsMsg": "You can now go to the Marking: results tab and publish the results.",
    "WaitingForCoAssessors2": "Results cannot be published before the following assessor(s)/moderator(s) have submitted their scores:",
    "CandidatesSubmitted": "Congratulations, you have submitted the scores of all handed in answers",
    "CandidatesScored": "Well done, you have finished scoring of all handed in answers",
    "NoScoreSubmit": "Candidates were not scored. Please wait for the candidates to start submitting their answers",
    "AutoScored": "All the questions are automatically scored. No action is needed",
    "AutoSubmitted": "All the questions are automatically scored. No action is needed",
    "All": "All",
    "AssignedToMe": "Assigned to me",
    "AssignedToOthers": "Assigned to others",
    "SomeQuestionsScored": "You have scored {0} out of {1} questions.",
    "SomeQuestionsSubmitted": "You have submitted the scores of {0} out of {1} questions.",
    "AllQuestionsScored": "You have finished scoring all question submissions.",
    "NoQuestionSubmitted": "Questions were not scored. Please wait for the candidates to start submitting their answers",
    "AllStatuses": "All statuses"
  },
  "Marking.Tabs": {
    "Archive": "Archive",
    "Assessments": "Assessments",
    "Candidates": "Candidates",
    "Complete": "Completed",
    "Coordinator": "Coordinator",
    "MarkingOverview": "Overview",
    "ToBeAssessed": "Assess",
    "Results": "Results",
    "Audit": "Completed",
    "ReScore": "Rescoring",
    "ReviewSessions": "Candidate review"
  },
  "Marking.Warning": {
    "AddAnotherMarker": "Please add another marker",
    "AddModerator": "Please add moderator",
    "AddOneMarker": "Please add at least one marker",
    "AddTwoMarkers": "Please add at least two markers",
    "DuplicatedAssessor": "Allocations can't be saved. Some candidates have the same assessors. Please select other assessor.",
    "MissingAssessor": "Some candidates are missing an assessor",
    "AddPublisher": "Please add at least one publisher",
    "ItemsMissingAssessor": "Some items are missing an assessor",
    "ItemsDuplicatedAssessor": "Allocations can't be saved. Some items have the same assessors. Please select other assessor."
  },
  "Marking": {
    "AddAssessors": "Add assessors",
    "AnonymousAssessor": "Anonymous assessor",
    "AnonymousAssessorDescription": "Selecting this ensures that the assessors will be hidden from each other",
    "AnonymousCandidateDescription": "Selecting this option hides the name of the candidate. ",
    "Assessing": "Assessing",
    "AssessingAllocationChanged": "You changed some assessors who have already started evaluating the exam. Evaluations and annotations of these assessors will be deleted. ",
    "AssessingRoleWasChanged": "Assessing role has been changed for the following users",
    "AssessingSettingsChanged": "Changing settings may lead to the deletion of existing evaluations and annotations of assessors.",
    "AssessingType": "Assessing type",
    "AutomaticAllocation": "Automatic allocation",
    "AutomaticAllocationWarning": "Some candidates already have this user assigned as the second assessor. You'll be able to change it manually",
    "Coordinator": "Coordinator",
    "DeleteOfEvaluationsWarning": "Existing evaluations and annotations of these assessors will be deleted.",
    "DifferenceInScoring": "Difference in scoring",
    "DifferenceInScoringDescription": "Allows you to select the accepted percentage before candidate submissions goes to moderation",
    "Marker": "Marker",
    "Moderation": "Moderation",
    "OverviewPageTitle": "Marking",
    "ProximityToPassMark": "Proximity to pass-mark",
    "ProximityToPassMarkDescription": "Allows you to select the accepted proximity to pass-mark before candidate submissions goes to moderation",
    "RemoveAssessors": "Remove assessors",
    "SelectAssessor": "Select assessor",
    "SetAssessorRandomly": "Set assessor randomly",
    "SharingAnnotationsDescription": "Selecting this option will allow the assessors to view each others assessments",
    "ShowAssessorAnnotations": "Show assessor annotations",
    "ShowAssessorAnnotationsDescription": "Selecting this option will allow the moderator to view annotations from the assessor(s)",
    "UseModeration": "Use moderation",
    "UseModerationDescription": "Selecting this option enables the use of moderation for the assessment",
    "UseModerationsChanged": "You changed \"Use moderation\". All moderators will be deleted",
    "NotAssigned": "not assigned",
    "ReScoring": "Re-scoring",
    "Audit": "Audit",
    "ReviewSessions": "Candidate review",
    "AllocationBy": "Allocation by",
    "AllocationItemTitle": "Item",
    "AllocationItemId": "Item ID",
    "DifferenceInScoringAttempt": "Difference in scoring attempt",
    "DifferenceInScoringItem": "Difference in scoring item",
    "ShowAll": "Show all",
    "NoAvailableModerator": "No available moderator",
    "NoAvailableAssessor": "No available assessors",
    "AutomaticItemsWarning": "Some items already have this user assigned as the second assessor. You'll be able to change it manually",
    "PassMarkRange": "Marking results range",
    "PassMarkRangeDescription": "Allows you to select the marking results range when candidate submissions goes to moderation",
    "ModerationDescription": "Moderators are senior assessors tasked with verifying the marking of assessors. Moderators can be allocated automatically to scripts based on business rules",
    "AssessingDescription": "Assessors are tasked with manually scoring questions.It’s possible to have multiple assessors assigned to an assessment",
    "ScoreAutoScoredChanged": "You changed \"Score auto-scored questions\". All assessors will be deleted",
    "AllocationOfAssessors": "Allocation of assessors",
    "ProgressReport": "Progress report",
    "SearchUsers": "Search users to add",
    "RoleNotAssigned": "Role has not been assigned to {0} users",
    "Conclusion": "Conclusion",
    "SecondMarkerName": "Second marker name",
    "FirstMarkerName": "First Marker Name",
    "ModeratorName": "Moderator name",
    "SampleModerationDescription": "Allows you to select the percentage of candidates/questions that should randomly go to each moderator.\r\nSample moderation is only activated after the schedule window has ended.",
    "SampleModeration": "Sample moderation",
    "DeleteStepConfirmation": "Are you sure you want to delete the step {0}?",
    "ModerationRoundsChanged": "You deleted all moderation rounds. All moderators will be deleted",
    "ModerationSettingsChanged": "Changing settings may lead to the deletion of existing evaluations and annotations of moderators.",
    "ModeratorsAutomaticAllocationWarning": "Some candidates already have this user assigned as moderator. You'll be able to change it manually",
    "ModeratorsAutomaticItemsWarning": "Some items already have this user assigned as moderator. You'll be able to change it manually",
    "ViewProctoredRecordings": "View proctored recordings",
    "VoidAttempts": "Void attempt(s)",
    "Remarking": "Remarking",
    "MarkingProgressStatus": "Marking progress status",
    "MarkerName": "Marker name"
  },
  "MarkingCoordinateStatus": {
    "AssessingInProgress": "Assessing",
    "AssessorNeeded": "Assessor needed",
    "ReadyForAssessing": "Ready for assessing",
    "ModerationNeeded": "Moderation needed",
    "ModerationInProgress": "Moderation in progress",
    "ResultsPending": "Results pending",
    "ResultsPublished": "Results published"
  },
  "MarkingEvaluatorStatus": {
    "Archived": "Archived",
    "Assessed": "Assessed",
    "AssessingInProgress": "Assessing in progress",
    "ModerationComplete": "Moderation complete",
    "ModerationNeeded": "Moderation needed",
    "Pending": "Pending",
    "ReadyForAssessing": "Ready for assessing"
  },
  "MarkingState": {
    "MarkingFinished": "Finished marking",
    "MarkingProgress": "Marking in progress",
    "MarkingReady": "Ready for marking",
    "ModerationProgress": "Moderation in progress",
    "ModerationReady": "Ready for moderation",
    "ReMarkingProgress": "Re-marking in progress",
    "ReMarkingReady": "Ready for re-marking"
  },
  "MarkingStatus": {
    "All": "All",
    "Assessed": "Assessed",
    "BeingAssessed": "Being assessed",
    "NotStarted": "Not started",
    "ReadyToBeAssessed": "Ready to be assessed",
    "Started": "Started"
  },
  "MarkingType": {
    "Computer": "Automatic marking",
    "Human": "Manual marking",
    "OnlyCorrectResults": "Only correct",
    "WrongResults": "Only wrong/partially wrong"
  },
  "MarkingWorkflowState": {
    "Final": "Final - results released",
    "InProgress": "In progress",
    "ReadyForMarking": "Ready for marking",
    "ReadyForModeration": "Ready for moderation",
    "ReadyForReMarking": "Ready for re-marking",
    "Undefined": "Undefined"
  },
  "MatchScoringType": {
    "Description": "Polytomous scoring gives the candidate partial score if answered partially correct. With dichotomous scoring the candidate must answer everything correct in order to get a score.",
    "Dichotomous": "Dichotomous",
    "Polytomous": "Polytomous"
  },
  "MediaSortInfo": {
    "LastUpdated": "Last updated",
    "LeastUsed": "Least used",
    "MostUsed": "Most used"
  },
  "Modules.Modules": {
    "Assessments": "Assessments",
    "Collections": "Collections"
  },
  "Modules.Reports.Tabs": {
    "Detailed": "Detailed results",
    "MasteryLevel": "Mastery level",
    "Summary": "Summary"
  },
  "Modules": {
    "Dashboard": "Dashboard",
    "Marking": "Marking",
    "Reports": "Reports"
  },
  "NotAdmin": {
    "NoUsers": "No users available since you are not added as Administrator to any hierarchy"
  },
  "Notification.DeleteResults.Plural": {
    "Assessment": "Assessments",
    "AssessmentNotDeletedUsed": "{0} assessments were not deleted. Can't delete scheduled assessments.",
    "AssessmentRole": "Assessment roles",
    "AssessmentRoleNotDeletedUsed": "{1} assessment roles were not deleted. They are used in sharing.",
    "AssessmentScale": "Assessment scales",
    "AssessmentScaleNotDeletedUsed": "{0} assessment scales were not deleted. They are used in marking.",
    "Collection": "Collections",
    "CollectionNotDeletedUsed": "{0} collections were not deleted. They contains items used in assessment(s).",
    "CollectionRole": "Collection roles",
    "CollectionRoleNotDeletedUsed": "{0} collection roles were not deleted. They are used in sharing.",
    "DeletedSuccessfully": "{0} {1} have been deleted.",
    "Grade": "Grades",
    "GradeNotDeletedUsed": "{0} grades were not deleted. They are used in marking.",
    "Hierarchy": "Hierarchy",
    "HierarchyNotDeletedUsed": "{0} hierarchies were not deleted. They are used or contains sub-hierarchies used in other parts of the system.",
    "LabelNotDeletedUsed": "{0} labels was not deleted. These labels are used in question(s).",
    "LearningObjective": "Learning Objectives",
    "LearningObjectiveNotDeletedUsed": "{0} items was not deleted. They are used or contain objectives used in collection(s), question(s) or assessment(s).",
    "MarkingRole": "Marking roles",
    "MarkingRoleNotDeletedUsed": "{0} marking roles were not deleted. They are connected to assessor(s).",
    "MediaElement": "Media elements",
    "MediaElementNotDeletedUsed": "{0} media elements were not deleted. These media elements are used in question(s).",
    "NotDeletedInQuarantine": "{0} {1} were not deleted. These {1} is in quarantine.",
    "NotDeletedNoPermissions": "{0} {1} were not deleted. You don't have permissions to delete this {1}.",
    "ObjectiveNotDeletedUsed": "{0} learning objectives were not deleted. They are used or contains objectives used in question(s).",
    "Qualification": "Qualifications",
    "Question": "Items",
    "QuestionNotDeletedUsed": "{0} items were not deleted. These items are used in assessment(s).",
    "Schedule": "Schedules",
    "ScheduleNotDeletedUsed": "{0} schedules were not deleted. Can't delete ongoing exams.",
    "SiteRole": "Site roles",
    "SiteRoleNotDeletedUsed": "{0} site roles were not deleted. They are connected to user(s).",
    "Taxonomy": "Taxonomies",
    "TaxonomyCategory": "Taxonomy categories",
    "TaxonomyCategoryNotDeletedUsed": "{0} taxonomy categories were not deleted. They contains items used in question(s).",
    "TaxonomyItemNotDeletedUsed": "{0} taxonomies were not deleted. These taxonomies are used in question(s).",
    "Term": "Terms",
    "TermNotDeletedUsed": "{0} terms were not deleted. These terms are used in schedule(s).",
    "User": "Users",
    "UserNotDeletedSelf": "{0} users were not deleted. You cannot delete yourself.",
    "Template": "Templates",
    "RepositoryNotDeletedUsed": "{0} repositories was not deleted. They are used or contain objectives used in collection(s), question(s) or assessment(s).",
    "Repository": "repositories",
    "Label": "labels",
    "NotDeletedConnectedItem": "{0} questions was not deleted. These are connected questions that can't be deleted separately from section.",
    "Cluster": "Clusters",
    "ClusterNotDeletedUsed": "{0} clusters were not deleted. These clusters are used in assessment(s)."
  },
  "Notification.DeleteResults": {
    "Assessment": "Assessment",
    "AssessmentNotDeletedUsed": "Assessment {1} was not deleted. Can't delete scheduled assessment.",
    "AssessmentRole": "Assessment role",
    "AssessmentRoleNotDeletedUsed": "Assessment role {1} was not deleted. It is used in sharing.",
    "AssessmentScale": "Assessment scale",
    "AssessmentScaleNotDeletedUsed": "Assessment scale {1} was not deleted. It is used in marking.",
    "Category": "Category",
    "CategoryNotDeletedUsed": "Category {1} was not deleted. It is contains objectives used in question(s) or assessment(s).",
    "Collection": "Collection",
    "CollectionNotDeletedUsed": "Collection {1} was not deleted. It contains items used in assessment(s).",
    "CollectionRole": "Collection role",
    "CollectionRoleNotDeletedUsed": "Collection role {1} was not deleted. It is used in sharing.",
    "DeletedSuccessfully": "{0} {1} was successfully deleted.",
    "Folder": "Folder",
    "FolderNotDeletedUsed": "Folder {1} was not deleted. It is used or contains objectives used in collection(s), question(s) or assessment(s).",
    "Grade": "Grade",
    "GradeNotDeletedUsed": "Grade {1} was not deleted. It is used in marking.",
    "Hierarchy": "Hierarchy",
    "HierarchyNotDeletedUsed": "Hierarchy {1} was not deleted. It is used or contains sub-hierarchies used in other parts of the system.",
    "Label": "Label",
    "LabelNotDeletedUsed": "Label {1} was not deleted. This label is used in question(s).",
    "LearningObjective": "Learning Objective",
    "LearningObjectiveNotDeletedUsed": "Learning objective {1} was not deleted. It is used in question(s) or assessment(s).",
    "MarkingRole": "Marking role",
    "MarkingRoleNotDeletedUsed": "Marking role {1} was not deleted. It is connected to assessor(s).",
    "MediaElement": "Media element",
    "MediaElementNotDeletedUsed": "Media element {1} was not deleted. This media element is used in question(s).",
    "NotDeletedInQuarantine": "{0} {1} was not deleted. This {2} is in quarantine.",
    "NotDeletedNoPermissions": "{0} {1} was not deleted. You don't have permissions to delete this {2}.",
    "ObjectiveNotDeletedUsed": "Learning objective {1} was not deleted. It is used or contains objectives used in question(s).",
    "Qualification": "Qualification",
    "QualificationNotDeletedUsed": "Qualification {1} was not deleted. This qualification is used in assessment(s).",
    "Question": "Item",
    "QuestionNotDeletedUsed": "Item {1} was not deleted. This item is used in assessment(s).",
    "Repository": "Repository",
    "RepositoryNotDeletedUsed": "Repository {1} was not deleted. It is used or contains objectives used in collection(s), question(s) or assessment(s).",
    "Schedule": "Schedule",
    "ScheduleNotDeletedUsed": "Schedule {1} was not deleted. Can't delete ongoing exams.",
    "SiteRole": "Site role",
    "SiteRoleNotDeletedUsed": "Site role {1} was not deleted. It is connected to user(s).",
    "Subject": "Subject",
    "SubjectNotDeletedUsed": "Subject {1} was not deleted. It is contains objectives used in question(s) or assessment(s).",
    "Taxonomy": "Taxonomy",
    "TaxonomyCategory": "Taxonomy category",
    "TaxonomyCategoryNotDeletedUsed": "Taxonomy category {1} was not deleted. It is used or contains items used in other parts of the system.",
    "TaxonomyItemNotDeletedUsed": "Taxonomy {1} was not deleted. This taxonomy is used in question(s).",
    "TaxonomyNotDeletedUsed": "Taxonomy {1} was not deleted. It is used in other parts of the system.",
    "Template": "Template",
    "TemplateText": "You are about to remove {0} template(s).",
    "Term": "Term",
    "TermNotDeletedUsed": "Term {1} was not deleted. This term is used in schedule(s).",
    "User": "User",
    "UserNotDeletedSelf": "User {1} was not deleted. You cannot delete yourself.",
    "UserNotDeletedUsed": "User {1} was not deleted. You cannot delete yourself.",
    "UserNotDeletedHasResults": "User {0} was not deleted. The user has results.",
    "UserNotDeletedInQuarantine": "User {0} was not deleted. The user is in quarantine.",
    "AssessmentNotDeletedInQuarantine": "Assessment {0} was not deleted. The assessment is in quarantine.",
    "CollectionNotDeletedInQuarantine": "Collection {0} was not deleted. The collection is in quarantine.",
    "NotDeletedConnectedItem": "Question {1} was not deleted. This is connected question that can't be deleted separately from section.",
    "Cluster": "Cluster",
    "ClusterNotDeletedUsed": "Cluster{1} was not deleted. This cluster is used in assessment(s).",
    "NotDeletedInfoConnectedToItem": "Connected to Item(s):",
    "UserUsedInOtherParts": "Can't delete user {0}. The user is used in other parts.",
    "CollectionWasDeleted": "Collection {1} was deleted.",
    "NoPermission": "Collection {1} was not deleted. You don't have permissions to delete this collection.",
    "NoPermissionPlural": "{1} collection(s) was not deleted. You don't have permissions to delete this collection(s).",
    "ItemNoPermission": "Item {1} was not deleted. You don't have permissions to delete this item.",
    "ItemsNoPermissionPlural": "{1} item(s) was not deleted. You don't have permissions to delete this item(s).",
    "MediaElementsDeletedPlural": "Media elements were deleted",
    "MediaElementDeleted": "Media element {0} was deleted successfully.",
    "NotDeletedConnectedItemPlural": "{0} questions was not deleted. This is connected question that can't be deleted separately from section."
  },
  "Notification.Errors": {
    "OneError": "Error: {0}",
    "SeveralErrors": "{0} errors have occured:"
  },
  "Notification.Messages.EssayEvaluation": {
    "ErrorAnnotationsSave": "Your annotations were not saved.",
    "ErrorScoreChanged": "The score was not saved.",
    "SuccessAnnotationsSave": "Your annotations have successfully been saved.",
    "SuccessScoreChanged": "The score was saved successfully."
  },
  "Notification.Messages.FileUpload": {
    "ErrorFileUploaded": "Media element was not uploaded.",
    "FileTypeNotSupported": "File type {0} not supported",
    "SuccessFileUploaded": "Media element was uploaded successfully."
  },
  "Notification.Messages.Question": {
    "EmptyAnswersRequirement": "Answer(s) cannot be empty",
    "EmptyChoicesRequirement": "Choices cannot be empty",
    "EmptyExtMatchConnectionRequirement": "You need to create at least one connection between an option in the left column and a matching value in the right column in order to be able to save this question",
    "EnableAdd": "You don't have permission to add new items.",
    "EnableEdit": "You don't have permission to edit this item.",
    "ExtIdMustBeUnique": "Item Id must be unique.",
    "LockedBy": "Locked by {0}.",
    "MinimumNumberOfChoicesRequirementViolation": "Sorry, but this type of question requires at least {0} choices",
    "MinValueLessThenMaxRequirement": "Min value should be less then max value",
    "NeedsMinimumAmountOfRows": "This row cannot be removed because a minimum of {0} row(s) is required.",
    "ScoringTypeRequirement": "No scoring is selected, please select the method to score this item",
    "SectionUsedInPublishedAssessment": "This section is being used in published assessment(s).",
    "SelectCorrectAnswerRequirement": "Select the correct answer",
    "SelectImageRequirement": "Please select image",
    "SelectStatusRequirement": "Please select status",
    "SpecifyBlanks": "Please set blanked word(s)",
    "SpecifyDistractors": "Please set  blanked word(s) and distractor(s)",
    "SpecifyScoreRequirement": " Please enter the score",
    "SpecifySectionTitle": "Please enter the title of the section",
    "SpecifySowisoMode": "Please select mode",
    "SpecifyTextRequirement": "Please enter the question text",
    "SpecifyTextRequirement2": "Please enter the text",
    "UsedInAssessmentNotificationMessage": "This item is being used in assessment(s). Your possibilities to edit this item are limited.",
    "UsedInAssessmentNotificationMessageNotEditable": "This item is being used in assessment(s).",
    "SpecifyPageTitle": "Please enter the title of the page",
    "EmptyPageTextRequirement": "Please enter the page text",
    "EmptySectionTextRequirement": "Please enter the section text",
    "FunctionalIdRequired": "Please set Item ID",
    "SectionCantHaveLiveStatus": "It isn't possible to change status to Live. Section included not Live statused questions.",
    "EmptySowisoSolutionRequirement": "Question cannot have solutions with empty definitions",
    "UsedInSelectionNotificationMessage": "This item is being used in assessment(s). Your possibilities to edit this item are limited.",
    "QuestionTitleInvalid": "Title is invalid. You can fix it or remove completely.",
    "InstructionsInvalid": "Instruction(s) is invalid. You can fix it or remove completely.",
    "MaxTimeInvalid": "Please enter correct maximum time for section.",
    "PassMarkInvalid": "Please enter correct pass mark for section.",
    "ValueIsNotInValidRange": "Value should be a number between ±1.0e-28 and ±7.9228e28",
    "IncorrectNumericFormat": "Format is invalid",
    "SectionOptionDisabled": "Options will be available as soon as one or more questions are added.",
    "SectionDurationNotValid": "Section duration is not valid. Please update section or attempt duration (Attempt duration: {0}m, section duration: {1}m) to make it valid.",
    "SpecifyPageType": "Please specify the type of the page"
  },
  "Notification.Messages.RequestErrors": {
    "ServerNotResponding": "The server is not responding, try again later.",
    "SowisoServerError": "SOWISO server error",
    "HierarchyDepthExceeded": "No more than 10 sub-hierarchies can be added"
  },
  "Notification.Messages.Rollback": {
    "RollbackSuccessful": "Question is rolled back successfully."
  },
  "Notification.Messages.Trashcan.Assessments": {
    "RestoreItem": "Assessment {0} was restored",
    "RestoreItems": "{0} assessments were restored"
  },
  "Notification.Messages.Trashcan.Collections": {
    "RestoreItem": "Collection {0} was restored",
    "RestoreItems": "{0} collections were restored"
  },
  "Notification.Messages.Trashcan.Users": {
    "RestoreItem": "User {0} was restored",
    "RestoreItems": "{0} users were restored"
  },
  "Notification.Messages": {
    "ArchiveSuccessful": "Object(s) have been archived.",
    "CollectionCreatedSuccessfully": "New collection has been created.",
    "DeletePermanentlySuccessful": "Objects have been deleted.",
    "EnterCorrectValues": "Please enter correct values",
    "ErrorExternalApiSettings": "External API settings were not saved",
    "ErrorGlobalSettings": "Customer global settings were not saved",
    "ImportSuccessful": "Import has finished successfully.",
    "NoPermissionShareAssessment": "You don't have permission to share this assessment.",
    "NoPermissionShareCollection": "You don't have permission to share this collection.",
    "RestoreSuccessful": "Object(s) have been restored.",
    "SubmitResultsSuccessful": "Results have been submitted.",
    "SuccessExternalApiSettings": "External API settings were successfully saved",
    "SuccessfulChangesSaving": "Changes have been saved successfully",
    "SuccessfulItemCreation": "New item has been created successfully",
    "SuccessfulTopicCreation": "Topic has been created successfully",
    "SuccessGlobalSettings": "Customer global settings were successfully saved",
    "TemplateHasBeenCreated": "Template has been successfully saved",
    "TopicNotCreatedError": "The server is not responding, topic has not been created.",
    "UnarchiveSuccessful": "Object(s) have been unarchived.",
    "MakingAssessmentCurrentVersion": "Please wait, making this version current.",
    "MakingAssessmentCurrentVersionFinished": "Congratulations. You have now created a new current version of the assessment.",
    "CopySuccessful": "Object(s) have been copied.",
    "ErrorOccuredDuringChangesSaving": "An error occurred while saving changes",
    "RoundingRuleSaveSuccess": "Rounding rule has been successfully changed",
    "EnterCorrectRange": "Please enter correct range",
    "SolutionIsInRange": "Solution is in the range from {0} to {1}.",
    "ConnectedQuestionsRestoredWithSection": "Object(s) have been restored. Connected questions are restored together with the section(s).",
    "ErrorOccurredDuringDataLoading": "An error occurred while loading data",
    "SowisoSetRestoreSuccessful": "Object(s) have been restored. All connected questions are restored together .",
    "ImportSuccessfulCount": "{0} item(s) were imported successfully.",
    "AssessmentUnlockSuccessful": "Assessment was successfully unlocked",
    "UserCreated": "User created",
    "SetPinSuccessful": "PIN-code for {scheduleTitle} was created.",
    "SetPinFailed": "PIN-code for {scheduleTitle} was not created.",
    "SetSeveralPinsSuccessful": "PIN-code for {0} schedules was created.",
    "SetSeveralPinsFailed": "PIN-code for {0} schedules was not created.",
    "PleaseCorrectErrors": "Please fill all required fields and correct all validation errors!",
    "MarkingSchemeLock": "This marking scheme is already being edited. Your co-author needs to exit this marking scheme in order for you to make changes.",
    "SubmitSuccessful": "{0} item(s) have been submitted successfully.",
    "SubmitFailed": "{0} item(s) have not been submitted.",
    "WhileInProgress": "Please wait, the operation is in progress...",
    "VoidSuccessful": "{0} attempt(s) have been voided successfully.",
    "NoAttemptsVoided": "No attempts have been voided.",
    "ProctorioSettingsCannotBeEmpty": "This config is not supported because all settings are disabled.",
    "IntegrationSaveSuccess": "Integration has been saved successfully",
    "IssuerIsAlreadyInUse": "All issuers must be unique. One or more of the entered issuers is already configured in the \"{0}\" integration.",
    "LtiPlatformNotFound": "No shared Platform configuration was found for the provided Client ID",
    "FieldMustBeUnique": "{1} must be unique. The entered {1} is used in \"{0}\"",
    "SubmitScoresSuccessful": "{0} item(s) have been submitted and auto-published successfully",
    "UserIdCannotBeEmpty": "Unable to view report as the user does not have a User ID. Please, contact your administrator.",
    "QuestionsDurationLongerThanAttempts": "One or more forms exceed the allowed duration of this assessment. You can either adjust the duration of this assessment or the time allowed per question",
    "UpdatedAndPublishedSuccessful": "Great job. You have successfully updated and published {count} of {total} assessments.",
    "DeleteAssessmentsSuccess": "{0} assessments have been deleted.",
    "UnarchivePublishedAssessmentsFailed": "Apologies, assessment(s) that has been marked can't be unarchived.",
    "ScoringCriteriaLock": "Scoring criteria are already being edited. Your co-author needs to exit edit mode in order for you to make changes."
  },
  "Notification.Type": {
    "alert": "alert",
    "danger": "danger",
    "dismissable": "dismissable",
    "error": "error",
    "info": "info",
    "success": "success",
    "warning": "warning"
  },
  "NotificationService": {
    "AddedAsAssessor": "You are added as an assessor to {0}",
    "AddedAsModerator": "You are added as a moderator to {0}",
    "AssessmentDeleted": "Assessment {6} was deleted by {2}",
    "AssessmentShared": "Assessment {0} is shared with you by {1}",
    "AssessmentStarted": "{0} start at {1}",
    "AssessmentStatusChanged": "{3} assessment was {4} by {2}",
    "AssessmentUpdated": "Assessment {3} was updated by {2}",
    "CollectionQuestionsShared": "Questions from collection {0} are shared with you by {1}",
    "CollectionShared": "Collection {0} is shared with you by {1}",
    "EvaluatorAssessment": "You are added as an assessor to {0}",
    "ExamFinished": "User {0} has finished exam {1}",
    "MediaElementShared": "Media element {0} is shared with you by {1}",
    "QuestionAdded": "{1} was added to {0} collection by {2} ",
    "QuestionDeleted": "Item {6} was deleted from {0} collection by {2}",
    "QuestionStatusChanged": "Status {5} of {1} in {0} collection was changed to {4} by {2} ",
    "QuestionUpdated": "{1} in {0} collection was updated by {2}",
    "ScheduleAutomaticallyChanged": "schedule {scheduleTitle} has been automatically changed",
    "AddedAsPublisher": "You are added as a publisher to {0}",
    "LoggedInAsYou": "User {username} {role} logged in as you temporarily for support purposes. No action is needed.",
    "ScheduleShared": "Schedule {0} is shared with you by {1}",
    "AddedAsRemarker": "You are added as a remarker to {0}"
  },
  "ObjectivesModal": {
    "SelectLearningObjectives": "Select learning objectives"
  },
  "PassedStatus": {
    "Failed": "Failed",
    "NotAssessed": "Not assessed",
    "NotSatisfactory": "Failed",
    "NotSubmitted": "Not submitted",
    "Passed": "Passed",
    "Satisfactory": "Passed",
    "Undefined": "Undefined",
    "Voided": "Voided",
    "NotPassed": "Not passed"
  },
  "PINCode": {
    "EnterPINCode": "Enter your PIN code",
    "LogIn": "Log in",
    "WrongPINCode": "Wrong PIN code!"
  },
  "Plugins": {
    "AudioCapture": "Audio capture",
    "MediaLibrary": "Media library",
    "InsertMath": "Insert math"
  },
  "Print.Credentials": {
    "Assessment": "Assessment",
    "NoSelectionWarning": "Please select at least one candidate",
    "Welcome": "Welcome",
    "YouCanLoginAt": "You can login at",
    "ConfirmPrintCredentials": "Are you sure? This will generate a completely new password for each selected user! This action cannot be undone.",
    "ExplanatoryIntroText": "To enter this exam please use the URL and “Keycode” shown here",
    "URL": "URL",
    "Schedule": "Exam",
    "ExplanatoryPinText": "At exam time you will be handed a PIN which you will need in addition to the keycode.",
    "ExplanatoryClosingText": "In the event that you also have a regular username/password please note that it will be disabled during this exam.",
    "EnableKeycode": "Do you want to enable keycodes?"
  },
  "Profile": {
    "12TimeFormat": "12 hours",
    "24TimeFormat": "24 hours",
    "Activity": "Activity",
    "AtLeastOneCapitalLetter": "At least one capital letter",
    "AtLeastOneLetter": "At least one letter",
    "AtLeastOneNumber": "At least one number",
    "BeAtLeast8Characters": "Be at least 8 characters",
    "ChangePassword": "Change password",
    "ChangePhoto": "Change photo",
    "ChangingPhoto": "Changing photo",
    "ConfirmPassword": "Confirm password",
    "CurrentPassword": "Current password",
    "Email": "Email",
    "EnterNewPassword": "Enter new password",
    "FirstName": "First name",
    "Hierarchies": "Hierarchies",
    "LastName": "Last name",
    "LongTimeFormat": "Long time format",
    "MemberSince": "Member since",
    "NearestCity": "Nearest city",
    "NewCollectionProfileTitle": "New collection role",
    "NewSiteProfileTitle": "New site role",
    "Password": "Password",
    "PasswordMustMeetRequirements": "Password must meet the following requirements:",
    "Region": "Region",
    "RemovePhoto": "Remove photo",
    "RemovingPhoto": "Removing photo",
    "Role": "Role",
    "SelectLanguage": "Select language",
    "ShortTimeFormat": "Short time format",
    "StandardsAndFormats": "Standards and formats",
    "ThereAreNoNotifications": "There are no notifications",
    "TimeFormat": "Time format",
    "ChangePasswordNoPermission": "You don't have permissions to change your password"
  },
  "ProfitAndLoss": {
    "Eindbalans": "Balance",
    "Resultaat": "Result",
    "Saldibalans": "Balance",
    "ScoreForBalance": "Subscore For Balance",
    "ScoreForBalanceProfit": "Subscore For Result",
    "ScoreForEquity": "Subscore For Equity",
    "ScoreForProfitAndLossAccount": "Subscore For Profit And Loss Account",
    "Totalen": "Totals",
    "WinstEnVerliesrekening": "Profit and Loss Account"
  },
  "Progress": {
    "ActionsDoneCounter": "{0} of {1} actions done"
  },
  "Provider": {
    "IMS LIS": "IMS LIS",
    "LIS": "IMS LIS"
  },
  "Question.Difficulties": {
    "Easy": "Easy",
    "Hard": "Hard",
    "Medium": "Medium"
  },
  "Question.Editor.Sidebar": {
    "LearningObjectives": "Learning objective",
    "NoLearningObjective": "No learning objective added",
    "NoRevisions": "No revisions",
    "NotShared": "Not shared",
    "Preview": "Preview",
    "Question": "Question",
    "Revision": "Revision",
    "Set": "Add",
    "Sharing": "Sharing",
    "Tags": "Tags",
    "View": "View",
    "AddLO": "Add learning objective",
    "ObjectiveTip": "Learning objectives helps you organize the items and lets you use the blueprint to create assessments",
    "NoTaxonomy": "No taxonomies added",
    "ViewHistory": "View history",
    "SelectTaxonomy": "Select taxonomy",
    "RevisionHistory": "Revision history",
    "LastModified": "Last modified",
    "TypeComment": "Add a comment...",
    "NoHistory": "No changes have been saved",
    "Current": "current",
    "SelectStatus": "Select status",
    "Reply": "Reply..."
  },
  "Question.Editor": {
    "EditQuestion": "Edit question",
    "EditSection": "Edit section",
    "NewQuestion": "New question",
    "NewQuestionTitle": "Add {0} question",
    "NewSection": "New section",
    "AdvancedOptions": "Advanced options",
    "Options": "Options",
    "FixedPosition": "Fixed position of alternatives",
    "FixedPositionHint": "Allows you to fix position of certain alternatives, while using random order",
    "Feedback": "Feedback",
    "ShowFeedback": "Show feedback on alternatives",
    "ShowFeedbackHint": "Allows you to enter feedback on each alternative",
    "RandomiseOrderHint": "Allows you to fix the position of alternatives, while using random order",
    "ShowQuestionFeedback": "Show feedback on question",
    "ShowQuestionFeedbackHint": "Allows you to enter feedback on question",
    "LimitAnswers": "Equal to correct options",
    "NoLimitAnswers": "No limit",
    "MaximumNumberOfCandidateSelection": "Maximum number of candidate selection",
    "Sections": "Sections",
    "HandleEmptyCell": "Handle empty cell as 0",
    "HandleEmptyCellHint": "Allows in section candidate's empty cells count as 0",
    "ChoiceLabels": "Add labels",
    "WorkoutOption": "Allow notepad for candidates",
    "DisablePausingAndRewindingOption": "Disable pausing and rewinding of audio",
    "PlaybackLimitOption": "Set the number of playbacks",
    "DisableNavigationOnPlayingOption": "Disable navigation while audio is playing",
    "isPlaybackLimitedOption": "Limit the number of playbacks",
    "NotepadOption": "Allow notepad for candidates.",
    "GeneralOptionsTip": "Allows you to set general options that will affect how the question behaves.",
    "AllowedSelection": "Allowed selection",
    "AllowedSelectionTip": "Allows you to set how many choices the candidates can select."
  },
  "Question.EditorTitle": {
    "EitherOr": "Add Either/Or question",
    "Essay": "Add Essay question",
    "ExtendedMatch": "Add Extended match question",
    "FileResponse": "Add File response question",
    "FillInTheBlank": "Add Fill in the blank question",
    "Hotspot": "Add Hotspot question",
    "Match": "Add Match question",
    "MultipleChoice": "Add Multiple choice question",
    "MultipleResponse": "Add Multiple response question",
    "Numeric": "Add Numeric question",
    "Order": "Add Order question",
    "Section": "Add Section",
    "SelectFromList": "Add Select from list question",
    "ShortAnswer": "Add Short answer question",
    "Sowiso": "Add Mathematical question",
    "Page": "Add page",
    "DragAndDrop": "Add Drag and drop question",
    "Vpl": "Add Programming question",
    "FinancialStatement": "Add Financial Statement question",
    "Cip": "Add Comprehensive Integrated Puzzle question",
    "ExtendedMultipleChoice": "Add Extended multiple choice question"
  },
  "Question.Hotspot.Action": {
    "Clear": "Clear",
    "Delete": "Delete",
    "Ellipse": "Ellipse",
    "Freeform": "Pen",
    "Rect": "Rect"
  },
  "Question.Hotspot": {
    "CantAddMoreHotspots": "You can't add more than {0} hotspots for this question"
  },
  "Question.Marking.Annotations": {
    "View": "View"
  },
  "Question.Marking": {
    "Automatic": "Automatic marking",
    "ChangeScore": "Change score",
    "Manual": "Manual marking",
    "MarkQuestion": "Mark question",
    "ScoreItem": "Needs scoring",
    "View": "View",
    "NeedAssessment": "Need assessment",
    "Change": "Change"
  },
  "Question.MarkingTypes": {
    "Automatic": "Automatic",
    "Manual": "Manual"
  },
  "Question.Purposes": {
    "Both": "Both",
    "Formative": "Formative",
    "Summative": "Summative"
  },
  "Question.RevisionsDialog": {
    "RevisionHistory": "Revision history"
  },
  "Question.Sowiso": {
    "PracticeMode": "Practice",
    "TestMode": "High stake"
  },
  "Question.Statuses": {
    "Draft": "Draft",
    "Undefined": "Undefined"
  },
  "Question.Types": {
    "EitherOr": "Either/Or",
    "EquationEntry": "Equation entry",
    "Essay": "Essay",
    "FileResponse": "File response",
    "FillInTheBlank": "Fill in the blank",
    "Hotspot": "Hotspot",
    "Match": "Match",
    "MultipleChoice": "Multiple choice",
    "MultipleResponse": "Multiple response",
    "Numeric": "Numeric",
    "Order": "Order",
    "SelectFromList": "Select from list",
    "ShortAnswer": "Short answer",
    "Sowiso": "Mathematical question",
    "SowisoSingle": "Mathematical",
    "DragAndDrop": "Drag and drop",
    "Section": "Section",
    "Page": "Page",
    "ExtendedMatch": "Extended match",
    "Vpl": "Programming",
    "FinancialStatement": "Financial statement",
    "Cip": "Comprehensive Integrated Puzzle",
    "ExtendedMultipleChoice": "Extended multiple choice"
  },
  "QuestionAuthoring": {
    "EnableRichEditor": "Enable rich editor",
    "FileNotUploaded": "File was not uploaded",
    "MarkingScheme": "Marking scheme",
    "SaveAndAddQuestionOfThisType": "Save and add question of this type",
    "SetMaximumNumberOfWords": "Set the maximum number of words for candidate's answer",
    "UploadNewFile": "Upload new file"
  },
  "QuestionEditor.Content": {
    "AddAlternative": "Add alternative",
    "AddBlank": "Add Blank",
    "AddEmptyBlank": "Add Empty Blank",
    "AddScore": "Add score",
    "Alternatives": "Alternatives",
    "AlternativesSeparation": "(Different alternatives are separated by commas)",
    "AnswerAlternatives": "Answer alternatives",
    "AnswerCaseSensitivenessCheckbox": "Check this box if you want the answer to be case-sensitive",
    "AnswerMustBeCaseSensitive": "Answers are required to be case-sensitive",
    "BlankedWords": "Blanked words",
    "Correct": "Correct",
    "CorrectAlternatives": "Correct alternatives",
    "CorrectAlternativesSeparation": "(Multiple alternatives are separated by\ncommas. Any alternatives that contain commas must be put in quotation marks (example: \"3,14\", \"3,16\"))",
    "CreateBlank": "Create Blank",
    "CreateHotspot": "Create hotspot",
    "CreateHotspotDescription": "After uploading the image, select the hotspots. You can create more than one hotspot.",
    "Distractors": "Distractors",
    "DistractorsSeparation": "(Different distractors are separated by commas. Any alternatives that contain commas must be put in quotation marks (example: \"3,14\", \"3,16\"))",
    "EnableRichEditor": "Enable rich text editor for candidate",
    "EnterAnswerAlternatives": "Enter the answer alternatives",
    "EnterAnswerSettings": "Enter the answer settings",
    "EnterBlankWords": "Enter the blank words",
    "EnterCorrectAnswers": "Enter the correct answer(s)",
    "EnterQuestion": "Enter the question",
    "EnterScore": "Enter score",
    "EnterSectionTitle": "Enter the title of the section",
    "EnterTextInBlank": "Enter the text in which you want the blank fields to appear",
    "EnterValuesOfLedgerTable": "Enter ledger table data",
    "EnterValuesOfLiquidityBudgetTable": "Enter Liquidity budget data",
    "EnterValuesOfProfitAndLossTable": "Enter profit and loss table data",
    "EnterValuesOfResultBudgetTable": "Enter Results budget data",
    "Feedback": "Feedback",
    "GrossProfit": "Gross Profit",
    "HideFeedback": "(Hide feedback)",
    "Label": "Label",
    "MarkingScheme": "Enter the marking scheme",
    "MatchingAnswersDescription": "The matching pairs can be text, image or sound, or a mix of all elements. The order will be randomly shuffled for the candidate.",
    "New": "New",
    "NoBlankedOutWords": "You have not blanked out any words. The text you choose to blank will be shown in this list.   ",
    "NoScoreInputs": "Nothing selected for scoring",
    "RandomiseOrder": "Randomize order of alternatives",
    "RandomizeOrderChoices": "Randomize order for choices",
    "Remove": "Remove",
    "Results": "Results",
    "Score": "Score",
    "ScoreItem": "Name",
    "ScoringType": "Scoring type",
    "SetMaximumNumberOfWords": "Set the maximum number of words for candidate's answer",
    "SetMaximumScore": "Set maximum score for this question",
    "Settings": "Settings",
    "ShowFeedback": "(Show feedback)",
    "SomeInputsDontHaveScore": "Not all records have a score. The missing records are highlighted.",
    "SumOfCosts": "Sum of costs",
    "SwitchMode": "Switch mode",
    "ToReplaceTextWithBlank": "To replace some text with a blank field, highlight the text and click create blank.",
    "UploadFile": "Upload file",
    "EnterValuesOfLiquidityBalanceTable": "Enter Liquidity balance data",
    "EnterPageTitle": "Enter the title of the page",
    "AddBackgroundImage": "Add background image",
    "RemoveImage": "Remove image",
    "HideComments": "Hide comments",
    "ShowComments": "Show comments",
    "FeedbackOnCorrectAnswer": "If the answer is correct, display the following feedback",
    "FeedbackOnPartiallyAnswer": "If the answer is partially correct, display the following feedback",
    "FeedbackOnIncorrectAnswer": "If the answer is incorrect, display the following feedback",
    "FeedbackCorrectHint": "Your answer is correct",
    "FeedbackPartiallytHint": "Your answer is only partially correct",
    "FeedbackIncorrectHint": "Your answer is incorrect",
    "FeedbackOnQuestions": "Feedback on questions",
    "Fixed": "Fixed",
    "Position": "Position",
    "EnableSpellChacker": "Enable spell checker for candidate",
    "AddSection": "Add section",
    "AddRow": "Add row",
    "EnterCorrectData": "Enter the correct data",
    "Categories": "Categories",
    "UseDistractors": "Use distractors",
    "EnterTitle": "Enter the title",
    "GeneralFeedback": "General feedback",
    "TitleInvalid": "Must be {0} characters or less",
    "OnScreenInstructions": "On-screen instructions",
    "PaperBasedInstructions": "Paper-based instructions",
    "InstructionsInvalid": "Must be {0} characters or less",
    "Criteria": "Criteria",
    "CriteriaHint": "After adding criteria score will be recalculated",
    "AddCriteria": "Add criterion",
    "AddSubcriteria": "Add subcriterion",
    "CriteriaInvalid": "Criteria title is required",
    "CriteriaTitleFieldInvalid": "Please enter correct criteria Title",
    "CriteriaDescriptionFieldInvalid": "Please enter correct criteria Description",
    "CriteriaAreInvalid": "Criteria are invalid",
    "MaxDistractorsNotification": "Count of distractors more then possible value of general count of distractors",
    "MinTotalScoreRequirement": "The total score should be greater than or equal to 1",
    "AudioPlaybackLimitRequirement": "The audio playback limit number should be greater than 0",
    "PlaybackNumberIsInvalid": "The number should be greater than 0",
    "Scoring": "Scoring",
    "ScoringTip": "Define how scoring will be done for this question.",
    "MaxTimeForQuestion": "Max time allowed for the candidate in this question",
    "MaxTimeForQuestionTip": "Leave the field empty if the duration is unlimited.",
    "EnableRichTextEditor": "Enable rich-text editor",
    "Rationale": "Rationale"
  },
  "QuestionEditor.Revisions": {
    " NoComments": " No comments",
    "Changes": "Changes",
    "Comment": "Comment",
    "Comments": "Comments",
    "Compare": "Compare",
    "Created": "Created",
    "CreatedBy": "Created by",
    "Modified": "Modified",
    "ModifiedBy": "Modified by",
    "NoComments": "No comments",
    "NoRevisions": "No revisions",
    "Question": "Question",
    "Rollback": "Rollback",
    "Score": "Score",
    "Status": "Status",
    "WriteAComment": "Write a comment",
    "AddComment": "Add comment"
  },
  "QuestionEditor.Sidebar": {
    "Computer": "Computer",
    "CreatedDateTimeString": "Created: {0}",
    "ItemPurpose": "Item purpose",
    "ModifiedDateTimeString": "Modified: {0}",
    "Print": "Print",
    "QuestionId": "Question Id",
    "Status": "Status",
    "Taxonomy": "Taxonomy",
    "Topic": "Topic",
    "SeedLabel": "Seed item",
    "SeedInfo": "Seed items are considered unscored and will not count towards the score of the candidate. Typically it’s used if you want to test the item before applying them to live assessments."
  },
  "QuestionEditor.Sowiso.Feedback": {
    "NewRule": "new rule"
  },
  "QuestionEditor.Sowiso": {
    "WrongPriority": "Feedback with the same priority and opposite evaluation already exists",
    "SetPreview": "Preview set",
    "WrongTestUsage": "The partial score in test usage must be between 0 and 100"
  },
  "QuestionEditor.TabbedContent": {
    "AddFeedback": "Add rule",
    "AddOverrideHint": "Add override hint",
    "AddSolution": "Add solution",
    "AddVariable": "Add variable",
    "AnswerFields": "Answer fields",
    "AuthorComments": "Author comments",
    "Decimals": "Decimals",
    "DecimalsTooltip": "In case the variable is a decimal number, you can define the number of decimal places here",
    "Definition": "Definition",
    "DeleteFeedback": "Delete rule",
    "DeleteSolution": "Delete solution",
    "DeleteVariable": "Delete last variable",
    "EnterQuestion": "Enter the question",
    "EvaluationType": "Evaluation type",
    "Feedback": "Solution",
    "FeedbackChanged": "Feedback has been changed",
    "FeedbackCreated": "Feedback has been created",
    "FeedbackRemoved": "Feedback has been removed",
    "Feedbacks": "Feedback",
    "FeedbackTitle": "Rule {0}",
    "IncorrectInput": "Incorrect input",
    "NFeedbacks": "Negative feedback",
    "NoFeedbacks": "No feedback",
    "NoSolutions": "No solutions",
    "NoVariables": "No variables",
    "OppositeEvaluation": "Opposite evaluation",
    "OverrideHint": "Override hint",
    "PFeedbacks": "Positive feedback",
    "PostInput": "Post input",
    "Precision": "Precision",
    "PrecisionTooltip": "In case of numerical answers, the absolute precision of the answer can be set here. e.g. When the correct answer is 1, set precision to 0.1 to let all answers between 0.9 and 1.1 be correct.",
    "PreInput": "Pre input",
    "PrePostInputs": "Pre- and post- inputs",
    "Preview": "Preview",
    "Priority": "Priority",
    "Question": "Question",
    "RangeHigh": "Range High",
    "RangeLow": "Range Low",
    "RemoveTrailingZeros": "Remove trailing zeros",
    "SelectSowisoMode": "Select mode",
    "Settings": "Settings",
    "SolutionChanged": "Solution has been changed",
    "SolutionCreated": "Solution has been created",
    "SolutionRemoved": "Solution has been removed",
    "Solutions": "Solutions",
    "SolutionTitle": "Solution {0}",
    "SowisoMode": "Mode",
    "TestUsage": "Test usage",
    "TextChanged": "Text has been changed",
    "VariableChanged": "Variable has been changed",
    "VariableCreated": "Variable has been created",
    "VariableRemoved": "Variable has been removed",
    "Variables": "Variables",
    "NumberOfInputFields": "Number of input fields",
    "Solution": "Solution",
    "SettingsChanged": "Settings have been changed",
    "QuestionSet": "Question set",
    "CantAddHint": "The question must be saved before adding variables",
    "CantChangeInputHint": "The question must be saved before changing number of input fields",
    "IncorrectInputCopy": "There are input errors in your answer. Your answer has not been copied",
    "AnswerWilBeReplaced": "Copied answer will completely replace your current answer. Continue?"
  },
  "QuestionEditor": {
    "AddEitherOrQuestion": "Add either/or question",
    "AddEssayQuestion": "Add essay question",
    "AddFileResponseQuestion": "Add file response question",
    "AddFillInTheBlankQuestion": "Add fill in the blank question",
    "AddHotspotQuestion": "Add hotspot question",
    "AddMatchQuestion": "Add match question",
    "AddMultipleChoiceQuestion": "Add multiple choice question",
    "AddMultipleResponseQuestion": "Add multiple response question",
    "AddNumericQuestion": "Add numeric question",
    "AddOrderQuestion": "Add order question",
    "AddSectionQuestion": "Add section",
    "AddSelectFromListQuestion": "Add select from list question",
    "AddShortAnswerQuestion": "Add short answer question",
    "AddSowisoQuestion": "Add mathematical",
    "ExtendedMatchDescription": "Allows you to create questions with multiple matches",
    "ExtendedMatchTitle": "Extended match",
    "Resource": "Add Resource",
    "MediaFile": "Add Media file",
    "AllowPopup": "Allow opening in pop-up",
    "CloseWhenNavigating": "Close when navigating",
    "General": "General",
    "GeneralTip": "Allows you to set general options that will affect how the question behaves",
    "FeedbackTip": "Allows you to give automated feedback on questions.",
    "FS.OnlyWholeNumbers": "Allow only whole numbers",
    "FS.RemoveDecimal": "Please remove decimal values on Question tab in order to activate this option!"
  },
  "QuestionNavigation": {
    "ForwardOnly": "Forward only",
    "FreeNavigation": "Allow free navigation"
  },
  "Questions": {
    "AvailableQuestions": "Available questions",
    "NoAnswer": "No answer",
    "NoQuestions": "No questions",
    "SelectedQuestions": "Selected questions"
  },
  "QuestionTypes": {
    "EitherOrDescription": "Allows you to select one of two predefined answers",
    "EitherOrTitle": "Either/or",
    "EquationEntryDescription": "Equation Description",
    "EquationEntryTitle": "Equation entry",
    "EssayDescription": "Allows you to enter an open answer to a question",
    "EssayTitle": "Essay",
    "FileResponseDescription": "Allows you to upload a file as a part of your answer",
    "FileResponseTitle": "File response",
    "FillInTheBlankDescription": "Allows you to enter the correct answer in a blank text field",
    "FillInTheBlankTitle": "Fill in the blank",
    "HotspotDescription": "Allows you to click on the correct answer",
    "HotspotTitle": "Hotspot - click the picture",
    "MatchingDescription": "Allows you to drag and drop an alternative to the correct location",
    "MatchingTitle": "Matching",
    "MultipleChoiceDescription": "Allows you to identify the correct answer from a list of alternatives",
    "MultipleChoiceTitle": "Multiple choice",
    "MultipleResponseDescription": "Allows you to identify one or several correct answers from a list of alternatives",
    "MultipleResponseTitle": "Multiple response",
    "NumericDescription": "Allows you to enter a numeric answer",
    "NumericTitle": "Numeric",
    "OrderingDescription": "Allows you to drag and drop a list of alternatives in the correct order",
    "OrderingTitle": "Ordering",
    "SelectFromListDescription": "Allows you to select the correct answer from a list of alternatives",
    "SelectFromListTitle": "Select from a list",
    "ShortAnswerDescription": "Allows you to submit a short, open answer",
    "ShortAnswerTitle": "Short answer",
    "SowisoDescription": "Allows you to create math question",
    "FinancialStatement": "Financial statement"
  },
  "RandomAssessment": {
    "QuestionBlocksWarning": "All sections created for the assessment will be deleted"
  },
  "RegistrationForm": {
    "SubmitConfirmation": "Are you sure you want to submit this form? After submitting you can not go back and change your answers."
  },
  "Reports.AssessmentPerfomance.DiscriminationDifficultyChart": {
    "PointDescriptionFormat": "discrimination: {0}{2}difficulty: {1}",
    "Title": "Item difficulty by item-total correlation discrimination",
    "XAxisTitle": "Item difficulty p-value",
    "YAxisTitle": "Item-total correlation discrimination"
  },
  "Reports.AssessmentPerfomance": {
    "Analytics": "Analytics",
    "AnalyticsResults": "Analytics results",
    "AssessmentName": "Assessment name",
    "ChanceScore": "Chance score",
    "DifficultyDiscrimination": "Difficulty - discrimination",
    "End": "End",
    "EndDate": "End date",
    "FrequencyDistribution": "Frequency distribution",
    "Grade": "Grade",
    "MaxScore": "Max score",
    "NoAssessments": "No assessments",
    "NoData": "No data",
    "NumberOfCandidates": "Number of candidates",
    "NumberOfItems": "No. of items",
    "NumberOfPassed": "No. of passed",
    "Percentage": "Percentage",
    "Score": "Score",
    "Start": "Start",
    "StartDate": "Start date",
    "Title": "Title",
    "Qulifications": "Qualification",
    "Delivered": "Delivered",
    "Items": "Items",
    "LastSat": "Last sat",
    "PassRate": "Pass rate",
    "Reliability": "Reliability",
    "AverageDifficulty": "Avg. P-Value",
    "AverageDifficultyCorrected": "Avg. Pc-Value",
    "AverageRir": "Avg. Rir",
    "AverageRit": "Avg. Rit",
    "ExternalId": "Item ID",
    "Version": "Version",
    "Code": "Code"
  },
  "Reports.CandidateResults": {
    "AchivementLevel": "Achievement level",
    "AssessmentName": "Assessment name",
    "AverageScore": "Average score",
    "Code": "Code",
    "EndDate": "End date",
    "Ending": "Ending",
    "Grade": "Grade",
    "HighestScore": "Highest score",
    "LearningObjectives": "Learning objectives",
    "LowestScore": "Lowest score",
    "Name": "Name",
    "NoAssessments": "No assessments",
    "NoCandidates": "No candidates",
    "NoQuestions": "No questions",
    "NoSchedules": "No schedules",
    "NumberOfCandidates": "No. of candidates",
    "NumberOfCorrect": "No. of correct",
    "NumberOfItems": "No.of items",
    "Qualification": "Qualification",
    "ScheduleTitle": "Schedule title",
    "Score": "Score",
    "StartDate": "Start date",
    "Starting": "Starting",
    "Status": "Status",
    "Taxonomies": "Taxonomies",
    "Title": "Title",
    "Type": "Type",
    "Hierarchy": "Hierarchy",
    "UserNumber": "User ID",
    "NoAssessmentsAvailable": "No assessments available",
    "AssessmentVersion": "Version {0}",
    "AllAssessments": "All assessments",
    "Form": "Forms",
    "FlagForRemarking": "Flag for re-marking",
    "FlagForRemarkingTooltip": "You can flag a candidate for remarking only if the results are published, with Passed/Failed result and with status Final result."
  },
  "Reports.Charts.CollectionsItemsAssessments.Legend": {
    "Assessments": "Assessments",
    "Collections": "Collections",
    "Items": "Items"
  },
  "Reports.Charts.CollectionsItemsAssessments": {
    "Title": "Overview of number of collections, items and assessments",
    "YAxisTitle": "Amount"
  },
  "Reports.Charts.MonthlyAssessmentVolume": {
    "Title": "Monthly assessment volume",
    "YAxisTitle": "Amount"
  },
  "Reports.Export": {
    "ScheduleName": "Schedule name"
  },
  "Reports.Results": {
    "Export": "Export to Excel",
    "Schedules": "Schedules",
    "Candidates": "Candidates"
  },
  "Reports.Shared": {
    "All": "All",
    "Term": "Term"
  },
  "Reports.Sidebar": {
    "AssessmentPerfomanceDescription": "Allows you to view various statistical data on assessments.",
    "AssessmentPerfomanceTitle": "Assessment performance",
    "CandidateResultsDescription": "Allows you to view detailed results of the candidates.",
    "CandidateResultsTitle": "Candidate results",
    "ReportsTitle": "Reports",
    "StatisticsTitle": "Statistics",
    "VolumeDescription": "Allows you to view various statistical data on volume of collections, items and assessments.",
    "VolumeTitle": "Volume"
  },
  "Reports.Volume": {
    "All": "All",
    "Hierarchies": "Hierarchies",
    "Status": "Status"
  },
  "Reports": {
    "Average": "Average",
    "CandidatesAchieved": "Achievement level of the candidates",
    "StatisticalData": "Shows statistical data of the assessments and items",
    "Hint": "The reports section is in beta. We are currently working on improvements. If you have feedback, we would love to hear from you."
  },
  "ResultsBudget": {
    "AddIncorrectLabel": "Add incorrect label"
  },
  "ResultShow": {
    "AfterAllAttempts": "After last attempt",
    "AfterEachAttempt": "After each attempt",
    "Never": "Never",
    "WhenAssessorDecides": "When assessor decides"
  },
  "Roles.Admin": {
    "OwnRoleWarning": "It is your current role. Changing it you change permissions for your user account."
  },
  "Schedule.Info": {
    "AssessmentEndInfo": "Select when you want this schedule to close. Candidates can only take the assessment during this time frame.",
    "AssessmentEndLabel": "Schedule deadline",
    "AssessmentStartInfo": "Select when you want this schedule to open. Candidates can only take the assessment during this time frame.",
    "AssessmentStartLabel": "Schedule opens",
    "ExternalIdInfo": "Enter the external id you want to give the schedule.",
    "ExternalIdPlaceholder": "External ID",
    "ScheduleNameInfo": "Enter the name of the schedule.",
    "ScheduleNamePlaceholder": "Name of schedule",
    "TermInfo": "Select the term you want to associate with this schedule.",
    "TimeZoneLabel": "Time zone",
    "HierarchyInfo": "Select the hierarchy you want to associate with this schedule",
    "AssessmentDateFormat": "Please enter the date in the following format",
    "AssessmentRestrictionFrom": "From:",
    "AssessmentRestrictionTo": "To:",
    "LockNotification": "This schedule is already being edited by {0}. Your co-author needs to exit this schedule in order for you to make changes."
  },
  "Schedule.States": {
    "Assessing": "Assessing",
    "Final": "Final",
    "NotStarted": "Not started",
    "OnGoing": "On going"
  },
  "Schedule.Statuses": {
    "Assessing": "Being assessed",
    "Marked": "Marked",
    "NotStarted": "Not started",
    "Ongoing": "Ongoing",
    "ReadyForAssessing": "Ready for assessing"
  },
  "Schedule": {
    "Summary": "Schedule summary"
  },
  "ScheduleItem.Alert": {
    "InformCandidatesDescription": "Sends out an email to all candidates with details regarding the assessment.",
    "InformCandidatesTitle": "Inform candidates",
    "InformEvaluatorsDescription": "Sends out an email to all assessors with details regarding the assessment.",
    "InformEvaluatorsTitle": "Inform assessors",
    "InformInvigilatorsDescription": "Sends out an email to all proctors with details regarding the assessment.",
    "InformInvigilatorsTitle": "Inform proctors"
  },
  "ScheduleItem.Breadcrums": {
    "DeliveringSchedule": "Delivering: schedule",
    "EditScheduleItem": "Edit schedule item"
  },
  "ScheduleItem.Candidates.Dialogs.Add": {
    "NumOfCandidatesSelected": "Total: {0} candidate(s) selected",
    "Title": "Add candidates"
  },
  "ScheduleItem.Candidates": {
    "All": "All",
    "CandidateId": "User ID",
    "CandidateNumber": "Candidate number",
    "Comment": "Comment",
    "DateOfBirth": "Date of birth",
    "ExtraTime": "Extra time",
    "Hierarchy": "Hierarchy",
    "Name": "Name",
    "NoCandidates": "No candidates",
    "NotSet": "Not set",
    "PINCode": "PIN code"
  },
  "ScheduleItem.Evaluators": {
    "Add": "Add",
    "AssignToAllCandidates": "Assign to all candidates",
    "CandidateId": "User ID",
    "CandidateNumber": "Candidate number",
    "ConvertToExternal": "Convert to external",
    "ExternalEvaluators": "External assessors",
    "InternalEvaluators": "Internal assessors",
    "NotSet": "Not set",
    "Remove": "Remove",
    "SearchForEvaluators": "Search for assessors"
  },
  "ScheduleItem.Info": {
    "Alert": "Alert",
    "AssessingDeadline": "Assessing deadline",
    "Assessment": "Assessment",
    "AssessmentStartEnd": "Timeframe in which the assessment can be started",
    "EvaluationStartEnd": "Marking start/end",
    "NotSelected": "Not selected",
    "Qualification": "Qualification",
    "Qualifications": "Qualifications",
    "Schedule": "Schedule",
    "ScheduleName": "Schedule name",
    "SetTimeZone": "Set time zone",
    "Term": "Term",
    "_To": "to"
  },
  "ScheduleItem.Information.Sections": {
    "Alert": "Alert",
    "Assessment": "Assessment",
    "AssessmentStartEnd": "Timeframe in which the assessment can be started",
    "EvaluationStartEnd": "Marking start/end"
  },
  "ScheduleItem.Invigilators.Dialogs.Add": {
    "NumOfInvigilatorsSelected": "Total: {0} proctor(s) selected",
    "Title": "Add proctor"
  },
  "ScheduleItem.Invigilators": {
    "AddInvigilators": "Add proctors",
    "Email": "E-mail",
    "Hierarchy": "Hierarchy",
    "Name": "Name",
    "NoInvigilators": "No proctors",
    "RemoveInvigilators": "Remove",
    "Role": "Role",
    "SearchFor": "Search for",
    "SearchInvigilator": "Search invigilator",
    "SelectHierarchy": "Please select a hierarchy"
  },
  "ScheduleItem.Sidebar.Sections": {
    "": "Sections",
    "Details": "Details",
    "Preview": "Preview",
    "Progress": "Progress",
    "Schedule": "Schedule"
  },
  "ScheduleItem.Sidebar": {
    "Activate": "Activate",
    "Activated": "Activated",
    "AlreadyActivated": "Already activated",
    "BackToDraft": "Back To DRAFT",
    "CannotDeactivate": "You can't deactivate this schedule",
    "NotActivated": "Not activated"
  },
  "ScheduleItem.Steps": {
    "Assessors": "Assessors",
    "Candidates": "Candidates",
    "Evaluators": "Assessors",
    "Information": "Information",
    "Invigilators": "Proctors",
    "Options": "Options"
  },
  "ScheduleItem": {
    "AssessmentTitle": "Assessment: {0}",
    "AddCandidates": "Add candidates",
    "AddInvigilators": "Add proctors",
    "ActivateSchedule": "Activate schedule"
  },
  "ScheduleItemState": {
    "All": "All",
    "Assessing": "Assessing",
    "Current": "Current",
    "Final": "Final",
    "Marked": "Marked",
    "MarkingFinished": "Finished marking",
    "MarkingProgress": "Marking in progress",
    "MarkingReady": "Ready for marking",
    "ModerationProgress": "Moderation in progress",
    "ModerationReady": "Ready for moderation",
    "NotActivated": "Not activated",
    "NotStarted": "Not started",
    "Ongoing": "Ongoing",
    "ReMarkingProgress": "Re-marking in progress",
    "ReMarkingReady": "Ready for re-marking",
    "ActiveSessions": "Active sessions",
    "Finished": "Finished"
  },
  "ScheduleItemStates": {
    "Assessing": "Being assessed",
    "Current": "Current",
    "Final": "Final",
    "Marked": "Marked",
    "NotStarted": "Not started",
    "Ongoing": "Ongoing"
  },
  "Schedules.Overview": {
    "Type": "Type",
    "NoSchedules": "No schedules",
    "PopoverAssessment": "Assessment title",
    "PopoverScheduled": "Scheduler",
    "PopoverStarts": "Starting",
    "PopoverEnds": "Ending",
    "End": "End",
    "Start": "Start",
    "NeedsAssessing": "Needs assessing",
    "NeedsModeration": "Needs moderation",
    "CanPublish": "Results that can be published"
  },
  "ScoreReport": {
    "LoAchievement": "LO Achievement",
    "MeanTooltip": "The mean (average) of a data set is found by adding all numbers in the data set and then dividing by the number of values in the set.",
    "MedianTooltip": "The median is the middle value when a data set is ordered from least to greatest."
  },
  "ScoringType": {
    "Dichotomous": "Dichotomous",
    "Polytomous": "Polytomous"
  },
  "Search": {
    "All": "All",
    "Assessments": "Assessments",
    "Collections": "Collections",
    "DeliveredFollowingResults": "delivered the following result(s)",
    "FoundWhere": "Found where",
    "HaveNotFoundAnyItem": "Haven't found any item",
    "Questions": "Questions",
    "ReTypeYourQuery": "Re-type your query",
    "Schedules": "Schedules",
    "SearchResults": "Search results",
    "SearchTitle": "Your search for {0} delivered the following result(s)",
    "YourSearchFor": "Your search for",
    "Type.Schedule": "Schedule",
    "Type.Assessment": "Assessment",
    "Type.Collection": "Collection",
    "Type.Question": "Item",
    "Place.Title": "Title",
    "Place.FunctionalId": "ID",
    "Place.QuestionText": "Question",
    "Place.QuestionFeedback": "Feedback",
    "Place.QuestionChoiceText": "Alternative",
    "Place.QuestionChoiceFeedback": "Alternative Feedback",
    "Place.QuestionMatchAnswerText": "Answer",
    "Place.QuestionOrderAnswerText": "Answer",
    "Place.QuestionShortAnswerAnswerText": "Answer",
    "Place.AssessmentCode": "Code"
  },
  "SectionDialog": {
    "CancelConfirmation": "Are you sure you want to cancel? All changes will be lost."
  },
  "SectionPreview": {
    "Title": "Section preview"
  },
  "Services.ScheduleItemService": {
    "Active": "Active",
    "Assessing": "Assessing",
    "Draft": "Draft",
    "Inactive": "Draft",
    "Marked": "Marked",
    "NotActivated": "Not activated",
    "NotStarted": "Not started",
    "Ongoing": "Ongoing",
    "ReadyForAssessing": "Ready for assessing"
  },
  "Services": {
    "CanBeDeletedPermanentrly": "Can be deleted permanently",
    "Community": "Community",
    "InQuarantine": "In quarantine",
    "Unlimited": "Unlimited",
    "Yes": "Yes",
    "_Minutes": "minutes"
  },
  "Settings.Home": {
    "AtLeastOneCapitalLetter": "At least one capital letter",
    "AtLeastOneLetter": "At least one letter",
    "AtLeastOneNumber": "At least one number",
    "BeAtLeastNCharacters": "Be at least {0} characters",
    "ChangePassword": "Change password",
    "ConfirmPassword": "Confirm password",
    "CurrentPassword": "Current password",
    "EnterNewPassword": "Enter new password",
    "PasswordMustMeetRequirements": "Password must meet the following requirements:",
    "Question": "Question"
  },
  "Settings.Taxonomies": {
    "TaxonomyTagAlreadyBeenUsed": "{0}'s tag has already been used in the taxonomy '{1}'"
  },
  "Shared.AssessmentPreview": {
    "Assessment": "Assessment",
    "Blueprint": "Blueprint",
    "CandidateView": "Candidate view",
    "CompleteTest": "Complete test",
    "ContinueTest": "Continue test",
    "CorrectAnswer": "Correct answer",
    "Duration": "Duration",
    "Flag": "Flag",
    "Introduction": "Introduction",
    "Mandatory": "Mandatory",
    "Next": "Next",
    "NumberOfAttempts": "Number of attempts",
    "NumberOfQuestions": "Number of questions",
    "PercentageOfPass": "Percentage to pass",
    "Prev": "Prev",
    "Question": "Question",
    "Score": "Score",
    "TestInformation": "Information",
    "TimeRemaining": "Time remaining:",
    "WhichAttemptsCounts": "Which attempts counts",
    "YourAnswer": "Your answer",
    "Check": "Check"
  },
  "Shared.Modules": {
    "Admin": "Admin",
    "Assessments": "Assessments",
    "Dashboard": "Dashboard",
    "Delivering": "Delivering",
    "Library": "Library",
    "Marking": "Marking",
    "Reports": "Reports"
  },
  "Shared.Sharing": {
    "Add": "Add",
    "Community": "Community",
    "Organisation": "Organization",
    "Person": "Person",
    "Role": "Role",
    "ShareAssessment": "Share this assessment with",
    "ShareCollection": "Share this collection with",
    "ShareMedia": "Share media element with",
    "ShareMedias": "Share media elements with",
    "StartTypingNameOfOrganisation": "Start typing the name of organization",
    "StartTypingNameOfUser": "Start typing the name of user"
  },
  "Shared.TimeZone": {
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Atlantic": "Atlantic",
    "Australia": "Australia",
    "Europe": "Europe",
    "Indian": "Indian",
    "Pacific": "Pacific",
    "Region": "Region",
    "TimeZone": "TimeZone"
  },
  "Shared": {
    "Asc": "Asc",
    "Assessment": "Assessment",
    "Attempts": "Attempts",
    "Blueprint": "Blueprint",
    "CandidateView": "Candidate view",
    "ContinueTest": "Continue test",
    "CorrectAnswer": "Correct answer",
    "CorrectAnswerWithColon": "Correct answer:",
    "CreatedBy": "Created by",
    "CriteriaForCompletion": "Criteria for completion",
    "Custom": "Custom",
    "DeleteItems": "Delete item (s)",
    "Desc": "Desc",
    "DisplayQuestionsInRandomOrder": "Display questions in random order",
    "Duration": "Duration",
    "ExtraTimeForCandidatesWithDisabilities": "Additional time for candidates with access arrangements",
    "Feedback": "Feedback",
    "FeedbackOnAlternatives": "Feedback on alternatives",
    "ForwardOnly": "Forward only",
    "ForwardOnlyDescription": "Candidates must answer a question before they are allowed to proceed.",
    "FoundWhere": "Found where",
    "FreeNavigation": "Free navigation",
    "FreeNavigationDescription": "Candidates can skip questions and navigate back and forth.",
    "Home": "Home",
    "Introduction": "Introduction",
    "ItemsDeletionConfirmation": "Are you sure to delete this item (s)?",
    "LastUpdated": "Last updated",
    "Logout": "Logout",
    "Mandatory": "Mandatory",
    "MaxTimeForAttempt": "Max time allowed for each attempt (minutes)",
    "MySettings": "My settings",
    "Next": "Next",
    "NoFeedback": "No feedback",
    "NumberOfAttempts": "Number of attempts",
    "NumberOfAttemptsAllowed": "Number of attempts allowed",
    "NumberOfQuestions": "Number of questions",
    "OnAlternatives": "On alternatives",
    "OnAlternativesDescription": "Shows feedback after every alternative.",
    "OnQuestions": "On questions",
    "OnQuestionsDescription": "Shows feedback after every question.",
    "PartiallyCorrectAnswerWithColon": "Partially correct answer:",
    "PassMarkScoreDescription": "Candidates must obtain this score in order to receive the Pass mark.",
    "PenaltyAbsenceExplanation": "All correct answers are rewarded - useful for training and motivation.",
    "PenaltyExplanation": "Give a penalty for incorrect or incomplete answers. Useful in exams and formal tests. The penalty may prevent participants from guessing.",
    "PercentageOfPass": "Percentage to pass",
    "Question": "Question",
    "QuestionNavigation": "Question navigation",
    "QuestionPreview": "Question preview",
    "RandomQuestionsOrderDescription": "Present the questions in a random order from candidate to candidate",
    "Range": "Range",
    "RangeBoundsSeparator": " > ",
    "ResultAndFeedback": "Result and feedback",
    "Score": "Score",
    "ScoringMethod": "Scoring method",
    "SharingSeveral": "In several sharing mode you can only add users.",
    "ShowOnlyTotalScore": "Show only total score",
    "ShowOnlyTotalScoreDescription": "Candidates will see their total score, but not which questions are answered correct/incorrect.",
    "ShowResultsPage": "Show results page",
    "ShowResultsPageDescription": "Candidates will see their results including correct/incorrect answers.",
    "TestInformation": "Information",
    "Title": "Title",
    "Unlimited": "Unlimited",
    "UploadFile": "Upload file",
    "Value": "Value",
    "WhichAttemptCounts": "Which attempt counts",
    "WhichAttemptsCount": "Which attempts count",
    "WithoutPenalty": "Without penalty",
    "WithPenalty": "With penalty",
    "WorkingOutBox": "Working out box",
    "WrongAnswerWithColon": "Wrong answer:",
    "YourAnswer": "Your answer",
    "FeedbackDisplayType": "Display feedback"
  },
  "SharingState": {
    "Community": "Community",
    "Institution": "Institution",
    "Personal": "Personal",
    "Undefined": "Undefined"
  },
  "SPL.JournalEntry.QuestionEditor.Content": {
    "AccountName": "Account Name",
    "AccountNumber": "Account Number",
    "Credit": "Credit",
    "Debit": "Debit",
    "SelectAccountList": "Select account list",
    "SelectAnAccount": "Select an account",
    "SelectCurrency": "Select a currency symbol"
  },
  "SPL.JournalEntry.Validation": {
    "requireOneValue": "Give one answer for Debit or Credit"
  },
  "SPL.ProfitAndLoss.QuestionEditor.HeaderA": {
    "DefaultText": "Saldibalans Windvang per 31 december 2016 in euro's"
  },
  "SPL.ProfitAndLoss.QuestionEditor.HeaderB": {
    "DefaultText": "Winst- en verliesrekening en eindbalans Windvang in euro's"
  },
  "StartPage": {
    "Author": "Author",
    "Delivery": "Delivery"
  },
  "StatePermissions": {
    "Deny": "Deny",
    "Modify": "Modify",
    "View": "View"
  },
  "StatisticsPopover": {
    "Difficulty": "Difficulty",
    "DifficultyEasy": "Question too easy",
    "DifficultyHard": "Question too difficult",
    "DifficultyMedium": "Medium",
    "MaxScore": "Maximum score"
  },
  "TaxesModal": {
    "SelectTaxonomies": "Select taxonomies"
  },
  "TemplateQuestionDeletion": {
    "UsedWarning": "That template is used in assessment."
  },
  "TimeFormat": {
    "12 hours": "12 hours",
    "24 hours": "24 hours"
  },
  "Timer": {
    "MinutesRemaining": "minutes",
    "SecondsRemaining": "sec"
  },
  "Upload": {
    "OnlyOneFileMustBeSelected": "Only one file must be selected"
  },
  "User.Import.Error.Message": {
    "ImportContainsDuplicateUsernames": "Import contains duplicate usernames: {0}",
    "MultipleUsersCanBeSynched": "More than one user to synchronize",
    "UsersCanNotBeSynched": "User cannot be synchronized by username",
    "ImportContainsDuplicateUsername": "Import contains duplicate username",
    "ImportContainsDuplicateSynchronizationKey": "Import contains duplicate synchronization key",
    "ImportContainsInvalidSynchronizationKey": "Guid should contain 32 digits and/or letters"
  },
  "User.Import.Label": {
    "Message": "Message",
    "RowNumber": "Row"
  },
  "User.Import.Warning.Message": {
    "ErrorMessagesReachedThreshold": "The maximum number of errors to be displayed is reached. The rest of the errors will not be shown."
  },
  "User.Import": {
    "Generate": "Generate (doesn't change when synchronizing)",
    "SelectColumn": "Select column",
    "InTrashcan": "in Trash can"
  },
  "User.PasswordChange": {
    "Allowed": "Allowed",
    "MustChangeOnNextLogin": "Must change password on next login (changed to Allowed after login)",
    "NotAllowed": "Not allowed",
    "PasswordNeverExpires": "Password never expires"
  },
  "User": {
    "AccountInformation": "Account information",
    "AddHierarchy": "Add hierarchy",
    "AddNewIp": "  Add New Ip",
    "AddNewUser": "Add new user",
    "AddressLine1": "Address line 1",
    "AddressLine2": "Address line 2",
    "AddSubHierarchy": "Add sub-hierarchy",
    "CandidateId": "User ID",
    "CandidateNumber": "Candidate number",
    "CellularPhone": "Cellular phone",
    "ChangePassword": "Change password",
    "ConfirmNewPassword": "Confirm new password",
    "ConfirmPassword": "Confirm password",
    "Created": "Created",
    "CreateUser": "Create user",
    "CurrentPasswordIncorrect": "Current password is incorrect",
    "DateOfBirth": "Date of birth",
    "DeleteSubHierarchy": "Delete sub-hierarchy",
    "Email": "Email",
    "EmailAddress": "E-mail address",
    "EnterNewPassword": "Enter new password",
    "EnterPassword": "Enter password",
    "FirstName": "First name",
    "Hierarchies": "Hierarchies",
    "Hierarchy": "Hierarchy",
    "Import": "Import",
    "ImportUsers": "Import users",
    "IncorrectPassword": "Incorrect password",
    "LastLogin": "Last login",
    "LastName": "Last name",
    "LoginIPWhitelistAll": "Empty = all allowed",
    "LoginIPWhitelistMandatory": "* Mandatory",
    "LoginIPWhitelistTitle": "Allow login from these IP addresses",
    "Name": "Name",
    "NoHierarchies": "No hierarchies",
    "NoItems": "No items",
    "None": "None",
    "NoUsers": "No users",
    "NumberOfImportedRowsInFile": "How many rows in the file that will be imported: ",
    "NumberOfRowsContainedErrorsInFile": "Rows in the file that contains errors (will not be imported): ",
    "NumberOfSynchronizedRowsInFile": "How many rows in the file that will be synchronized: ",
    "OrganisationsBoldHelp": "Organisations are shown in bold.",
    "Password": "Password",
    "PasswordChange": "Password change",
    "PasswordsDontMatch": "Passwords don't match",
    "PersonalInformation": "Personal information",
    "PostAddress": "Post address",
    "PostCode": "Postal code",
    "Profile": "Role",
    "ReEnterPassword": "Re-enter password",
    "SelectHierarchy": "Select hierarchy",
    "SelectProfile": "Select role",
    "SelectSubHierarchy": "Select sub-hierarchy",
    "SetUserAccountExpiration": "Set when user account expires",
    "StartHierarchy": "Start hierarchy",
    "SubHierarchy": "Sub-hierarchy",
    "TryImport": "Try import",
    "UserAccountNeverExpiresCondition": "User account never expires when left empty",
    "UserDeleteConfirmation": "Are you sure to delete this user (s)?",
    "UserInformation": "User information",
    "UserName": "Username",
    "Username": "Username",
    "AvatarUri": "Avatar URI",
    "LoginInformation": "Login information",
    "LoginAsButton": "Login as user",
    "LoginAsButton.UserDoesNotHavePermissions": "User does not have any permissions in the system",
    "NumberOfUsersInTrashcan": "How many users are in Trash can",
    "NumberOfExistsSubGroups": "How many subgroups already exist in the system: ",
    "NumberOfNewSubGroups": "How many subgroups will be created: "
  },
  "UserChangePassword": {
    "Allowed": "Allowed",
    "ChangeOnLogin": "Change on login",
    "NotAllowed": "Not allowed"
  },
  "UserResultStatus": {
    "AssessingComplete": "Assessing complete",
    "AssessingInProgress": "Assessing in progress",
    "Correction": "Correction in progress",
    "HandedIn": "Handed in",
    "ModerationAssessingComplete": "Assessing complete",
    "ModerationComplete": "Moderation complete",
    "ModerationHandedIn": "Handed in",
    "ModerationInProgress": "Moderation in progress",
    "ModerationNeeded": "Moderation needed",
    "ModerationScoringComplete": "Scoring complete",
    "ModerationScoringInProgress": "Scoring in progress",
    "NotHandedIn": "Not handed in",
    "NotSatisfactory": "Not satisfactory",
    "NotSubmitted": "Not submitted",
    "ReadyForAssessing": "Ready for assessing",
    "ReadyForModeration": "Moderation needed",
    "Satisfactory": "Satisfactory",
    "ScoringComplete": "Scoring complete",
    "ScoringInProgress": "Scoring in progress",
    "Submitted": "Submitted",
    "WaitingCoassessors": "Waiting for co-assessors",
    "WaitingForCoAssessor": "Waiting for co-assessor",
    "WaitingForModerator": "Waiting for moderator",
    "Voided": "Voided"
  },
  "Users": {
    "DeletedUser": "Deleted user"
  },
  "Validation.Date": {
    "GreaterThan": "Must be greater than Start date",
    "LessThan": "Must be less than End date"
  },
  "Validation.Warning": {
    "Common": "Some values are not correct"
  },
  "Validation": {
    "Accept": "Please enter a value with a valid extension",
    "AlreadyInUse": "This value is already in use",
    "CreditCard": "Please enter a valid credit card number",
    "Date": "Please enter a valid date",
    "DateISO": "Please enter a valid date (ISO)",
    "Digits": "Please enter only digits",
    "FieldRequired": "This field is required",
    "IntegerNumber": "Please enter valid integer number",
    "InvalidEmail": "Please enter a valid email address",
    "Length": "Please enter at least {0} and no more than {1} characters",
    "LimitCharacterLess": "Please enter at least {0} characters",
    "LimitCharacterMore": "Please enter no more than {0} characters",
    "Max": "Please enter a value less than or equal to {0}",
    "Min": "Please enter a value greater than or equal to {0}",
    "NoSpaces": "Spaces are not allowed",
    "NotValid": "Input is not valid",
    "Number": "Please enter a valid number",
    "OnceAgain": "Please enter the same value again",
    "PasswordsDoNotMatch": "The passwords do not match",
    "Range": "Please enter a value between {0} and {1}",
    "Remote": "Please fix this field",
    "Url": "Please enter a valid URL",
    "Number.Min": "Please enter a value greater than {0}",
    "MinNotEqual": "Please enter a value greater than {0}",
    "MaxNotEqual": "Please enter a value less than {0}",
    "MaxLength": "Please enter a value less than or equal to {0} characters",
    "InvalidExternalId": "This field can only contain [-_a-zA-Z0-9.@].",
    "MinLength": "Please enter a value more than or equal to {0} characters",
    "MaxLength (Copy)": "Please enter a value less than or equal to {0} characters",
    "FieldRequired (Copy)": "This field is required",
    "DigitsRequired": "{0} digits required"
  },
  "VAssessedStatuses": {
    "All": "All",
    "Assessed": "Assessed",
    "NotAssessed": "Not assessed"
  },
  "VAttempts": {
    "AllAttempts": "All attempts ",
    "AllNotMarkedAttempts": "All not marked attempts ",
    "BestAttempt": "Best attempt",
    "FirstAttempt": "First attempt",
    "LastAttempt": "Last attempt",
    "NotHandedIn": "Not handed in",
    "NotSubmitted": "Not submitted",
    "ThatCounts": "Attempts that count",
    "Voided": "Voided attempt"
  },
  "VPassedStatuses": {
    "All": "All",
    "Failed": "Failed",
    "NotAssessed": "Not assessed",
    "NotSatisfactory": "Failed",
    "Passed": "Passed",
    "Satisfactory": "Passed"
  },
  "WebServices": {
    "AddIntegration": "Add integration",
    "AdministrativeProvider": "Administrative provider",
    "DefaultHierarchy": "Default hierarchy",
    "Hierarchy": "Hierarchy",
    "LastRun": "Last run",
    "NoIntegrations": "No integrations",
    "Password": "Password",
    "SecurityToken": "Security token",
    "SelectHierarchy": "Select hierarchy",
    "StartHierarchy": "Start hierarchy",
    "SystemToUse": "System to use",
    "Title": "Title",
    "UrlToGroupService": "URL (Group Management)",
    "UrlToMembershipService": "URL (Membership Management)",
    "UrlToPersonService": "URL (Person Management)",
    "UserName": "User name"
  },
  "WhichAttemptCounts": {
    "Best": "Best attempt",
    "Last": "Last attempt"
  },
  "Workflow.States": {
    "Archived": "Archived",
    "Draft": "Draft",
    "Live": "Live",
    "ReadyForReview": "Ready for review",
    "ReviewedApproved": "Reviewed - approved",
    "ReviewedNotApproved": "Reviewed - not approved"
  },
  "WorkflowState": {
    "Approved": "Reviewed - approved",
    "Archived": "Archived",
    "Draft": "Draft",
    "Live": "Live",
    "NotApproved": "Reviewed - not approved",
    "ReadyForReview": "Ready for review",
    "ReviewedApproved": "Reviewed - approved",
    "ReviewedNotApproved": "Reviewed - not approved",
    "Undefined": "Undefined",
    "Withdrawn": "Withdrawn"
  },
  "AssessmentPreview": {
    "GeneratedAssessment": "Forms",
    "CanNotBeShown": "The preview cannot be shown. You need the following",
    "AtLeast1Question": "At least 1 question",
    "PercentageForPassMark": "Percentage for pass mark",
    "TitleOfAssessment": "Title of the assessment",
    "DialogScore": "Score",
    "DialogSeed": "Seed item",
    "DialogObjective": "Learning objective",
    "DialogHide": "Hide",
    "DialogItemId": "External ID",
    "DialogLink": "Show item information",
    "DialogHeader": "Item information",
    "DialogNoObjective": "No learning objectives",
    "DialogNoItemId": "No ID",
    "DialogNoSeed": "No seed item",
    "DialogNoScore": "No score",
    "Assessment": "assessment",
    "AssessmentScale": "Assessment scale"
  },
  "Marking.Evaluation.Sidebar": {
    "MarkingScheme": "Marking scheme",
    "Scoring": "Scoring"
  },
  "Evaluation.Results.Submission": {
    "TableHint": "Remember, you have to submit the scores once you are done with scoring all the questions.",
    "ContinueMarking": "Continue marking"
  },
  "Marking.Evaluation": {
    "Question": "Question",
    "TitleTemplate": "Assessing Question {0}, submitted by {1} on {2}",
    "Answer": "Answer",
    "ExceedsWordsLimit": "Exceeds the allowed word limit of {0}"
  },
  "QuestionEditor.Content.Numeric": {
    "FormatSelectLabel": "Decimal marker"
  },
  "AssessmentPageType": {
    "Welcome": "Welcome screen",
    "Other": "Other screen",
    "Finish": "Finish screen"
  },
  "PagePreview": {
    "Title": "Page preview"
  },
  "SPL.LiquidityBalance.QuestionEditor.Score.Name": {
    "DebitTotal": "Subscore for Debit",
    "CreditTotal": "Subscore for Credit"
  },
  "General.LabelEditor": {
    "Suggestions": "Suggestions",
    "NewLabel": "New Label"
  },
  "Admin.User": {
    "Labels": "Labels",
    "SpecialNeeds": "Extra time",
    "IpAddresses": "Allow login via these IP addresses",
    "DisableLogin": "Disable Cirrus login",
    "PasswordReset": "Disable password reset",
    "EnableReadSpeaker": "Enable ReadSpeaker",
    "PercentageExtraTime": "Percentage extra time"
  },
  "Assessment.Info.Pages": {
    "YouCanNow": "You can now:",
    "SelectType": "Select type",
    "TableHint": "You need to add at least a welcome and a finish screen.",
    "BeforeTableTitle": "Add the pages you want to appear before the questions",
    "SelectPageType": "Please select page type to search",
    "DialogTitle": "Add page",
    "SearchForPages": "Search for pages you want to add to the assessment",
    "SectionTitle": "Additional pages",
    "AfterTableTitle": "Add the pages you want to appear after the questions",
    "NoPages": "No pages"
  },
  "AssessmentPagesTypes": {
    "NDA": "NDA",
    "Welcome": "Welcome screen",
    "Registration": "Registration form",
    "Finish": "Finish screen",
    "Other": "Other"
  },
  "AssessmentPagesInterceptPurposes": {
    "Welcome": "You can't add more than 1 welcome page",
    "NDA": "You can't add more than 1 NDA page",
    "Registration": "You can't add more than 1 registration page",
    "Finish": "You can't add more than 1 finish page"
  },
  "Reports.Results.Candidates": {
    "CandidateName": "Candidate name",
    "SubmittedDate": "Submitted",
    "CandidateId": "User ID",
    "ScheduleName": "Schedule name",
    "EmptyTable": "No candidates",
    "Score": "Score",
    "Grade": "Grade",
    "AssessmentTitle": "Assessment title",
    "Organization": "Hierarchy",
    "Assessment": "Assessment",
    "PercentCorrect": "% Correct",
    "CandidateAnswer": "Candidate answer",
    "MarkerComment": "Marker comment",
    "MarkerScore": "Marker score",
    "ModeratorComment": "Moderator comment",
    "ModeratorScore": "Moderator score",
    "SecondMarkerComment": "Second marker comment",
    "SecondMarkerScore": "Second marker score",
    "Email": "Email",
    "Version": "Version",
    "Status": "Status",
    "Failed": "Failed",
    "Passed": "Passed",
    "NotSubmitted": "Not submitted",
    "SectionId": "Section Id",
    "SectionResult": "Section Result",
    "SectionStatus": "Section Status",
    "AverageMark": "Average Mark",
    "FirstMarkerComment": "First Marker Comment",
    "FirstMarkerScore": "First Marker Score"
  },
  "Deliver": {
    "SectionTimeExpired": "The time of the section has expired"
  },
  "DragAndDropQuestion": {
    "AddResponse": "Add response",
    "PlaceholderNameMustBeUnique": "Placeholder name must be unique",
    "ResponseNameMustBeUnique": "Response name must be unique",
    "DrawConnections": "Draw connections between placeholders and responses",
    "PlaceholderNameCannotBeEmpty": "Placeholder name cannot be empty",
    "ResponseNameCannotBeEmpty": "Response name cannot be empty",
    "AddPossibleResponses": "Add possible responses",
    "BackgroundImageCannotBeEmpty": "Background image cannot be empty",
    "AtLeastOnePlaceholderRequired": "At least one placeholder required",
    "AtLeastOneConnectionRequired": "At least one connection between placeholders and responses required",
    "DuplicateResponses": "Duplicate responses",
    "AtLeastOneResponseRequired": "At least one response required",
    "ResponseImageCannotBeEmpty": "Response image cannot be empty",
    "ResponsesPosition": "Responses position"
  },
  "Delivery.Survey": {
    "WarningUnansweredQuestion": "You cannot continue with this question unanswered",
    "WarningDialogTitle": "Response required",
    "WarningUnansweredQuestions": "You cannot continue with unanswered questions",
    "WarningSubmitUnansweredSurvey": "You cannot submit this form. You need to answer all questions",
    "SuggestionMC": "Select the answer"
  },
  "BackLink": {
    "BackTo": "Back to"
  },
  "General.Result": {
    "SeedInfoTableHint": "Not all scores are submitted to the total score because of seed items."
  },
  "AssessmentForm": {
    "QuestionNotAdded": "Question was not added to the assessment form"
  },
  "Assessment.Publish": {
    "Title": "Are you ready to publish the assessment?",
    "AssignAssessors": "Assessors",
    "AutoScoredHint": "This assessment contains only auto-scored questions and no markers are needed.",
    "AutoScored": "Auto-scored",
    "Workflow": "Marking workflow",
    "WorkflowSimple": "Scheduler is assessor (Simple)",
    "WorkflowExtended": "Coordinator assign assessors (Extended)",
    "WorkflowSimpleHint": "Selecting this option will automatically assign the scheduler of the assessment as a single marker. The coordinator can later change this, by manually adding markers.",
    "WorkflowExtendedHint": "Selecting this option enables the coordinator to select the assessors/moderators for this assessment.",
    "Todo": "To do",
    "TodoEmpty": "You are all set and can publish the assessment",
    "EditPublish": "Edit publish settings",
    "AssessmentScheduled": "The assessment has been scheduled and cannot be edited.",
    "AssessmentHasNonLiveAndCannotBePublished": "Assessment contains non-live items and cannot be published",
    "AssessmentHasNonLiveItemsInSelected": "Assessment contains non-live items",
    "AssessmentScheduledUnpublished": "The assessment has been scheduled",
    "AssessAutoScoredQuestions": "Manually score auto-scored questions",
    "AssessAutoScoredQuestionsHint": "Selecting this option will allow the assessors to score auto-scored questions",
    "Tip": "By publishing the assessment it will be ready for scheduling. If you want to make changes to the assessment at a later stage you need to Unpublish it.",
    "AssignAssessorsTip": "Allows you to set some high-level marking behaviours.",
    "WorkflowTip": "With a simple workflow, the scheduler of the assessment is automatically assigned as a marker. With extended workflow, the marking coordinator can set up the marking workflow and supports multiple markers and moderators",
    "UpdateStatusTooltip": "Please update status",
    "AssignAssessorsSwitch": "No assessor",
    "FormsInvalidTooltip": "One or more of the forms in this assessment are not ready to be published. Please check them and make sure they are ready before publishing."
  },
  "Reports.Candidates": {
    "Candidates": "Candidates",
    "AllHierarchies": "All hierarchies",
    "SearchCandidates": "Search candidates...",
    "Hierarchy": "Hierarchy"
  },
  "CandidateResult": {
    "QuestionType": "Question type",
    "QuestionId": "Question Id"
  },
  "CustomScoreReport": {
    "SendPdfSuccess": "Score report was sent successfully",
    "SendPdfFail": "Score report wasn't sent",
    "SendPdfEmailMissed": "E-mail was not sent since you don't have an e-mail address",
    "SendPdfSuccessWithEmail": "Score report was sent to {1} successfully",
    "NotificationExitMessage": "To exit the assessment, click on the “Exit” button at the bottom of the Score Report.",
    "EndOfAssessment": "End of assessment",
    "ScoreReportNotSent": "The Score Report has not been sent since you don't have an e-mail address.",
    "EndOfAssessmentReached": "You have reached the end of the assessment.",
    "ScoreReportSentTo": "The Score Report has been sent to: {0}",
    "SentPdfSuccessAutomatically": "The score report is automatically mailed to you at {email}. The assessment has ended. Once you click on Exit you will be logged out.",
    "SentPdfFailAutomatically": "E-mail was not sent since you don't have an e-mail address. The assessment has ended. Once you click on Exit you will be logged out.",
    "NotificationOkMessage": "Click “OK” to show the Score Report.",
    "ScoreReportWillBeSentTo": "The Score Report would been sent to: {0} <br/> \r\nOnce you click on Exit you will be logged out"
  },
  "QuestionEditor.Content.Warning": {
    "SelectEquityRecord": "Select a 'Equity Capital' record"
  },
  "Assessments.Import": {
    "NotImported": "Assessment was not imported.",
    "SuccessfullyImported": "Assessment {assessmentTitle} was imported.",
    "SomeQuestionsNotImported": "Questions with ID's: {questionIds} were not imported. You can add them manually."
  },
  "CandidateResults": {
    "QuestionType": "Question type",
    "QuestionId": "Question Id",
    "ShortSearchPlaceholder": "Search for the candidate or schedule..."
  },
  "SPL.LiquidityBalance.Label": {
    "ShortTermDebt": "Short term debt",
    "LongTermDebt": "Long term debt",
    "EquityCapital": "Equity Capital",
    "LiquidityBalanceCredit": "Liquidity Balance credit",
    "Total": "Total",
    "CurrentAssets": "Current assets",
    "FixedAsset": "Fixed asset",
    "LiquidityBalanceDebit": "Liquidity Balance debit"
  },
  "ExportResults": {
    "CandidatesResultsLabel": "Candidates results",
    "CandidatesResultsWithSurveyLabel": "Candidates results including registration form data",
    "CandidatesResultsWithSurveyHint": "Shows the results for each candidate including total score, grade, and whether the candidate passed or not. In addition it shows what the candidate answered to the registration form.",
    "Subtitle": "Select what you want to export to an Excel file",
    "IncludingSeedItems": "Including seed items",
    "ExportedCandidates": "Results were not exported for following candidates:",
    "CandidatesScoresHint": "Shows the total score the candidate scored on each question.",
    "CandidatesAnswersLabel": "Candidate answers",
    "CandidatesResultsHint": "Shows the results for each candidate including total score, grade and whether the candidate passed or not.",
    "CandidatesAnswersHint": "Shows the alternative(s) the candidate answered on each question. Only works for appropriate question types - see our knowledge base on exporting questions via the link on the bottom left of your screen.",
    "YouDontSelectAnyData": "You didn't select any data to export.",
    "CandidatesScoresLabel": "Candidates scores",
    "ExportLongTimeWarning": "You are trying to export a lot of results, it can take a long time.",
    "NothingToExportWarning": "Nothing to export.",
    "PreventExportWarning": "You can not export more than {0} results.",
    "CandidatesAnswersWithCommentsLabel": "Candidate results - extended",
    "CandidatesAnswersWithCommentsHint": "Shows the results for each candidate including answers on essay questions and comments from assessors",
    "CandidatesCriteriaScoresHint": "Shows the criteria scores the candidate scored on each question.",
    "CandidatesCriteriaScoresLabel": "Candidates scores - with criteria scores",
    "Error": "An error occurred during generation of export file(s)",
    "DownloadPreliminaryResults": "Export preliminary results"
  },
  "Assessment.Info.GeneralInformation": {
    "SectionTitle": "General Information",
    "ExternalIdUnique": "External ID should be unique. The entered ID is used in \"{0}\"."
  },
  "Results.Assessment.Summary": {
    "PercentageToPass": "Percentage to pass:",
    "NoOfQuestions": "No. of questions:",
    "ManualScored": "Manual scored questions:",
    "NoOfCandidates": "No. of candidates:",
    "AttemptsAllowed": "Attempts allowed:",
    "WhichAttemptCount": "Which attempt count:",
    "TimeAllowed": "Time allowed:",
    "AverageTimeSpent": "Average time spent:",
    "Assessed": "Assessed:",
    "NotAssessed": "Not assessed:",
    "LowestScore": "Lowest score:",
    "HighestScore": "Highest score:",
    "AverageScore": "Average score:",
    "AssessmentSummary": "Assessment summary",
    "ViewAssessmentSummary": "View assessment summary"
  },
  "EvaluationResults.Submission": {
    "SubmitScores": "Submit scores"
  },
  "EvaluationResults.PublishResults": {
    "TitlePublish": "Are you ready to publish the results?",
    "InformCandidates": "Inform candidates",
    "SendEmail": "Send e-mail to candidates",
    "SendEmailTip": "An e-mail will be sent to the candidates with the results",
    "ResultsInDashboard": "Show results on candidate dashboard",
    "ResultsInDashboardTip": "If candidate reports are available, they will show on the candidate's dashboard. Otherwise only percentage score and passed/failed will be shown",
    "ToDo": "You still need score {0} out of {1} candidates",
    "ToDoEmpty": "All candidates have been scored.",
    "ReleaseResultDescription": "After you have published the results, they will either automatically be available for the candidates on their dashboard, or needs to be manually released to the dashboards. This depends on the assessment options.",
    "ReleaseResult": "Release results to candidates"
  },
  "Exam.ConnectionDrop": {
    "BrowserUnableToConnect": "Currently your browser is unable to connect to the Internet",
    "DoNotReloadYourBrowser": "Do not reload or close your browser! Or you may lose any answers not send yet (or if submitting, may not be submitted)!",
    "PlatformWillAutomaticallyTryAgain": "The platform will automatically try again.",
    "PleaseWait": "Please wait - Unable to connect to the Internet",
    "CurrentlyThereIsNoConnection": "Currently there is no connection to the server. (HB11)",
    "InvigilatorHelp": "If this message persists, please ask the invigilator for help.",
    "TheSystemWillAutomaticallyRetry": "The system will automatically retry.",
    "Warning": "Warning!",
    "CurrentlyThereIsConnectionProblems": "Currently your computer has problems connecting to the server. (Q43)"
  },
  "Delivering.Schedule.Notifications": {
    "Candidates": "Notify candidates",
    "Invigilators": "Notify proctors",
    "Tip": "Select who you want to notify by e-mail.",
    "UnscheduleAlert": "This schedule has been printed. If you deactivate it, the print version will become invalid."
  },
  "Admin.User.Edit": {
    "InvalidIpWarning": "Format is invalid"
  },
  "Assessment.Forms": {
    "EmptyListText": "No forms available",
    "EditSection": "Section settings",
    "EmptySections": "The form(s) are invalid because it’s using an empty section. You need to either remove the section or add questions to the section in the library",
    "NotValidForMatrix": "The form(s) are invalid because they do not meet the requirements specified in the blueprint. Please review and adjust the questions accordingly"
  },
  "Framework.TableSelectionHint": {
    "AllPageRowsSelected": "All {0} rows on this page has been selected.",
    "AllTableRowsSelected": "All {0} rows on this table has been selected.",
    "SelectAllInTable": "Select all {0} items in this table.",
    "UndoTheSelection": "Undo the selection."
  },
  "Reports.AssessmentPerformance": {
    "NoAssessments": "No assessments",
    "SearchAssessments": "Search assessments...",
    "ThisOverviewShowsLatestPublishedVersion": "This overview shows the latest published version of the assessments. For an overview of all the versions, click on the assessment title."
  },
  "SearchGroupsDialog": {
    "Choose": "Choose",
    "DialogTitle": "Search for hierarchy",
    "OneLevelUp": "One level up",
    "SearchPlaceholder": "Search hierarchies"
  },
  "SearchGroupsInput": {
    "Hierarchy": "Hierarchy",
    "PleaseSelectHierarchy": "Please select hierarchy",
    "SearchHierarchy": "Search hierarchy"
  },
  "Framework.DateFilter": {
    "LastXDay": "Last {0} days"
  },
  "Assessment.Breadcrumbs": {
    "FormsOverview": "forms",
    "VersionsOverview": "versions",
    "ItemsOverview": "Items"
  },
  "Assessment.Messages": {
    "SuccessCreateRevision": "New version successfully generated",
    "SuccessUpdateVersions": "You have successfully created a new version of the assessment. To make this version current, you need to publish it",
    "UnlockedAssessment": "Assessment was unlocked by admin"
  },
  "AssessmentRevisionHistory": {
    "CurrentVersion": "Current version",
    "MakeThisVersionCurrentVersion": "Make this version current version",
    "MakeThisVersionCurrentVersionConfirmation": "Are you sure you want to make this version the current version of the assessment? All schedules that have not started yet will start using this version."
  },
  "AssessmentFormsStatistics": {
    "NoForms": "No forms"
  },
  "AssessmentQuestionsStatistics": {
    "NoItems": "No items",
    "P": "P",
    "Pc": "Pc",
    "Rir": "Rir",
    "Rit": "Rit"
  },
  "AssessmentVersionsStatistics": {
    "NoVersions": "No versions"
  },
  "CollectionItem.Validation": {
    "FunctionalIdUsed": "Item ID \"{0}\" is already in use by a other question.",
    "QuestionTextRequired": "Question text should not be empty",
    "EmptyChoices": "Choices cannot be empty",
    "SelectCorrectAnswer": "Select the correct answer(s)",
    "SelectJustOneCorrectAnswer": "Select one correct answer",
    "QuestionTextRequired.WithFuncId": "Question text should not be empty for item \"{0}\"",
    "SelectJustOneCorrectAnswer.WithFuncId": "Select one correct answer for item \"{0}\"",
    "EmptyChoices.WithFuncId": "Choices cannot be empty for item \"{0}\"",
    "SelectCorrectAnswer.WithFuncId": "Select the correct answer(s) for item \"{0}\"",
    "EmptyQuestions": "Questions cannot be empty",
    "SameChoices": "Choices cannot have the same text within the same question",
    "SameScores": "The correct answer must have a higher score than the partial correct answer(s)"
  },
  "Assessment.Info.Availability": {
    "ActivateLabel": "Activate",
    "Always": "Always",
    "AlwaysHint": "Assessment can always be scheduled",
    "DeactivateLabel": "Deactivate",
    "SectionTitle": "Active",
    "SetTimeSpan": "Set time span",
    "TimeSpanHint": "Assessment can be scheduled within a certain time period",
    "TimeSpanNever": "Never",
    "TimeSpanNow": "Now",
    "TimeSpanSpecific": "At a specific time"
  },
  "Assessment.QuestionSelection": {
    "filterQAll": "All",
    "filterQSelected": "Selected",
    "filterQNotSelected": "Not selected",
    "filterSAll": "All",
    "filterSScored": "Scored",
    "filterSSeed": "Seed",
    "filterStLive": "Live",
    "filterStWithdrawn": "Withdrawn",
    "QuestionSet": "Question set"
  },
  "Assessment.Gen.Forms": {
    "Title": "Title",
    "Items": "Items",
    "ChanceScore": "Chance score",
    "Type": "Type",
    "MaxScore": "Max score",
    "DialogTitle": "Create form",
    "DialogQuestions": "Questions:",
    "DialogQuestionsHint": "of {0} available",
    "DialogAssessmentType": "Assessment type:",
    "FixedForm": "Fixed",
    "FixedFormHint": "Allows you to add one fixed form. All candidates will get the same questions.",
    "MultipleForms": "Multiple forms",
    "MultipleFormsHint": "Allows you to add multiple fixed assessment forms. Each candidate will get a random form.",
    "RandomForms": "Random (LOFT)",
    "RandomFormsHint": "Allows you to add random forms. Each candidate will get different questions.",
    "EmptyTable": "You haven’t created any test forms yet. Click on Add form to create the first form in this assessment.",
    "RandomAssessment": "Randomly generated",
    "ValueLess": "Please enter a value greater than or equal to {0}",
    "ValueMore": "Please enter a value less than or equal to {0}",
    "Description": "A form is a variant of the assessment. Currently you can only create one form for each assessment, but soon we will support multiple forms.",
    "ValueIncorrect": "Please enter a value between {min} and {max} inclusive",
    "TitleIncorrect": "Title should be unique, not empty and less than {0} symbols.",
    "TitleNotUnique": "This title already exists",
    "Form": "Form",
    "FormDeletionConfirmation": "Are you sure you want to delete this form(s)?",
    "DeleteForms": "Delete form(s)",
    "QuestionsAmountOutOfRange": "Please enter one of available values: ",
    "MissingElementsTip": "Welcome/Finish page or Assessment scale is missing",
    "MissingOrWithdrawnElementsTip": "Welcome/finish page missing. One or more required questions/pages have the Withdrawn status",
    "DifficultyInvalid": "Difficulty is invalid. Please check your question selection",
    "InvalidDifficultyTotal": "Warning, the total percentage of the combined difficulties must be 100%",
    "InvalidDifficultyMethod": "Difficulty method is not selected",
    "InvalidDifficultyValue": "The value is out of range",
    "RandomOptionTooltip": "Also called Linear on the Fly Test forms. Each candidate will get a unique set of questions. Great for preventing cheating and content theft",
    "FixedOptionTooltip": "All candidates will get the same questions. Note that you can still randomise the order of the question and create multiple fixed forms",
    "PValueOptionTooltip": "The traditional method for measuring difficulty of questions. Great if you have measured the difficulty of your questions",
    "AngoffOptionTooltip": "An alternative way of measuring the difficulty of questions. Subject matter experts needs to manually set the difficulty for items within the item-bank",
    "DifficultyQuestionCountsHint": "{0} easy, {1} medium and {2} hard items will be selected",
    "NoQuestionsForLevel": "No {0} questions in selected questions"
  },
  "Reports.CandidateResults.PrintDialog": {
    "CandidateResults": "Candidate results",
    "Detailed": "Detailed",
    "PrintResults": "Print results",
    "ReportType": "Report type",
    "Results": "Results",
    "ScoreReport": "Score report",
    "ShowWrongAnswers": "Show only wrong/partially correct answers",
    "Summary": "Summary",
    "DisabledOption": "This option is turned off at Assessment > Options"
  },
  "Assessment.AssessmentQuestions": {
    "CreateSection": "Add section",
    "ExcludeItems": "Exclude items",
    "IncludeItems": "Include items",
    "AtLeastOneShouldBeIncluded": "At least one question should be included.",
    "AtLeastNumberRequred": "At least {0} questions required for learning objective \"{1}\" and taxonomy \"{2}\".",
    "AtMostNumberAllowed": "At most {0} questions allowed for learning objective \"{1}\" and taxonomy \"{2}\".",
    "SectionsWillBeRemoved": "Sections {0} will be removed. Do you want to continue?",
    "SectionWillBeRemoved": "Section {0} will be removed. Do you want to continue?",
    "QuestionsWillBeRandomlyGenerated": "Questions will be randomly generated when the candidate starts the assessment",
    "AtLeastNumberRequred.Subject": "At least {0} questions required for subject \"{1}\" and taxonomy \"{2}\".",
    "AtMostNumberAllowed.Subject": "At most {0} questions allowed for subject \"{1}\" and taxonomy \"{2}\".",
    "PrintNotification": "The assessment is not published.",
    "AtLeastOneHasToBeIncluded": "At least one question should be included.",
    "CreateSectionDeprecationTip": "This way of adding sections will be discontinued shortly. If you want to continue using sections, please create them within collections.",
    "IncludeConfirm": "Are you sure you want to include {0} item(s)?<br>Total score included will become <b>{1}</b>.",
    "AlreadyExcludedMessage": "{0} of {1} selected items have been already excluded from the assessment.",
    "ExcludeConfirm": "Are you sure you want to exclude {0} item(s)?<br>Total score included will become <b>{1}</b>.",
    "AlreadyIncludedMessage": "{0} of {1} selected items have been already included to the assessment."
  },
  "Reports.Print.Results.Summary": {
    "AssessmentId": "Assessment ID",
    "AssessmentStarted": "Assessment started",
    "Candidate": "Candidate",
    "CorrectAnswers": "Correct answers",
    "Failed": "Failed",
    "Grade": "Grade",
    "Minutes": "minutes",
    "NotAnswered": "Not answered",
    "NumberOfQuestions": "Number of questions",
    "PartiallyCorrectAnswers": "Partially correct answers",
    "Passed": "Passed",
    "Result": "Result",
    "Score": "Score",
    "TimeSpent": "Time spent",
    "Version": "Version",
    "WrongAnswers": "Wrong answers",
    "MaxScore": "Max score",
    "PassPercentage": "Percentage for Pass mark",
    "AssessmentFinished": "Assessment finished"
  },
  "Reports.Print.Results.Table": {
    "Answer": "Submitted answer",
    "ItemId": "Item ID",
    "Question": "Question",
    "QuestionType": "Question type",
    "SubjectScore": "Score",
    "TotalScore": "Total score"
  },
  "Printing": {
    "AudioThumbnail": "Audio file",
    "VideoThumbnail": "Video files are not supported in printed assessments.",
    "EmbeddedThumbnail": "Embedded content is not supported in printed assessments."
  },
  "Admin.Qualifications.Dialogs.Edit": {
    "Title": "Edit qualification"
  },
  "Admin.Terms.Dialogs.Edit": {
    "Title": "Edit term"
  },
  "Admin.Labels.Dialogs.Edit": {
    "Title": "Edit label"
  },
  "Admin.GlobalSettings.RoundingRule": {
    "NeedPoint": "Rounding up/down conditional",
    "NeedPointHint": "Candidate's percentage score will be rounded up if .5 and above",
    "RoundingDown": "Rounding down",
    "RoundingDownHint": "Candidate's percentage score will be rounded down",
    "RoundingRulesHint": "Setting rounding rules will impact candidate results on the whole site",
    "RoundingRulesTitle": "Rounding rules",
    "RoundingUp": "Rounding up",
    "RoundingUpHint": "Candidate's percentage score will be rounded up",
    "UseTwoDecimalsHint": "Percentage will be displayed like this: 55.84%",
    "UseTwoDecimals": "Use two decimals"
  },
  "Admin.Skins": {
    "Preview": "Preview",
    "UploadFailed": "Upload failed. The chosen file is not an image.",
    "UploadImage": "Choose image",
    "UploadLogoTitle": "Upload logo",
    "CropImage": "Crop image",
    "AddImage": "Add image",
    "Logo": "Logo",
    "HierarchyIsNotValid": "A theme has already been connected to this hierarchy. Please choose another hierarchy or remove the hierarchy from the other theme.",
    "ColorNotValid": "Incorrect theme color(s)"
  },
  "Admin.ObjectivesAddRepository": {
    "MainTitle": "Add learning objective repository",
    "Title": "Title",
    "Description": "Description",
    "Hierarchy": "Hierarchy",
    "EditRepository": "Edit learning objective repository"
  },
  "Admin.GlobalSettings": {
    "GlobalSettingsTitle": "Global settings",
    "TenantID": "Directory (tenant) ID",
    "ClientSecretValidation": "Client Secret should be min. 20 and max. 100 characters!",
    "ServiceAccountUsernameValidation": "Service Account Username should be min. 1 and max. 100 characters!",
    "ErrorRetrievingCredentials": "Error retrieving credentials!",
    "IntegrationRevocationError": "Error revoking API credentials!",
    "ConnectedAccounts": "Connected accounts",
    "RevokeOffice365Integration": "Revoke Office365 Integration",
    "Microsoft365Account": "Microsoft 365 Account",
    "ApiDataSaveSuccess": "API data have successfully been saved!",
    "ConnectedAccountsDescription": "Allows you to connect the site to various cloud accounts",
    "ActiveCloudAccounts": "Active cloud accounts",
    "ClientID": "Application (client) ID",
    "TenantIDValidation": "Tenant ID should be min. 1 and max. 100 characters!",
    "ErrorSavingCredentials": "Error saving credentials!",
    "ClientSecret": "Client Secret",
    "ServiceAccountUsername": "Service account user name",
    "ApiCredentialsNotFound": "API credentials are not found!",
    "ClientIDValidation": "Client ID should be min. 1 and max. 100 characters!",
    "IntegrationRevocationSuccess": "Your integration has successfully been revoked!",
    "ChangeAccount": "Change account",
    "AddAccount": "Add account",
    "RevocationInProgress": "Revocation in progress, please wait..",
    "AccountConnected": "has been successfully connected!"
  },
  "Admin.Skin.Colors": {
    "Buttons": "Buttons",
    "Code": "Code",
    "SupportingColor": "Supporting color",
    "Widgets": "Widgets"
  },
  "Assessment.Tabs": {
    "Blueprint": "Blueprint",
    "GenerateAssessment": "Forms",
    "Information": "Information",
    "Options": "Options",
    "QuestionSelection": "Question selection",
    "Overview": "Overview"
  },
  "Sowiso": {
    "NumberOfInputFieldsUsed": "An error has occured. Answer field {0} is still used in a {1}."
  },
  "Assessment.Blueprint": {
    "AddLearningObjective": "Add learning objective",
    "BlueprintIsInvalid": "The blueprint is invalid. You need to change the values marked in red.",
    "NoLearningObjectivesSelected": "No learning objectives selected",
    "NoTaxonomyCategory": "No taxonomy category",
    "YouAreUsing": "You are using",
    "ChangeTaxonomyCategory": "Changing taxonomy category will reset all learning objectives 'Min' and 'Max' values. Are you sure you want to change taxonomy category?",
    "AddBlueprint": "Add blueprint",
    "CreateNew": "Create new",
    "BasedOnCollection": "Based on collection",
    "NoBlueprintsAvailable": "No blueprints available",
    "AddBlueprintWarning": "All existing blueprint data will be deleted. Are you sure you want to continue?",
    "BlueprintCreated": "Congratulations! The first step in building your blueprint is done. Now you can define  blueprint's questions/score criteria.",
    "BlueprintIsValid": "Your blueprint is valid. You are able to create one or more test forms.",
    "AddBlueprintSimplified": "Simplified - with topics",
    "AddBlueprintExtended": "Extended - with learning objectives",
    "NewBlueprint": "New blueprint",
    "CollectionQuestion": "WHICH COLLECTIONS DO YOU WANT TO INCLUDE?",
    "CollectionDescription": "Selecting one or more collections allows you to specify from which collections the questions should be drawn from.",
    "NoBlueprintItems": "Select some questions to review blueprint structure.",
    "WithoutTopic": "Without topic",
    "ShowBlueprint": "Show blueprint",
    "WithoutLearningObjective": "Without learning objective"
  },
  "SavingIndicator": {
    "BusySaving": "Busy saving...",
    "AllChangesSaved": "All changes have been saved"
  },
  "Sowiso.Error": {
    "CannotRemoveVariable": "Failed to delete variable",
    "WrongType": "Wrong type"
  },
  "Admin.WebServices.Dialogs.Edit": {
    "Title": "Edit integration"
  },
  "Library.Collections.Dialogs.EditCollection": {
    "Title": "Edit collection"
  },
  "Assessment.Alert": {
    "ChangeBlueprint": "You have already created a form based on this blueprint. In order to change the blueprint you need to delete the form.",
    "ChangeSelectedQuestions": "You have already created a form based on this question selection. In order to change the question selection you need to delete the form.",
    "CreateBlueprint": "To start create your blueprint, you need to add learning objectives and a taxonomy group. "
  },
  "CollectionItemImport": {
    "NotPermissionsToSetStatuses": "You do not have permission to set statuses:",
    "SomeQuestionWillBeImportedAsDraft": "Some questions will have draft statuses",
    "SomeQuestionWontBeImported": "Some questions will not be imported",
    "SomeQuestionScoresWillBeRoundedDown": "Some scores in questions are incorrect, they will rounded down",
    "SomeSowisoSetsAreIncomplete": "You have selected not all questions of sowiso set. Anyway all questions from sowiso set will be imported."
  },
  "Notification.CopyResult": {
    "ScheduleNoCopyAssessmentArchived": "Schedule {scheduleTitle} was not copied. Assessment is archived."
  },
  "Submission": {
    "AssessMultiple": "Moderate multiple",
    "SubmitMultiple": "Submit scores",
    "SubmitConfirm1": "After you have submitted the scores you cannot make any changes to the scoring.",
    "SubmitConfirm2": "After you have submitted the scores, the results will either be moved to the <b>Results tab</b>, where you can manually release them to the candidates, or they are automatically published to the candidates. This depends on the options set by the assessment author.",
    "ModerateConfirm1": "The scores of the assessor will be used to moderate {0} selected candidates. If you have multiple assessors, the average score will be used.",
    "ModerateConfirm2": "If you have already scored some of the selected candidates these scores will be overwritten.",
    "BulkModeration": "Bulk moderation"
  },
  "AssessMultiple": {
    "AssessAnswers": "Assess answers for",
    "Assessment": "Assessment",
    "AssessmentDescription": "Scores from assessors will be used. If two assessors are used, then the score will be the average of the two assessors.",
    "Comment": "Comment",
    "ManualScoring": "You have already manually scored some of the selected candidates. If you continue, the manual scoring will be overwritten.",
    "SelectAssessors": "Select the pool of assessors you want to allocate to this assessment. Only users with publish permissions are able to publish the results of the candidates."
  },
  "UsersList": {
    "ShowAll": "Show all ({0})",
    "Hide": "Hide"
  },
  "Delivery.Dashboard.Completed": {
    "All": "All",
    "Failed": "Failed",
    "Grade": "Grade",
    "NotPublished": "Not published",
    "Passed": "Passed",
    "PercentageCorrect": "Percentage correct",
    "Result": "Result",
    "View": "View",
    "YouDoNotHavePervissionsToViewReport": "You don’t have permission to view the report",
    "AttemptsThatCount": "Attempts that count",
    "AttemptsThatNotCount": "Attempts that don’t count",
    "NotDislosed": "Not disclosed",
    "ReviewSessionEnds": "Review session ends",
    "ReviewSessionStarts": "Review session starts"
  },
  "Delivery.Dashboard": {
    "AssessmentTitle": "Assessment title",
    "Code": "Code",
    "Completed": "Completed",
    "ContinueTest": "Continue test",
    "Duration": "Duration",
    "Ending": "Deadline",
    "Next30Days": "Next 30 days",
    "NoTests": "No tests",
    "NotYetAvailable": "Not yet available",
    "Qualification": "Qualification",
    "RequiresLockDownBrowser": "Requires lock-down browser",
    "SafeExamBrowser": "Safe Exam Browser",
    "Starting": "Available",
    "StartTest": "Start test",
    "Today": "Today",
    "Upcoming": "Upcoming",
    "YouNeedToUseSafeExamBrowser": "You need to use Safe Exam Browser for this assessment. Please check if you're using the correct version and configuration or contact your system administrator (to check the SEB configuration in Cirrus).",
    "CompletedAssessments": "Completed assessments",
    "Submitted": "Submitted",
    "PlannedReviewSessions": "Planned review sessions",
    "YouNeedToUseChromeForProctorIo": "You need to use Chrome browser for this Proctorio assessment. Please check if you're using the correct browser or contact your system administrator",
    "RequiresChromeForProctorIo": "Remote proctored"
  },
  "Proctor.Keys": {
    "ActiveCandidateKeyRequests": "Active candidate key requests",
    "Approve": "Approve",
    "Browser": "Browser",
    "Deny": "Deny",
    "Key": "Key",
    "NoRequests": "No Requests"
  },
  "User.ImportDialog": {
    "ErrorsHeader": "Errors",
    "SynchronisationsHeader": "Synchronisations"
  },
  "Statistics": {
    "LastCalculated": "Last calculated",
    "AvgAngoff": "Avg. Angoff"
  },
  "Admin.ImsLti": {
    "Config": "Config",
    "ConsumerKey": "Consumer key",
    "RegenerateSecretKey": "Regenerate secret key",
    "SecretKey": "Secret key",
    "AddItem": "Add item",
    "ItemCreated": "Item successfully created",
    "RemoveSelectedItems": "Remove selected items",
    "SecretKeyRegenerated": "Secret key successfully regenerated",
    "SelectedItemsRemoved": "Items successfully removed",
    "YouAreAboutToRemoveSelectedItems": "You are about to remove selected items. They may be used in active integrations. Do you want to continue?",
    "CreateUsers": "Create users",
    "MappingSaved": "User mapping successfully saved",
    "UserMapping": "User mapping settings",
    "PlatformId": "Platform ID"
  },
  "Admin.EditUser": {
    "ViewReports": "View reports",
    "ReScoring": "Re-scoring"
  },
  "ImsLti": {
    "PleaseSelectRole": "Please select role"
  },
  "Marking.CandidateResults": {
    "CandidateId": "User ID",
    "CandidateName": "Candidate name",
    "NoResults": "No results",
    "NotSatisfactory": "Not satisfactory",
    "ReMarked": "Re-marked",
    "Satisfactory": "Satisfactory",
    "ScheduleTitle": "Schedule title",
    "UserId": "User ID",
    "CandidateResultsNeedsToBePublished": "{0} candidate results needs to be published. The marking coordinator determines who can publish which results. ",
    "PublishResults": "Publish results",
    "PublishResultsTip": "You are about to publish the results to {0} candidates.",
    "ResultsHaveBeenPublished": "Results have been published.",
    "ResultsPublishingHasBeenFailed": "Results publishing has been failed.",
    "ResultsWillBeShownOnDashboard": "{0} results will be shown on dashboard for candidates.",
    "ShowResultsOnCandidateDashboard": "Show results on candidate dashboard",
    "ShowResultsOnCandidateDashboardTip": "If candidate reports are setup for this assessment, they will show on the candidate's dashboard after you publish. Otherwise only percentage score and passed/failed will be shown.",
    "YouDoNotHaveAllPermissions": "You have selected {0} candidates, but you can only publish {1} candidates. Are you sure you want to continue?",
    "YouDoNotHaveAnyPermissions": "You can view selected results but do not have sufficient publication permissions. Please confer with your marking coordinator.",
    "HasPermissionsPublishResults": "You have permissions to publish results of {0} candidates.",
    "YouHavePermissionsToPublish": "You have permissions to publish",
    "InstructionInformation": "Congratulations, your candidates have been marked and you can now take the next step to publish their results.",
    "YouCanPublish": "You can publish",
    "YouCannotPublish": "You can not publish"
  },
  "MarkingAssessors": {
    "UserId": "User ID",
    "SelectAssessorsModerators": "Select the pool of assessors and moderators you want to allocate to this assessment",
    "NoPermissionToAssess": "The following users have NO permission to assess results:",
    "NoPermissionToPublish": "The following users have NO permission to publish results:",
    "ChangeSettingsLimited": "Your possibilities to change the settings are limited.",
    "ChangeAllocationsLimited": "You can't change allocations for these candidates/items.",
    "SomeResultsArePublished": "Some of the candidate results are published.",
    "TableHint": "Hint: By selecting Other, you can assign non-assessors to publish the results on this assessment.",
    "ChangeAssessorsLimited": "Your possibilities to change assessors are limited.",
    "MarkingIsFinished": "Schedule is finished and all results are submitted.",
    "SomeResultsAreRescored": "Some of the candidate results are rescored.",
    "NoCandidates": "No candidates"
  },
  "Admin.SEB": {
    "KeySaved": "Key has been successfully saved",
    "KeyShouldBeAlphanumeric": "Key should be an alphanumeric string."
  },
  "Answer.Sowiso": {
    "Solution": "Solution"
  },
  "Question.MediaFile": {
    "AllowToBeOpenedInPopup": "Allow media file to be opened in a popup",
    "BrowseMediaFile": "Browse media file",
    "NoThumbnail": "No preview",
    "SelectMedia": "Select media"
  },
  "Admin.LearningObjectives.Import.Errors": {
    "DuplicateExternalId": "Some items contain ids that already exist in the system: {ids}",
    "InvalidTree": "Some items are in wrong places: {ids}",
    "InvalidType": "Some items contain an invalid type: {ids}",
    "EmptyTitle": "Some items contain an empty title: {ids}",
    "DuplicateIdsInFile": "File contains duplicates of ids: {ids}",
    "CircularDependency": "File contains circular dependencies: {ids}"
  },
  "Results": {
    "TypeHereToSearch": "Search for the candidate or schedule title you want to view the results for..."
  },
  "Marking.ReScoring": {
    "NotReScored": "Not rescored",
    "ReScored": "Rescored"
  },
  "Marking.Rescoring": {
    "ChangeAnswer": "Change answer",
    "FullScore": "Full score",
    "SelectQuestionsAndRescoreThem": "Select questions and rescore them",
    "YouCanNow": "You can now",
    "YouHaveMadeChangesNotification": "You have made changes that will affect {0} candidates. These changes will take effect when you click Apply changes.",
    "AreYouReadyToApplyChanges": "Are you ready to apply the changes?",
    "ChangesToAssessmentMightTakeAWhile": "Changes to the scoring for this schedule might take a while to recalculate, depending on the number of items you have changed.",
    "IUnderstandConsequences": "I understand the consequences of changing the scoring for this schedule",
    "AnswerAlternatives": "Answer alternatives",
    "AnswerChanged": "Answer changed",
    "AreTouSureYouWantToRemoveThisItem": "Are you sure you want to remove this item? Your changes will only apply after you have clicked Apply changes.",
    "AreYouSureYouWantToAwardFullScore": "Are you sure you want to award full score for this item? Your changes will only apply after you have clicked Apply changes.",
    "AreYouSureYouWantToChangeAnswer": "Are you sure you want to change the answer to this item? Your changes will only apply after you have clicked Apply changes.",
    "AwardFullScore": "Award full score",
    "ChangeAnswerConfirmation": "I understand the consequences of changing items",
    "ChangesFailedToApply": "Changes failed to apply.",
    "ChangesSuccessfullyApplied": "Changes successfully applied.",
    "DiscardChangesConfirmation": "Are you sure you want to discard changes?",
    "FullScoreConfirmation": "I understand the consequences of awarding full score for items",
    "IncludeCandidatesWhoHaveNotAnswered": "Include candidates who haven't answered this question",
    "ItIsNotPossibleToChangeAnswer": "Unfortunately it’s not possible to change the answer of this question type.",
    "NewScore": "New score",
    "OriginalScore": "Original score",
    "RemoveItemConfirmation": "I understand the consequences of removing items",
    "ThisScheduleIsAlreadyBeingReScored": "This assessment is already being rescored by {0}. {0} needs to exit this assessment in order for you to make changes.",
    "NotReScored": "Not rescored",
    "SearchForItemYouWantToView": "Search for items you want to view...",
    "Results.CandidateName": "Candidate name",
    "Results.UserId": "User ID",
    "Results.Submitted": "Submitted",
    "Results.OriginalStatus": "Original result",
    "Results.AdjustedStatus": "Adjusted result",
    "Results.OriginalGrade": "Original grade",
    "Results.AdjustedGrade": "Adjusted grade",
    "Results.OriginalScore": "Original percentage",
    "Results.AdjustedScore": "Adjusted percentage",
    "Results.FilterByFailed": "Not passed",
    "Results.FilterByPassed": "Passed",
    "Results.FilterByAll": "All",
    "Results.Search": "Search for the candidate you want to view the results for...",
    "Results.FilterBy": "Filter by",
    "Results.NotSatisfactory": "Not satisfactory",
    "Results.Satisfactory": "Satisfactory",
    "NewScoreShouldBeGreaterThanZero": "New score should be greater than 0",
    "SelectCorrectAnswer": "Select the correct answer",
    "SendEmailTip": "An e-mail will be sent to the candidates",
    "YourChangesHaveNotBeenApplied": "Your rescoring changes have not been applied. Results shown in the table below shows how your changes to the scoring of this assessment will affect the candidates.",
    "ShortSearchResultsPlaceholder": "Search for the candidate...",
    "CriteriaNotification": "At least one criterion must be added",
    "Hint": "Rescoring the assessment allows you to give full score on questions, remove questions and adjust the questions. Results will be recalculated after rescoring",
    "ChangeQuestion": "Change question",
    "NewScoreShouldBeGreaterOrEqualsOne": "New score should be greater than or equal to 1",
    "CannotRemoveAllQuestions": "Impossible to remove all questions",
    "ItIsNotPossibleToChangeAnswerWithScorePerAlternative": "Unfortunately it’s not possible to change the answer of this question type, because it has several scores for alternative."
  },
  "Marking.Rescoring.Tabs": {
    "Rescore": "Rescore",
    "Results": "Results"
  },
  "Library.CollectionItems": {
    "SearchPlaceholder": "Search for item title, ID, text or label",
    "ShortSearchPlaceholder": "Search for item name or ID..."
  },
  "Marking.Audit": {
    "SearchPlaceholder": "Search for the candidate or schedule title you want to view the results for...",
    "ShortSearchPlaceholder": "Search for the candidate or schedule..."
  },
  "Content.Schedules": {
    "Search": "Search for the schedule or assessment title you want to find...",
    "ShortSearchPlaceholder": "Search for the schedule or assessment..."
  },
  "Delivering.AddCandidates": {
    "Name": "Name",
    "UserId": "User ID",
    "Birth": "Date of birth",
    "Email": "E-mail",
    "NoItems": "To add candidates, you can use the search box above. You can also click on the filter icon if you want to search for a group of candidates.",
    "NoPermission": "The following candidates have NO permission to participate the schedule: {0}",
    "StartedExam": "The following candidates have started exam and can't be removed:",
    "NoPin": "You need to generate a PIN code before you can activate the schedule."
  },
  "Schedule.AddCandidates": {
    "Search": "Search for the candidate(s) you want to schedule",
    "SelectCandidates": "Candidates",
    "SelectFirstYear": "First year candidates",
    "SearchFor": "Search for",
    "CandidatesAdded": "{0} user(s) has been added",
    "CandidatesRemoved": "{0} candidate(s) has been removed",
    "InvigilatorsAdded": "{0} proctor(s) has been added",
    "CannotFind": "Cannot find the candidates you are looking for? Try publishing their results on the Results tab",
    "ShortSearchPlaceholder": "Search for the candidate..."
  },
  "Delivering.AddInvigilators": {
    "Name": "Name",
    "Role": "Role",
    "Email": "E-mail",
    "Hierarchy": "Hierarchy",
    "NoItems": "To add proctors, you can use the search box above. You can also click on the filter icon if you want to search for a group of proctors.",
    "NoPermission": "The following users have NO permission to invigilate the schedule: {0}"
  },
  "Schedule.AddInvigilators": {
    "Search": "Search for the invigilator(s) you want to schedule",
    "ShortSearchPlaceholder": "Search for the invigilator..."
  },
  "Collection.Items": {
    "MassActionConfirmation": "You are about to perform a mass action. Do you want to continue?",
    "MassActionsErrorMessage": "An error occurred while applying changes.",
    "MassActionsProcessingMessage": "Please wait while your collection is being updated. This might take some minutes depending on the number of items. You can leave this page in the meantime.",
    "MassActionsSuccessMessage": "All changes have been successfully applied.",
    "MassActionsPleaseWait": "Please wait",
    "LabelConfirmation": "You are about to delete a label that used in question(s). The label will be removed from all questions. Do you want to continue?",
    "DeleteLabel": "Delete label",
    "FuncIdReindexSuccessMessage": "Collection item ID's were successfully updated"
  },
  "Admin.ContentManagement.Common": {
    "DontShowScoreReport": "None",
    "ShowScoreReport": "Show score report",
    "ShowScoreReportWithObjectives": "Show score report with learning objectives"
  },
  "Assessment.Share": {
    "AnonymousSharing": "Anonymous sharing",
    "AnonymousSharingHint": "A hyperlink will be created which can be shared with users",
    "AnonymousSharingPendingHint": "A hyperlink is being generated...",
    "OnlyYouHaveAccessToThisAssessment": "Only you have access to this assessment at the moment.",
    "ShareWith": "Share with:",
    "Title": "Who do you want to share this assessment with?",
    "YouCanShareTheAssessment": "You can share the assessment with other users by typing their names in the Add person dialogue box.",
    "AddPerson": "Add person",
    "SelectRole": "Select role"
  },
  "MarkingWorkflow": {
    "Extended": "Extended",
    "NoMarking": "No marking",
    "Simple": "Simple",
    "Undefined": "Undefined"
  },
  "Delivering.Labels": {
    "NoLablesAvailable": "No labels available"
  },
  "ReviewSession": {
    "ScheduleTitle": "Schedule title",
    "Score": "Score",
    "Grade": "Grade",
    "LastSat": "Last sat",
    "EditScheduleSettings": "Edit schedule settings",
    "AreYouReadyToSchedule": "Are you ready to schedule the review session?",
    "ScheduleCandidates": "You are about to schedule a review session for {0} candidates",
    "SendEmailTip": "An e-mail will be sent to the candidates with information about the review session",
    "Todo": "To do",
    "TodoEmpty": "You are all set and can publish the review session",
    "EnterSetData": "Set the time period for review session",
    "ChooseCandidates": "Add candidates",
    "Unschedule": "Unschedule",
    "Name": "Name",
    "UserId": "User ID",
    "Hierarchy": "Hierarchy",
    "Results": "Results",
    "Viewed": "Viewed",
    "Published": "Published",
    "NotSatisfactoryResults": "Not satisfactory",
    "SatisfactoryResults": "Satisfactory",
    "CantDeleteAll": "You need to unschedule review session if you want to delete all candidates. At least one candidate must be listed in scheduled review session.",
    "AllResultsViewed": "Results of selected candidate(s) were viewed. You can't remove selected candidate(s)",
    "SetResultsOptions": "Select report to show to candidates",
    "NotSubmittedResults": "Not submitted",
    "ResolveConflictsInResults": "There are conflicts with other review sessions for some candidates",
    "LastViewed": "Last viewed",
    "ReviewSessionTitle": "Review session title",
    "ReviewStarting": "Review starting",
    "ReviewEnding": "Review ending",
    "SpecialNeeds": "Special Needs"
  },
  "Marking.ReviewSession": {
    "Name": "Name",
    "UserId": "User ID",
    "Birth": "Date of birth",
    "Email": "E-mail",
    "Search": "Search for the candidate(s) you want to schedule a review session for",
    "AddCandidates": "Add candidates",
    "Title": "Review session",
    "CantDeleteAll": "Can't delete any of the selected review sessions. Can't delete sessions in which results were viewed by candidates.",
    "ShortSearchPlaceholder": "Search for the candidate..."
  },
  "Library.Collection.ChangeStatus": {
    "LockedMessage": "Item {0} was not updated. This item is locked by another user.",
    "NoPermissionsBatchMessage": "{0} items were not updated. You don't have permissions to change these items status.",
    "NoPermissionsMessage": "Item {0} was not updated. You don't have permissions to change this item status.",
    "SuccessBatchMessage": "{0} items were successfully updated.",
    "SuccessMessage": "Item {0} was successfully updated.",
    "UsedBatchMessage": "{0} items were not updated. These items are used in assessment.",
    "UsedMessage": "Item {0} was not updated. This item is used in assessment.",
    "ErrorBatchMessage": "{0} items were not updated. Error occurred while changing status.",
    "ErrorMessage": "Item {0} was not updated. Error occurred while changing status.",
    "InvalidBatchMessage": "{0} items were not updated. These items are not valid.",
    "InvalidMessage": "Item {0} was not updated. This item is not valid.",
    "LockedBatchMessage": "{0} items were not updated. These items are locked by another user.",
    "HasNonLiveQuestionsBatchMessage": "{0} items were not updated. They included items that are not set to Live status.",
    "HasNonLiveQuestionsMessage": "Item {0} was not updated. It included items that are not set to Live status."
  },
  "Library.Collection.Copy": {
    "ErrorBatchMessage": "{0} items were not copied. Error occurred while copying items.",
    "ErrorMessage": "Item {0} was not copied. Error occurred while copying item.",
    "NoPermissionsMessage": "Items were not copied. You don't have permissions to copy these items.",
    "SuccessBatchMessage": "{0} items were successfully copied.",
    "SuccessMessage": "Item {0} was successfully copied."
  },
  "Marking.EditReviewSession.Options": {
    "AlwaysHint": "The results will always be available on the candidate dashboard.",
    "LockDownBrowserHint": "Selecting this option forces the candidates to review the results in lock-down mode. This is useful for high-stakes assessments.",
    "ReviewPeriod": "Review period",
    "SaveOptionsFailedMessage": "Error occurred while saving options",
    "SaveOptionsSucceedMessage": "Options successfully saved",
    "SetTimeSpanHint": "The results can only be viewed within a certain period.",
    "ShowAnnotations": "Show annotations",
    "ShowAnnotationsHint": "Selecting this option will allow the candidate to see the annotations of the assessor(s).",
    "UsePinCodeHint": "Selecting this option will adds an extra layer of security by using a pin code that candidates must enter.",
    "EndDateMinValueMessage": "Review period ending should be greater or equal to {0}",
    "EndDateRequiredMessage": "Please enter review period ending",
    "PinCodeLengthMessage": "Pin code should be 4 characters long",
    "PinCodeRequiredMessage": "Please enter pin code",
    "StartDateLessThanEndDateMessage": "Review period starting should be less than ending",
    "StartDateMinValueMessage": "Review period starting should be greater or equal to {0}",
    "StartDateRequiredMessage": "Please enter review period starting",
    "CandidateExperience": "Candidate experience",
    "ShowPassedFailed": "Show only passed/failed",
    "ShowPassedFailedHint": "Shows only if the candidate passed or failed",
    "Summary": "Summary",
    "SummaryHint": "Shows the questions and whether the candidate answered (in)correctly.",
    "Detailed": "Detailed",
    "DetailedHint": "Shows the correct answer to each question",
    "IncorrectAnswers": "Show only incorrect/partially correct answers",
    "IncorrectAnswersdHint": "Show only the questions the candidate answered incorrect or partially correct",
    "ScoreWithLo": "Score report",
    "ScoreWithLoHint": "Shows the subject achievement",
    "ScoreLo": "Show learning objectives",
    "ScoreLoHint": "Shows the learning objective achievement",
    "ShowFeedback": "Show feedback",
    "ShowFeedbackHint": "Selecting this option will allow the candidate to view feedback associated with the questions in the assessment",
    "MarkingScheme": "Show marking scheme",
    "MarkingSchemeHint": "Selecting this option will allow the candidate to see the marking scheme",
    "ExternalIdUsed": "External ID already used in the system"
  },
  "Marking.ReviewSessions": {
    "DeleteReviewSessionConfirmation": "Are you sure you want to delete {0} review session?",
    "DeleteReviewSessions": "Delete review session(s)",
    "DeleteReviewSessionsConfirmation": "You are about to delete {0} out of {1} selected review session which results haven't been viewed. Are you sure you want to continue?",
    "DeleteReviewSessionsFailed": "An error occurred while deleting review session(s).",
    "DeleteReviewSessionsSucceed": "Review session(s) successfully deleted.",
    "NewCandidateReviewSession": "New candidate review session",
    "NoOfCandidates": "No. of candidates",
    "ReviewEnds": "Review ends",
    "ReviewStarts": "Review starts",
    "ScheduleReview": "Schedule review",
    "SearchPlaceholder": "Search for the assessment you have scheduled review sessions for...",
    "NoItems": "No results found",
    "ReviewSessionsNotDeletedViewed": "{0} out of {1} review sessions were not deleted. Can't delete review sessions that contain viewed results.",
    "ShortSearchPlaceholder": "Search for the assessment...",
    "SearchCandidates": "Search candidates",
    "SearchCandidatesTip": "To add candidates, you can use the search box below. You can also click on the filter icon if you want to search for a group of candidates.",
    "AddCandidatesSuccess": "You have added {0} candidate(s) to the {1}."
  },
  "Library.Collection.ChangeItemPurpose": {
    "ErrorBatchMessage": "{0} items were not updated. Error occurred while changing item purpose.",
    "ErrorMessage": "Item {0} were not updated. Error occurred while changing item purpose.",
    "InvalidBatchMessage": "{0} items were not updated. These items are not valid.",
    "InvalidMessage": "Item {0} were not updated. This item is not valid.",
    "LockedBatchMessage": "{0} items were not updated. These items are locked by another user.",
    "LockedMessage": "Item {0} was not updated. This item is locked by another user.",
    "NoPermissionsBatchMessage": "{0} items were not updated. You don't have permissions to change these items purpose.",
    "NoPermissionsMessage": "Item {0} was not updated. You don't have permissions to change this item purpose.",
    "SuccessBatchMessage": "{0} items were successfully updated.",
    "SuccessMessage": "Item {0} was successfully updated.",
    "UsedBatchMessage": "{0} items were not updated. These items are used in assessment.",
    "UsedMessage": "Item {0} was not updated. This item is used in assessment."
  },
  "Marking.ScheduleReviewSession": {
    "CreateReviewSession": "Create review session",
    "CreateReviewSessionFailedMessage": "Error occurred while creating review session",
    "SearchPlaceholder": "Search for the assessment you want to schedule the review session for..."
  },
  "MailTemplates.ReviewSession": {
    "InformCandidateAlways": "<p>Dear {{ FirstName }} {{ LastName }},</p><p>Your results for: {{ ExamTitle }} are ready. You can log in to your exam dashboard and select Completed to view the results.<br><br><p>Best regards,<br>Cirrus Assessment Platform</p>",
    "InformCandidateTimeSpan": "<p>Dear {{ FirstName }} {{ LastName }},</p><p>Your results for: {{ ExamTitle }} are ready. You can log in to your exam dashboard and select Completed to view the results. The results will be available from {{ StartDate }} to {{ EndDate }}.<br><br><p>Best regards,<br>Cirrus Assessment Platform</p>"
  },
  "Delivery.Annotations": {
    "Score": "Score",
    "OverallConclusion": "Overall conclusion",
    "Annotations": "Annotations",
    "AnnotationsHint": "You can view the annotations from your markers by selecting them in this dropdown menu",
    "PreviousQuestion": "Previous question",
    "NextQuestion": "Next question",
    "Marker": "Marker",
    "NoAvailableAnnotations": "No available annotations",
    "NoComments": "No comments",
    "AssessorVeiw": "You are viewing the screen as: "
  },
  "Collection.Labels": {
    "CreateNew": "Create new",
    "LabelAs": "Label as:"
  },
  "QuestionEditor.Sowiso.Sets": {
    "Title": "Question",
    "Score": "Score",
    "Status": "Status",
    "TotalScore": "Total score"
  },
  "Assessment.CreateNew": {
    "Title": "New assessment",
    "SelectType": "Select assessment type",
    "Formative": "Formative",
    "FormativeTip": "Allows you to create a formative assessment. Formative assessments are mainly for practice purpose. Choosing this assessment type limits your question selection to formative item type. ",
    "Summative": "Summative",
    "SummativeTip": "Allows you to create a summative assessment. Summative assessments are high-stakes assessments like exams. Choosing this assessment type limits your question selection to summative only item type.",
    "Mixed": "Mixed",
    "MixedTip": "Allows you to create a mixed assessment. This assessment type is a mix of formative and summative assessment. Choosing this assessment types enables you to select both formative and summative item types.",
    "Details": "Details",
    "AssessmentTitle": "Title",
    "AssessmentCode": "Code",
    "AssessmentTitlePlaceholder": "Type the title",
    "AssessmentCodePlaceholder": "Type the code",
    "EnterTheCode": "Code required",
    "EnterTheTitle": "Title required",
    "TitleNotValid": "Please enter a title of this assessment",
    "CodeNotValid": "Please enter a code of this assessment",
    "TypeNotValid": "Please select a type of this assessment",
    "AllowPrint": "I want to be able to print this assessment",
    "AllowPrintTip": "If you check this option, you will not be able to add all question types",
    "AllowPrintTipForTypes": "The following question types are supported for printing",
    "PrintAssessmentTip": "If you check this option, you will not be able to add all question types. The following question types are supported for printing: Either/Or, Multiple choice, Multiple response, Section.",
    "Required": "* Required",
    "TitleIsTooLong": "Max Title length can be {0} characters",
    "CodeIsTooLong": "Max Code length can be {0} characters"
  },
  "AssessmentFormOptions": {
    "FromAndIncludingPercentage": "From and including %",
    "PercentageInvalidMaxValueMessage": "Percentage should be less than or equal to {0}",
    "ScoreInvalidFormatMessage": "Please enter valid number for score",
    "ScoreInvalidMaxValueMessage": "Score should be less than or equal to {0}",
    "FromAndIncludingScore": "From and including score",
    "PercentageInvalidFormatMessage": "Please enter valid number for percentage",
    "ScoreInvalidMinValueMessage": "Score should be greater than or equal to {0}",
    "PercentageInvalidMinValueMessage": "Percentage should be greater than or equal to {0}",
    "ViewCompleteAssessmentScale": "View complete assessment scale",
    "ErrorOccuredWhileLoadingScaleGrades": "Error occurred while loading scale grades.",
    "ErrorOccuredWhileRecalculatingScaleGrades": "Error occurred while recalculating scale grades.",
    "MinGradePercentageInvalidValueMessage": "Percentage should be equal to 0",
    "MinGradeScoreInvalidValueMessage": "Score should be equal to 0",
    "SelectManually": "Select manually",
    "UseAngoff.Tooltip": "Please note that the cutscore is automatically calculated based on the Angoff values defined for the questions used in this form.",
    "Subtitle": "An assessment scale transforms the score of the candidates into a passmark and grade.",
    "AdjustPassMarkValueSubtitle": "Be sure to understand more about how this works before using this with our dichotomous question types. {0} in our article \"score calculation when using adjust for chance score\" on our support site.",
    "ScaleSelectorPlaceholder": "Select scale",
    "UseAngoff.ValuesInfo": "Cutscore for this score form is <b>{0}</b> and the passmark is <b>{1}%.</b>",
    "UseAngoff.ErrorInfo": "One or more questions used in this form doesn't contain Angoff values.<br>You need to make sure that all questions have Angoff values set before using the Angoff method to calculate the cut score.",
    "ViewAdjustedCompleteScale": "View adjusted complete scale",
    "ViewOriginalCompleteScale": "View original complete scale"
  },
  "Admin.Saml": {
    "Login": "Login attribute name",
    "LinkTip": "The SAML endpoint URL contains your identity provider metadata",
    "LoginTip": "Field name in SAML request is used to locate user identity",
    "MetadataTip": "Your identity provider metadata. Via URL is strongly recommended as then the metadata will be automatically updated.",
    "SaveConfiguration": "Save сonfiguration",
    "LoginUsername": "via username",
    "LoginId": "via User ID",
    "Authentication": "Enable SAML2 Authentication",
    "ProviderName": "SAML Identity Provider name",
    "ProviderNameTip": "Your identity provider name",
    "LoginType": "Lookup user in Cirrus via",
    "LoginTypeTip": "To lookup the user, this user field is searched with the value of the attribute named with ‘Login attribute name’",
    "SelectType": "Select lookup field",
    "MetadataUrl": "SAML SP metadata URL",
    "NameNotValid": "Provider name is not valid",
    "LoginTypeNotValid": "Login attribute type is not valid",
    "LoginNotValid": "Login attribute name is not valid",
    "LinkNotValid": "Metadata URL is not valid",
    "MetadataUpload": "Metadata upload",
    "FromXml": "From XML document",
    "FromURL": "From URL (Recommended)",
    "XmlNotValid": "Metadata from XML document is not valid",
    "XmlEmpty": "Metadata from XML can't be empty",
    "NotSaved": "Data wasn't saved. Try again later or contact your system administrator.",
    "SSOMode": "Single Sign-On mode",
    "SelectSSOMode": "Select SSO Mode",
    "SSOModeMixedHint": "Default behavior: Adds an SSO button to the Login form. Non-SSO users can easily login using username/password. ",
    "SSOModeEnforcedHint": "Automatic redirect to customer's identity provider and disable username/password login. Warning: For support, Cirrus Service Desk requires an active valid user in the customer system!",
    "SSOModeAutomaticHint": "Automatic redirect to SSO page. Login form available via"
  },
  "Submissions.RightSidebar": {
    "Progress": "Progress",
    "Submitted": "Submitted",
    "Scoring": "Scoring",
    "WaitingFor": "Waiting for",
    "WaitingForHint": "The following persons need to complete and submit their scoring:",
    "Collapse": "Collapse sidebar",
    "WaitingForNone": "None. You are all set"
  },
  "Assessment.Pages": {
    "SearchPlaceholder": "Search for the name or ID of the page you want to find...",
    "ShortSearchPlaceholder": "Search for the name or ID..."
  },
  "Assessment.Form": {
    "AddPage": "Add page",
    "PageAddedSuccessfully": "Page added successfully",
    "ErrorOccuredWhileAddingPage": "Error occurred while adding page",
    "ErrorOccuredWhileRemovingPages": "Error occurred while removing pages",
    "HideQuestions": "Hide questions",
    "ShowQuestions": "Show questions",
    "HideIntroduction": "Hide introduction",
    "HideFinish": "Hide finish",
    "ShowFinish": "Show finish",
    "ShowIntroduction": "Show introduction",
    "FormHasNoPages": "Start building the Assessment Form by adding Welcome and Finish pages.",
    "EditSettingsDialog.SubmitButtonText": "Update form",
    "AngoffIsTurnedOff": "Angoff has been turned OFF for this site. If you want to use Angoff, please ask your administrator to turn it on.",
    "AngoffUnavailableInRandomForm": "Angoff is not available in random form"
  },
  "ExternalApi": {
    "SelectAssessmentCreator": "Select assessment owner",
    "SelectCollectionCreator": "Select collection owner",
    "SelectReviewSessionOwner": "Select review session owner"
  },
  "Question.Editor.Sidebar.Section": {
    "NotConnectedTip": "This question is not connected to a section"
  },
  "Question.Editor.Sidebar.Questions": {
    "Tip": "By adding questions to sections, these questions will always be drawn together from the library"
  },
  "QuestionEditor.Section": {
    "QuestionType": "Question type",
    "ItemId": "Item ID",
    "Status": "Status"
  },
  "PermanentSection": {
    "MaxTime": "Max time for section",
    "MaxTimeTip": "It is possible to set a maximum allowed time for a section. Please note that the time allowed cannot be more than the max time for the complete assessment.",
    "MaxTimeMinutes": "In minutes. Leave blank for unlimited time.",
    "DurationNotValid": "Please enter a value between 1 and {0}",
    "MaxScore": "Max score",
    "ShowAdvancedOptions": "Show advanced options",
    "PassMark": "Pass mark",
    "PassMarkNotValidPercentage": "Value cannot be greater than 100",
    "PassMarkNotValidScore": "Value cannot be greater than max score of the section",
    "HideAdvancedOptions": "Hide advanced options",
    "PassMarkTypePercentage": "Percentage",
    "PassMarkTypeScore": "Score",
    "PassMarkTip": "Allows you to set a specific pass mark for the section. If set, candidates must pass the section in order to pass the complete assessment. Leave blank if no pass mark is required.",
    "NumberOfQuestions": "Number of questions to answer",
    "NumberOfQuestionsTip": "Set the number of questions required to answer. Changing this value will affect the total score a candidate can achieve.",
    "ShowIntroduction": "Show section introduction page",
    "ShowIntroductionTip": "Allows you to display the section introduction page before entering the section.",
    "HideDetailed": "Hide detailed information",
    "HideDetailedTip": "Allows you to hide detailed information, like time allowed for the section and the number of questions required to answer.",
    "ShowBasicOptions": "Show basic options",
    "HideBasicOptions": "Hide basic options",
    "HideAssessmentDetails": "Hide assessment details",
    "ShowAssessmentDetails": "Show assessment details",
    "PassMarkTip2": "If the specific pass mark set, candidates must pass the section in order to pass the complete assessment.",
    "PassMarkPlaceholder": "Enter the pass mark",
    "ValueRangeTip": "Value should be between {min} and {max}. Leave blank if no pass mark is required"
  },
  "QuestionEditor.Status": {
    "ResetNotification": "Not all linked questions are “Live” - section status will revert to Draft upon saving.",
    "ResetNotificationWithdrawn": "Status will be reset to Withdrawn after saving"
  },
  "AllocationType": {
    "Candidate": "Candidate",
    "Items": "Items"
  },
  "Admin.ExternalApi.GenerateTokenDialog": {
    "Title": "Generate EAPI Token",
    "WarningMessage": "Attention: If you regenerate token you will not be able to use an old one!",
    "ExternalApiUserField": "External API User",
    "UserSelectPlaceholder": "Select user"
  },
  "Admin.ExternalApi": {
    "TokenWasCopyToClipboard": "Token was copied!",
    "TokenSuccessfullyGenerated": "Token was successfully generated!",
    "TokenPlaceholder": "Click generate to create token for using external API"
  },
  "RightSidebar": {
    "Collapse": "Collapse sidebar",
    "Expand": "Expand sidebar"
  },
  "QuestionEditor.Sowiso.Set": {
    "UsedInSection": "This question is used in section. It's not possible to create a set."
  },
  "SowisoSetPreview": {
    "Title": "Mathematical question set preview"
  },
  "Assessment.Hierarchies": {
    "EmptyListText": "No hierarchies available"
  },
  "Admin.Clusters.Dialogs.Add": {
    "Title": "Add cluster"
  },
  "Admin.Clusters": {
    "Title": "Title",
    "NoHierarchiesSelected": "No hierarchies selected",
    "Hierarchy": "Hierarchy",
    "SelectHierarchy": "Select hierarchy",
    "UsedInAssessments": "This cluster is used in assessment(s)",
    "Description": "Description",
    "AddCluster": "Add cluster",
    "NoClusters": "No clusters",
    "Hierarchies": "Hierarchies",
    "DeleteHierarchy": "Cluster should contain at least one hierarchy",
    "DeletedHierarchy": "{0} hierarchy(s) were deleted from {1} cluster",
    "SavedSuccess": "Cluster {0} was saved successfully"
  },
  "Admin.Clusters.Dialogs.Edit": {
    "Title": "Edit cluster"
  },
  "Assessments.AssignmentConnections": {
    "AvailableTo": "Available for scheduling by",
    "CanUse": "Who can schedule?",
    "Tip": "Users belonging to the selected hierarchies or clusters of hierarchies can schedule this assessment. If you don't select a hierarchy, only you will be able to schedule this assessment form."
  },
  "Admin.Vpl": {
    "MaxFileSize": "Maximum upload file size",
    "MaxFileSizeTip": "Maximum upload file size",
    "DefaultFileSize": "Default maximum upload file size",
    "DefaultFileSizeTip": "Default maximum upload file size",
    "MaxExeFileSize": "Maximum execution file size",
    "MaxExeFileSizeTip": "Maximum execution time",
    "DefaultExeFileSize": "Default maximum execution file size",
    "DefaultExeFileSizeTip": "Default maximum execution time",
    "MaxExeProcesses": "Maximum number of processes",
    "MaxExeProcessesTip": "Maximum number of processes",
    "DefaultExeProcesses": "Default maximum number of processes",
    "DefaultExeProcessesTip": "Default maximum number of processes",
    "JailServers": "Execution servers list",
    "JailServersTip": "Select servers you want to use for run/evaluate",
    "AcceptCert": "Accept self signed certificates",
    "AcceptCertTip": "If the execution servers are not using self signed certificates uncheck this option",
    "WebsocketProtocol": "WebSocket protocol",
    "Proxy": "Proxy",
    "ProxyTip": "Proxy from Cirrus to execution servers",
    "UseWatermarks": "Use watermarks",
    "UseWatermarksTip": "Adds watermarks to student's files (only to supported languages)",
    "DiscardSubmissionPeriod": "Discard submission period",
    "DiscardSubmissionPeriodTip": "For each student and assignment, the system tries to discard submissions. The system keep the last one and at least a submission for every period",
    "EditorTheme": "Editor theme",
    "EditorThemeTip": "Editor theme",
    "MaxExeMemory": "Maximum memory used",
    "MaxExeMemoryTip": "Maximum execution time",
    "DefaultExeMemory": "Default maximum memory used",
    "DefaultExeMemoryTip": "Default maximum memory used",
    "MaxExeTime": "Maximum execution time",
    "MaxExeTimeTip": "Maximum execution time",
    "DefaultExeTime": "Default maximum execution time",
    "DefaultExeTimeTip": "Default maximum execution time",
    "WebsocketProtocolTip": "Type of WebSocket protocol (ws:// or wss://) used by the browser to connect to execution servers",
    "WebsocketProtocol.Encrypted": "Use encrypted (wss) websocket protocol",
    "WebsocketProtocol.Unencrypted": "Use unencrypted (ws) websocket protocol"
  },
  "Admin.Vpl.Errors": {
    "ValueMustBeGreaterThanZero": "Value must be greater than zero"
  },
  "Clusters.CanSchedule": {
    "EmptyTable": "No users",
    "Name": "Name",
    "UserName": "User name",
    "Role": "Role",
    "Email": "E-mail",
    "UserId": "User ID"
  },
  "Clusters": {
    "CanScheduleDialog": "Who can schedule",
    "HierarchyIsContainedInCluster": "This hierarchy is contained in an already added cluster"
  },
  "Delivering.Hierarchies": {
    "EmptyListText": "No hierarchies available"
  },
  "Question": {
    "CantCheckMoreChoices": "You can't check more than {0} choices for this question",
    "CantDrawMoreConnections": "You can't draw more than {0} connections for this question"
  },
  "Assessment.Sowiso": {
    "QuestionSetTitle": "Question set"
  },
  "Assessment.Hierarchy": {
    "EmptyListText": "No hierarchy"
  },
  "Assessment.Clusters": {
    "EmptyListText": "No clusters"
  },
  "Delivering.Clusters": {
    "EmptyListText": "No clusters"
  },
  "Admin.Vpl.Confirmation": {
    "ConfirmDefaultChanges": "Some of questions have default value for settings that you are trying to change. These values will be inherited",
    "ConfirmMaxChanges": "Some of questions have larger values than you set as maximum limits, they will not be changed"
  },
  "Item.Validation": {
    "PleaseEnterMaximumNumberOfFiles": "Please enter maximum number of files",
    "FuncIdShouldBeUnique": "Item ID should be unique",
    "MaximumNumberOfProcessesShouldBeLessOrEqual": "Maximum number of processes should be less than or equal to {0}",
    "MaximumNumberOfRequestedFiles": "Number of requested files should be less than or equal to {0}",
    "PleaseEnterTestCases": "Please enter test cases"
  },
  "CodeEditor.Actions": {
    "RemoveFileModalTitle": "Delete",
    "CreateFileModalTitle": "New file",
    "RenameFileModalTitle": "Rename",
    "CreateFileText": "Enter a new file name",
    "RenameFileText": "Rename file \"{0}\" to",
    "RemoveFileText": "Delete file \"{0}\""
  },
  "Readspeaker": {
    "Listen": "Listen"
  },
  "Library.Statistics": {
    "VersionOverview": "Version overview",
    "SearchPlaceholder": "Search for question title, ID, text or label",
    "NoResultsText": "Add or import items to the collection to start collect statistics data"
  },
  "CollectionItemStatistics": {
    "ChanceScore": "Chance score",
    "PCValue": "Pc-Value",
    "PValue": "P-Value",
    "Answered": "Answered",
    "GivenAnswers": "Given answers",
    "Angoff": "Angoff"
  },
  "AssessmentPrintDialog": {
    "IncludePages": "Include introduction and finish pages",
    "IncludePagesTip": "Will print introduction and finish pages for the form",
    "IncludeQuestions": "Include questions",
    "IncludeQuestionsTip": "Will print the questions for the assessment",
    "IncludeQRCode": "Include QR code",
    "IncludeQRCodeTip": "Will print the QR code which is used to recognise the assessment when printing. This QR code will be printed on a separate sheet",
    "DialogHeader": "Print assessment form"
  },
  "Assessment.DownloadAnswerForm": {
    "MoreThanAllowedAlternativesConfirmation": "Questions have more than 4 alternatives.",
    "MoreThanAllowedQuestionsConfirmation": "Forms have more than 120 questions."
  },
  "Collection.Statistics": {
    "SearchPlaceholder": "Search for items..."
  },
  "Rescoring": {
    "ShortSearchPlaceholder": "Search for the schedule..."
  },
  "Questions.Vpl.Tabs": {
    "ExecutionOptions": "Execution options",
    "TestCases": "Test cases",
    "ExecutionFiles": "Execution files",
    "Question": "Question",
    "RequestedFiles": "Requested files"
  },
  "Questions.Vpl": {
    "MaximumExecutionTime": "Maximum execution time",
    "MaximumExecutionFileSize": "Maximum execution file size",
    "MaximumNumberOfFiles": "Maximum number of files",
    "FilesToKeepWhenRunning": "Files to keep when running",
    "DebugScript": "Debug script",
    "Run": "Run",
    "MaximumMemoryUsed": "Maximum memory used",
    "MaximumNumberOfProcesses": "Maximum number of processes",
    "Evaluate": "Evaluate",
    "RunScript": "Run script",
    "Debug": "Debug"
  },
  "SectionInfoPopover": {
    "PassMark": "Pass mark",
    "Percentage": "Percentage",
    "MaxTimeForSection": "Max time for section",
    "Failed": "Failed",
    "SectionSettings": "Section settings",
    "Passed": "Passed",
    "SectionResults": "Section results",
    "Score": "Score",
    "SectionResult": "Section result"
  },
  "InvigilatorLogs.Types": {
    "PageVisitedExamLog": "Page visited",
    "QuestionVisitedExamLog": "Question visited",
    "StartedExamLog": "Exam started",
    "ConfirmedExamLog": "Candidate clicked \"Start/continue test\"",
    "ContinuedExamLog": "Attempt continued",
    "ConnectionLostExamLog": "Connection lost",
    "QuestionAnsweredExamLog": "Question answered",
    "CompleteExamLog": "Exam completed",
    "QuestionAnsweredWithConnectionFailExamLog": "Question answered with error",
    "ChangedExamStatusLog": "Exam status changed",
    "ChangedExamStatusReceivedLog": "Exam status changed (server log)",
    "SurveyQuestionVisitedExamLog": "Survey question visited",
    "SurveyQuestionAnsweredExamLog": "Survey question answered",
    "SurveySubmittedExamLog": "Survey submitted",
    "LogoffExamLog": "Logoff",
    "ImageLoadFailedLog": "Image load failed",
    "CandidateSaveAnswer": "Candidate save answer",
    "SignalrDisconneted": "Connection lost",
    "UncaughtExamError": "Uncaught exam error",
    "CaughtExamError": "Caught exam error",
    "AnswersNotSaved": "Answers not saved",
    "AnswersSaved": "Answers saved",
    "UnrecognizableLogType": "Unrecognizable log type",
    "ExamLog": "Unknown record",
    "QuestionAnswerWasNotSavedExamLog": "Question answer was not saved",
    "StatusChanged": "Exam status changed (client log)",
    "RealtimeStatusChanged": "Realtime status changed",
    "AnswersQueueUnstuck": "Answers queue unstuck",
    "AnswersQueueStuck": "Answers queue stuck",
    "ExamOpened": "Exam opened",
    "Unload": "Unload page",
    "BeforeUnload": "Before page unload",
    "ConnectionLost": "Connection lost",
    "ConnectionRestored": "Connection restored",
    "WorkoutNoteSavedExamLog": "Notepad note saved",
    "InvigilatorMessageReadLog": "Message from proctor viewed",
    "CandidateChangedWorkoutNote": "Candidate changed notepad note",
    "ProctorIoStatusError": "Proctor.io status error",
    "ProctorIoStatusActive": "Proctor.io status active",
    "RationaleSavedExamLog": "Rationale saved",
    "RationaleWasNotSavedExamLog": "Rationale was not saved"
  },
  "FinancialStatement": {
    "SectionHeaderPlaceholder": "Enter the section header",
    "Debit": "Debit",
    "Credit": "Credit",
    "Score": "Score",
    "AddSeparatorTooltip": "Add separator",
    "ScoringBy": "Scoring by",
    "ScoringByTip": "Scoring by row allows you to set at score per correct row, while scoring by question allows you to set a score for the complete question.",
    "ScoringByRow": "Scoring by row",
    "ScoringByQuestion": "Scoring by question",
    "InvalidScore": "Sections shouldn't contain rows with empty or 0 score.",
    "SectionsInvalid": "Question should contain at least one section.",
    "SectionsRowsInvalid": "Question shouldn't contain section with no rows for answer.",
    "SectionsTitleInvalid": "Title of question sections shouldn't be empty.",
    "SectionsRowInvalid": "Titles of rows of question sections  should be filled",
    "DebitCreditInvalid": "At least one column per row should be filled with number or formula",
    "AddRow": "Add row",
    "AddSubRow": "Add sub-row",
    "AddSeparator": "Add separator",
    "SectionsHeaderInvalid": "Sections shouldn't contain header rows with no title",
    "DebitCreditNumberInvalid": "Numbers of section should be less than 10 digits and can contain 2 digits after the decimal point ",
    "AddHeader": "Add header",
    "Section": "Section",
    "SectionHeader": "Section header",
    "SectionSubtitle": "Section subtitle",
    "FormulaTooltip": "<b>Formula can contain: </b><br/>\r\nArithmetic operations like <b>+, -, /, *, ^</b><br/>\r\nComparison operations like  <b>=, >, >=, <, <=, <> </b><br/>\r\nCell coordinates like <b>A1, a1</b>",
    "DebitCreditExpressionInvalid": "Cell in section with formula isn't valid",
    "InvalidMaxScore": "Max score should be more than 0",
    "NonExistingVar": "Non existing cell is used"
  },
  "Questions.Cip.ScoringType": {
    "FullNoScore": "Full/no score",
    "PartialScore": "Partial score",
    "FullNoScoreDescription": "Full/ no score means that the candidate either get's full score for the row or zero points if 1 or more mistakes are made.",
    "PartialScoreDescription": "Partial score means that the candidate gets full score if the whole row is correct, 50% score if 1 mistake is made and 0 score if 2 or more are incorrect.",
    "PolytomousScoringRules": "Polytomous scoring rules",
    "ScorePerCell": "Score per cell",
    "ScorePerCellDescription": "Score will be distributed proportionally on the number of cells."
  },
  "Item.Cip.Validation": {
    "AllFieldsAreRequired": "All fields are required",
    "ColumnsAreRequired": "Please add at least one column",
    "RowsAreRequired": "Please add at least one row"
  },
  "Questions.Cip.Content": {
    "EnterAnswerAlternatives": "Enter the answer alternatives",
    "EnterColumnHeader": "Enter the column header",
    "EnterRowHeader": "Enter the row header",
    "AddColumn": "Add column",
    "AddRow": "Add row",
    "Delete": "Delete"
  },
  "Delivering.Invigilation.SubmittedBy": {
    "Candidate": "Candidate",
    "System": "System"
  },
  "QuestionPreview": {
    "UnrecognizedEvaluationError": "Unrecognized evaluation error",
    "EvaluationInProgress": "Evaluation in progress",
    "ProgramTimeout": "Program timeout",
    "ProgramOutOfMemory": "Program out of memory",
    "HttpRequestError": "Http request error",
    "UnsupportedFileExtension": "Unsupported file extension",
    "ServersAreNotAvailable": "Servers are not available"
  },
  "VplEditor": {
    "CompilationFailed": "Compilation failed",
    "SummaryOfTestsText": "{0} test(s) run / {1} test(s) passed",
    "ProgramOutput": "Program output",
    "SummaryOfTests": "Summary of tests",
    "Input": "Input",
    "Connecting": "Connecting...",
    "IncorrectProgramOutput": "Incorrect program output",
    "ExpectedOutput": "Expected output",
    "EvaluationFailed": "Evaluation failed",
    "Disconnected": "Disconnected"
  },
  "Editor.ExtendedMC": {
    "RemoveQuestion": "Remove question",
    "AddQuestion": "Add question"
  },
  "Exam.Vpl": {
    "UnrecognizedEvaluationError": "Unrecognized evaluation error",
    "EvaluationInProgress": "Evaluation in progress",
    "ProgramOutOfMemory": "Program out of memory",
    "ProgramTimeout": "Program timeout",
    "SocketConnectionError": "Socket connection error. Check that your execution server is available and support SSL.",
    "HttpRequestError": "Http request error",
    "UnsupportedFileExtension": "Unsupported file extension",
    "ServersAreNotAvailable": "Servers are not available",
    "PleaseEnterAnswer": "Please enter your answer",
    "ParsingEvaluationFeedbackError": "Parsing evaluation feedback error"
  },
  "Vpl": {
    "AnswerLabel": "Write your code below"
  },
  "Questions.Cip": {
    "OptionsInQuestionText": "Options in question text"
  },
  "General.Assessement": {
    "BrowseForCollections": "Browse for collections"
  },
  "Assessment.Toolbar": {
    "AddRow": "Add row"
  },
  "Admin.GlobalSettings.Tabs": {
    "GeneralSettings": "General",
    "Vpl": "VPL",
    "Proctorio": "Proctorio"
  },
  "PuzzleScoringType": {
    "Dichotomous": "Dichotomous",
    "PolytomousByCells": "Polytomous: Score per cell",
    "PolytomousByRows": "Polytomous: Full/no score",
    "PolytomousByHalfRows": "Polytomous: Partial score"
  },
  "Delivery.PermanentSection": {
    "RequiredToAnswerCount": "{0} of {1}",
    "RequiredToAnswer": "Required to answer:"
  },
  "Delivery.SectionAnswers": {
    "AnsweredCount": "{0} out of {1} question in the section are answered.",
    "AnsweredCountPlural": "{0} out of {1} questions in the section are answered.",
    "RequiredCountPlural": "Required questions to answer - {0}.",
    "SectionAnswered": "The section is fully answered."
  },
  "Exam.Section.IntroPage": {
    "TimedSectionWarning": "This is a timed section. The timer will start as soon as you click on Next"
  },
  "Author.PermanentSection": {
    "RequiredToAnswer": "Required to answer:",
    "RequiredToAnswerCount": "{0} of {1}"
  },
  "Reports.Candidates.Export.Results": {
    "StartDate": "Start date",
    "StartTime": "Start time",
    "SubmitDate": "Submit date",
    "SubmitTime": "Submit time",
    "TimeSpent": "Time spent"
  },
  "LoginAs": {
    "LoggedInAsAnotherUser": "You are assuming the identity of another user. Any actions taken will be completed as that user.",
    "CloseSession": "Close the browser window"
  },
  "ContentManagement": {
    "UnlockConfirmation": "Are you sure you want to unlock assessment \"{0}\" locked by \"{1}\"? Unsaved changes will be lost.",
    "Unlock": "Unlock assessment"
  },
  "Library.Collection.Statistics": {
    "LastAnswered": "Last answered"
  },
  "Delivery.ExternalLogin.Errors": {
    "ScheduleWasDeleted": "Schedule was deleted",
    "ScheduleIsNotFound": "Schedule is not found",
    "ScheduleWasArchived": "Schedule was archived",
    "ScheduleIsNotActivated": "Schedule is not activated",
    "UserIsNotCandidate": "You are not added as a candidate to this assessment",
    "UnrecognizedError": "Unrecognized error",
    "UserDoesNotHavePermissions": "User does not have permissions to participate this exam",
    "UserHasFinishedExam": "You have already completed the exam",
    "UserIsNotYetCandidate": "You will be redirected to the exam shortly. Please wait"
  },
  "Delivering.Schedule.LtiSettings": {
    "RegisterUrlLabel": "LTI XML Config URL",
    "ConsumerKeyLabel": "Consumer key",
    "SecretKeyLabel": "Secret key",
    "RegisterUrlWasCopyToClipboard": "LTI XML Config URL was copied!",
    "ConsumerKeyWasCopyToClipboard": "Consumer key was copied!",
    "SecretKeyWasCopyToClipboard": "Secret key was copied!",
    "RegenerateSecretKeyConfirmation": "If you regenerate secret key you will not be able to use an old one!",
    "RegenerateSecretKeySuccess": "Secret key was generated!"
  },
  "Candidate.Results": {
    "Answers": "Answers"
  },
  "Hotspot": {
    "ShowOriginal": "Show original size",
    "ShowScaled": "Show scaled size"
  },
  "Marking.Assessors.Validation": {
    "PassMarkRange.IvalidValues": "Please enter values between 0 and 100",
    "PassMarkRange.BothRequired": "Both fields are required",
    "PassMarkRange.FromGreaterThanTo": "First value must be less or equal to second value"
  },
  "EvaluationAnnotation": {
    "NoAssessor": "No assessor assigned"
  },
  "General.LoFilter": {
    "SelectAll": "Select all",
    "UnSelectAll": "Unselect all",
    "NoLoAvailable": "No learning objectives available"
  },
  "General.Filter": {
    "Filter": "Filter",
    "SelectAll": "Select all",
    "UnSelectAll": "Unselect all"
  },
  "FeedbackType": {
    "General": "General",
    "Detailed": "Detailed"
  },
  "Dialogs.SetPin": {
    "SetPinSchedules": "Set PIN",
    "Hint": "Allows you to set a 4-digit pin code for the selected schedules."
  },
  "Admin.Webhooks": {
    "Url": "Url",
    "CreateWebhook": "Create webhook",
    "ContentType": "Content type",
    "Events": "Events",
    "IsActive": "Active",
    "NoWebhooks": "No webhooks"
  },
  "Admin.Webhooks.Events": {
    "ExamResultReady": "Exam results ready",
    "ScheduleFinished": "Schedule finished",
    "ExamResultSatisfactory": "Only when result is SATISFACTORY"
  },
  "Notification.Messages.Webhooks": {
    "SuccessfullyDeleted": "Webhooks were successfully deleted.",
    "HasBeenCreated": "Webhook has been successfully created",
    "HasBeenUpdated": "Webhook has been successfully updated"
  },
  "Admin.Webhooks.Editor": {
    "NewTitle": "Webhooks - New webhook",
    "EditTitle": "Webhooks - Edit webhook",
    "IsActiveField": "Active",
    "IsActiveFieldTip": "Inactive webhook will not trigger requests",
    "TitleField": "Title",
    "TitleFieldTip": "Title of webhook with a short description",
    "URLField": "Payload URL",
    "URLFieldTip": "URL of the endpoint on your server that will receive the webhook POST requests",
    "ContentTypeField": "Content type",
    "ContentTypeFieldTip": "Content type that will be used for requests",
    "SecretField": "Secret key",
    "SecretFieldTip": "The secret allows you to be ensure that requests come from Cirrus",
    "EventsField": "Events",
    "EventsFieldTip": "Events that can trigger the webhook",
    "TitleFieldCanNotBeEmpty": "Title cannot be empty",
    "URLFieldCanNotBeEmpty": "Payload URL cannot be empty",
    "SecretFieldCanNotBeEmpty": "Secret cannot be empty",
    "EventsFieldAtLeastOneRequired": "At least one event should be set",
    "URLFieldMustBeValidURL": "Payload URL must be valid URL",
    "SecretKeyIsIncorrect": "Secret Key can only contains alphanumeric symbols or [ _ , - ]",
    "PayloadTemplate": "Payload template",
    "AuthType": "Authorization type"
  },
  "Assessment.Options.TestForms": {
    "Title": "Test-form settings",
    "FormsRandom": "Random test form",
    "FormsRandomDescription": "Selecting this option will shuffle the order of the test forms. Otherwise candidates will get the forms in the order they are presented in the forms overview tab.",
    "ShuffleFormsOrder": "Shuffle the order of the test forms"
  },
  "Admin.Sharing.Collections": {
    "Title": "Who do you want to share the selected collections(s) with?",
    "UseQuestionsTip": "By checking \"Use questions\", the user has permission to use the questions within this collection when creating an assessment"
  },
  "Admin.Sharing": {
    "AlreadySharedInfo": "Users with whom it has already been shared are not shown",
    "ShareWith": "Share with",
    "ROLE_NOT_FOUND": "Role not found",
    "User": "Cannot be shared with user {0}",
    "Collection": "Collection {0} cannot be shared",
    "COLLECTION_NOT_FOUND": "Collection not found",
    "USER_WAS_DELETED": "User was deleted",
    "USER_CAN_NOT_HAVE_RIGHTS_TO_COLLECTIONS": "User does not have permissions to have collections shared with him",
    "USER_CAN_NOT_HAVE_RIGHTS_TO_QUESTIONS": "User does not have permissions to have questions shared with him",
    "SharingCollectionsSuccessful": "Collections have been shared successfully",
    "ASSESSMENT_NOT_FOUND": "Assessment not found",
    "ASSESSMENT_WAS_DELETED": "Assessment was deleted",
    "USER_CAN_NOT_HAVE_RIGHTS_TO_ASSESSMENTS": "Assessments can not be shared with this user",
    "COLLECTION_WAS_DELETED": "Collection was deleted",
    "USER_NOT_FOUND": "User not found",
    "SharingAssessmentsSuccessful": "Assessments have been shared successfully",
    "IMPOSSIBLE_TO_CHANGE_OWNER_ROLE": "User role can not be changed for some collections, because he is an owner",
    "ASSESSMENT_SHARING_IMPOSSIBLE_TO_CHANGE_OWNER_ROLE": "User role can not be changed for some assessments, because he is an owner",
    "Assessment": "Assessment {0} cannot be shared"
  },
  "Sharing": {
    "UseQuestions": "Use questions",
    "Role": "Role"
  },
  "Notification.Message": {
    "NoChanges": "There are not changes to save!"
  },
  "CollectionItemImport.ErrorReasons": {
    "ItemHasIncorrectCountsOfConnections": "Questions support only one connection",
    "SomeOfConnectionsNotFound": "Some of connections are not found",
    "QuestionHasNotSectionConnections": "Only section can be parent of questions",
    "ParentSectionIsUsedInAssessment": "Parent section is used in assessment",
    "SectionHasNotQuestionConnections": "Only questions can be children of section",
    "ItemHasValidationErrors": "Item has validation errors",
    "ItemHasInappropriateStatus": "Status is not allowed",
    "ChildQuestionIsUsedInAssessment": "Some of the child questions are used in assessments",
    "ChildQuestionIsAlreadyInSection": "Some of the child questions are already in sections"
  },
  "General.TaxonomiesFilter": {
    "NoTaxonomiesAvailable": "No taxonomies available"
  },
  "Admin.Sharing.Assessments": {
    "Title": "Who do you want to share the selected assessment(s) with?"
  },
  "Scoring": {
    "SpellingError": "Spelling error",
    "KeyboardShortcuts": "Keyboard shortcuts",
    "SaveMarks": "Save marks",
    "ViewAsYourself": "View as yourself",
    "ViewAsAssessor": "View as assessor",
    "ViewAsModerator": "View as moderator",
    "OnlyMarkers": "Only markers",
    "VisibilityOnlyMarkersDescription": "The annotation will be shown to markers only",
    "VisibilityAllDescription": "The annotation will be shown to markers and candidates. Note that the visibility to candidates is also dependent on turning on annotations in the assessment options"
  },
  "Schedule.Share": {
    "OnlyYouHaveAccessToThisSchedule": "Only you have access to this schedule at the moment.",
    "YouCanShareTheSchedule": "You can share the schedule with other users by typing their names in the Add person dialogue box.",
    "Title": "Who do you want to share this schedule with?"
  },
  "MarkingScheme.Info": {
    "LockNotification": "This marking scheme is already being edited by {0}. Your co-author needs to exit this marking scheme in order for you to make changes."
  },
  "Notification.Messages.Section": {
    "SpecifyTextRequirement": "Please enter the section text"
  },
  "Delivering.Invigilation.ExtraTime": {
    "WarningAttemptDurationEqualsExamDuration": "Extra time can not be added because the attempt duration equals to the schedule duration",
    "EnterAmountWarning": "{0} minutes max",
    "EnterAmount": "Enter amount of minutes"
  },
  "Assessment.Options.Workout": {
    "NoWorkout": "No notepad",
    "OnlySelected": "Only selected questions",
    "All": "All questions",
    "NoWorkoutTip": "Not allow use notepad to the candidate",
    "OnlySelectedTip": "Allow use of notepad for selected questions.",
    "AllTip": "Allow notepad to the candidate."
  },
  "Groups": {
    "MoveInProgress": "Group wasn't moved, previos group moving in progress..."
  },
  "Delivery.Exams.MessageFromInvigilator": {
    "ViewLink": "View message(s)"
  },
  "Notification.Messages.Invigilation": {
    "SuccessMessageSending": "Message was sent",
    "DoNotHavePermissionToSend": "You don't have permission to send this message"
  },
  "Delivery.Exams": {
    "MessageFromInvigilator": "Message from Proctor"
  },
  "AllocationAssignmentType": {
    "Manual": "Manual",
    "AssessorDecides": "Let Assessor decide"
  },
  "Marking.EditReviewSession.Share": {
    "AuthorAccessOnlyTip": "Only you have access to this review session at the moment.",
    "Tip": "You can share the review session with other users by typing their names in the Add person dialogue box.",
    "Title": "Who do you want to share this review session with?",
    "DialogTitle": "Share this review session"
  },
  "Marking.EditReviewSession.Info": {
    "LockNotification": "This review session is already being edited by {0}. Your co-author needs to exit this review session in order for you to make changes."
  },
  "Marking.ProgressReport": {
    "ToBeMarked": "To be marked",
    "ScoredByCoAssessor": "Scored by co-assessor",
    "Autoscored": "Autoscored"
  },
  "Evaluation.Submissions": {
    "ScoredByYou": "questions have been scored by you",
    "HaveToBeScored": "questions needs to be scored by you",
    "Autoscored": "questions have been auto-scored"
  },
  "Evaluation.ProgressReport": {
    "AssessedBy": "Assessed by {0}",
    "NotScored": "Question is not scored"
  },
  "Delivery.Exam.Notepad": {
    "Error": "Attempt is not in progress, has been completed or voided by invigilator."
  },
  "Admin.Templates.Notification": {
    "ExternalIdUnique": "External ID should be unique"
  },
  "Evaluation.Info": {
    "LockNotification": "This question is already being edited by {0}. Your co-author needs to exit this question in order for you to make changes."
  },
  "Admin.Proctorio": {
    "ExamSettings.RecordVideo": "Record video",
    "ExamSettings.RecordVideoTip": "Require the Test Taker to have a webcam and record the webcam for the entire duration of the exam",
    "ExamSettings.RecordAudio": "Record audio",
    "ExamSettings.RecordAudioTip": "Require the Test Taker to have a microphone and record audio for the entire duration of the exam",
    "ExamSettings.RecordScreen": "Record screen",
    "ExamSettings.RecordScreenTip": "Capture and record the full desktop screen for the entire duration of the exam",
    "ExamSettings.RecordWebTraffic": "Record web traffic",
    "ExamSettings.RecordWebTrafficTip": "Capture screenshots and URLs of any websites visited during the exam",
    "ExamSettings.RecordRoomStart": "Record room at the start",
    "ExamSettings.RecordRoomStartTip": "Require the Test Taker to perform a room scan at the start of the exam",
    "ExamSettings.VerifyVideo": "Verify video",
    "ExamSettings.VerifyVideoTip": "Ensure that the webcam is working and it is not virtualized or broken",
    "ExamSettings.VerifyAudio": "Verify audio",
    "ExamSettings.VerifyAudioTip": "Ensure that the microphone is working and it is not virtualized or muted",
    "ExamSettings.VerifyDesktop": "Verify desktop",
    "ExamSettings.VerifyDesktopTip": "Ensure that the desktop recording is working and is being properly recorded",
    "ExamSettings.VerifyId": "ID verification",
    "ExamSettings.VerifyIdAuto": "Automatic ID verification",
    "ExamSettings.VerifyIdAutoTip": "Require the Test Taker to present photo identification prior to starting the exam and will be automatically scanned",
    "ExamSettings.VerifyIdLive": "Live ID verification",
    "ExamSettings.VerifyIdLiveTip": "Require the Test Taker to present photo identification prior to starting the exam. The ID is then reviewed and verified by a Proctorio agent before they are allowed into the exam",
    "ExamSettings.VerifySignature": "Signature verification",
    "ExamSettings.VerifySignatureTip": "Require the Test Taker to sign an agreement before exam start",
    "ExamSettings.Fullscreen": "Fullscreen",
    "ExamSettings.FullscreenHint": "Force the exam in fullscreen, prevent access to other applications and websites",
    "ExamSettings.FullscreenLenient": "Lenient",
    "ExamSettings.FullscreenLenientTip": "Navigating away from the exam page for more than 30 seconds results in removal from the exam",
    "ExamSettings.FullscreenModerate": "Moderate",
    "ExamSettings.FullscreenModerateTip": "Navigating away from the exam page for more than 15 seconds results in removal from the exam",
    "ExamSettings.FullscreenSevere": "Severe",
    "ExamSettings.FullscreenSevereTip": "Navigating away from the exam page results in instant removal from the exam",
    "ExamSettings.Clipboard": "Clipboard",
    "ExamSettings.ClipboardTip": "Disable copy/paste functionality, including screen printing and the context menu",
    "ExamSettings.NewTabs": "New Tabs",
    "ExamSettings.NoTabs": "No tabs",
    "ExamSettings.NoTabsTip": "Disable new tabs or windows during the exam",
    "ExamSettings.LinksOnly": "Links only",
    "ExamSettings.LinksOnlyTip": "Disable new tabs or windows during the exam except links embedded in the exam page",
    "ExamSettings.CloseTabs": "Close tabs",
    "ExamSettings.CloseTabsTip": "Force all other tabs and windows to be closed before the exam starts",
    "ExamSettings.OneScreen": "One screen",
    "ExamSettings.OneScreenTip": "Force the Test Taker to disable all but one monitor before starting the exam",
    "ExamSettings.Print": "Disable printing",
    "ExamSettings.PrintTip": "Disable ability to print exam content for exam distribution preventing",
    "ExamSettings.Downloads": "Disable downloads",
    "ExamSettings.DownloadsTip": "Prevent the Test Taker form downloading files through the browser",
    "ExamSettings.Cache": "Clean cache",
    "ExamSettings.CacheTip": "Remove system temporary files after the exam is submitted",
    "ExamSettings.RightClick": "Disable right click",
    "ExamSettings.RightClickTip": "Disable right mouse button click functionality",
    "ExamSettings.Reentry": "Re-entry",
    "ExamSettings.NoReentry": "No re-entry",
    "ExamSettings.NoReentryTip": "Requires the exam to be completed in one sitting, any disconnection will end the exam",
    "ExamSettings.AgentReentry": "Agent re-entry",
    "ExamSettings.AgentReentryTip": "Requires the exam to be completed in one sitting, any disconnection will end the exam. To resume the attempt, the Test Taker must open a chat with a Proctorio agent to allow re-entry",
    "ExamSettings.Calculator": "Calculator",
    "ExamSettings.CalculatorBasic": "Basic calculator",
    "ExamSettings.CalculatorBasicTip": "Allows Test Takers to perform calculations using an on-screen calculator with basic functions",
    "ExamSettings.CalculatorSci": "Scientific calculator",
    "ExamSettings.CalculatorSciTip": "Allows Test Takers to perform calculations using an on-screen calculator with scientific functions",
    "ExamSettings.Whiteboard": "Whiteboard",
    "ExamSettings.WhiteboardTip": "Allows Test Takers to use a scratch pad and drawing tools on-screen",
    "ExamSettings.RecordRoom": "Room recording",
    "ExamSettings.RecordRoomIntelligentTip": "Forces test taker to show entire room at random intervals during the exam",
    "ExamSettings.RecordRoomIntelligent": "Intelligent room recording",
    "AssessmentIsProctored": "This assessment is remote proctored"
  },
  "Schedule.Candidate": {
    "SuccessRemoved": " {0} candidates were successfully removed",
    "SuccessNotRemoved": "{0} candidates had started the exam and weren't removed",
    "ErrorRemoveAll": "It is not possible to delete all candidates from activated schedule. At least one candidate should remain.",
    "Removed": "Candidate \"{0}\" was successfully removed",
    "NotRemoved": "Candidate \"{0}\" had started the exam and wasn't removed",
    "Remove.ConnectionError": "Failed to remove candidate \"{0}\". No internet connection",
    "CannotAddMoreCandidates": "This schedule cannot be above the limit of {0} candidates"
  },
  "Delivery.Notification": {
    "CandidateRemoved": "You have been removed from this assessment."
  },
  "Assessment.Actions": {
    "Print": "Print assessment"
  },
  "Admin.GlobalSettings.ProctorioTab": {
    "Title": "Proctorio settings",
    "Hint": "Please make the settings selections for this template"
  },
  "Test": {
    "Key": "ZERO"
  },
  "Evaluation.Notification": {
    "ScoringModelHasChanged": "The scoring model has changed."
  },
  "Notification.Messages.Skins": {
    "DataFetchFailed": "An error occurred while loading the application skins data."
  },
  "Exam": {
    "NavigationWhileAudioPlayingNotification": "You are about to leave the question while the audio file is playing. After confirmation listening attempt will be counted. Are you sure you want to leave the question?"
  },
  "UserImport.Errors": {
    "InternalError": "Oops, something went wrong.",
    "IncorrectFilesInRequest": "The file has an invalid format. User import only supports Excel files with .xls and .xlsx extensions.",
    "IncorrectFileSize": "The file is too big. The maximum size of the file is 4 MB.",
    "ReadContentError": "The file has invalid content. Check if the file is a valid Excel file.",
    "IncorrectNumberOfRowsInFile": "The file contains an invalid number of rows. The file should contain at least 2 rows and not more than 2001.",
    "IncorrectNumberOfColumnsInFile": "The file contains an invalid number of columns. The maximum number of columns is 100.",
    "IncorrectHeaderRow": "The file contains an incorrect header row. The header row should not be empty, not have empty cells and duplicates.",
    "SessionIsNotFound": "Import session expired.",
    "ProfileIsNotFound": "The site role is not found.",
    "StartGroupIsNotFound": "The start hierarchy is not found.",
    "CurrentUserDoesNotHaveAccessToGroup": "You don't have access to manage users in the selected hierarchy.",
    "SourcedIdExists": "Synchronization key is in use.",
    "InvalidSpecialNeeds": "The field should contain \"yes\" or \"no\".",
    "ExternalIdDuplicated": "Import contains duplicate user id",
    "InvalidPassword": "Password can not contain spaces and should have at least 5 and no more than 500 symbols in it.",
    "InvalidUserName": "Username should not contain spaces or special symbols and the length can not be greater than 500 symbols",
    "InvalidExternalId": "This field can only contain [-_a-zA-Z0-9.@] symbols and the length can not be greater than 500 symbols",
    "InvalidReasonableAdjustments": "The field should contain \"yes\" or \"no\".",
    "InvalidPercentageExtraTime": "The field should contain an integer value between 0 and 999"
  },
  "UserImport": {
    "UseDefaultRegionalSettings": "Use default regional settings",
    "SelectRegion": "Select region"
  },
  "General.Errors": {
    "IdUsed": "ID already used in the system",
    "UndefinedError": "Undefined error"
  },
  "Schedule.Candidates": {
    "Remove.ConnectionError": "Failed to remove {0} candidates. No internet connection",
    "DeleteError": "An uncategorized error occurred while deleting candidates",
    "SyncInfo": "Synchronization info",
    "SyncCandidates": "Synchronize candidates",
    "OverHardLimit": "This schedule is above the limit of {0} candidates. Adding candidates is not possible",
    "OverSoftLimit": "This schedule is above the recommended size of {0} candidates"
  },
  "Admin.Hierarchy.Errors": {
    "MaximumDepthExceeded": "Can't add another nested hierarchy. Maximum depth exceeded."
  },
  "app-author.features.users.search": {
    "placeholder": "Search for users or hierarchies to add"
  },
  "QuestionEditor.Opt": {
    "Feedback": "Feedback"
  },
  "Marking.Coordination": {
    "AddModerationRound": "Add moderation round"
  },
  "Delivery.Exam.FileResponse": {
    "Tip": "A file has been created for you to answer. Click on the Answer button to open it.",
    "OpenedOn": "Opened on",
    "SaveFile": "Save file"
  },
  "Assessment.Options.Notepad": {
    "NoNotepadTip": "Do not allow use of notepad for candidates.",
    "NoNotepad": "No notepad",
    "AllTip": "Allow use notepad to the candidate",
    "OnlySelected": "Only allow on selected questions",
    "OnlySelectedTip": "Allow use of notepad for selected questions.",
    "All": "Allow on all questions"
  },
  "Admin.GlobalSettings.O365": {
    "ConfirmRevokeText": "Are you sure you want to revoke access to this O365 account?\r\n\r\nWarning : High impact. All questions with O365 files connected with this account will stop working.",
    "ConfirmRevokeTitle": "Please confirm"
  },
  "": {
    "Assessments.CreateNew.SelectPurpose": "Select assessment purpose",
    "Assessments.CreateNew.SelectPurposeTip": "By determining the item purpose of the assessment, you make sure your item selection is limited to the selected",
    "QuestionEditor.Sidebar": "Topic",
    "Import": "Import"
  },
  "Library.Office365": {
    "ReplaceFileConfirmation": "You have already uploaded a file to this question. Do you want to replace the current file with a new one?",
    "FileExtensions": "Supported file types: .xlsx, .docx, .pptx",
    "FilenameLength": "Filename cannot exceed 100 characters",
    "Filesize": "Max file size allowed for upload is 4 MB",
    "FileUploadError": "Error uploading file!",
    "DeleteFileConfirmation": "Are you sure you want to delete the file?",
    "FilenameSizeExceeded": "File name cannot exceed 100 characters!",
    "FilenameInvalid": "File name cannot contain the following characters:  < , > , : , \" , / , \\ , | , ? , * ",
    "FileDownloadError": "An error occurred while downloading the file"
  },
  "Schedule.Candidates.Sync": {
    "NumberOfCandidates": "Number of candidates",
    "Synchronize": "Synchronize",
    "SyncInProgress": "Synchronization is in progress. Please wait.",
    "CouldntSynchronize": "Unexpected error occurred during synchronization. Please, try to relaunch from your LMS",
    "SyncNotPossible": "Synchronization not possible. You must first configure groups of less than {0} candidates in your LMS",
    "AddRemoveCounts": "This synchronization will add {0} candidate(s) and remove {1} candidate(s)",
    "FilteredOutCount": "{0} candidate(s) need to be added later by syncing other groups (to another schedule)",
    "RemovedCountWarning": "All {0} candidate(s) that were manually added or synchronized previously will be removed",
    "UpToDate": "This schedule is already up to date",
    "LmsGroup": "LMS Group",
    "AreYouSure": "Are you sure?",
    "OverHardLimit": "You must select a group so this schedule remains below the limit of {0} candidates",
    "OverSoftLimit": "This schedule would be above the recommended size of {0} candidates",
    "LmsContextId": "LMS \"Context\" ID",
    "FetchingInfo": "Fetching (candidate) membership data from your LMS. Please wait.",
    "TrashCanWarning": "{0} deleted candidate(s) with the following user ids will not be added",
    "LmsContextTitle": "LMS \"Context\" Title",
    "ExternalIdWarning": "If you use an LTI Exam launch, and not the preferred Dashboard LTI launch, the LTI custom parameter “schedule_id=” in your LMS must match this schedule’s “External ID” in Cirrus. You may have to choose a unique “External ID” and copy it to your LTI custom parameter",
    "PleaseSelectGroup": "Please select at least one group",
    "CouldntFetchInfo": "Could not fetch (candidate) membership data. Please, try to relaunch from your LMS",
    "InvalidCountWarning": "{0} candidate(s) could not be added",
    "FilteredOutWarning": "When candidates are in multiple groups, they will only be added from the first group highest on the list above",
    "ExcludeCandidatesLabel": "Exclude {0} candidate(s) that are in multiple groups",
    "ExcludeCandidatesWarning": "Please check this option if you want to exclude candidates also in groups higher on the list now. Those candidates would need to be added later by syncing other groups (to another schedule)"
  },
  "Delivery.Confirmation": {
    "SaveAndContinue": "Save file and continue",
    "ContinueWithoutSaving": "Continue without saving",
    "DialogContent": "Do you want to save the changes or continue without saving?",
    "DialogContentWithoutFreeNavigation": "You are about to navigate away from this question. Note that you are not able to back to this question after you have navigated away. Are you sure you want to continue and submit this question?"
  },
  "Author.WebhookEditor": {
    "InvalidPlaceholders": "Unsupported {{placeholder}} detected"
  },
  "Results.Export": {
    "Criterion": "Criterion",
    "QuestionTotal": "Question total"
  },
  "Evaluation.FileTemplate": {
    "IFrameHint": "If you have third-party cookies blocked in your browser, the preview of the file is blocked. To open the file in a new tab please click"
  },
  "DeliveryMethod": {
    "OnScreen": "On-screen",
    "Paper": "Paper",
    "DeliveryMethod": "Delivery method"
  },
  "AssessmentDashboard": {
    "Options": "Set options for the assessment",
    "Questions": "Select a pool of questions",
    "Forms": "Create form(s)",
    "Publish": "Publish the assessment",
    "Info": "Give the assessment a name"
  },
  "Admin.GlobalSettings.ExitURLs": {
    "ExitURLsTitle": "Exit URL",
    "AuthorTitle": "Author (other)",
    "DeliveryTitle": "Candidate Delivery",
    "ExitURLsHint": "Set the URL that users will be forwarded to after ended assessment. Leave empty if you want the users to be forwarded to the Cirrus login screen"
  },
  "AssessmentPageDetails": {
    "Attempt": "Attempt",
    "Duration": "Duration",
    "MaxScore": "Max score",
    "Percentage": "Percentage for pass-mark",
    "ScheduleEnd": "Schedule end",
    "AttemptCount": "Which attempt counts",
    "ScheduleStart": "Schedule start",
    "NumberOfQuestions": "Number of questions"
  },
  "AssessmentPage": {
    "WelcomePageDetailsHint": "Allows you to set which details on the welcome page should be visible for the candidates"
  },
  "Marking.Notifications": {
    "AttemptWasVoidedByAnotherAssessor": "Assessor {0} voided the attempt of candidate {1}"
  },
  "Assessments.CreateNew": {
    "SelectPurpose": "Select assessment purpose",
    "SelectPurposeTip": "By determining the item purpose of the assessment, you make sure your item selection is limited to the selected"
  },
  "Reports.Candidate": {
    "DateSubmitted": "Date submitted",
    "OverallScore": "Overall score"
  },
  "Library.Topic": {
    "ConfirmMassRemoval": "Are you sure you want to remove the topics from the selected questions? Once removed, then they would have to be manually added again.",
    "AddTopic": "Add topic",
    "RemoveTopics": "Remove topics",
    "Topics": "Topics",
    "TopicsChanged": "Topics were changed",
    "BulkAddWarning": "By bulk-assigning topics you will remove already added topics to the questions you have selected.",
    "ValidationMaxLength": "Max Topic name length can be 30 characters.",
    "ValidationForbiddenSymbols": "Topic name is not allowed to have '/' or '\\' in it.",
    "SelectTopic": "Select topic"
  },
  "Library.Collection.ChangeTopic": {
    "UsedMessage": "Item {0} was not updated. This item is used in assessment.",
    "ErrorMessage": "Item {0} were not updated. Error occurred while changing topic.",
    "InvalidMessage": "Item {0} were not updated. This item is not valid.",
    "SuccessMessage": "Item {0} was successfully updated.",
    "LockedMessage": "Item {0} was not updated. This item is locked by another user.",
    "UsedBatchMessage": "{0} items were not updated. These items are used in assessment.",
    "ErrorBatchMessage": "{0} items were not updated. Error occurred while changing topic.",
    "SuccessBatchMessage": "{0} items were successfully updated.",
    "InvalidBatchMessage": "{0} items were not updated. These items are not valid.",
    "LockedBatchMessage": "{0} items were not updated. These items are locked by another user.",
    "UnsupportedMessage": "Item {0} was not updated. A page can not have a topic assigned.",
    "UnsupportedBatchMessage": "{0} items were not updated. Pages can not have a topic assigned."
  },
  "Collection.Library": {
    "TopicsPopupNoPermission": "You don't have permission to edit this item"
  },
  "Library.Library": {
    "TopicsPopupEmptyTopicNameError": "name of topic should not be empty",
    "TopicsPopupSameTopicNameError": "A topic with the same name already exists"
  },
  "Delivering.ScheduleDialog": {
    "DetailsDescription": "Specify the details for this schedule.",
    "DurationError": "The duration of schedule must be longer than the duration of assessment: {1} minutes.",
    "RangeError": "The schedule duration must lie within assessment active time span {1} {2}",
    "YearsError": "The schedule duration date range must be less than 2 years",
    "ArchivedHierarchyWarning": "The hierarchy used in this schedule has been archived. You need to select a different hierarchy before you can activate the schedule"
  },
  "Admin.GlobalSettings.Keycode": {
    "KeycodeHint": "Allow candidates to log in using keycodes. A Scheduler will be able to enable keycode login per assessment.",
    "UseKeycode": "Use keycode",
    "RequireUsername": "Require username",
    "UseKeycodeTip": "Keycodes allow your candidates to log in for a specific exam using a 8-digit keycode instead of a username and password."
  },
  "Account.Login.Keycode": {
    "Description": "Keycode log in with the Cirrus platform"
  },
  "Reports.Aria": {
    "Overview": "Score report overview"
  },
  "Admin.General": {
    "SelectTemplate": "Select Template"
  },
  "General.Error": {
    "DateRangeNotValid": "Your date range is not valid"
  },
  "Deliver.Results": {
    "ScoreReportTableCaptionTopics": "Score report table with topics",
    "ScoreReportTableCaptionObjectives": "Score report table with learning objectives"
  },
  "Admin.Integrations.ImsLti.Dialog": {
    "LineItemBaseUrlTip": "Only fill for Grade Services of a clustered Platform/LMS with multiple Issuers",
    "IssuerTip": "If there are multiple put each on a separate line",
    "Oauth2TokenUrl": "OAuth2 Token Endpoint URL",
    "RedirectEndpoint": "LTI1.3 Tool Redirect Endpoint",
    "LineItemBaseUrl": "Line Item Base URL",
    "OidcAuthUrl": "OpenID Connect (OIDC) Authentication Endpoint URL",
    "PlatformIdTip": "Please choose a short identifier that will be used in the Cirrus LTI URLs (5 to 15 characters, only a-z, A-Z, 0-9 and hyphen ‘-’ allowed)",
    "PublicKeyTip": "Use only if Platform/LMS lacks JWKS URL support",
    "EnableGradeServices": "Enable Grade Services",
    "LmsBlackboard": "Blackboard",
    "EnableCandidateSyncTip": "Membership service (Roster) must be supported and enabled in your Platform/LMS",
    "Oauth2KeySetUrl": "OAuth2 Public KeySet URL",
    "EnableGradeServicesTip": "Create Line Item (Gradebook Column) must be supported and enabled in your Platform/LMS",
    "PublicKeyGeneration": "Public key will be generated after save",
    "LaunchUrl": "LTI1.3 Launch URL",
    "LmsCanvasCloud": "Canvas Cloud",
    "OnTheFlyScheduling": "On-the-fly Scheduling for Exam Launch",
    "EnableCandidateSync": "Enable Candidate Synchronization for Schedules",
    "SecurityRiskTip": "Leave disabled unless you understand the Security and Performance implications!",
    "OnTheFlyCreation": "On-the-fly User Creation",
    "PlatformIdInvalid": "Value can only contain a-z, A-Z, 0-9 and hyphen ‘-’",
    "JwksUrlTip": "Preferred for Platform/LMS that support it",
    "ProvideToLms": "Provide to the Platform/LMS",
    "RedirectEndpointTip": "Same as Launch URL",
    "ProvidedByLms": "Provided by the Platform/LMS",
    "LmsSakai": "Sakai",
    "OidcEndpoint": "LTI1.3 Tool OpenID Connect/Initialization Endpoint",
    "JwksUrl": "LTI1.3 Tool JWKS URL",
    "ProvideToLmsPlatformIdTip": "These fields will be filled immediately after entering the “Platform ID” at the top of this page",
    "PlatformIdNotFilled": "Please enter a Platform ID first"
  },
  "Schedule.TodoList": {
    "SelectInvigilators": "Select invigilators (optional)",
    "Info": "Give the schedule a name"
  },
  "Delivering.Schedule.Error": {
    "Candidate": "Select candidates and click ‘Add Candidates’ to add them to the schedule",
    "HasStarted": "One or more candidates have started this assessment. Changes cannot be made."
  },
  "Delivering.Schedule.Dialogs": {
    "SelectedAssessment": "Selected assessment",
    "SelectedAssessmentDescription": "You have selected the following assessments to schedule:",
    "ExtraTimeOptions": "(Extra time {0} minutes)"
  },
  "Delivery.Schedule": {
    "RemoteProctored": "Remote proctored",
    "NoSecurity": "No security"
  },
  "Reports.Tabs": {
    "Overview": "Overview",
    "Results": "Results",
    "Performance": "Performance",
    "Usage": "Usage"
  },
  "Author.Reports.Results": {
    "ViewBySchedule": "View by schedule",
    "ViewByAssessment": "View by assessment",
    "ViewByCandidate": "View by candidate"
  },
  "Author.Reports.RemarkingDialog": {
    "AddDescription": "Add description",
    "AssignedTo": "Assigned to",
    "ReasonForRemarkingTip": "The reason for remarking will be shown to the remarker",
    "ShowOriginalAssessors": "Show original assessors",
    "SearchForUsers": "Search for users",
    "NoneAvailableAssessors": "None of available assessors matched this search",
    "ShowAllAvailableAssessors": "Show all available assessors",
    "ReasonForRemarking": "Reason for remarking",
    "AssignedToTip": "Allows you to set the user who is tasked with re-marking the selected candidate(s)",
    "CreateRemarkingSession": "Create re-marking session",
    "ConfirmationText": "Are you sure you want to change the remarking session? if assessors have already started marking, the scoring will be removed.",
    "DescriptionRequiredError": "Description is a mandatory field",
    "AssessorRequiredError": "At least one assessor required",
    "DescriptionMaxLengthError": "Description max length is 200",
    "EditRemarkingSession": "Edit re-marking session",
    "NoAssessorPermission": "The assessor does not have remarking permission"
  },
  "Author.Reports.CandidateResults.Status": {
    "FinalResult": "Final result",
    "RemarkingInProgress": "Remarking in progress",
    "FlaggedForRemarking": "Flagged for re-marking",
    "IntermediaryResult": "Intermediate result"
  },
  "ExportReports": {
    "ReportsDialogHeader": "Select which reports you to want to export to excel",
    "ReportsDialogTip": "You have selected {0} candidate(s).",
    "ReportsDialogTitle": "Export reports"
  },
  "Author.Marking.Remarking.Candidates.SubmitScoresDialog": {
    "Title": "Submit scores",
    "SubmittingHeader": "Are you ready to submit the scores?",
    "SubmittingText": "You are about to submit the scores of {0} candidate(s)",
    "WhatsNextHeader": "What's next?",
    "WhatsNextText": "After you have submitted the scores, you need to publish the results. This can be done on the Results tab.",
    "SubmitAndPublishHeader": "Are you ready to submit and publish the scores?",
    "SubmitScoreBtnTooltip": "One or more results have already been submitted. You can only submit results that haven’t already been submitted",
    "SubmitAndPublishText": "You are about to submit and publish the scores of {0} candidate(s)"
  },
  "Marking.Remarking.Candidates": {
    "AdjustedPercentage": "Adjusted percentage",
    "AdjustedScore": "Adjusted score",
    "NotSubmitted": "Not-submitted",
    "ShowResults": "Show results"
  },
  "Delivering.CandidateReview": {
    "UnarchiveDialogTitle": "Unarchive review sessions(s)",
    "UnarchiveDialogText": "Are you sure you want to unarchive this review session?{0}\nCandidates will be able to view their results again.",
    "ArchiveDialogTitle": "Archive review sessions(s)",
    "ArchiveDialogText": "Are you sure you want to archive this review session?{0}\nIt’s currently active and candidates will no longer be able to view their results.",
    "SetPinTitle": "Set PIN code",
    "SetPinText": "Setting a PIN code requires the candidates to enter a pin code before accessing the review session.",
    "ActivateSession": "Activate review session",
    "ActivateSessionReadyText": "Are you ready to activate the review session?",
    "ActivateSessionHint": "By activating the review session, the candidates can view the results within the set time-frame.",
    "InformUsersHint": "By selecting these options, you will inform the candidates about the scheduled review session.",
    "KeycodeHint": "Selecting this option will include the keycode in the email sent to the candidates.",
    "DeActivateSession": "Deactivate review session",
    "DeActivateSessionReadyText": "Are you ready to deactivate the review session?",
    "DeActivateSessionHint": "By deactivating the review session, the candidates cant view the results within the set time-frame.",
    "EditSessionSettings": "Edit review session settings"
  },
  "Delivery.Eula": {
    "BackToEula": "Back to EULA",
    "DeclineConfirmText": "Please, be aware that you must accept the EULA to take this exam. By declining the EULA you will abort your attempt."
  },
  "Marking.Remarking": {
    "NoResults": "No available schedules",
    "NumberOfCandidates": "# of candidates"
  },
  "Admin.Plagiarism": {
    "TurnitinUrl": "Turnitin URL",
    "TurnitinApiKey": "Turnitin API Key",
    "TestConnection": "Test Connection",
    "IndexingOptions": "Indexing Options",
    "SourceTextVisibility": "Institution Source Text Visibility",
    "TurnitinUrlTip": "Your institution’s unique Turnitin URL. Takes the format of https://[YourInstitution].turnitin.com. For example. https://universityofturnitin.turnitin.com ",
    "TurnitinApiKeyTip": "The unique API key generated when configuring the integration in Turnitin.",
    "IndexingOptionsTip": "Choose if uploaded files will be available to be matched against in future Similarity Reports. ",
    "SourceTextVisibilityTip": "Instructors of matching sources within the same institution can view the full text of the original submission. ",
    "MatchDetailVisibilityTip": "Instructors of matching sources within the same institution can view basic details about the original submission and the person who submitted the file. This includes class details, their name, and submission dates.",
    "MatchDetailVisibility": "Institution Match Detail Visibility",
    "IndexNoSubmissions": "Don’t index any submissions",
    "IndexAllSubmissions": "Index all submissions",
    "ConnectionSuccessful": "Connection was established",
    "ConnectionCouldNotBeEstablished": "Connection was not established",
    "ErrorMessage": "Error during Save. Could not successfully set up integration with Turnitin, please try again later starting with “Test Connection”"
  },
  "Plagiarism": {
    "MatchDetailVisibility": "Institution Match Detail Visibility",
    "NotAvailable": "There is no information available",
    "NotAvailableDescription": "Plagiarism detection was not turned on for this question"
  },
  "Evaluation.Plagiarism": {
    "Match": "{0} match",
    "PlagiarismReportNotReady": "Plagiarism report is not ready yet",
    "PlagiarismReport": "Plagiarism report",
    "StatusMessage": "TurnItIn status message",
    "ErrorMessage": "An error occurred while generating the report"
  },
  "General.Remarking": {
    "PassRateTooltip": "Pass rate is the percentage of candidates who passed this assessment"
  },
  "General.Office365": {
    "ExceptionMessage": "Office 365 Integration error - please try again later and if the issue persists contact your administrator with the information shown below."
  },
  "Evaluation.Plagiarism.Report": {
    "ErrorMessage": "Could not retrieve report from Turnitin, please try again later"
  },
  "Author.Delivering.ReviewSession": {
    "ArchiveSuccess": "You have archived {0} session(s)",
    "ArchiveError": "Error while archieving {0} session(s)",
    "UnarchiveError": "Error while unarchieving {0} session(s)",
    "UnarchiveSuccess": "You have unarchived {0} session(s)",
    "SetPinSuccess": "You have set PIN code(s) for {0} session(s)",
    "SetPinError": "Error while setting PIN code(s) {0} session(s)",
    "RemoveSuccess": "You have deleted {0} session(s)",
    "RemoveError": "Error while deleting 2 session(s)",
    "CopySuccess": "You have copied {0} review session(s)",
    "CopyError": "Error while copying {0} session(s)",
    "DialogStepOne": "Step 1 of 2: select {0}",
    "BackToSchedule": "Back to schedule",
    "ActivateSuccess": "{0} review session has been successfully activated",
    "DeactivateSuccess": "{0} review session has been successfully deactivated",
    "DeactivateError": "Error while deactivation {0} review session",
    "ActivateError": "Error while activation {0} review session",
    "OptionsSaveSuccess": "Option save successful",
    "RemoveSomeCandidatesConfirmationText": "You are about to remove {0} out of {1} selected candidates who haven't viewed results. Are you sure you want to continue?",
    "RemoveOneCandidateConfirmationText": "Are you sure you want to remove {0} who hasn’t viewed results? Once removed, you can add them again by clicking on Add candidates.",
    "RemoveCandidatesConfirmationText": "Are you sure you want to remove the selected candidate(s)? Once removed, you can add them again by clicking on Add candidates.",
    "DeactivateNotice": "Cannot deactivate this session as some candidate has started review.",
    "ExportFileName": "Review session export ({0})"
  },
  "Author.delivering.ReviewSessions": {
    "AddReviewSession": "Add review session",
    "AddReviewSessionDialogTitle": "Add candidate review session"
  },
  "Author.Delivering.ReviewSessions": {
    "StepOneTip": "Search for and select the {0} you want to create a candidate review session for.",
    "StepTwoIntegrationTip": "Will this review session be used for integrations?",
    "StepTwoKeycodeTip": "Keycodes can be used by candidates to access the review session directly.",
    "StepTwoReviewWindowTip": "The schedule window is the time-frame when the candidate can view the results of the exam on their dashboard.",
    "StepTwoReviewWindowHeader": "CANDIDATE REVIEW WINDOW",
    "StepTwoTitleFieldPlaceholder": "Enter review session title *",
    "StepTwoHeader": "Step 2 of 2: Settings",
    "StepTwoSelectedItem": "Selected {0}: ",
    "StepTwoHeaderTip": "Specify the details for this review session."
  },
  "ReviewSession.Todo": {
    "Assessment": "Select assessment and set review period",
    "SetOptions": "Set options"
  },
  "ReviewSession.Options.Navigation": {
    "CandidateDeliveryTitle": "Order of candidate delivery",
    "OriginalTitle": "Order of original form",
    "CandidateDeliveryTip": "The order of questions in review will be same as was during the assessment.",
    "OriginalTip": "The order of questions in review will be same as the fixed form created by author."
  },
  "Delivering.ReviewSession.Error": {
    "Candidate": "Select candidates and click ‘Add Candidates’ to add them to the review session"
  },
  "Delivering.ReviewSession.Keycode": {
    "PendingTooltip": "Activation of review session is pending",
    "EndedTooltip": "Review session has ended"
  },
  "Author.Delivering.ReviewSession.Info": {
    "LockNotification": "This review session is already being edited by {0}. Your co-author needs to exit this schedule in order for you to make changes."
  },
  "Delivering.ReviewSession": {
    "KeycodeNote": "Note: New keycodes are generated for the session"
  },
  "Delivery.Feedback": {
    "SelectFeedbackTheme": "Select type of feedback",
    "EnterFeedbackTitle": "Enter a short feedback title",
    "DescribeFeedback": "Describe the issue",
    "ReportFeedbackTitle": "Report feedback on this question",
    "ReportFeedback": "Report feedback",
    "ReportFeedbackHint": "You are about to submit feedback on the current question. This feedback is useful for the author of this question in order to improve the question for the future.",
    "Typo": "Spelling/typo",
    "DisplayProblem": "Display problem",
    "NonSolvable": "Not solvable question",
    "WrongHint": "Feedback/Hint is wrong",
    "Enable": "Candidates can report feedback",
    "EnableInfo": "Allows candidates to give feedback on items during the assessment"
  },
  "Author.Admin.Content.Feedback": {
    "AnnounceDialogTitle": "Announce feedback via email",
    "AnnounceMessageLabel": "Prepend a message (optional)",
    "AnnounceMessageText": "Item authors will get email with feedback report.",
    "AnnounceAdditionalEmailsText": "If you want to announce this feedback also to others, add their emails below:",
    "AnnounceAdditionalEmailsLabel": "Add additional emails",
    "UpdateStatusText": "Update status of selected item(s):",
    "UpdateStatusLabel": "Choose new status for the selected items",
    "UpdateStatusRemarkLabel": "Add status remark",
    "ExportFileName": "Candidates feedback export ({0})",
    "FillAuthorEmail": "Please fill in the “Additional email(s)” as none of the authors has an email for one or more of the selected items."
  },
  "Admin.GlobalSettings.CandidateFeedback": {
    "Defaults": "Candidate Feedback Defaults",
    "Hint": "Here you can provide defaults for users with \"Edit report feedback option\" permission for assessments.",
    "Enable": "Turn on \"Candidates can report feedback\" option for new assessments",
    "Email": "Email CC address for the announce action"
  },
  "Section": {
    "ItemsDurationExceedsSectionDuration": "The duration of the questions within this section exceeds the duration of the section"
  },
  "Labels.ItemsEditor": {
    "Tip": "You can apply existing labels or create/edit/delete personal labels which will be visible only for you within this collection."
  },
  "Library.Collection.Editor": {
    "Tip1": "A collection is an item bank, where you can create and manage questions (items).",
    "LearningObjectivesTip": "Adding learning objective repositories to your collection allows you to limit the objectives to those contained in the repositories.",
    "TaxonomiesTip": "Adding taxonomy groups to your collection allows you to limit the taxonomies to those contained in the taxonomy group.",
    "AlertAboutEdit": " You can change collection settings at any time by clicking on the 3-dots button in the top right corner.",
    "Tip2": "After creation collection can be shared with co-workers for collaborative authoring.",
    "PrefixTip1": "Prefix is a string that is used as part of items' functional identifiers.",
    "PrefixTip2": "Prefix is created automatically but can be changed to a more meaningful value."
  },
  "Admin.GlobalSettings.ItemDifficultyScale": {
    "ItemDifficultyScaleTitle": "Item difficulty scale",
    "ItemDifficultyScaleHint": "Allows you to set the difficulty scale for items.",
    "UseAngoff": "Use Angoff",
    "Lowest": "Lowest",
    "Highest": "Highest",
    "RangeValidationError": "Difficulty boundaries can not overlap and should be in ascending order."
  },
  "Admin.ContentManagement.Feedback": {
    "AdditionalEmailsRequiredTooltip": "Please fill in the “Additional email(s)\""
  },
  "Assessment.Options.Results": {
    "ShowDurationTip": "Select the amount of time the candidate has to review the results after completing the assessment"
  },
  "Section.NavigationOptionTitles": {
    "Inherit": "Inherit assessment options",
    "Forward": "Only forward navigation",
    "Free": "Free navigation"
  },
  "Section.NavigationOptions": {
    "SelectorLabel": "Navigation"
  },
  "QuestionEditor.Content.Rationale": {
    "ShowRationaleInputField": "Show rationale input field"
  },
  "Question.Rationale": {
    "Placeholder": "Add your rationale here"
  },
  "Library.Items.Filter": {
    "SelectPlaceholder": "Select from list"
  },
  "Library.Items.ChangeItemPurpose.ConfirmText": {
    "All": "You are about to change the item purpose to {0} for <b>ALL</b> items in this collection. Do you want to continue?",
    "Selected": "You are about to change the item purpose to {0} for {1} selected item(s). Do you want to continue?"
  },
  "Library.Items.ChangeStatus.ConfirmText": {
    "All": "You are about to change the status to {0} for <b>ALL</b> items in this collection. Do you want to continue?",
    "Selected": "You are about to change the status to {0} for {1} selected item(s). Do you want to continue?"
  },
  "Delivery.Office365": {
    "QuestionTip": "Click on the button to open the file to answer the question.",
    "QuestionTip2": "All answer files will be submitted automatically after finishing the attempt.",
    "SubmissionPending": "Office365 answer file submission in progress. Please try again later."
  },
  "Assessment.Messages.Navigation": {
    "UnderForwardOnlyNavigationRule": "Forward-only navigation has been set for this assessment/section",
    "ClosestAvailableQuestion": "You will be navigated to the question №",
    "VisitingNextQuestionsForbidden": "You cannot navigate to the next question since you already viewed question(s) and navigation settings prevents you from viewing it again"
  },
  "Assessment.Dialog": {
    "SelectAssessmentTemplate": "Search for and select assessment you want to use as a template."
  },
  "Dialogs.UpdateConfirm": {
    "UpdateAssessments": "Update and publish assessment(s)"
  },
  "Author.Reports.CandidateResults.Publish": {
    "PendingFinalResult": "Pending final result"
  },
  "Notification.Messages.UpdateAssessments": {
    "SomeCantUpdateAndPublish": "Warning, {0} out of {1} assessments have been updated and published. You need to make sure the remaining assessments are ready to be updated and published.",
    "NoOneCantUpdateAndPublish": "No Update and Publish action can be performed. Either the assessment doesn’t need to be updated or assessment is not ready for publishing"
  },
  "Notification": {
    "NoPermission": "You don’t have permission to perform this action."
  },
  "Notification.Messages.MassActionApply": {
    "NoPermissionForSomeAssessments": "The action was performed successfully on some of the assessments. You lack the permission for the remaining assessments."
  },
  "MarkingCoordinateStatusText": {
    "AddAssessor": "Add assessor",
    "Submitted": "Submitted",
    "Published": "Published"
  },
  "MarkingCoordinateStatusTooltipText": {
    "AddAssessor": "Assessors need to be added to this assessment. Optionally you can also add moderators",
    "NotStarted": "The assessment is ready to be marked, but none of the assessors or moderators have started yet",
    "AssessingInProgress": "At least one assessor has started marking this assessment",
    "Submitted": "All the scores have been submitted by the assessors and moderators. Now the results need to be published",
    "Published": "All the results have been published"
  },
  "Author.Assessments": {
    "CreateRegularAssessment": "Allows you to create a new assessment from scratch",
    "CreateTemplatedAssessment": "Allows you to create a new assessment based on an existing assessment. Settings will be copied from the selected assessments"
  },
  "Author.Marking.Overview": {
    "SetMarkingWorkflow": "Set the marking workflow",
    "AddAssessorsPool": "Add a pool of asessors",
    "ManuallyMarked": "To be manually marked",
    "NumberOfAssignedAssessors": "Number of assigned assessors",
    "CheckedListTitle": "The role of the coordinator",
    "CheckedListDescription": "The coordinator is responsible for setting the marking workflow, assigning markers and monitoring the marking progress",
    "AllocateAssessors": "Allocate assessors"
  },
  "Delivering.InvigilationOverview": {
    "NoResultsText": "Activate at least one Schedule to start monitoring."
  },
  "Assessments.FormEditor": {
    "TabPages": "Intro and Finish pages",
    "FinishPage": "Finish page"
  },
  "Delivering.Invigilation.ResumeExam": {
    "Description": "Resume exam for {0} selected candidates?",
    "NotPausedDescription": "Possible to resume only candidates with status {0}.<br><br>Resume exam for {1} selected candidates?"
  },
  "Delivering.Invigilation.SendMessageDialog": {
    "MessagePlaceholder": "Your message goes here",
    "Title": "Send message to candidates",
    "Description": "After clicking on the Send button, this message will appear on the screens of the selected candidates with {0} status.<br><br>If the candidate started the exam, but had some connection problems they will get the message as soon as they are rejoined the exam and continue.\n          "
  },
  "Delivering.Invigilation.VoidExam": {
    "Description": "Void exam for {0} selected candidates? The action is irreversible.",
    "NotPausedOrInProgressDescription": "Possible to void only candidates who are {0} or {1}.<br><br>Void exam for {2} selected candidates? The action is irreversible.\n"
  },
  "Delivering.Invigilation.PauseExam": {
    "NotInProgressDescription": "Possible to pause only candidates with status {0}.<br><br>Pause exam for {1} selected candidates?"
  },
  "AssessmentFormPages": {
    "DisplayBeforeQuestions": "Before questions",
    "DisplayAfterQuestions": "After questions"
  },
  "Library.Filter": {
    "ScoreType": "Score type"
  },
  "Admin.Media.DeleteDialog": {
    "AmountTooltip": "{0} of {1} selected elements are used in questions, so it won’t be deleted.",
    "Tooltip": "Are you sure you want to delete {0} elements?"
  },
  "Admin.Library": {
    "AddElement": "Add element",
    "ToReview": "To review"
  },
  "Admin.Library.Filters": {
    "SearchForLabels": "Search for labels",
    "SearchItemTypes": "Search item types",
    "SelectState": "Select state"
  },
  "Assessment.Form.Warning": {
    "WithdrawnElementsInForm": "In order to publish the form, the selected questions/sections/pages must have Live status. You can change the status inside the collection"
  },
  "Author.Library.Collections": {
    "NoResults": "Click on Add collection to start building your item bank"
  },
  "Author.Library.Collection": {
    "RestoreDialog": "Are you sure you want to restore this collection?",
    "RestoreDialogTitle": "Restore collection(s)?",
    "ExportedCollections": "Collection overview {0}"
  },
  "TestWizard.Button": {
    "CancelWithoutSaving": "Cancel without saving",
    "TestWizard": "Test wizard",
    "ContinueTestWizard": "Continue test wizard",
    "TestWizardTooltip": "Allows you to create and schedule a simplified assessment"
  },
  "TestWizard.FormField": {
    "AssessmentDurationPlaceholder": "Assessment duration",
    "SetDurationPlaceholder": "Set duration"
  },
  "Author.Library.Items": {
    "RestoreDialogTitle": "Restore item(s)?",
    "RestoreDialog": "Are you sure you want to restore this item(s)?",
    "CollectionConnectedDeleteInfo": "Item(s) from a deleted collection can't be restored separately from the collection. Please restore the collection."
  },
  "TestWizard.Publish": {
    "Tip": "By publishing the assessment you will create the assessment and schedule it. If you want to make changes to the assessment at a later stage you need to Unpublish it."
  },
  "Author.Library.Media": {
    "RestoreDialogTitle": "Restore media element(s)?",
    "RestoreDialog": "Are you sure you want to restore this media element(s)?",
    "SharingDialogText": "Who do you want to share this element with?",
    "DownloadTooltip": "You can download each media element one by one."
  },
  "Admin.Media": {
    "ShareButtonTooltip": "You can share only personal elements.",
    "DeleteButtonTooltip": "All selected items are used in questions, so it will not be deleted."
  },
  "Library.Collections.Plural": {
    "WereArchived": "Collections were archived",
    "WereNotArchivedPermission": "{0} collections were not unarchived. Not enough permissions.",
    "WereUnarchived": "Collections were unarchived."
  },
  "Assessments.Options": {
    "ApplicationUsage": "Applications usage",
    "FeedbackToCandidates": "Feedback to candidates",
    "WhenToShowFeedback": "When to show feedback"
  },
  "TestWizard.ConfirmationDialog": {
    "CancelWithoutSaving.Description": "Are you sure you want to navigate away from the test wizard? All changes will be removed."
  },
  "TestWizard.AddCandidatesDialog": {
    "SearchPlaceholder": "Search by name, user ID or email"
  },
  "General.Validation": {
    "OnlyIntegerNumbers": "Only integer numbers are allowed",
    "OnlyNumbersRange": "Only numbers from {0} to {1} are allowed",
    "OnlyNumbers": "Only numbers are allowed"
  },
  "AssessmentOptions": {
    "PercentageReasonableAdjustment": "Percentage extra time"
  },
  "TestWizard.Todo": {
    "Hierarchy": "Please select a schedule hierarchy",
    "Duration": "Please enter a Schedule duration",
    "MaxTimePerAttemptIsMissing": "Please select an Assessment duration",
    "ShowResultsOptionIsMissing": "You need to select the type of results to show",
    "UserIds": "Set user IDs"
  },
  "Warnings.Tooltip": {
    "NoWarnings": "No warnings"
  },
  "Profile.TwoFactorAuth": {
    "TwoFactorAuthSuccessfullyEnabled": "Two-factor authentication was successfully enabled",
    "TwoFactorAuthSuccessfullyDisabled": "Two-factor authentication was successfully disabled",
    "InvalidCode": "Provided code is invalid",
    "Code": "6-digit code",
    "IsEnabled": "Two-factor authentication is enabled",
    "EnterCodeToDisable": "Enter the 6-digit code here to disable",
    "FollowStepsToEnable": "Please follow these steps to enable two-factor authentication",
    "InstallApp": "Install a verification app on your phone (e.g. Google authenticator)",
    "ScanQrCode": "Scan this QR code with your verification app",
    "UseManualEntryKey": "OR use this manual entry key",
    "EnterCodeHere": "Enter the 6-digit code here"
  },
  "Marking.Assess": {
    "NotAssignedYet": "You haven't been assigned to mark any assessments yet."
  },
  "Admin.News": {
    "EditPostTitle": "Edit previous post",
    "PublishSuccessful": "Post was successfully published",
    "UpdateSuccessful": "Post was successfully updated",
    "DeleteSuccessful": "Post was successfully deleted",
    "EditorPlaceholder": "Type news here",
    "PostTitle": "Post news",
    "DeleteConfirmTitle": "Delete previous post",
    "DeleteConfirmText": "Are you sure you want to delete the previous news post?",
    "TextLengthValidationMessage": "Text must be between 1 and 2000 characters"
  },
  "Account.ResetPasswordRequested": {
    "Title": "Check your email",
    "Description": "<p>We have sent you a link to reset your password</p><p>Check spam folder if you cannot find mail in the inbox.</p><p>If you entered a <b>valid username</b> an email containing a recovery link will have been sent to your user's email address.</p><p><i>For security reasons we cannot disclose if the username you entered was correct</i></p>"
  },
  "Admin.Overview": {
    "Description": "We are currently working on further improvements to the Overview page. News you are posting here will be visible on the login page"
  },
  "Scoring.Navigation": {
    "NextQuestion": "Next question",
    "PreviousQuestion": "Previous question"
  },
  "Marking.Scoring": {
    "FeedbackToCandidate": "Feedback to candidate",
    "Points": "Points",
    "EditMode": "Edit mode",
    "TotalPoints": "Total points",
    "BackToScoring": "Back to scoring",
    "ViewAsColleagues": "View as Colleagues",
    "AssessMode": "Assess mode",
    "NewCriterion": "New criterion",
    "NewSubCriterion": "New subcriterion",
    "EditModeDisabled": "Rescoring option in coordination is OFF or scoring has been done for this question by one of the assessors"
  },
  "QuestionEditor.Comments": {
    "InputPlaceholder": "Comment to co-authors"
  },
  "Annotations": {
    "NotAvailable": "There are no annotations yet",
    "NotAvailableDescription": "Adding annotations helps provide valuable insights and feedback to improve the quality of exam questions and the overall assessment process."
  },
  "Comments": {
    "NotAvailable": "There are no comments yet",
    "NotAvailableDescription": "Adding comments helps provide valuable insights and feedback to improve the quality of exams and the overall assessment process."
  },
  "ScoringTag": {
    "Source": "Source?",
    "OffTopic": "Off-topic",
    "Good": "Good",
    "Grammar": "Grammar",
    "Disagree": "Disagree",
    "Rewrite": "Rewrite"
  },
  "General.Author.Library": {
    "RevisionTooltip": "A version is a major change to the item that affects the psychometric data."
  },
  "Notepad": {
    "CandidateLeftNoNotes": "Candidate left no notes"
  },
  "QuestionEditor.Overview": {
    "Hint": "Here is some high-level data on this question.",
    "UsedInLinkTooltip": "Open the assessment (this will take the user to the dashboard of that assessment)",
    "UsedInNoAccessTooltip": "You don't have access to this assessment",
    "AvgTimeSpentInfo": "Candidates spent on average {0} on answers.",
    "DifficultyAngoffInfo": "Question is considered {0} based on Angoff value of {1}",
    "DifficultyPValueInfo": "Question is considered {0} based on a p-value of {1}",
    "LastUsedInfo": "This question was last used on {0}",
    "FooterText": "Want more details? You can view the extensive report on the {0} tab",
    "DifficultyNoData": "No information available on question {0}.",
    "AvgTimeSpentNoData": "No data on {0} spent on answers.",
    "LastUsedNoData": "No information on the {0} of this question.",
    "UsedInNoData": "No data on the {0} using this question.",
    "NewItemFooterText": "Once the item starts gathering data, you can view detailed psychometrics on the Statistics tab"
  },
  "Files": {
    "MaximumLimitReached": "Maximum file limit reached. To upload new files, please remove existing ones."
  },
  "Scoring.GeneralComments": {
    "Placeholder": "Comment for markers"
  }
}
